// ClientDetail module — extracted from deskte-full.jsx (refactor #7).
// Includes ClientDetail (the main client page) plus its tab components and
// helpers. Most exports are also used from inside Clients (the list view)
// which currently still lives in deskte-full.jsx.

import { avisarKitEnviado, textoSinMensajeDeKit } from '../mensajeDelKitUsado.js';
import { useState, useEffect, useRef, useMemo } from 'react';
import DateField from './DateField.jsx';
import { ClientHealthSherpa } from './ClientHealthSherpa.jsx';
import { nombreDelTipoDeCotizacion } from './quoteCoverageFields.js';
import { setAiOpenClient } from '../aiContext.js';
import {
  Users, FileText, Bell, Shield, Search, Plus, Edit2, Trash2,
  ChevronRight, Upload, Send, CheckCircle, X, Save, Eye, ArrowRight,
  LogOut, Globe, MoreVertical, TrendingUp, Folder, Mail, Phone,
  Calendar, Hash, Building, AlertTriangle, ArrowLeft, Link2,
  Copy, Check, ListTodo, UserCircle, Crown, UserPlus, Flag,
  ClipboardList, CheckSquare, Circle, UserCog, Heart, Smile,
  FolderOpen, FileSignature, ExternalLink, Gift,
  DollarSign, BarChart2, ClipboardCheck, Star, Lock, Unlock,
  PenTool, Receipt, ChevronDown, Layers, Activity, Clock,
  Download, EyeOff, Paperclip, XCircle, CreditCard, MessageSquare,
  ChevronLeft, Edit3, UserX, Megaphone, Settings, Sparkles, Ticket, Repeat,
  Bold, Italic, Underline, AlignLeft, AlignCenter, AlignRight, AlignJustify, RefreshCw, HeartPulse,
} from 'lucide-react';
import { miembrosDelHogarConCorreo } from '../correosDelHogar.js';
import LifeChangeKitModal from './LifeChangeKitModal.jsx';
import { ApplyTemplateModal } from './ActionTemplatesView.jsx';
import { ClientApplicationsTab } from './ApplicationsView.jsx';
import { FollowupsView } from './FollowupsView.jsx';
import { TicketsView } from './TicketsView.jsx';
import { AttendedChip, SeatLabelsEditor } from './AttendedBy.jsx';
import MedicosTab from './MedicosTab.jsx';
import { toast } from './Toast.jsx';
import { ClientEncuestasTab } from './ClientEncuestasTab.jsx';
import { MoverPolizaModal } from './MoverPolizaModal.jsx';
import { marcaDeLaAgencia } from '../marcaDeLaAgencia.js';
import { identidadDePoliza } from '../identidadDePoliza.js';
import { opcionesDeCotizacion, irACotizar, opcionesDePlantilla, irAFirmar, irAFirmas, irAInscribirEnHealthSherpa } from '../enlacesDeLaFicha.js';
import { AiDraftButton } from './AiDraftButton.jsx';
import {
  listPortalTokens, createPortalToken, revokePortalToken,
  listRenewalReviews, createRenewalReview, revokeRenewalReview,
  getAgencySettings,
  createPolicy as apiCreatePolicy,
  updatePolicy as apiUpdatePolicy,
  deletePolicy as apiDeletePolicy,
  sendWelcomeKit as apiSendWelcomeKit,
  verifyPin,
  listClientPaymentMethods,
  createClientPaymentMethod,
  updateClientPaymentMethod,
  deleteClientPaymentMethod,
  revealClientPaymentMethod,
  listEntityHistory,
  listClientEmails as apiListClientEmails,
  sendClientEmail as apiSendClientEmail,
  sendClientSms as apiSendClientSms,
  getClientSmsThread as apiGetClientSmsThread,
  deleteClientEmail as apiDeleteClientEmail,
  updateClientEmailLabels as apiUpdateClientEmailLabels,
  postClientPresence,
  createClient as apiCreateClient,
  listClientReferralsGiven,
  unlinkClientReferral,
  listQuotes as apiListQuotes,
  getQuote as apiGetQuote,
  downloadQuotePdfAuthed as apiDownloadQuotePdf,
  deleteQuote as apiDeleteQuote,
  convertQuoteToPolicy as apiConvertQuoteToPolicy,
} from '../api.js';
import { Modal, Input, Select, Textarea, Avatar, StatCard, InfoBlock, confirmDialog, NoteEditor, NoteFormatButtons, RichNoteBox, renderRichNote } from './ui.jsx';
import { mensajeDeFalloDeSolicitud } from '../motivoDeSolicitud.js';
import { isRichNote } from '../noteFormat.js';
import { esNotaLarga, ESTILO_RECORTADO } from '../notaLarga.js';
import { SsnRevealModal } from './SsnRevealModal.jsx';
import { uid, fmt, daysUntil, fmtMoney, fmtMoneyZero, fmtMonth, MONTHS_LIST, formatPhoneUS, formatClientName, TAG_FLUOR_COLORS, tagColorFor, tagColorKey, tagChipStyle, presentingAgentName, renewalWindowDays, ageFromDob, nombreDeQuienRefirio } from '../utils.js';
import { hasSeatPermission, normalizeSeatPermissions } from '../seatPermissions.js';
import { openWhatsApp } from '../whatsapp.js';
import { enviarSmsAlCliente } from '../enviarSms.js';
import {
  getLastVisited, markClientVisited,
  getLastSeenTabs, setLastSeenTabs,
  countNewerThan, TRACKABLE_TABS,
} from '../clientFreshness.js';
import { prefsGet, prefsSet } from '../uiPrefsStore.js';
import {
  POLICY_TYPES, getPolicyType, getCoverageList,
  memberHasCoverage, countInsuredMembers, countInsuredByType,
  buildCoveragePatchFromPolicy, buildCoverageSyncFromPolicyEdit,
  hasCurrentSpouse,
} from '../policyTypes.js';
import { aseguradosDeLaPoliza, polizaYaEnVigor } from '../aseguradosDeLaPoliza.js';
import { esEstatusCancelado } from '../policyStatuses.js';
import {
  PolicyForm, PolicyCard, PaymentInfoBlock,
} from './PoliciesView.jsx';
import { TaskCard, TaskForm, ClientTasksInline } from './TasksView.jsx';
import { BlobImg, openBlobInNewTab } from './BlobMedia.jsx';
import { DocFolder, DocTypeThumbnail } from './DocFolder.jsx';
import { actionMeta } from '../etiquetasDeActividad.js';
import PhoneText from './PhoneText.jsx';
// Que documentos pide de verdad una carta de elegibilidad (queja 70).
import { tiposPedidos, fechaLimite, fechaDeCarta } from '../documentosDeElegibilidad.js';
import { parsePennieFormat, parseMarylandFormat, parseResultadosConAccionNecesaria, stripGuideAppendix, isResultsOnlyEligibility } from '../parsearElegibilidad.js';
import { unirTextoDeLaPagina } from '../textoDePdf.js';
import { FileActions } from '../../deskte-file-utils.jsx';
import { copiaDePoliza } from '../copiaDePoliza.js';
import { sumaOtrosIngresos, ingresoTotalDePersona, dineroLegible, tipoDeIngresoLegible } from '../otrosIngresos.js';
import { motivoDeSubidaFallida } from '../motivoDeSubidaFallida.js';
import {
  uploadDocument as apiUploadDocument,
  deleteDocument as apiDeleteDocument,
  getDocumentReadUrl as apiGetDocumentReadUrl,
  createNote as apiCreateNote,
  updateNote as apiUpdateNote,
  deleteNote as apiDeleteNote,
  uploadNoteAttachment as apiUploadNoteAttachment,
  listNoteComments as apiListNoteComments,
  addNoteComment as apiAddNoteComment,
  updateNoteComment as apiUpdateNoteComment,
  deleteNoteComment as apiDeleteNoteComment,
  // El comentario que viaja por SSE llega en la forma CRUDA del backend
  // (`content`, adjuntos sin firmar). Hay que pasarlo por el mismo mapeo que
  // usan las llamadas HTTP antes de meterlo en el hilo.
  mapNoteCommentFromApi,
  updateClient as apiUpdateClient,
  setClientDriveUrl as apiSetClientDriveUrl,
  setClientAssignedAgent as apiSetClientAssignedAgent,
  setClientStatus as apiSetClientStatus,
  setClientReadyToSubmit as apiSetClientReadyToSubmit,
  duplicateClient as apiDuplicateClient,
  getClient as apiGetClient,
  listPastedMessages as apiListPastedMessages,
  appendPastedMessages as apiAppendPastedMessages,
  createDocRequest as apiCreateDocRequest,
  listDocuments as apiListDocuments,
  listNotes as apiListNotes,
  listTasks as apiListTasks,
  listSignatures as apiListSignatures,
  getPaymentTracker as apiGetPaymentTracker,
  markPolicyPayment as apiMarkPolicyPayment,
} from '../api.js';

// Status pill color map for client signature lists. Mirrors the constant
// in deskte-full.jsx — extract overlooked it.
const SIGN_STATUS = {
  signed:   { bg: 'bg-emerald-500/15', text: 'text-emerald-400' },
  SIGNED:   { bg: 'bg-emerald-500/15', text: 'text-emerald-400' },
  pending:  { bg: 'bg-amber-500/15',   text: 'text-amber-400' },
  PENDING:  { bg: 'bg-amber-500/15',   text: 'text-amber-400' },
  declined: { bg: 'bg-red-500/15',     text: 'text-red-400' },
  DECLINED: { bg: 'bg-red-500/15',     text: 'text-red-400' },
};

// ── File-internal helpers (mirrors of helpers in deskte-full.jsx so the
//    extracted ClientDetail can run standalone without prop drilling). If the
//    versions in deskte-full.jsx ever change, update both. ──

const parseDob = (dob) => new Date(dob + (dob.length === 10 ? 'T00:00:00' : ''));
const birthdayThisWeek = (dob) => {
  if (!dob) return false;
  const today = new Date(); const b = parseDob(dob);
  const nb = new Date(today.getFullYear(), b.getMonth(), b.getDate());
  const diff = (nb - today) / (1000 * 60 * 60 * 24);
  return diff >= 0 && diff < 7;
};
const birthdayToday = (dob) => {
  if (!dob) return false;
  const today = new Date(); const b = parseDob(dob);
  return today.getMonth() === b.getMonth() && today.getDate() === b.getDate();
};
const getAge = (dob) => {
  if (!dob) return null;
  const today = new Date(); const b = parseDob(dob);
  let age = today.getFullYear() - b.getFullYear();
  const m = today.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < b.getDate())) age--;
  return age;
};
const willTurnAge = (dob, targetAge) => {
  if (!dob) return null;
  const b = parseDob(dob);
  const targetDate = new Date(b.getFullYear() + targetAge, b.getMonth(), b.getDate());
  const today = new Date();
  return Math.ceil((targetDate - today) / (1000 * 60 * 60 * 24));
};
const daysUntilBirthday = (dob) => {
  if (!dob) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const b = parseDob(dob);
  let nb = new Date(today.getFullYear(), b.getMonth(), b.getDate());
  nb.setHours(0, 0, 0, 0);
  if (nb < today) nb.setFullYear(nb.getFullYear() + 1);
  return Math.round((nb - today) / (1000 * 60 * 60 * 24));
};
const fmtBday = (dob) => {
  const b = parseDob(dob);
  return b.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

// Saludo de cumpleanos desde la ficha del cliente.
//
// El SMS ya NO abre la app de mensajes del ordenador: sale por Deskte (Quo /
// Twilio) via `enviarSmsAlCliente`, desde el numero de la agencia y quedando
// en el hilo del cliente (Lissette, 2026-09-01). Correo y WhatsApp siguen
// abriendo el programa del agente, que ahi es lo correcto: el correo sale de
// su buzon y el WhatsApp de su cuenta.
async function sendGreeting(channel, client, subject, body, lang) {
  const phone = (client.phone || '').replace(/[^0-9+]/g, '');
  const waPhone = phone.startsWith('+') ? phone.replace('+', '') : (phone.startsWith('1') ? phone : '1' + phone);
  if (channel === 'email' && client.email) {
    window.open('mailto:' + client.email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body), '_blank', 'noopener,noreferrer');
  } else if (channel === 'whatsapp' && phone) {
    window.open('https://wa.me/' + waPhone + '?text=' + encodeURIComponent(body), '_blank', 'noopener,noreferrer');
  } else if (channel === 'sms') {
    const r = await enviarSmsAlCliente({ clientId: client.id, telefono: client.phone, mensaje: body, lang });
    if (r.enviado) toast.success(lang === 'es' ? `SMS enviado a ${client.phone}` : `SMS sent to ${client.phone}`);
    else if (r.texto) toast.warn(r.texto);
  }
}

const CHANNEL_BTNS = [
  { id: 'email', icon: '📧', color: '#0099cc' },
  { id: 'whatsapp', icon: '💬', color: '#25d366' },
  { id: 'sms', icon: '📱', color: '#ffb700' },
];

const EMAIL_TEMPLATE_DEFAULTS = [
  { id: 'et4', subject: 'Happy Birthday {{firstName}}!', subjectEs: '¡Feliz Cumpleaños {{firstName}}!',
    body: 'Hi {{firstName}},\n\nJust wanted to wish you a wonderful birthday from all of us!\n\nBest,\n{{agentName}}',
    bodyEs: 'Hola {{firstName}},\n\n¡Solo quería desearte un feliz cumpleaños de parte de todo el equipo!\n\nSaludos,\n{{agentName}}' },
];

function Badge({ status, t, type = 'client' }) {
  const map = { active: 'dkt-bdg dkt-bdg-grn', pending: 'dkt-bdg dkt-bdg-amb', inactive: 'dkt-bdg dkt-bdg-dim', prospect: 'dkt-bdg dkt-bdg-cyn', referral: 'dkt-bdg dkt-bdg-ref' };
  const cls = map[status] || 'dkt-bdg dkt-bdg-dim';
  const label = t.statuses[status] || status;
  return (
    <span className={cls}>
      <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'currentColor', display: 'inline-block' }} />
      {label}
    </span>
  );
}

function CopiedBtn({ link, label, es }) {
  const [copied, setCopied] = useState(false);
  return (
    <button onClick={() => { navigator.clipboard?.writeText(link).catch(() => {}); setCopied(true); setTimeout(() => setCopied(false), 2000); }} className="dkt-copy">
      {copied
        ? <><Check size={11} style={{ color: 'var(--c-green,#00ff88)' }} />{es ? '¡Copiado!' : 'Copied!'}</>
        : <><Copy size={11} />{label}</>}
    </button>
  );
}

/**
 * Icono de copiar junto a un dato de la ficha (Lissette 2026-08-13: "tener el
 * ícono ahí de una vez para copiar", en vez de subrayar con el mouse).
 *
 * Acusa recibo en el propio botón — un check verde por un segundo — y no con
 * un toast: estos botones se repiten por toda la ficha y una tanda de toasts
 * sería peor que no avisar de nada.
 *
 * REGLA: copia EXACTAMENTE lo que ya está en pantalla y nada más. Nunca pide
 * al servidor un dato sin enmascarar para meterlo en el portapapeles — si el
 * SSN se muestra como ***-**-1234, eso es lo que se copia.
 */
function CopyBtn({ value, label, lang = 'es', size = 12, style }) {
  const [done, setDone] = useState(false);
  const es = lang === 'es';
  const txt = String(value ?? '').trim();
  // "--" es el marcador de "sin dato" de la ficha; no hay nada que copiar.
  if (!txt || txt === '--') return null;
  const what = label ? `${es ? 'Copiar' : 'Copy'} ${label}` : (es ? 'Copiar' : 'Copy');
  return (
    <button
      type="button"
      className="dkt-copy-ic"
      style={style}
      title={done ? (es ? '¡Copiado!' : 'Copied!') : what}
      aria-label={what}
      onClick={(e) => {
        e.stopPropagation();
        Promise.resolve(navigator.clipboard?.writeText(txt))
          .then(() => { setDone(true); setTimeout(() => setDone(false), 1400); })
          .catch(() => {});
      }}
    >
      {done
        ? <Check size={size} style={{ color: 'var(--c-green,#00ff88)' }} />
        : <Copy size={size} />}
    </button>
  );
}

// HTML-escape user-controlled values before they go into `document.write`.
// The print window inherits the opener's origin (`app.deskte.com`) and
// could read `window.opener.__deskteAuth.getAccessToken` — so a stored XSS
// payload in any client field (notes, firstName from a bad CSV import,
// dependent name, etc.) would otherwise execute in the authenticated
// session's origin and exfiltrate the bearer token. Closed by audit fix
// C3 (2026-05-20).
function escapeHtmlAttr(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// Excel export via SheetJS (lazy-loaded from CDN so the main bundle stays
// small). Mirror of the helper in deskte-full.jsx so the "Excel" button on
// the client detail page works without a top-level import — the original
// reference in this file was unbound and threw on click.
async function exportToExcel(data, filename, sheetName) {
  const XLSX = await import('https://cdn.sheetjs.com/xlsx-0.20.3/package/xlsx.mjs');
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName || 'Data');
  XLSX.writeFile(wb, filename);
}

// Full rich client profile printer. Mirrors the version in deskte-full.jsx
// so the "Print" button on the client detail page renders the complete
// ficha — personal info, spouse, dependents, policies, documents, notes —
// instead of the old simplified fallback that only showed name + email +
// policies. Lissette regression 2026-05-20: "el botón de print no está
// sacando la ficha completa". The two copies share the same shape; if you
// change one, change both (or factor out into crm-app/printers/).
function printClientFicha(client, policies, docs, lang, brand) {
  if (typeof window === 'undefined') return;
  const es = lang === 'es';
  // Branding: agency name first, agent display name second. If neither is
  // set (logged out, demo, legacy caller) fall back to plain "Insurance
  // Agency". Logo is rendered only when an agency uploaded one; the URL
  // is treated as opaque and embedded as <img src=…> — no fallback.
  const brandAgency = (brand && brand.agencyName) ? String(brand.agencyName) : (es?'Agencia de Seguros':'Insurance Agency');
  const brandAgent  = (brand && brand.agentName)  ? String(brand.agentName)  : '';
  const brandLogo   = (brand && brand.agencyLogoUrl) ? String(brand.agencyLogoUrl) : '';
  // Pin date-only strings ('YYYY-MM-DD') to LOCAL midnight; otherwise
  // new Date('2026-06-01') parses as UTC and renders one day early in
  // Florida (UTC-4/-5) on the exported PDF. Mirrors utils.fmt.
  const fmt = d => { if(!d) return '—'; const dt = /^\d{4}-\d{2}-\d{2}$/.test(d) ? new Date(d+'T00:00:00') : new Date(d); return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString('en-US',{year:'numeric',month:'short',day:'numeric'}); };
  const na = '—';
  const h = escapeHtmlAttr;
  // CSP NOTE (root cause Lissette never got the bordered ficha across many
  // sessions): the SPA's CSP is `style-src-elem 'self'` (inline <style> blocks
  // BLOCKED) but `style-src-attr 'unsafe-inline'` (inline style="" attributes
  // ALLOWED). The print window opens about:blank and INHERITS that CSP, so any
  // <style>…</style> we wrote was silently dropped → every version rendered as
  // unstyled plain text. Fix: NO <style> block — every rule lives in an inline
  // `style="…"` attribute, which the CSP permits. @media print is unavailable
  // inline, so break-inside:avoid / color-adjust go on the elements directly.
  const CADJ = '-webkit-print-color-adjust:exact;print-color-adjust:exact';
  const S = {
    body:  `font-family:'Segoe UI',system-ui,sans-serif;color:#1e293b;padding:32px 40px;line-height:1.5;font-size:13px;${CADJ}`,
    header:'display:flex;align-items:flex-start;justify-content:space-between;border-bottom:3px solid #0e7490;padding-bottom:14px;margin-bottom:18px',
    sec:   `border:1.5px solid #0f172a;border-radius:8px;overflow:hidden;margin:0 0 16px;break-inside:avoid;${CADJ}`,
    secH:  `background:#0e7490;color:#fff;font-size:13px;font-weight:700;padding:7px 12px;${CADJ}`,
    table: 'width:100%;border-collapse:collapse',
    th:    `background:#e2e8f0;text-align:left;padding:7px 10px;font-size:11px;color:#0f172a;font-weight:700;border:1px solid #cbd5e1;vertical-align:top;${CADJ}`,
    td:    'padding:7px 10px;border:1px solid #cbd5e1;font-size:12px;vertical-align:top',
    empty: 'padding:10px 12px;color:#94a3b8;font-size:12px;font-style:italic',
    notes: 'padding:10px 14px;font-size:12px;white-space:pre-wrap',
    footer:'margin-top:20px;padding-top:9px;border-top:1px solid #94a3b8;font-size:9px;color:#94a3b8;display:flex;justify-content:space-between',
  };
  // Colored status pill, fully inline (CSP-safe). Unknown status → neutral.
  const BADGE = {
    active:    'background:#dcfce7;color:#15803d;border-color:#86efac',
    pending:   'background:#fef3c7;color:#92400e;border-color:#fcd34d',
    inactive:  'background:#f1f5f9;color:#64748b;border-color:#cbd5e1',
    prospect:  'background:#e0f2fe;color:#0369a1;border-color:#7dd3fc',
    referral:  'background:#d1fae5;color:#047857;border-color:#6ee7b7',
    cancelled: 'background:#fee2e2;color:#b91c1c;border-color:#fca5a5',
  };
  const badge = (k, label) => `<span style="display:inline-block;padding:2px 10px;border-radius:100px;font-size:10px;font-weight:700;border:1px solid #cbd5e1;${CADJ};${BADGE[k]||BADGE.inactive}">${label}</span>`;
  const statusMap = {active:es?'Activo':'Active',pending:es?'Pendiente':'Pending',inactive:es?'Inactivo':'Inactive',prospect:es?'Prospecto':'Prospect',referral:es?'Referido':'Referral'};
  const immigMap = {us_citizen:es?'Ciudadano':'US Citizen',permanent_resident:es?'Residente Permanente':'Permanent Resident',cuban_haitian_entrant:es?'Entrante cubano/haitiano (parole)':'Cuban/Haitian entrant (parole)',visa_holder:es?'Titular de Visa':'Visa Holder',undocumented:es?'Indocumentado':'Undocumented',daca:'DACA',tps:'TPS',asylee:es?'Asilado / Refugiado':'Asylee / Refugee',work_permit:es?'Permiso de Trabajo (EAD)':'Work Permit (EAD)',pending:es?'En Proceso':'Pending',other:es?'Otro':'Other'};
  const pols = (policies||[]).filter(p=>p.clientId===client.id);
  const clientDocs = (docs||[]).filter(d=>d.clientId===client.id);
  const sp = client.spouse || {};
  const deps = client.dependents || [];
  const w = window.open('','_blank','width=900,height=700');
  if(!w)return;
  // Defense in depth: severs window.opener so the print window cannot
  // reach the parent's __deskteAuth bearer even if the escape ever slips.
  try { w.opener = null; } catch {}
  // row/row2 don't auto-escape because some cells embed legitimate inline
  // HTML (badges, <strong>). Callers MUST pre-escape user values via h().
  const row = (label, val) => `<tr><th style="${S.th};width:16%">${label}</th><td style="${S.td}">${val || na}</td></tr>`;
  const row2 = (l1, v1, l2, v2) => `<tr><th style="${S.th};width:16%">${l1}</th><td style="${S.td};width:34%">${v1 || na}</td><th style="${S.th};width:16%">${l2}</th><td style="${S.td}">${v2 || na}</td></tr>`;
  // The address fields exist under two name conventions in different code
  // paths — the API returns `address/city/state/zipCode`, the legacy form
  // wrote `addressStreet/addressCity/addressState/addressZip`. Try both
  // so the ficha shows the address regardless of which path populated it.
  const addressStr = [
    client.addressStreet || client.address,
    client.addressCity || client.city,
    client.addressState || client.state,
    client.addressZip || client.zipCode,
  ].filter(Boolean).join(', ');
  // Referral metadata uses the same dual-name pattern.
  const refFirst = client.refFirstName || client.referredByFirstName;
  const refLast = client.refLastName || client.referredByLastName || '';
  const refPhone = client.refPhone || client.referredByPhone;
  const refLine = refFirst ? h(`${refFirst} ${refLast}${refPhone?(' ('+refPhone+')'):''}`.trim()) : '';
  // SSN comes from the API as `ssnMasked` (already `***-**-1234`) or as a
  // simple `hasSsn` boolean. We never see the full SSN here — reveal is a
  // separate PIN-gated round-trip — so the ficha shows the masked form.
  const primarySsn = h(client.ssnMasked || (client.hasSsn ? '***-**-****' : na));
  const spouseSsn = h(sp.ssnMasked || (sp.ssnLast4 ? '***-**-' + sp.ssnLast4 : na));
  // Colored status pill for a policy row. Known statuses get a class +
  // localized label; anything unrecognized falls back to the escaped raw
  // value so we never blank out an unusual status.
  const polBadge = (s) => {
    const map = {
      active:    { k: 'active',    l: es ? 'Activa'    : 'Active' },
      cancelled: { k: 'cancelled', l: es ? 'Cancelada' : 'Cancelled' },
      canceled:  { k: 'cancelled', l: es ? 'Cancelada' : 'Cancelled' },
      pending:   { k: 'pending',   l: es ? 'Pendiente' : 'Pending' },
      inactive:  { k: 'inactive',  l: es ? 'Inactiva'  : 'Inactive' },
      expired:   { k: 'inactive',  l: es ? 'Vencida'   : 'Expired' },
    };
    const m = map[String(s || '').toLowerCase()];
    return m ? badge(m.k, m.l) : (h(s) || na);
  };
  const TH = (c) => `<th style="${S.th}">${c}</th>`;
  const TD = (c) => `<td style="${S.td}">${c}</td>`;
  const sec = (title, inner) => `<div style="${S.sec}"><div style="${S.secH}">${title}</div>${inner}</div>`;
  const empty = (txt) => `<div style="${S.empty}">${txt}</div>`;
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${h(client.firstName)} ${h(client.lastName)} — ${h(brandAgency)}</title></head>
<body style="margin:0;${S.body}">
<div style="${S.header}"><div style="display:flex;align-items:center;gap:12px">${brandLogo?`<img src="${h(brandLogo)}" alt="${h(brandAgency)}" style="width:auto;height:64px;max-width:220px;object-fit:contain;display:block;flex-shrink:0">`:''}<div><div style="font-size:19px;font-weight:800;color:#0e7490;letter-spacing:-0.01em;line-height:1.1">${h(brandAgency)}</div>${brandAgent?`<div style="font-size:11px;color:#64748b;margin-top:2px">${h(brandAgent)}</div>`:''}<span style="font-size:9px;color:#64748b;text-transform:uppercase;letter-spacing:0.15em;font-weight:700;margin-top:3px;display:block">${es?'Ficha Completa del Cliente':'Complete Client Profile'}</span></div></div><div style="text-align:right;font-size:11px;color:#64748b">${es?'Impreso':'Printed'}: ${new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'})}</div></div>

${sec(`1. ${es?'Información Personal':'Personal Information'}`, `<table style="${S.table}">
${row2(es?'Nombre':'First Name',`<strong>${h(client.firstName)}</strong>`,es?'Apellido':'Last Name',`<strong>${h(client.lastName)}</strong>`)}
${row2(es?'Teléfono':'Phone',h(client.phone),'Email',h(client.email))}
${row2(es?'Fecha de Nacimiento':'Date of Birth',fmt(client.dob),es?'Estado Civil':'Marital Status',h(client.maritalStatus))}
${row2(es?'Idioma Preferido':'Preferred Language',client.preferredLang==='spanish'?(es?'Español':'Spanish'):(es?'Inglés':'English'),es?'Estado del Cliente':'Client Status',badge(client.status||'active',h(statusMap[client.status]||client.status)))}
${row2(es?'Dirección':'Address',h(addressStr),es?'Condado':'County',h(client.county))}
${row2(es?'Ingresos del Primario':'Primary Income',h(client.annualIncome),es?'Empleador':'Employer',h(client.employer))}
${row2('SSN',primarySsn,es?'Estatus Migratorio':'Immigration Status',h(immigMap[client.immigrationStatus]||client.immigrationStatus))}
${row2(es?'Tamaño del Hogar':'Household Size',client.householdSize?(h(client.householdSize)+' '+(es?'personas':'persons')):'',es?'Miembros Asegurados':'Insured Members',h(String(countInsuredMembers(client))))}
${(()=>{ const bt=countInsuredByType(client); const parts=POLICY_TYPES.filter(pt=>bt[pt.id]).map(pt=>`<span style="display:inline-block;margin:0 12px 2px 0;white-space:nowrap">${pt.icon||''} ${h(es?(pt.labelEs||pt.label):pt.label)}: <strong>${bt[pt.id]}</strong></span>`); return parts.length?`<tr><th style="${S.th};width:16%">${es?'Asegurados por Tipo':'Insured by Type'}</th><td colspan="3" style="${S.td}">${parts.join('')}</td></tr>`:''; })()}
${row2(es?'Referido por':'Referred By',refLine,es?'Creado':'Created',fmt(client.createdAt))}
</table>`)}

${sec(`2. ${es?'Cónyuge / Pareja':'Spouse / Partner'}`, sp.firstName?`<table style="${S.table}">
${row2(es?'Nombre':'First Name',h([sp.firstName,sp.middleName].filter(Boolean).join(' ')),es?'Apellido':'Last Name',h(sp.lastName))}
${row2(es?'Teléfono':'Phone',h(sp.phone),es?'Fecha de Nacimiento':'Date of Birth',fmt(sp.dob))}
${row2(es?'Empleador':'Employer',h(sp.employer),es?'Ingresos':'Income',h(sp.income))}
${row2(es?'Estatus Migratorio':'Immigration',h(immigMap[sp.immigrationStatus]||sp.immigrationStatus),'SSN',spouseSsn)}
</table>`:empty(es?'No registrado':'Not on file'))}

${sec(`3. ${es?'Dependientes':'Dependents'} (${deps.length})`, deps.length?`<table style="${S.table}">
<tr>${TH(es?'Nombre':'Name')}${TH(es?'Relación':'Relation')}${TH(es?'Fecha Nac.':'DOB')}${TH(es?'Empleador':'Employer')}${TH(es?'Ingresos':'Income')}${TH(es?'Inmig.':'Immig.')}${TH('SSN')}${TH(es?'Asegurado':'Insured')}</tr>
${deps.map(d=>`<tr>${TD(h([d.firstName,d.middleName,d.lastName].filter(Boolean).join(' ')))}${TD(h(d.relation)||na)}${TD(fmt(d.dob))}${TD(h(d.employer)||na)}${TD(h(d.income)||na)}${TD(h(immigMap[d.immigrationStatus]||d.immigrationStatus)||na)}${TD(h(d.ssnLast4?'***-**-'+d.ssnLast4:na))}${TD(memberHasCoverage(d)?(es?'Sí':'Yes'):(es?'No':'No'))}</tr>`).join('')}
</table>`:empty(es?'Sin dependientes registrados':'No dependents on file'))}

${sec(`4. ${es?'Pólizas':'Policies'} (${pols.length})`, pols.length?`<table style="${S.table}">
<tr>${TH(es?'Tipo':'Type')}${TH(es?'Compañía':'Carrier')}${TH(es?'Plan':'Plan')}${TH('# '+(es?'Póliza':'Policy'))}${TH(es?'ID de Miembro':'Member ID')}${TH(es?'Prima/Mes':'Premium/Mo')}${TH(es?'Estado':'Status')}${TH(es?'Inicio':'Effective')}${TH(es?'Renovación':'Renewal')}</tr>
${pols.map(p=>{
  // QUIEN VA ASEGURADO en esta poliza, en una fila debajo de la suya
  // (Lissette 2026-09-19: "las polizas no muestran tampoco los miembros en
  // esas polizas"). La ficha listaba a la familia por un lado y las polizas
  // por otro, y nunca decia que persona iba en que poliza — que es lo que se
  // mira cuando esto se imprime para la aseguradora o para el cliente.
  //
  // La regla se importa; NO se escribe aqui. Es la misma que usa la tarjeta de
  // la poliza en pantalla, asi que el papel y la pantalla no pueden decir
  // numeros distintos (E-296).
  const gente = aseguradosDeLaPoliza(p, client, deps, { titular: es?'Titular':'Primary', conyuge: es?'Conyuge':'Spouse' });
  const fila = `<tr>${TD(h((getPolicyType(p.type)?.label)||p.type))}${TD(h(p.carrier)||na)}${TD(h(p.plan)||na)}${TD(h(p.policyNumber)||na)}${TD(h(p.memberId)||na)}${TD(h(fmtMoney(p.monthlyPremium)))}${TD(polBadge(p.status))}${TD(fmt(p.effectiveDate))}${TD(fmt(p.renewalDate))}</tr>`;
  // Cero asegurados NO se calla: "Sin asegurados marcados" dice que el dato
  // esta vacio, mientras que no poner la fila se lee como que la poliza no
  // tiene a nadie por naturaleza (regla de oro 89).
  const texto = gente.length
    ? gente.map(x=>x.relation ? `${h(x.name)} <span style="color:#6b7280">(${h(x.relation)})</span>` : h(x.name)).join(' &middot; ')
    : `<span style="color:#9ca3af">${es?'Sin asegurados marcados en esta poliza':'No insured members marked on this policy'}</span>`;
  const etiqueta = `${es?'Asegurados':'Insured'}${gente.length?` (${gente.length})`:''}`;
  return fila + `<tr><td colspan="9" style="${S.td};padding-top:2px;padding-bottom:6px;font-size:9.5pt"><strong style="color:#374151">${etiqueta}:</strong> ${texto}</td></tr>`;
}).join('')}
</table>`:empty(es?'Sin pólizas':'No policies'))}

${sec(`5. ${es?'Documentos':'Documents'} (${clientDocs.length})`, clientDocs.length?`<table style="${S.table}">
<tr>${TH(es?'Nombre del Archivo':'File Name')}${TH(es?'Tipo':'Type')}${TH(es?'Requerido':'Required')}${TH(es?'Fecha de Subida':'Upload Date')}</tr>
${clientDocs.map(d=>`<tr>${TD(h(d.name))}${TD(h(d.type)||na)}${TD(d.required?(es?'Sí':'Yes'):(es?'No':'No'))}${TD(d.uploadedAt?fmt(d.uploadedAt):`<span style="color:#dc2626;font-weight:700">${es?'PENDIENTE':'PENDING'}</span>`)}</tr>`).join('')}
</table>`:empty(es?'Sin documentos':'No documents'))}

${client.notes?sec(`6. ${es?'Notas del Agente':'Agent Notes'}`,`<div style="${S.notes}">${h(client.notes)}</div>`):''}

<div style="${S.footer}"><span>${es?'CONFIDENCIAL':'CONFIDENTIAL'} — ${h(brandAgency)}${brandAgent?` · ${h(brandAgent)}`:''} — ${es?'Solo para uso interno':'Internal use only'}</span><span>ID: ${h(client.id)} | ${new Date().toLocaleTimeString('en-US')}</span></div>
</body></html>`;
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 600);
}

// Human label for a changed field, so the diff cards read "Dirección"
// not "address". Falls back to a prettified field name.
const FIELD_LABELS_ES = {
  firstName:'Nombre', lastName:'Apellido', email:'Email', phone:'Teléfono',
  phoneSecondary:'Teléfono 2', address:'Dirección', city:'Ciudad', state:'Estado',
  zipCode:'ZIP', dateOfBirth:'Fecha Nac.', preferredLanguage:'Idioma',
  source:'Origen', status:'Estado', maritalStatus:'Estado Civil',
  immigrationStatus:'Estatus Migratorio', employer:'Empleador',
  annualIncome:'Ingresos', householdIncome:'Ingreso del hogar', householdSize:'Tamaño Hogar', insuredMembers:'Miembros Asegurados',
  referredByFirstName:'Referido (Nombre)', referredByLastName:'Referido (Apellido)',
  referredByPhone:'Referido (Tel.)', spouseFirstName:'Cónyuge Nombre',
  spouseLastName:'Cónyuge Apellido', spouseDateOfBirth:'Cónyuge Fecha Nac.',
  spouseEmployer:'Cónyuge Empleador', spouseImmigrationStatus:'Cónyuge Estatus',
  spouseAnnualIncome:'Cónyuge Ingresos', tags:'Etiquetas',
  linkedParentId:'Vínculo (id)', linkedParentName:'Dependiente de',
  coverage:'Cobertura', dependents:'Dependientes', county:'Condado',
  employerPhone:'Tel. Empleador',
  driveUrl:'Carpeta', spousePhone:'Cónyuge Teléfono', spouseEmail:'Cónyuge Email',
  spouseEmployerPhone:'Cónyuge Tel. Empleador',
  employmentType:'Tipo de Empleo', employmentDesc:'Descripción de Empleo',
  spouseEmploymentType:'Cónyuge Tipo de Empleo', spouseEmploymentDesc:'Cónyuge Descripción de Empleo',
};
const FIELD_LABELS_EN = {
  firstName:'First Name', lastName:'Last Name', email:'Email', phone:'Phone',
  phoneSecondary:'Phone 2', address:'Address', city:'City', state:'State',
  zipCode:'ZIP', dateOfBirth:'DOB', preferredLanguage:'Language',
  source:'Source', status:'Status', maritalStatus:'Marital Status',
  immigrationStatus:'Immigration', employer:'Employer', annualIncome:'Income', householdIncome:'Household income',
  householdSize:'Household Size', insuredMembers:'Insured Members',
  referredByFirstName:'Referrer First', referredByLastName:'Referrer Last',
  referredByPhone:'Referrer Phone', spouseFirstName:'Spouse First',
  spouseLastName:'Spouse Last', spouseDateOfBirth:'Spouse DOB',
  spouseEmployer:'Spouse Employer', spouseImmigrationStatus:'Spouse Immigration',
  spouseAnnualIncome:'Spouse Income', tags:'Tags',
  linkedParentId:'Link (id)', linkedParentName:'Dependent of',
  coverage:'Coverage', dependents:'Dependents', county:'County',
  employerPhone:'Employer Phone',
  driveUrl:'Folder', spousePhone:'Spouse Phone', spouseEmail:'Spouse Email',
  spouseEmployerPhone:'Spouse Employer Phone',
  employmentType:'Employment Type', employmentDesc:'Job Description',
  spouseEmploymentType:'Spouse Employment Type', spouseEmploymentDesc:'Spouse Job Description',
};
function fieldLabel(f, lang) {
  const m = lang === 'es' ? FIELD_LABELS_ES : FIELD_LABELS_EN;
  if (m[f]) return m[f];
  // Dotted paths from the structured diff: "dependents.Ana Perez.immigrationStatus".
  // Label the LAST segment from the map and keep the owner as a prefix, so the
  // reader sees "Ana Perez -> Estatus Migratorio" instead of a raw path.
  const raw = String(f || '');
  if (raw.includes('.')) {
    const parts = raw.split('.');
    const leaf = parts[parts.length - 1];
    const owner = parts.slice(0, -1).join(' ');
    const leafLabel = m[leaf] || leaf.replace(/([A-Z])/g, ' $1').replace(/^\w/, (c) => c.toUpperCase()).trim();
    return `${owner} - ${leafLabel}`;
  }
  return raw.replace(/([A-Z])/g, ' $1').replace(/[._]/g, ' ').replace(/^\w/, (c) => c.toUpperCase()).trim();
}

// Coded values must not reach the reader raw. The History diff printed the
// stored code — "permanent_resident -> us_citizen" — which is exactly the
// "no se ve bien" Lissette reported (2026-07-21). These maps already existed
// for the profile view; History just never used them. Matched on the LAST
// path segment so "dependents.Ana Perez.immigrationStatus" resolves too.
function auditValueLabel(field, value, lang) {
  if (value === '' || value == null) return value;
  const es = lang === 'es';
  const leaf = String(field || '').split('.').pop();
  const MAPS = {
    immigrationStatus: {
      us_citizen: es ? 'Ciudadano' : 'US Citizen',
      permanent_resident: es ? 'Residente Permanente' : 'Permanent Resident',
      cuban_haitian_entrant: es ? 'Entrante cubano/haitiano (parole)' : 'Cuban/Haitian entrant (parole)',
      visa_holder: es ? 'Titular de Visa' : 'Visa Holder',
      undocumented: es ? 'Indocumentado' : 'Undocumented',
      daca: 'DACA', tps: 'TPS',
      asylee: es ? 'Asilado / Refugiado' : 'Asylee / Refugee',
      work_permit: es ? 'Permiso de Trabajo (EAD)' : 'Work Permit (EAD)',
      pending: es ? 'En Proceso' : 'Pending',
      other: es ? 'Otro' : 'Other',
    },
    maritalStatus: {
      single: es ? 'Soltero(a)' : 'Single',
      married: es ? 'Casado(a)' : 'Married',
      divorced: es ? 'Divorciado(a)' : 'Divorced',
      widowed: es ? 'Viudo(a)' : 'Widowed',
      separated: es ? 'Separado(a)' : 'Separated',
      domestic_partner: es ? 'Pareja de Hecho' : 'Domestic Partner',
    },
    // Client statuses AND policy statuses share the `status` field name. The
    // policy enum arrives upper-case from the backend, which is why History
    // showed "Activo -> CANCELLED" — one side mapped, the other raw.
    status: {
      active: es ? 'Activo' : 'Active', ACTIVE: es ? 'Activo' : 'Active',
      inactive: es ? 'Inactivo' : 'Inactive', INACTIVE: es ? 'Inactivo' : 'Inactive',
      prospect: es ? 'Prospecto' : 'Prospect', PROSPECT: es ? 'Prospecto' : 'Prospect',
      referral: es ? 'Referido' : 'Referral', REFERRAL: es ? 'Referido' : 'Referral',
      cancelled: es ? 'Cancelada' : 'Cancelled', CANCELLED: es ? 'Cancelada' : 'Cancelled',
      pending: es ? 'Pendiente' : 'Pending', PENDING: es ? 'Pendiente' : 'Pending',
      grace: es ? 'En gracia' : 'Grace period', GRACE: es ? 'En gracia' : 'Grace period',
      expired: es ? 'Vencida' : 'Expired', EXPIRED: es ? 'Vencida' : 'Expired',
      lapsed: es ? 'Caducada' : 'Lapsed', LAPSED: es ? 'Caducada' : 'Lapsed',
      terminated: es ? 'Terminada' : 'Terminated', TERMINATED: es ? 'Terminada' : 'Terminated',
    },
    preferredLang: { es: es ? 'Español' : 'Spanish', en: es ? 'Inglés' : 'English' },
    preferredLanguage: { es: es ? 'Español' : 'Spanish', en: es ? 'Inglés' : 'English' },
  };
  MAPS.spouseImmigrationStatus = MAPS.immigrationStatus;
  // Sentinels the backend writes when a whole dependent appears/disappears.
  // Language-neutral on the wire so the audit row reads correctly for an EN
  // and an ES viewer of the same agency.
  if (value === '__added__') return es ? 'Agregado' : 'Added';
  if (value === '__removed__') return es ? 'Eliminado' : 'Removed';
  const map = MAPS[leaf];
  const hit = map && map[String(value)];
  if (hit) return hit;
  // Booleans from the coverage diff read as "true"/"false" otherwise.
  if (value === true || value === 'true') return es ? 'Sí' : 'Yes';
  if (value === false || value === 'false') return 'No';
  return value;
}

// Pretty-prints ActivityLog.details. The backend writes details as a free-form
// JSON object (e.g. { fields: ["email", "phone"] } for client.updated). Render
// fields as a comma-joined list, drop empty objects, fall back to JSON.stringify
// for anything else so nothing is hidden from the audit reader.
//
// LA IDENTIDAD DE LA PÓLIZA YA NO SALE DE AQUÍ: vive en
// `crm-app/identidadDePoliza.js` y las dos pestañas la pintan siempre. Estaba
// dentro de esta función, que solo se llama cuando NO hay diferencias que
// enseñar, así que la fila que más la necesitaba —la del cambio— era la única
// que se quedaba sin ella (Lissette 2026-09-13).
function formatDetails(details, lang) {
  if (!details || typeof details !== 'object') return null;
  const es = lang === 'es';
  // Client merge — show the absorbed name in plain language instead of
  // the raw {mergedFrom,...} JSON that used to leak through (Lissette
  // flagged it as "se ve muy feo esos codigo").
  if (details.mergedName) {
    return es ? `Absorbió a "${details.mergedName}"` : `Absorbed "${details.mergedName}"`;
  }
  // Los campos modificados, cuando los hay.
  const campos = (Array.isArray(details.fields) && details.fields.length)
    ? `${es ? 'Campos modificados:' : 'Fields updated:'} ${details.fields.map((f) => fieldLabel(f, lang)).join(', ')}`
    : '';
  if (campos) return campos;
  if (details.reason) {
    return `${es ? 'Motivo:' : 'Reason:'} ${details.reason}`;
  }
  // Que archivo. `formatDetails` no sabia dibujar `{ name }`, asi que una fila
  // de documento decia que habia pasado algo pero no CON QUE (Asniel Lopez,
  // 2026-09-18). El renombrado lleva los dos nombres.
  if (details.from && details.to) {
    return `${details.from} → ${details.to}`;
  }
  if (details.name) {
    return details.via
      ? `${details.name} · ${es ? 'subido por el cliente' : 'uploaded by the client'}`
      : String(details.name);
  }
  if (details.via) {
    return `${es ? 'Vía:' : 'Via:'} ${details.via}`;
  }
  // Anything else: render NOTHING. The action label (e.g. "Updated")
  // already conveys what happened — dumping raw JSON into the audit
  // reader is noise, never useful to the agent.
  return null;
}

// Single source of truth shared by BOTH tabs so they never overlap:
//   - History  shows ONLY these actions (and only with a real diff).
//   - Activity Log shows everything EXCEPT these (its strict inverse).
// Lissette: "historia es para cambios de datos; activity log es para
// lo del PIN/SSN, merge, doc, correo" — the two must not duplicate.
const DATA_CHANGE_ACTIONS = new Set([
  'updated', 'client.updated',
  'policy_created', 'policy_updated', 'policy_deleted',
  'policy.created', 'policy.updated', 'policy.deleted',
  // Tasks / notes / appointments / eligibility / agency-logo are EVENTS
  // (activity), not "data changes on the client profile". They go to the
  // Activity Log tab, NOT History. Per Lissette: "historia es para
  // cuando cambie de direccion, poliza, ingreso... activity log es
  // cuando yo o mi seat haga algun cambio, merge, subio doc, envio
  // correo".
]);
// These need an actual before→after diff to be meaningful in History.
// Lifecycle rows (policy added/removed) stay without one — their label
// alone is the information.
const DIFF_REQUIRED_ACTIONS = new Set([
  'updated', 'client.updated', 'policy_updated', 'policy.updated',
]);
// PHI read-access events (every SSN reveal logs `phi.<field>.decrypted`,
// plus ssn.reveal*) are required for the HIPAA audit trail and are still
// written to the DB / admin audit log — but Lissette doesn't want one
// row per *view* flooding this tab ("solo cuando se edita el pin, no
// cada vez que se coloque"). Hide them from the Activity Log UI; keep
// ssn.edited / ssn.edit_denied (an actual change, or a blocked one).
const isPhiAccessEvent = (action) => {
  const a = String(action || '');
  // client.viewed is a HIPAA §164.312(b) access-audit row (one per user per
  // client per hour). It lives in the immutable DB log for compliance, but
  // per Lissette it must NOT flood this tab "cada vez que se consulte".
  return a.startsWith('phi.') || a === 'ssn.reveal' || a === 'ssn.reveal_denied' || a === 'client.viewed';
};

// Drop change rows whose value is a non-scalar (dependents, spouse).
// The backend stringified those to "[object Object]" — pure noise that
// rendered as "Dependents [object Object] → [object Object]".
function renderableChanges(details) {
  if (!details || !Array.isArray(details.changes)) return [];
  const ok = (v) => {
    if (v == null) return true;
    if (typeof v === 'object') return false;
    // Reject backend-stringified objects, including the array-joined form
    // "[object Object], [object Object]" (dependents/spouse lists) — the
    // old `!== '[object Object]'` only caught the single-object case.
    return !String(v).includes('[object Object]');
  };
  // Drop rows where BOTH sides are empty. A policy's `type_details` is an
  // object, so the backend diff records it as null → null and the card
  // rendered as two blank boxes "— → —": a visible row that says nothing,
  // always sitting at the top (Lissette 2026-07-22). Filtering here also
  // cleans up the rows already written to the append-only table.
  const empty = (v) => v == null || String(v).trim() === '';
  return details.changes
    .filter((c) => ok(c.from) && ok(c.to))
    .filter((c) => !(empty(c.from) && empty(c.to)));
}

export function ChangeHistoryTab({ clientId, lang }) {
  // Backend-driven history. Replaces the legacy `history` prop that only
  // carried the in-memory "last change" the SPA had observed since reload.
  // The endpoint is capped at 1000 rows server-side which is enough to
  // cover years of edits without paginating.
  const [items, setItems] = useState(null); // null = loading, [] = empty
  const [err, setErr] = useState(null);
  // Calendar filter. The audit log is retained 6 years (HIPAA), so a
  // client can accumulate years of rows — let the agent narrow to a
  // period instead of scrolling everything. Empty = show all.
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  useEffect(() => {
    let cancelled = false;
    if (!clientId) { setItems([]); return; }
    setItems(null);
    setErr(null);
    listEntityHistory('client', clientId, { limit: 1000 })
      .then(({ activity }) => {
        if (cancelled) return;
        // History = ONLY data changes to the client/profile (address,
        // income, policy, carrier changed X → Y). Everything else —
        // Created, merge, SSN/PHI access, doc upload, email sent — is
        // an EVENT and lives in the Activity Log tab, not here
        // (Lissette: "historia es para cuando cambie de direccion,
        // poliza, ingreso, compania de seguro... activity log es
        // cuando yo o mi seat haga algun cambio, merge, subio doc,
        // envio correo"). Whitelist is safer than a growing blacklist:
        // show only modification actions. `created` is intentionally
        // OUT — a record being born is a lifecycle event, not a data
        // change, and seeing "Created" here confused the user.
        // Keep only data-change actions, and for the ones that need a
        // diff, only when there's a renderable before→after (object-junk
        // and legacy diff-less rows are dropped — that was the empty
        // "✏️ Updated" card the user flagged as "un cuadro que no son").
        // Una fila que SOLO retuvo campos (el formulario traía datos y no se
        // escribió ninguno porque la ficha ya estaba llena) no tiene diff y
        // aun así es la más importante de enseñar: es la prueba de que no se
        // sobrescribió nada. Sin esta excepción, el caso de la aplicación de
        // vida seguiría siendo invisible en el Historial.
        const keptOnly = (d) => Array.isArray(d?.keptFields) && d.keptFields.length > 0;
        setItems((activity || []).filter((a) =>
          DATA_CHANGE_ACTIONS.has(a.action) &&
          (!DIFF_REQUIRED_ACTIONS.has(a.action) || renderableChanges(a.details).length > 0 || keptOnly(a.details)),
        ));
      })
      .catch((e) => {
        if (cancelled) return;
        setErr(e.message || (lang === 'es' ? 'Error al cargar el historial' : 'Failed to load history'));
        setItems([]);
      });
    return () => { cancelled = true; };
  }, [clientId, lang]);

  const fmtDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      + ' ' + d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  if (items === null) {
    return <div style={{ color: 'var(--c-text3,#45688a)', fontSize: '.8rem', textAlign: 'center', padding: '2rem' }}>
      {lang === 'es' ? 'Cargando historial…' : 'Loading history…'}
    </div>;
  }
  if (err) {
    return <div style={{ color: 'var(--c-red,#ff3d6b)', fontSize: '.8rem', textAlign: 'center', padding: '2rem' }}>{err}</div>;
  }
  if (items.length === 0) {
    return <div style={{ color: 'var(--c-text3,#45688a)', fontSize: '.8rem', textAlign: 'center', padding: '2rem' }}>
      {lang === 'es' ? 'Sin historial de cambios' : 'No change history'}
    </div>;
  }

  // Calendar range filter (inclusive). `toDate` covers the whole day.
  const fromTs = fromDate ? new Date(fromDate + 'T00:00:00').getTime() : null;
  const toTs = toDate ? new Date(toDate + 'T23:59:59.999').getTime() : null;
  const filtered = items.filter((h) => {
    const t = new Date(h.createdAt).getTime();
    if (fromTs != null && t < fromTs) return false;
    if (toTs != null && t > toTs) return false;
    return true;
  });
  const es = lang === 'es';
  const lbl = { display: 'block', fontSize: '.58rem', color: 'var(--c-text3,#45688a)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 3, fontFamily: 'var(--font-mono)' };
  const inp = { background: 'var(--c-surface2,#112538)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 7, padding: '.38rem .55rem', color: 'var(--c-text,#c8dff0)', fontSize: '.76rem', fontFamily: 'var(--font-body)', outline: 'none', colorScheme: 'dark' };
  const calendarBar = (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '.6rem', flexWrap: 'wrap', background: 'var(--c-surface,#0d1c2e)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 10, padding: '.6rem .75rem' }}>
      <span style={{ fontSize: '.72rem', color: 'var(--c-text2,#7aa3c0)', fontWeight: 600, alignSelf: 'center' }}>📅 {es ? 'Filtrar por fecha' : 'Filter by date'}</span>
      <div>
        <label style={lbl}>{es ? 'Desde' : 'From'}</label>
        <DateField value={fromDate} max={toDate || undefined} onChange={(e) => setFromDate(e.target.value)} style={inp} />
      </div>
      <div>
        <label style={lbl}>{es ? 'Hasta' : 'To'}</label>
        <DateField value={toDate} min={fromDate || undefined} onChange={(e) => setToDate(e.target.value)} style={inp} />
      </div>
      {(fromDate || toDate) && (
        <button type="button" onClick={() => { setFromDate(''); setToDate(''); }}
          style={{ background: 'var(--c-surface3,#162d44)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 7, padding: '.38rem .7rem', color: 'var(--c-text2,#7aa3c0)', fontSize: '.72rem', fontWeight: 600, cursor: 'pointer' }}>
          {es ? 'Limpiar' : 'Clear'}
        </button>
      )}
    </div>
  );

  if (filtered.length === 0) {
    return <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
      {calendarBar}
      <div style={{ color: 'var(--c-text3,#45688a)', fontSize: '.8rem', textAlign: 'center', padding: '2rem' }}>
        {es ? 'Sin cambios en ese rango de fechas' : 'No changes in that date range'}
      </div>
    </div>;
  }

  return <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
    {calendarBar}
    <div style={{ fontSize: '.62rem', color: 'var(--c-text3,#45688a)', fontFamily: 'monospace', letterSpacing: '.06em', textTransform: 'uppercase', textAlign: 'right' }}>
      {es ? `${filtered.length} eventos` : `${filtered.length} events`}
    </div>
    {filtered.map((h) => {
      const meta = actionMeta(h.action, lang);
      const changes = renderableChanges(h.details);
      // La póliza de la que habla la fila. SIEMPRE, también cuando hay cuadros
      // de antes/ahora: antes vivía dentro de `formatDetails`, que solo se
      // llama cuando NO hay diferencias, así que la fila que más lo necesita
      // —"Póliza actualizada · Premium"— era justamente la que no lo decía
      // (Lissette 2026-09-13).
      const identidad = identidadDePoliza(h.details, lang);
      const details = changes.length > 0 ? null : formatDetails(h.details, lang);
      // Name WHAT changed next to the action label so the card reads
      // "Actualizado · Dirección, Idioma" instead of a bare "Updated".
      const fieldSummary = changes.length
        ? changes.map((c) => fieldLabel(c.field, lang)).join(', ')
        : '';
      return <div key={h.id} style={{ background: 'var(--c-surface,#0d1c2e)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ padding: '.5rem .75rem', background: 'var(--c-surface2,#112538)', borderBottom: '1px solid var(--c-border,#1a3550)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '.35rem' }}>
          <span style={{ fontSize: '.73rem', fontWeight: 700, color: 'var(--c-white,#eef6ff)' }}>
            <span style={{ marginRight: 4 }}>{meta.icon}</span>{meta.label}
            {fieldSummary && (
              <span style={{ fontWeight: 500, color: 'var(--c-text2,#7aa3c0)' }}> · {fieldSummary}</span>
            )}
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
            <span style={{ fontSize: '.65rem', color: 'var(--c-cyan,#00d4ff)', fontWeight: 600 }}>👤 {h.userName || '—'}</span>
            <span style={{ fontSize: '.62rem', color: 'var(--c-text3,#45688a)', fontFamily: 'monospace' }}>{fmtDate(h.createdAt)}</span>
          </div>
        </div>
        {/* Quién lo mandó. Un cambio que llegó por un formulario público NO
            lo hizo el agente que aparece arriba —ese es solo el dueño de la
            solicitud—, y confundirlos es justo lo que hizo imposible
            entender el caso de la aplicación de vida (2026-08-18). */}
        {h.details?.source && (
          <div style={{ padding: '.45rem .75rem', background: 'rgba(0,212,255,.06)', borderBottom: '1px solid var(--c-border,#1a3550)', fontSize: '.7rem', color: 'var(--c-text2,#7aa3c0)' }}>
            📨 {es
              ? `Lo envió el cliente desde ${h.details.source === 'intake' ? 'su inscripción' : 'su solicitud'}${h.details.submittedBy ? ` (${h.details.submittedBy})` : ''}, no un agente.`
              : `Submitted by the client through their ${h.details.source === 'intake' ? 'enrollment' : 'application'}${h.details.submittedBy ? ` (${h.details.submittedBy})` : ''}, not by an agent.`}
          </div>
        )}
        {/* Qué póliza es. Va ANTES de los cuadros de antes/ahora porque es el
            sujeto de la frase: "de esta póliza, cambió esto". */}
        {identidad && (
          <div style={{ padding: '.45rem .75rem', borderBottom: (changes.length > 0 || details) ? '1px solid var(--c-border,#1a3550)' : 'none', fontSize: '.72rem', color: 'var(--c-text,#c8dff0)', fontWeight: 600 }}>
            📄 {identidad}
          </div>
        )}
        {/* Before → after diff cards (the format Lissette had before
            the backend rewrite lost it). One row per changed field. */}
        {changes.length > 0 && (
          // Original "cuadros grandes" format Lissette had: each changed
          // field shows OLD (red) and NEW (green) side-by-side cards.
          <div style={{ padding: '.5rem .75rem', display: 'flex', flexDirection: 'column', gap: '.3rem' }}>
            {changes.map((c, i) => {
              const label = fieldLabel(c.field, lang);
              const fromLbl = auditValueLabel(c.field, c.from, lang);
              const toLbl = auditValueLabel(c.field, c.to, lang);
              const oldV = fromLbl === '' || fromLbl == null ? '—' : String(fromLbl);
              const newV = toLbl === '' || toLbl == null ? '—' : String(toLbl);
              return (
                <div key={i} style={{ marginBottom: '.4rem' }}>
                  <div style={{ fontSize: '.65rem', color: 'var(--c-text3,#45688a)', fontWeight: 600, marginBottom: '.2rem', textTransform: 'uppercase', letterSpacing: '.05em' }}>{label}</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '.4rem' }}>
                    <div style={{ background: 'rgba(255,61,107,.08)', border: '1px solid rgba(255,61,107,.2)', borderRadius: 7, padding: '.3rem .6rem' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                        <span style={{ fontSize: '.63rem', fontWeight: 700, color: 'var(--c-text,#c8dff0)' }}>{label}</span>
                        <span style={{ fontSize: '.55rem', fontWeight: 700, color: 'var(--c-red,#ff3d6b)', letterSpacing: '.06em' }}>{lang === 'es' ? 'ANTES' : 'OLD'}</span>
                      </div>
                      <div style={{ fontSize: '.72rem', color: 'var(--c-text2,#7aa3c0)' }}>{oldV}</div>
                    </div>
                    <div style={{ background: 'rgba(0,255,136,.08)', border: '1px solid rgba(0,255,136,.2)', borderRadius: 7, padding: '.3rem .6rem' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                        <span style={{ fontSize: '.63rem', fontWeight: 700, color: 'var(--c-text,#c8dff0)' }}>{label}</span>
                        <span style={{ fontSize: '.55rem', fontWeight: 700, color: 'var(--c-green,#00ff88)', letterSpacing: '.06em' }}>{lang === 'es' ? 'AHORA' : 'NEW'}</span>
                      </div>
                      <div style={{ fontSize: '.72rem', color: 'var(--c-text,#c8dff0)' }}>{newV}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {details && (
          <div style={{ padding: '.5rem .75rem', fontSize: '.72rem', color: 'var(--c-text2,#7aa3c0)', lineHeight: 1.5 }}>
            {details}
          </div>
        )}
        {/* El registro tiene un tope de cambios por fila (activity_logs es
            append-only y una fila gigante no se puede recortar después). Que
            el tope exista está bien; que recorte EN SILENCIO no: la tarjeta
            se leería como completa. Se dice cuántos quedaron fuera. */}
        {h.details?.changesOmitted > 0 && (
          <div style={{ padding: '.45rem .75rem', borderTop: '1px solid var(--c-border,#1a3550)', fontSize: '.7rem', color: 'var(--c-text3,#45688a)' }}>
            {es
              ? `Este guardado cambió ${h.details.changesOmitted} campo(s) más de los que caben en un registro; no se listan aquí.`
              : `This save changed ${h.details.changesOmitted} more field(s) than one log row holds; they are not listed here.`}
          </div>
        )}
        {/* Lo que el formulario trajo y NO se guardó por estar la ficha ya
            llena. Es la prueba de la regla "solo lo vacío": sin enseñarlo,
            "no se sobrescribió nada" es una promesa que nadie puede
            comprobar. El valor que mandó el cliente vive en la solicitud. */}
        {Array.isArray(h.details?.keptFields) && h.details.keptFields.length > 0 && (
          <div style={{ padding: '.5rem .75rem', background: 'rgba(255,183,0,.06)', borderTop: '1px solid var(--c-border,#1a3550)', fontSize: '.7rem', color: 'var(--c-text2,#7aa3c0)', lineHeight: 1.5 }}>
            <strong style={{ color: 'var(--c-amber,#ffb700)' }}>{es ? 'No se sobrescribió:' : 'Kept unchanged:'}</strong>{' '}
            {h.details.keptFields.map((f) => fieldLabel(f, lang)).join(', ')}.{' '}
            {es
              ? 'El cliente mandó otro valor para esos campos; se conservó el de la ficha. Lo que envió está en su solicitud.'
              : 'The client sent a different value for those fields; the ficha kept its own. What they sent is in their application.'}
          </div>
        )}
      </div>;
    })}
  </div>;
}

export const CSS_STR=`:root{--sc-blue:#3b82f6;--sc-blue-bg:rgba(59,130,246,.18);--sc-green:#10b981;--sc-green-bg:rgba(16,185,129,.18);--sc-amber:#f59e0b;--sc-amber-bg:rgba(245,158,11,.18);--sc-purple:#8b5cf6;--sc-purple-bg:rgba(139,92,246,.18);--sc-red:#ef4444;--sc-red-bg:rgba(239,68,68,.18);--sc-gray:#6b7280;--sc-gray-bg:rgba(107,114,128,.18);--c-bg:#070d14;--c-bg2:#0b1622;--c-bg3:#0f1f30;--c-surface:#0d1c2e;--c-surface2:#112538;--c-surface3:#162d44;--c-border:#1a3550;--c-border2:#1f3f60;--c-cyan:#00d4ff;--c-cyan2:#00b4d8;--c-cyan-dim:rgba(0,212,255,.12);--c-green:#00ff88;--c-green-dim:rgba(0,255,136,.1);--c-amber:#ffb700;--c-amber-dim:rgba(255,183,0,.12);--c-red:#ff3d6b;--c-red-dim:rgba(255,61,107,.12);--c-text:#c8dff0;--c-text2:#7aa3c0;--c-text3:#45688a;--c-white:#eef6ff;--font-display:'Oxanium',sans-serif;--font-body:'Sora',sans-serif;--font-mono:'JetBrains Mono',monospace;} [data-theme="dark"][data-palette="sunset"]{ --c-cyan:#FF6B35;--c-cyan2:#F72585;--c-cyan-dim:rgba(255,107,53,.12);--c-green:#FFBE0B;--c-green-dim:rgba(255,190,11,.1);--c-bg:#0f0a16;--c-bg2:#1a1028;--c-bg3:#241838;--c-surface:#160e24;--c-surface2:#1e1430;--c-surface3:#2a1c40;--c-border:#3a2255;--c-border2:#4a3070;--c-text:#e8d4f0;--c-text2:#b090c8;--c-text3:#7a5599;--c-white:#f5eaff;} [data-theme="light"]{ --c-bg:#f0ece6;--c-bg2:#e6e0d8;--c-bg3:#dbd4ca; --c-surface:#f8f5f0;--c-surface2:#f0ece6;--c-surface3:#e6e0d8; --c-border:#d6cfc6;--c-border2:#c9c1b6; --c-cyan:#0078a8;--c-cyan2:#006690;--c-cyan-dim:rgba(0,120,168,.08); --c-green:#059669;--c-green-dim:rgba(5,150,105,.08); --c-amber:#d97706;--c-amber-dim:rgba(217,119,6,.1); --c-red:#dc2626;--c-red-dim:rgba(220,38,38,.08); --c-text:#1a2332;--c-text2:#5a6b7d;--c-text3:#8b95a3; --c-white:#1a2332; } [data-theme="light"][data-palette="sunset"]{ --c-cyan:#c2410c;--c-cyan2:#9a3412;--c-cyan-dim:rgba(194,65,12,.08); --c-green:#b45309;--c-green-dim:rgba(180,83,9,.08); --c-amber:#92400e;--c-amber-dim:rgba(146,64,14,.08); --c-red:#b91c1c;--c-red-dim:rgba(185,28,28,.08); --sc-blue:#c2410c;--sc-blue-bg:rgba(194,65,12,.07); --sc-green:#15803d;--sc-green-bg:rgba(21,128,61,.07); --sc-amber:#92400e;--sc-amber-bg:rgba(146,64,14,.07); --sc-purple:#7e22ce;--sc-purple-bg:rgba(126,34,206,.07); --sc-red:#b91c1c;--sc-red-bg:rgba(185,28,28,.07); } [data-theme="light"][data-palette="sunset"] .dkt-sidebar{border-color:#f5e6d3!important;} [data-theme="light"][data-palette="sunset"] .dkt-header{background:rgba(255,250,245,.95)!important;} [data-theme="light"][data-palette="sunset"] .dkt-btn-p{background:#c2410c!important;} [data-theme="light"][data-palette="sunset"] .dkt-nav-btn.act{background:rgba(194,65,12,.06)!important;border-color:rgba(194,65,12,.15)!important;} [data-theme="light"][data-palette="ocean"]{ --c-cyan:#0369a1;--c-cyan2:#075985;--c-cyan-dim:rgba(3,105,161,.08); --c-green:#047857;--c-green-dim:rgba(4,120,87,.08); --c-amber:#b45309;--c-amber-dim:rgba(180,83,9,.08); --sc-blue:#0369a1;--sc-blue-bg:rgba(3,105,161,.07); --sc-green:#047857;--sc-green-bg:rgba(4,120,87,.07); --sc-amber:#b45309;--sc-amber-bg:rgba(180,83,9,.07); --sc-purple:#6d28d9;--sc-purple-bg:rgba(109,40,217,.07); --sc-red:#b91c1c;--sc-red-bg:rgba(185,28,28,.07); } [data-theme="light"][data-palette="ocean"] .dkt-btn-p{background:#0369a1!important;} [data-theme="light"][data-palette="ocean"] .dkt-nav-btn.act{background:rgba(3,105,161,.06)!important;border-color:rgba(3,105,161,.15)!important;} [data-theme="light"] .dkt-shell::before{background-image:linear-gradient(rgba(0,120,168,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(0,120,168,.025) 1px,transparent 1px);} [data-theme="light"] .dkt-shell::after{background:linear-gradient(90deg,transparent,var(--c-cyan,#0078a8),var(--c-green,#059669),var(--c-cyan,#0078a8),transparent);} [data-theme="light"] .dkt-header{background:rgba(240,236,230,.95);} [data-theme="light"] .dkt-login{background:var(--c-bg,#070d14);} [data-theme="light"] .dkt-inp{background:var(--c-surface,#0d1c2e);color:var(--c-white,#eef6ff);} [data-theme="light"] .dkt-inp:focus{background:#fff;} [data-theme="light"] .dkt-stat{box-shadow:0 2px 12px rgba(0,0,0,.06);} [data-theme="light"] .dkt-card{box-shadow:0 2px 8px rgba(0,0,0,.05);} [data-theme="light"] .dkt-modal{background:var(--c-bg2,#0b1622);} .dkt-shell{min-height:100vh;background:var(--c-bg,#070d14);font-family:var(--font-body);color:var(--c-text,#c8dff0);display:flex;position:relative;} .dkt-shell::before{content:'';position:fixed;inset:0;pointer-events:none;z-index:0;background-image:linear-gradient(rgba(0,212,255,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(0,212,255,.025) 1px,transparent 1px);background-size:48px 48px;} .dkt-shell::after{content:'';position:fixed;top:0;left:0;right:0;height:2px;z-index:100;background:linear-gradient(90deg,transparent,var(--c-cyan,#00d4ff),var(--c-green,#00ff88),var(--c-cyan,#00d4ff),transparent);animation:dkt-scan 5s ease-in-out infinite;} @keyframes dkt-scan{0%,100%{opacity:.3}50%{opacity:.9}} .dkt-sidebar{position:fixed;inset-y:0;left:0;z-index:30;width:218px;background:var(--c-bg2,#0b1622);border-right:1px solid var(--c-border,#1a3550);display:flex;flex-direction:column;transform:translateX(-100%);transition:transform .2s;} @media(min-width:1024px){.dkt-sidebar{position:static;transform:none;}} .dkt-sidebar.open{transform:translateX(0);} .dkt-logo-wrap{padding:1rem .875rem;border-bottom:1px solid var(--c-border,#1a3550);display:flex;align-items:center;gap:.7rem;} .dkt-logo-icon{width:34px;height:34px;border-radius:9px;background:linear-gradient(135deg,var(--c-cyan2),#004e9a);display:flex;align-items:center;justify-content:center;box-shadow:0 0 14px rgba(0,180,216,.3);flex-shrink:0;} .dkt-logo-name{font-family:var(--font-display);font-size:.9rem;font-weight:700;color:var(--c-white,#eef6ff);letter-spacing:.02em;} .dkt-logo-ver{font-size:.58rem;color:var(--c-text3,#45688a);letter-spacing:.12em;text-transform:uppercase;font-family:var(--font-mono);} .dkt-nav{flex:1;padding:.5rem;overflow-y:auto;display:flex;flex-direction:column;gap:2px;} .dkt-nav-btn{width:100%;display:flex;align-items:center;gap:.6rem;padding:.52rem .7rem;border-radius:8px;font-size:.76rem;font-weight:500;font-family:var(--font-body);border:none;cursor:pointer;transition:all .15s;color:var(--c-text2,#7aa3c0);background:transparent;text-align:left;position:relative;} .dkt-nav-btn:hover{color:var(--c-cyan,#00d4ff);background:var(--c-cyan-dim);} .dkt-nav-btn.act{color:var(--c-cyan,#00d4ff);background:var(--c-cyan-dim);border:1px solid rgba(0,212,255,.18);box-shadow:0 0 10px rgba(0,212,255,.07);} .dkt-nav-btn.act::before{content:'';position:absolute;left:0;top:22%;bottom:22%;width:2px;background:var(--c-cyan,#00d4ff);border-radius:2px;box-shadow:0 0 6px var(--c-cyan,#00d4ff);} .dkt-nav-bdg{margin-left:auto;font-size:.6rem;font-weight:700;font-family:var(--font-mono);padding:.1rem .4rem;border-radius:100px;} .dkt-foot{padding:.65rem;border-top:1px solid var(--c-border,#1a3550);display:flex;flex-direction:column;gap:.35rem;} .dkt-user-row{display:flex;align-items:center;gap:.55rem;background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);border-radius:8px;padding:.45rem .6rem;} .dkt-av-sm{border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:.62rem;font-weight:700;color:#000;flex-shrink:0;border:1.5px solid rgba(0,212,255,.2);} .dkt-uname{font-size:.7rem;font-weight:600;color:var(--c-white,#eef6ff);} .dkt-urole{font-size:.58rem;color:var(--c-text3,#45688a);font-family:var(--font-mono);} .dkt-lng{display:flex;align-items:center;justify-content:center;gap:.4rem;font-size:.7rem;color:var(--c-text2,#7aa3c0);background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);border-radius:7px;padding:.38rem;cursor:pointer;font-family:var(--font-body);transition:all .2s;} .dkt-lng:hover{color:var(--c-cyan,#00d4ff);border-color:rgba(0,212,255,.25);} .dkt-clk{display:flex;align-items:center;gap:.4rem;background:rgba(0,255,136,.07);border:1px solid rgba(0,255,136,.18);border-radius:7px;padding:.38rem .65rem;font-size:.68rem;color:var(--c-green,#00ff88);font-weight:600;cursor:pointer;} .dkt-header{position:sticky;top:0;z-index:10;background:rgba(7,13,20,.9);backdrop-filter:blur(16px);border-bottom:1px solid var(--c-border,#1a3550);padding:.65rem 1.25rem;display:flex;align-items:center;gap:.7rem;} .dkt-header-tag{flex:1;font-size:.68rem;color:var(--c-text3,#45688a);font-family:var(--font-mono);letter-spacing:.06em;} .dkt-hbtn{display:flex;align-items:center;gap:.35rem;font-size:.7rem;background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);color:var(--c-text2,#7aa3c0);padding:.38rem .7rem;border-radius:7px;cursor:pointer;font-family:var(--font-body);transition:all .2s;} .dkt-hpills{display:flex;align-items:center;background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);border-radius:10px;padding:2px;gap:0;} .dkt-hpill{display:flex;align-items:center;justify-content:center;width:32px;height:28px;background:transparent;border:none;border-radius:8px;cursor:pointer;transition:all .2s;color:var(--c-text2,#7aa3c0);} .dkt-hpill:hover{background:var(--c-cyan-dim,rgba(0,212,255,.12));} .dkt-hpill-sep{width:1px;height:16px;background:var(--c-border,#1a3550);flex-shrink:0;} .dkt-hbtn:hover{color:var(--c-cyan,#00d4ff);border-color:rgba(0,212,255,.25);} .dkt-hmenu{display:none;align-items:center;justify-content:center;background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);color:var(--c-text2,#7aa3c0);padding:.38rem;border-radius:7px;cursor:pointer;} @media(max-width:1023px){.dkt-hmenu{display:flex;}} .dkt-main{flex:1;display:flex;flex-direction:column;min-width:0;} .dkt-content{flex:1;padding:1.25rem;overflow:auto;} .dkt-inner{max-width:1200px;margin:0 auto;} .dkt-card{background:var(--c-surface,#0d1c2e);border:1px solid var(--c-border,#1a3550);border-radius:14px;transition:border-color .2s;position:relative;} .dkt-card:hover{border-color:var(--c-border2,#1f3f60);} .dkt-stat{background:var(--c-surface,#0d1c2e);border:1px solid var(--c-border,#1a3550);border-radius:14px;padding:1.1rem;position:relative;overflow:hidden;transition:all .25s;} .dkt-stat:hover{border-color:var(--c-border2,#1f3f60);transform:translateY(-2px);box-shadow:0 8px 30px rgba(0,0,0,.3);} .dkt-stat-glow{position:absolute;top:-20px;right:-20px;width:80px;height:80px;border-radius:50%;filter:blur(30px);opacity:.15;background:var(--sc-blue);pointer-events:none;} .dkt-sc[data-sc="bg-blue-500"] .dkt-stat-glow{background:var(--c-cyan);} .dkt-sc[data-sc="bg-emerald-500"] .dkt-stat-glow{background:var(--c-green);} .dkt-sc[data-sc="bg-amber-500"] .dkt-stat-glow{background:var(--c-cyan);} .dkt-sc[data-sc="bg-purple-500"] .dkt-stat-glow{background:var(--c-green);} .dkt-sc[data-sc="bg-red-500"] .dkt-stat-glow{background:var(--c-red);} .dkt-sc[data-sc="bg-gray-500"] .dkt-stat-glow{background:var(--sc-gray);} .dkt-stat-icon{width:34px;height:34px;border-radius:9px;display:flex;align-items:center;justify-content:center;margin-bottom:.75rem;} .dkt-stat-val{font-family:var(--font-display);font-size:2rem;font-weight:800;line-height:1;margin-bottom:.2rem;} .dkt-stat-lbl{font-size:.68rem;color:var(--c-text3,#45688a);font-weight:500;text-transform:uppercase;letter-spacing:.07em;font-family:var(--font-mono);} .dkt-sec-title{font-family:var(--font-display);font-size:1.1rem;font-weight:700;color:var(--c-white,#eef6ff);} .dkt-sec-sub{font-size:.7rem;color:var(--c-text3,#45688a);font-family:var(--font-mono);letter-spacing:.04em;margin-top:.15rem;} .dkt-input-lbl{display:block;font-size:.66rem;font-weight:600;color:var(--c-text3,#45688a);text-transform:uppercase;letter-spacing:.08em;margin-bottom:.38rem;font-family:var(--font-mono);} .dkt-inp{width:100%;background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);border-radius:9px;padding:.62rem .875rem;font-size:.84rem;color:var(--c-text,#c8dff0);font-family:var(--font-body);transition:all .2s;outline:none;} .dkt-inp:focus{border-color:var(--c-cyan,#00d4ff);background:var(--c-surface3,#162d44);box-shadow:0 0 0 3px rgba(0,212,255,.08);} .dkt-inp::placeholder{color:var(--c-text3,#45688a);} .dkt-inp option{background:var(--c-surface2,#112538);color:var(--c-text,#c8dff0);} .dkt-btn-p{display:inline-flex;align-items:center;justify-content:center;gap:.4rem;background:linear-gradient(135deg,#0099cc,#0055aa);color:#fff;font-weight:700;font-size:.79rem;padding:.62rem 1.2rem;border-radius:9px;border:none;cursor:pointer;font-family:var(--font-body);transition:all .2s;box-shadow:0 4px 14px rgba(0,153,204,.22);letter-spacing:.02em;} .dkt-btn-p:hover{box-shadow:0 6px 22px rgba(0,153,204,.38);transform:translateY(-1px);filter:brightness(1.1);} .dkt-btn-s{display:inline-flex;align-items:center;justify-content:center;gap:.4rem;background:var(--c-surface2,#112538);color:var(--c-text,#c8dff0);font-weight:600;font-size:.79rem;padding:.62rem 1.2rem;border-radius:9px;border:1px solid var(--c-border,#1a3550);cursor:pointer;font-family:var(--font-body);transition:all .2s;} .dkt-btn-s:hover{border-color:var(--c-cyan,#00d4ff);color:var(--c-cyan,#00d4ff);} .dkt-btn-d{display:inline-flex;align-items:center;gap:.35rem;background:var(--c-red-dim);color:var(--c-red,#ff3d6b);font-weight:600;font-size:.75rem;padding:.48rem .9rem;border-radius:8px;border:1px solid rgba(255,61,107,.2);cursor:pointer;font-family:var(--font-body);transition:all .2s;} .dkt-btn-d:hover{background:rgba(255,61,107,.18);} .dkt-btn-g{display:inline-flex;align-items:center;gap:.32rem;background:transparent;color:var(--c-text2,#7aa3c0);font-size:.73rem;font-weight:500;padding:.38rem .68rem;border-radius:7px;border:1px solid var(--c-border,#1a3550);cursor:pointer;font-family:var(--font-body);transition:all .2s;} .dkt-btn-g:hover{color:var(--c-cyan,#00d4ff);border-color:rgba(0,212,255,.25);background:var(--c-cyan-dim);} .dkt-bdg{display:inline-flex;align-items:center;gap:.3rem;padding:.18rem .52rem;border-radius:100px;font-size:.63rem;font-weight:700;font-family:var(--font-mono);} .dkt-bdg-grn{background:rgba(0,255,136,.1);color:#00ff88;border:1px solid rgba(0,255,136,.15);} .dkt-bdg-amb{background:rgba(255,183,0,.12);color:#ffb700;border:1px solid rgba(255,183,0,.15);} .dkt-bdg-red{background:rgba(255,61,107,.12);color:#ff3d6b;border:1px solid rgba(255,61,107,.15);} .dkt-bdg-cyn{background:rgba(0,212,255,.1);color:#00d4ff;border:1px solid rgba(0,212,255,.15);} .dkt-bdg-dim{background:var(--ci-bg-04);color:var(--c-text3,#45688a);border:1px solid var(--ci-bg-06);} .dkt-av{border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-family:var(--font-display);color:#000;flex-shrink:0;border:1.5px solid rgba(0,212,255,.2);} .dkt-overlay{position:fixed;inset:0;background:rgba(0,0,0,.8);backdrop-filter:blur(8px);z-index:50;display:flex;align-items:center;justify-content:center;padding:1rem;} .dkt-modal{background:var(--c-bg2,#0b1622);border:1px solid var(--c-border2,#1f3f60);border-radius:16px;box-shadow:0 24px 80px rgba(0,0,0,.6),0 0 40px rgba(0,212,255,.04);width:100%;max-height:90vh;overflow-y:auto;} .dkt-mhdr{display:flex;align-items:center;justify-content:space-between;padding:1rem 1.2rem;border-bottom:1px solid var(--c-border,#1a3550);background:var(--c-surface,#0d1c2e);position:sticky;top:0;z-index:10;} .dkt-mtitle{font-family:var(--font-display);font-size:.95rem;font-weight:700;color:var(--c-white,#eef6ff);} .dkt-mbody{padding:1.2rem;} .dkt-policy{background:var(--c-surface,#0d1c2e);border:1px solid var(--c-border,#1a3550);border-radius:12px;padding:.9rem;transition:all .2s;} .dkt-policy:hover{border-color:var(--c-border2,#1f3f60);} .dkt-policy.pc-p{border-color:rgba(0,212,255,.16);background:rgba(0,212,255,.04);} .dkt-policy.pc-p:hover{border-color:rgba(0,212,255,.32);} .dkt-phase{display:flex;align-items:flex-start;gap:.5rem;background:rgba(0,180,216,.07);border:1px solid rgba(0,180,216,.14);border-radius:9px;padding:.65rem .85rem;font-size:.73rem;color:var(--c-cyan2);} .dkt-hr{border:none;border-top:1px solid var(--c-border,#1a3550);margin:.7rem 0;} .dkt-search{background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);border-radius:9px;padding:.52rem .85rem;font-size:.8rem;color:var(--c-text,#c8dff0);width:100%;font-family:var(--font-body);outline:none;transition:all .2s;} .dkt-search:focus{border-color:var(--c-cyan,#00d4ff);box-shadow:0 0 0 3px rgba(0,212,255,.07);} .dkt-search::placeholder{color:var(--c-text3,#45688a);} .dkt-copy{display:inline-flex;align-items:center;gap:.32rem;font-size:.7rem;font-weight:500;padding:.32rem .65rem;border-radius:7px;background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);color:var(--c-text2,#7aa3c0);cursor:pointer;transition:all .2s;font-family:var(--font-body);} .dkt-copy:hover{color:var(--c-cyan,#00d4ff);border-color:rgba(0,212,255,.25);} .dkt-tab{background:transparent;border:1px solid var(--c-border,#1a3550);border-radius:8px;padding:.38rem .85rem;font-size:.73rem;font-weight:600;color:var(--c-text2,#7aa3c0);cursor:pointer;font-family:var(--font-body);transition:all .2s;} .dkt-tab.on{background:var(--c-cyan-dim);border-color:rgba(0,212,255,.28);color:var(--c-cyan,#00d4ff);} .dkt-tab:hover:not(.on){color:var(--c-text,#c8dff0);border-color:var(--c-border2,#1f3f60);} .dkt-mono{font-family:var(--font-mono);} .dkt-cyan-lbl{font-size:.62rem;font-weight:700;color:var(--c-cyan,#00d4ff);text-transform:uppercase;letter-spacing:.1em;font-family:var(--font-mono);} *::-webkit-scrollbar{width:12px;height:12px;}*::-webkit-scrollbar-track{background:rgba(0,0,0,.08);}*::-webkit-scrollbar-thumb{background:var(--c-border2,#1f3f60);border-radius:8px;border:2px solid transparent;background-clip:padding-box;min-height:40px;}*::-webkit-scrollbar-thumb:hover{background:var(--c-cyan,#00d4ff);background-clip:padding-box;border:2px solid transparent;}*::-webkit-scrollbar-corner{background:transparent;}*{scrollbar-width:auto;scrollbar-color:var(--c-border2,#1f3f60) transparent;} .dkt-login{min-height:100vh;background:var(--c-bg,#070d14);display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden;} .dkt-login::before{content:'';position:absolute;inset:0;background-image:linear-gradient(rgba(0,212,255,.035) 1px,transparent 1px),linear-gradient(90deg,rgba(0,212,255,.035) 1px,transparent 1px);background-size:48px 48px;} .dkt-login-orb1{position:absolute;width:500px;height:500px;border-radius:50%;background:var(--c-cyan2);filter:blur(120px);opacity:.07;top:-150px;right:-100px;} .dkt-login-orb2{position:absolute;width:350px;height:350px;border-radius:50%;background:var(--c-green,#00ff88);filter:blur(100px);opacity:.06;bottom:-100px;left:-50px;} .dkt-login-box{position:relative;z-index:1;background:var(--c-bg2,#0b1622);border:1px solid var(--c-border2,#1f3f60);border-radius:20px;padding:2rem;width:100%;max-width:400px;box-shadow:0 32px 80px rgba(0,0,0,.5),0 0 60px rgba(0,212,255,.04);} .dkt-pin-btn{width:66px;height:66px;border-radius:12px;background:var(--c-surface2,#112538);border:1px solid var(--c-border,#1a3550);color:var(--c-text,#c8dff0);font-size:1.2rem;font-weight:600;cursor:pointer;font-family:var(--font-display);transition:all .15s;} .dkt-pin-btn:hover{border-color:var(--c-cyan,#00d4ff);color:var(--c-cyan,#00d4ff);background:var(--c-cyan-dim);} .dkt-pin-dot{width:13px;height:13px;border-radius:50%;border:1.5px solid var(--c-border2,#1f3f60);transition:all .15s;} .dkt-pin-dot.fil{background:var(--c-cyan,#00d4ff);border-color:var(--c-cyan,#00d4ff);box-shadow:0 0 8px var(--c-cyan,#00d4ff);} /* -- Tailwind dark overrides - applied inside .dkt-shell -- */ .dkt-shell .bg-white{background:var(--c-surface,#0d1c2e)!important} .dkt-shell .bg-gray-50{background:var(--c-surface2,#112538)!important} .dkt-shell .bg-gray-100{background:var(--c-surface3,#162d44)!important} .dkt-shell .bg-slate-50{background:var(--c-bg,#070d14)!important} .dkt-shell .text-gray-900{color:var(--c-white,#eef6ff)!important} .dkt-shell .text-gray-800{color:var(--c-white,#eef6ff)!important} .dkt-shell .text-gray-700{color:var(--c-text,#c8dff0)!important} .dkt-shell .text-gray-600{color:var(--c-text,#c8dff0)!important} .dkt-shell .text-gray-500{color:var(--c-text2,#7aa3c0)!important} .dkt-shell .text-gray-400{color:var(--c-text3,#45688a)!important} .dkt-shell .border-gray-200{border-color:var(--c-border,#1a3550)!important} .dkt-shell .border-gray-300{border-color:var(--c-border2,#1f3f60)!important} .dkt-shell .hover\:bg-gray-100:hover{background:var(--c-surface3,#162d44)!important} .dkt-shell .hover\:bg-gray-200:hover{background:var(--c-surface2,#112538)!important} .dkt-shell .hover\:text-gray-900:hover{color:var(--c-white,#eef6ff)!important} .dkt-shell .divide-gray-200>*+*{border-color:var(--c-border,#1a3550)!important} .dkt-shell .bg-blue-600{background:linear-gradient(135deg,#0099cc,#0055aa)!important;color:#fff!important} .dkt-shell .hover\:bg-blue-500:hover{filter:brightness(1.15)} .dkt-shell .text-blue-600{color:var(--c-cyan,#00d4ff)!important} .dkt-shell .text-blue-500{color:var(--c-cyan,#00d4ff)!important} .dkt-shell .text-blue-400{color:var(--c-cyan2)!important} .dkt-shell .text-blue-300{color:var(--c-cyan,#00d4ff)!important} .dkt-shell .bg-blue-50{background:var(--c-cyan-dim)!important} .dkt-shell .bg-blue-500\/10,.dkt-shell .bg-blue-600\/10{background:var(--c-cyan-dim)!important} .dkt-shell .bg-blue-600\/40{background:rgba(0,153,204,.4)!important} .dkt-shell .border-blue-200,.dkt-shell .border-blue-300,.dkt-shell .border-blue-400{border-color:rgba(0,212,255,.3)!important} .dkt-shell .text-blue-700{color:var(--c-cyan,#00d4ff)!important} .dkt-shell .text-emerald-400,.dkt-shell .text-emerald-500,.dkt-shell .text-emerald-600{color:var(--c-green,#00ff88)!important} .dkt-shell .bg-emerald-500\/10,.dkt-shell .bg-emerald-500\/15,.dkt-shell .bg-emerald-50{background:var(--c-green-dim)!important} .dkt-shell .border-emerald-200{border-color:rgba(0,255,136,.2)!important} .dkt-shell .text-amber-400,.dkt-shell .text-amber-500{color:var(--c-amber,#ffb700)!important} .dkt-shell .bg-amber-500\/10,.dkt-shell .bg-amber-500\/15,.dkt-shell .bg-amber-50{background:var(--c-amber-dim)!important} .dkt-shell .border-amber-200,.dkt-shell .border-amber-300{border-color:rgba(255,183,0,.2)!important} .dkt-shell .text-red-400,.dkt-shell .text-red-500{color:var(--c-red,#ff3d6b)!important} .dkt-shell .bg-red-500\/10,.dkt-shell .bg-red-500\/15,.dkt-shell .bg-red-50{background:var(--c-red-dim)!important} .dkt-shell .border-red-300{border-color:rgba(255,61,107,.2)!important} .dkt-shell .bg-red-600{background:var(--c-red,#ff3d6b)!important;color:#fff!important} .dkt-shell .text-purple-400,.dkt-shell .text-purple-500{color:#c084fc!important} .dkt-shell .bg-purple-500\/10,.dkt-shell .bg-purple-500\/15,.dkt-shell .bg-purple-50{background:rgba(192,132,252,.1)!important} .dkt-shell .text-pink-400,.dkt-shell .text-pink-300{color:#f472b6!important} .dkt-shell .bg-pink-500\/10,.dkt-shell .bg-pink-500\/5{background:rgba(244,114,182,.08)!important} .dkt-shell .border-pink-500\/10{border-color:rgba(244,114,182,.12)!important} .dkt-shell .bg-slate-500\/15,.dkt-shell .bg-slate-50{background:var(--c-surface2,#112538)!important} .dkt-shell .text-slate-500{color:var(--c-text3,#45688a)!important} .dkt-shell input,.dkt-shell select,.dkt-shell textarea{background:var(--c-surface2,#112538)!important;color:var(--c-text,#c8dff0)!important;border-color:var(--c-border,#1a3550)!important} .dkt-shell input:focus,.dkt-shell select:focus,.dkt-shell textarea:focus{border-color:var(--c-cyan,#00d4ff)!important;outline:none!important;box-shadow:0 0 0 3px rgba(0,212,255,.08)!important} .dkt-shell input::placeholder,.dkt-shell textarea::placeholder{color:var(--c-text3,#45688a)!important} .dkt-shell select option{background:var(--c-surface2,#112538);color:var(--c-text,#c8dff0)} .dkt-shell .rounded-2xl{border-radius:14px} .dkt-shell .rounded-xl{border-radius:10px} .dkt-shell .shadow-sm,.dkt-shell .shadow-md,.dkt-shell .shadow-lg{box-shadow:0 4px 20px rgba(0,0,0,.3)!important} [data-theme="light"] .dkt-shell .bg-white{background:#f8f5f0!important} [data-theme="light"] .dkt-shell .bg-gray-50{background:#f0ece6!important} [data-theme="light"] .dkt-shell .bg-gray-100{background:#e6e0d8!important} [data-theme="light"] .dkt-shell .text-gray-900{color:#1a2332!important} [data-theme="light"] .dkt-shell .text-gray-700{color:#1a2332!important} [data-theme="light"] .dkt-shell .text-gray-500{color:#5a6b7d!important} [data-theme="light"] .dkt-shell .text-gray-400{color:#8b95a3!important} [data-theme="light"] .dkt-shell .border-gray-200{border-color:#d6cfc6!important} [data-theme="light"] .dkt-shell input,[data-theme="light"] .dkt-shell select,[data-theme="light"] .dkt-shell textarea{background:#f8f5f0!important;color:#1a2332!important;border-color:#d6cfc6!important} [data-theme="light"] .dkt-bdg-grn{background:rgba(5,150,105,.08)!important;color:#059669!important;border-color:rgba(5,150,105,.2)!important;} [data-theme="light"] .dkt-bdg-amb{background:rgba(217,119,6,.08)!important;color:#d97706!important;border-color:rgba(217,119,6,.2)!important;} [data-theme="light"] .dkt-bdg-red{background:rgba(220,38,38,.08)!important;color:#dc2626!important;border-color:rgba(220,38,38,.2)!important;} [data-theme="light"] .dkt-bdg-cyn{background:rgba(0,120,168,.08)!important;color:#0078a8!important;border-color:rgba(0,120,168,.2)!important;} [data-theme="light"] .dkt-bdg-dim{background:rgba(0,0,0,.04)!important;color:#8b95a3!important;border-color:rgba(0,0,0,.08)!important;} [data-theme="light"] .dkt-stat:hover{box-shadow:0 4px 16px rgba(0,0,0,.08)!important;} [data-theme="light"] .dkt-nav-btn.act{background:rgba(0,120,168,.06)!important;border-color:rgba(0,120,168,.15)!important;box-shadow:none!important;} [data-theme="light"] .dkt-nav-btn.act::before{box-shadow:none!important;} [data-theme="light"] .dkt-btn-p{background:#2563eb!important;box-shadow:0 2px 8px rgba(37,99,235,.2)!important;} [data-theme="light"] .dkt-sidebar{background:#f8f5f0!important;border-color:#d6cfc6!important;} [data-theme="light"] .dkt-foot{border-color:#d6cfc6!important;} [data-theme="light"] .dkt-user-row{background:#f0ece6!important;border-color:#d6cfc6!important;} [data-theme="light"] .dkt-overlay{background:rgba(0,0,0,.4)!important;} [data-theme="light"] .dkt-modal{background:#f8f5f0!important;border-color:#d6cfc6!important;} [data-theme="light"] .dkt-mhdr{background:#f0ece6!important;border-color:#d6cfc6!important;} [data-theme="light"] .dkt-login{background:#f0ece6!important;} [data-theme="light"] .dkt-login::before{background-image:none!important;} [data-theme="light"] .dkt-login-box{background:#f8f5f0!important;border-color:#d6cfc6!important;box-shadow:0 8px 30px rgba(0,0,0,.08)!important;} [data-theme="light"]{--sc-blue:#2563eb;--sc-blue-bg:rgba(37,99,235,.07);--sc-green:#059669;--sc-green-bg:rgba(5,150,105,.07);--sc-amber:#d97706;--sc-amber-bg:rgba(217,119,6,.07);--sc-purple:#7c3aed;--sc-purple-bg:rgba(124,58,237,.07);--sc-red:#dc2626;--sc-red-bg:rgba(220,38,38,.07);--sc-gray:#4b5563;--sc-gray-bg:rgba(75,85,99,.07);} [data-theme="light"] .dkt-stat-glow{display:none!important;} [data-theme="light"] .dkt-shell::before{opacity:.3!important;} [data-theme="light"] .dkt-shell::after{opacity:.4!important;} [data-theme="light"] .dkt-clk{background:rgba(5,150,105,.06)!important;border-color:rgba(5,150,105,.15)!important;color:#059669!important;} [data-theme="light"] .dkt-shell .shadow-sm,[data-theme="light"] .dkt-shell .shadow-md,[data-theme="light"] .dkt-shell .shadow-lg{box-shadow:0 2px 8px rgba(0,0,0,.06)!important} @media(max-width:480px){.lnd-desktop-nav{display:none!important;}} @media(max-width:480px){.dkt-hbtn-txt{display:none!important;} .dkt-hbtn{padding:.35rem .5rem!important;min-width:0!important;} .dkt-header-tag{display:none!important;} .dkt-stat-val{font-size:1.4rem!important;} .dkt-stat-lbl{font-size:.55rem!important;}}`;


// Compact one-line summary of a person's immigration document details
// (USCIS #, card #, category, expiration). Returns "" when nothing is on file.
function immDocsText(docs, es){
  const d = docs || {};
  return [
    d.uscisNumber && `USCIS ${d.uscisNumber}`,
    d.cardNumber && `${es?"Tarjeta":"Card"} ${d.cardNumber}`,
    d.category && `${es?"Cat.":"Cat."} ${d.category}`,
    d.expirationDate && `${es?"Vence":"Exp"} ${d.expirationDate}`,
  ].filter(Boolean).join(" · ");
}

export function ClientHousehold({client,t,lang,onEdit,policies=[]}){
  const es=lang==="es";
  const spouse=client?.spouse;
  const deps=client?.dependents||[];
  // Member NAME formatter (was named `fmt`, which shadowed the imported DATE
  // `fmt` and made the household DOB render "(sin nombre)" — Lissette
  // 2026-06-22). Renamed so `fmt(m.dob)` uses the real date formatter.
  const nm=m=>[m.firstName,m.middleName,m.lastName].filter(Boolean).join(' ')|| (es?"(sin nombre)":"(no name)");
  const age=dob=>{if(!dob)return'';const d=new Date(dob),n=new Date();return Math.floor((n-d)/31557600000)+'y';};
  // Household = cónyuge + dependientes (Lissette 2026-05-28: el titular NO va
  // aquí). Datos generales de cada miembro sin abrir Editar. Cada miembro lleva
  // su `_key` (el mismo que usa PolicyForm para marcar asegurados) para poder
  // cruzar con las pólizas y mostrar qué seguros tiene.
  const all=[
    ...(hasCurrentSpouse(client)?[{...spouse,_role:es?"Cónyuge":"Spouse",_key:"spouse"}]:[]),
    ...deps.map((d,i)=>({...d,_role:d.relation||(es?"Dependiente":"Dependent"),_key:d.id||("dep"+i)})),
  ];
  // Asegurados POR TIPO de póliza — incluye al titular. Lissette 2026-06-23:
  // el total "Miembros Asegurados" no se movía al marcar Vision/Dental a gente
  // ya cubierta por ACA (cuenta personas, no coberturas); quiere verlo por tipo.
  const byType=countInsuredByType(client);
  const insuredTypeRows=POLICY_TYPES.filter(pt=>byType[pt.id]);
  const insuredSummary=insuredTypeRows.length>0?(
    <div style={{marginBottom:".6rem",padding:".55rem .7rem",background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:9}}>
      <div style={{fontSize:".58rem",color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".06em",fontFamily:"var(--font-mono)",marginBottom:".4rem"}}>{es?"Asegurados por tipo (incluye titular)":"Insured by type (incl. primary)"}</div>
      <div style={{display:"flex",gap:".4rem",flexWrap:"wrap"}}>
        {insuredTypeRows.map(pt=>(
          <span key={pt.id} title={es?(pt.labelEs||pt.label):pt.label} style={{display:"inline-flex",alignItems:"center",gap:5,fontSize:".72rem",fontWeight:600,background:"var(--c-surface3,#162d44)",border:`1px solid ${(pt.color||"#45688a")}55`,color:"var(--c-text,#c8dff0)",padding:".18rem .55rem",borderRadius:100}}>
            <span>{pt.icon}</span>{es?(pt.labelEs||pt.label):pt.label}<strong style={{color:"var(--c-cyan,#00d4ff)",marginLeft:2}}>{byType[pt.id]}</strong>
          </span>
        ))}
      </div>
    </div>
  ):null;
  if(all.length===0)return <div style={{padding:"1rem"}}>{insuredSummary}<div style={{padding:"1.5rem",textAlign:"center",color:"var(--c-text3,#45688a)",fontSize:".8rem"}}>{es?"Sin miembros del hogar (cónyuge o dependientes)":"No household members (spouse or dependents)"}</div></div>;
  const lic=m=>[m.driverLicenseState,m.driverLicenseNumber].filter(Boolean).join(" ");
  // Texto de la persona listo para pegar fuera del CRM (portal de la
  // aseguradora, un correo, lo que sea). Arma EXACTAMENTE los mismos datos que
  // muestran las etiquetas de abajo — el SSN va enmascarado porque enmascarado
  // se ve — solo que con nombre de campo delante y uno por línea.
  const memberCopyText=(m)=>{
    const rows=[
      [es?"Fecha nac.":"DOB", m.dob?`${fmt(m.dob)}${age(m.dob)?` (${age(m.dob)})`:""}`:""],
      [es?"Teléfono":"Phone", m.phone],
      ["Email", m.email],
      [es?"Empleador":"Employer", m.employer],
      [es?"Tel. empleador":"Employer phone", m.employerPhone],
      [es?"Ingreso":"Income", m.income||m.annualIncome],
      // Los de mas (un segundo trabajo, 2026-10-27), uno por linea, y el total.
      ...(Array.isArray(m.otrosIngresos)?m.otrosIngresos:[]).map((f,j)=>[`${es?"Otro ingreso":"Other income"} ${j+1}`, [f.monto,f.empleador,tipoDeIngresoLegible(f.tipo,es?"es":"en")].filter(Boolean).join(" — ")]),
      ...((Array.isArray(m.otrosIngresos)&&m.otrosIngresos.length)?[[es?"Ingreso total":"Total income", dineroLegible(ingresoTotalDePersona(m.income||m.annualIncome, m.otrosIngresos))]]:[]),
      [es?"Lugar de nacimiento":"Place of birth", m.placeOfBirth],
      [es?"Licencia":"License", lic(m)],
      ["SSN", m.ssnMasked||(m.ssnLast4?`***-**-${m.ssnLast4}`:"")],
      [es?"Estatus":"Status", m.immigrationStatus?String(m.immigrationStatus).replace(/_/g," "):""],
      [es?"Documentos":"Documents", immDocsText(m.immigrationDocs,es)],
    ].filter(([,v])=>String(v??"").trim());
    return [`${nm(m)} — ${m._role}`, ...rows.map(([k,v])=>`${k}: ${v}`)].join("\n");
  };
  // Pólizas en las que el miembro está marcado como asegurado — por su `_key`
  // (cónyuge/dependiente) o por su nombre en la lista de "otros asegurados".
  const policiesFor=(m)=>{
    const mn=[m.firstName,m.lastName].filter(Boolean).join(" ").toLowerCase().trim();
    return (policies||[]).filter(p=>{
      const ids=Array.isArray(p.policyInsured)?p.policyInsured:[];
      if(ids.includes(m._key))return true;
      const extra=Array.isArray(p.policyInsuredExtra)?p.policyInsuredExtra:[];
      return mn && extra.some(n=>String(n||"").toLowerCase().trim()===mn);
    });
  };
  return <div style={{padding:"1rem"}}>{insuredSummary}{all.map((m,i)=>{
    const mPolicies=policiesFor(m);
    return <div key={i} style={{padding:".65rem .75rem",background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:9,marginBottom:".4rem"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:".4rem"}}>
      <div style={{display:"flex",alignItems:"center",gap:2,minWidth:0}}>
        <div style={{fontWeight:600,color:"var(--c-white,#eef6ff)",fontSize:".84rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{nm(m)}</div>
        {/* Copia la persona ENTERA, no solo el nombre: para pegarla en el
            portal de la aseguradora hacen falta la fecha y el resto. */}
        <CopyBtn value={memberCopyText(m)} label={es?"los datos de esta persona":"this person's details"} lang={lang} size={12}/>
      </div>
      <span style={{fontSize:".65rem",background:"var(--c-surface3,#162d44)",border:"1px solid var(--c-border,#1a3550)",color:"var(--c-text3,#45688a)",padding:".15rem .45rem",borderRadius:5,flexShrink:0}}>{m._role}</span>
    </div>
    <div style={{fontSize:".7rem",color:"var(--c-text2,#7aa3c0)",marginTop:3,display:"flex",gap:".75rem",flexWrap:"wrap"}}>
      {m.dob&&<span>🎂 {fmt(m.dob)} {age(m.dob)?`(${age(m.dob)})`:""}</span>}
      {m.phone&&<span>📱 {m.phone}</span>}
      {m.email&&<span>✉️ {m.email}</span>}
      {m.employer&&<span>💼 {m.employer}</span>}
      {m.employerPhone&&<span>☎️ {m.employerPhone}</span>}
      {(m.income||m.annualIncome)&&<span>💵 {m.income||m.annualIncome}</span>}
      {(Array.isArray(m.otrosIngresos)?m.otrosIngresos:[]).map((f,j)=><span key={`oi${j}`}>💵 {[f.monto,f.empleador].filter(Boolean).join(" · ")}</span>)}
      {Array.isArray(m.otrosIngresos)&&m.otrosIngresos.length>0&&<span title={es?"Ingreso principal más los otros ingresos de esta persona":"Main income plus this person's other incomes"}>Σ {es?"Total":"Total"}: <b>{dineroLegible(ingresoTotalDePersona(m.income||m.annualIncome, m.otrosIngresos))}</b></span>}
      {m.placeOfBirth&&<span>🌍 {m.placeOfBirth}</span>}
      {lic(m)&&<span>🪪 {lic(m)}</span>}
      {(m.ssnMasked||m.ssnLast4)&&<span>🔒 {m.ssnMasked||("***-**-"+m.ssnLast4)}</span>}
      {m.immigrationStatus&&<span style={{color:"var(--c-text3,#45688a)"}}>{String(m.immigrationStatus).replace(/_/g," ")}</span>}
      {immDocsText(m.immigrationDocs,es)&&<span>🛂 {immDocsText(m.immigrationDocs,es)}</span>}
    </div>
    {/* Qué seguros tiene este miembro — pólizas donde está asegurado. */}
    <div style={{marginTop:".5rem",display:"flex",gap:".35rem",flexWrap:"wrap",alignItems:"center"}}>
      <span style={{fontSize:".58rem",color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".06em",fontFamily:"var(--font-mono)"}}>{es?"Seguros:":"Insurance:"}</span>
      {mPolicies.length===0
        ? <span style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",fontStyle:"italic"}}>{es?"Ninguno asignado a esta persona":"None assigned to this person"}</span>
        : mPolicies.map(p=>{
            const pt=getPolicyType(p.type);
            return <span key={p.id} title={[p.carrier,p.plan].filter(Boolean).join(" · ")} style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".66rem",fontWeight:600,background:"var(--c-surface3,#162d44)",border:`1px solid ${(pt.color||"#45688a")}55`,color:"var(--c-text,#c8dff0)",padding:".12rem .5rem",borderRadius:100}}>
              <span>{pt.icon}</span>{es?(pt.labelEs||pt.label):pt.label}{p.carrier?<span style={{opacity:.65,fontWeight:400}}>· {p.carrier}</span>:null}
            </span>;
          })}
    </div>
  </div>;})}</div>;
}

// Read-only Health/Life view (Lissette 2026-05-28): the expanded ficha is
// editable in the form's Salud/Legal tab; this profile tab surfaces it for
// the WHOLE family (titular + cónyuge + dependientes) without opening Edit.
export function ClientHealthLife({client,lang}){
  const es=lang==="es";
  const fmtHeight=(inches)=>inches?`${Math.floor(inches/12)}'${inches%12}"`:null;
  const bundleText=(b)=>{
    if(!b) return null;
    const tags=Array.isArray(b.tags)?b.tags:[];
    const parts=[tags.join(", "), b.notes].filter(Boolean);
    return parts.length?parts.join(" — "):null;
  };
  const rowsFor=(d)=>{
    const r=[];
    // País de nacimiento + licencia son datos GENERALES (Household / encabezado),
    // ya no salen aquí (Lissette 2026-05-28). Health/Life = físico + médico + legal.
    const phys=[fmtHeight(d.heightInches), d.weightLbs?`${d.weightLbs} lb`:null].filter(Boolean).join(" · ");
    if(phys) r.push([es?"Estatura / Peso":"Height / Weight", phys]);
    // Solo se muestra si SE PREGUNTO. Vacio no significa "no fuma", asi que
    // pintar "No" cuando no hay dato seria inventarse una respuesta.
    if(d.smoker) r.push([es?"¿Fuma?":"Smoker?", d.smoker==="yes"?(es?"Sí":"Yes"):(es?"No":"No")]);
    if(d.hasDui) r.push(["DUI / DWI", d.duiDetails||(es?"Sí":"Yes")]);
    if(d.hasFelony) r.push([es?"Felonía":"Felony", d.felonyDetails||(es?"Sí":"Yes")]);
    if(d.hasTicket) r.push([es?"Multas / Infracciones":"Tickets / Violations", d.ticketDetails||(es?"Sí":"Yes")]);
    const med=bundleText(d.medicalConditions);
    if(med) r.push([es?"Condiciones médicas / medicamentos":"Medical conditions / meds", med]);
    const fam=bundleText(d.familyHealthHistory);
    if(fam) r.push([es?"Historial familiar de salud":"Family health history", fam]);
    return r;
  };
  // Completeness of the health ficha for one person. Measures the 4 health
  // fields this tab surfaces (height, weight, tobacco, medical conditions,
  // family history). El tabaco SI cuenta, al reves que las banderas legales:
  // tiene tres estados, asi que "no fuma" es una respuesta de verdad y se
  // distingue de "sin preguntar". Legal flags (DUI/felony/ticket) are excluded: "no DUI" is
  // indistinguishable from "not asked", so counting them would understate
  // a complete ficha. Returns filled/total + pct for the chip.
  const fichaStats=(d)=>{
    const has=(v)=>v!==undefined&&v!==null&&v!=="";
    const bundleHas=(b)=>!!(b&&((Array.isArray(b.tags)&&b.tags.length>0)||(b.notes&&String(b.notes).trim())));
    const checks=[has(d?.heightInches),has(d?.weightLbs),has(d?.smoker),bundleHas(d?.medicalConditions),bundleHas(d?.familyHealthHistory)];
    const filled=checks.filter(Boolean).length;
    return {filled,total:checks.length,pct:Math.round((filled/checks.length)*100)};
  };
  const name=(d,fallback)=>[d?.firstName,d?.middleName,d?.lastName].filter(Boolean).join(" ")||fallback;
  const spouse=client?.spouse;
  const deps=client?.dependents||[];
  const people=[
    {data:client,role:es?"Titular":"Head",label:name(client,es?"Titular":"Head"),icon:"👤"},
    ...(hasCurrentSpouse(client)?[{data:spouse,role:es?"Cónyuge":"Spouse",label:name(spouse,es?"Cónyuge":"Spouse"),icon:"💍"}]:[]),
    ...deps.map((d)=>({data:d,role:d.relation||(es?"Dependiente":"Dependent"),label:name(d,es?"Dependiente":"Dependent"),icon:"🧒"})),
  ];
  return <div style={{padding:"1rem",display:"flex",flexDirection:"column",gap:".75rem"}}>
    <div className="dkt-phase" style={{marginBottom:".25rem"}}>
      🏥 {es?"Datos de salud y legales de la familia (solo lectura). Para editar, usa el botón Editar → pestaña Salud/Legal.":"Family health & legal data (read-only). To edit, use Edit → Health/Legal tab."}
    </div>
    {people.map((p,i)=>{
      const rows=rowsFor(p.data||{});
      const fs=fichaStats(p.data||{});
      const fsColor=fs.pct===100?{c:"var(--c-green,#00ff88)",bg:"rgba(0,255,136,.1)",bd:"rgba(0,255,136,.2)"}:fs.pct>0?{c:"var(--c-amber,#ffb700)",bg:"rgba(255,183,0,.12)",bd:"rgba(255,183,0,.2)"}:{c:"var(--c-text3,#45688a)",bg:"var(--ci-bg-04)",bd:"var(--ci-bg-08)"};
      const fsLabel=fs.pct===100?(es?"Ficha completa":"Complete"):fs.pct===0?(es?"Sin datos":"No data"):`${fs.pct}% · ${fs.filled}/${fs.total}`;
      return <div key={i} style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:10,padding:".875rem"}}>
        <div style={{display:"flex",alignItems:"center",gap:".4rem",marginBottom:rows.length?".6rem":0}}>
          <span>{p.icon}</span>
          <span style={{fontWeight:700,color:"var(--c-white,#eef6ff)",fontSize:".84rem"}}>{p.label}</span>
          <span title={es?`Ficha de salud: ${fs.filled} de ${fs.total} campos`:`Health ficha: ${fs.filled} of ${fs.total} fields`} style={{marginLeft:"auto",display:"inline-flex",alignItems:"center",gap:".3rem",fontSize:".6rem",fontWeight:700,fontFamily:"var(--font-mono)",color:fsColor.c,background:fsColor.bg,border:`1px solid ${fsColor.bd}`,padding:".12rem .45rem",borderRadius:100}}>
            {fs.pct===100?"✓":"●"} {fsLabel}
          </span>
          <span style={{fontSize:".62rem",background:"var(--c-surface3,#162d44)",border:"1px solid var(--c-border,#1a3550)",color:"var(--c-text3,#45688a)",padding:".12rem .45rem",borderRadius:5}}>{p.role}</span>
        </div>
        {rows.length===0
          ? <div style={{fontSize:".74rem",color:"var(--c-text3,#45688a)",fontStyle:"italic"}}>{es?"Sin datos de salud/legales aún":"No health/legal data yet"}</div>
          : <div style={{display:"flex",flexDirection:"column",gap:".4rem"}}>
              {rows.map(([k,v],j)=><div key={j} style={{display:"grid",gridTemplateColumns:"180px 1fr",gap:".5rem"}}>
                <span style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)",textTransform:"uppercase",letterSpacing:".04em"}}>{k}</span>
                <span style={{fontSize:".8rem",color:"var(--c-text,#c8dff0)",whiteSpace:"pre-wrap"}}>{v}</span>
              </div>)}
            </div>}
      </div>;
    })}
  </div>;
}

// Read-only render of ONE agency-shared custom tab for this client. The tab
// STRUCTURE (label + field labels) comes from the agency-shared definition
// (customTabDefs); the VALUES come from this client's `customValues` map keyed
// by field id. Mirrors the ClientHealthLife card/row layout. Editing happens
// in the ClientForm "🧩 Pestañas" tab; this view only displays.
export function ClientCustomTabs({client,customTabDefs,activeDefId,lang}){
  const es=lang==="es";
  const defs=Array.isArray(customTabDefs)?customTabDefs:[];
  const def=defs.find((d)=>d&&d.id===activeDefId);
  const values=(client?.customValues&&typeof client.customValues==="object")?client.customValues:{};
  if(!def) return <div style={{padding:"1rem"}}><div style={{fontSize:".74rem",color:"var(--c-text3,#45688a)",fontStyle:"italic"}}>{es?"Esta pestaña ya no existe.":"This tab no longer exists."}</div></div>;
  const fields=(Array.isArray(def.fields)?def.fields:[]).filter((f)=>f&&(f.label||"").trim());
  return <div style={{padding:"1rem",display:"flex",flexDirection:"column",gap:".75rem"}}>
    <div className="dkt-phase" style={{marginBottom:".25rem"}}>
      🧩 {es?"Pestaña personalizada (solo lectura). Para editar, usa el botón Editar → pestaña Pestañas.":"Custom tab (read-only). To edit, use Edit → Tabs."}
    </div>
    <div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderLeft:"3px solid var(--c-purple,#a78bfa)",borderRadius:10,padding:".875rem"}}>
      <div style={{display:"flex",alignItems:"center",gap:".4rem",marginBottom:fields.length?".6rem":0}}>
        <span>🧩</span>
        <span style={{fontWeight:700,color:"var(--c-white,#eef6ff)",fontSize:".84rem"}}>{def.label||(es?"Pestaña sin nombre":"Untitled tab")}</span>
      </div>
      {fields.length===0
        ? <div style={{fontSize:".74rem",color:"var(--c-text3,#45688a)",fontStyle:"italic"}}>{es?"Sin campos":"No fields"}</div>
        : <div style={{display:"flex",flexDirection:"column",gap:".4rem"}}>
            {fields.map((f,j)=>{ const v=(values[f.id]||"").toString();
              return <div key={f.id||j} style={{display:"grid",gridTemplateColumns:"180px 1fr",gap:".5rem"}}>
                <span style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)",textTransform:"uppercase",letterSpacing:".04em"}}>{f.label||"—"}</span>
                <span style={{fontSize:".8rem",color:v?"var(--c-text,#c8dff0)":"var(--c-text3,#45688a)",whiteSpace:"pre-wrap",fontStyle:v?"normal":"italic"}}>{v||(es?"—":"—")}</span>
              </div>;
            })}
          </div>}
    </div>
  </div>;
}

// Detect the cloud provider from a folder URL so the tab can show the
// right icon + label without making the agent type it. Falls back to a
// generic "Link" label when we don't recognize the host. Keep the list
// short — Lissette's beta partner uses Drive + OneDrive; the rest are
// here because the same field doubles as a "stash any cloud folder link"
// catch-all so we don't have to ship a second field later.
function detectDriveProvider(url) {
  if (!url) return { key: 'none', label: '', icon: '📁' };
  let host = '';
  try { host = new URL(url).hostname.toLowerCase(); } catch { return { key: 'invalid', label: 'Invalid URL', icon: '⚠️' }; }
  if (host.includes('drive.google.com') || host.includes('docs.google.com')) return { key: 'google', label: 'Google Drive', icon: '🟡' };
  if (host.includes('onedrive.live.com') || host.includes('sharepoint.com') || host.includes('1drv.ms')) return { key: 'onedrive', label: 'OneDrive', icon: '🔵' };
  if (host.includes('dropbox.com')) return { key: 'dropbox', label: 'Dropbox', icon: '🟦' };
  if (host.includes('box.com')) return { key: 'box', label: 'Box', icon: '📦' };
  if (host.includes('icloud.com')) return { key: 'icloud', label: 'iCloud Drive', icon: '☁️' };
  return { key: 'other', label: host, icon: '🔗' };
}

export function ClientDriveTab({ client, onClientPatched, lang }) {
  const es = lang === 'es';
  const saved = (client?.driveUrl || '').trim();
  const [value, setValue] = useState(saved);
  const [editing, setEditing] = useState(!saved);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  // Re-sync local state when the client switches (parent passes a new
  // client object). Without this the input keeps the previous client's
  // URL when the user navigates between client detail pages.
  useEffect(() => {
    setValue(saved);
    setEditing(!saved);
    setError('');
  }, [client?.id, saved]);

  const provider = detectDriveProvider(saved);
  const validateUrl = (s) => {
    const v = (s || '').trim();
    if (!v) return true; // empty is allowed (= clear the link)
    try {
      const u = new URL(v);
      return u.protocol === 'http:' || u.protocol === 'https:';
    } catch { return false; }
  };

  async function handleSave() {
    const v = value.trim();
    if (v && !validateUrl(v)) {
      setError(es ? 'URL inválida (debe empezar con http:// o https://)' : 'Invalid URL (must start with http:// or https://)');
      return;
    }
    setSaving(true);
    setError('');
    try {
      // Dedicated endpoint — saltea mapClientToApi (que destruiría al
      // cliente con placeholders en firstName/lastName). Ver
      // feedback_partial_patch_and_repair_cascade (Rosina #145).
      const patched = await apiSetClientDriveUrl(client.id, v);
      // Patch ONLY driveUrl into the parent's client state. The /drive
      // response intentionally omits the decrypted F4 ficha (license /
      // medical / family), so merging the whole `patched` object would blank
      // those out in memory and the next form Save would persist the blanks
      // (the 2026-05-28 wipe). Use the just-saved value so we never depend on
      // the response round-trip carrying the full record.
      onClientPatched && onClientPatched({ driveUrl: patched?.driveUrl ?? v });
      toast.success(es
        ? (v ? 'Carpeta del cliente guardada' : 'Carpeta del cliente eliminada')
        : (v ? 'Client folder saved' : 'Client folder removed'));
      setEditing(false);
    } catch (err) {
      setError(err?.message || (es ? 'No se pudo guardar' : "Couldn't save"));
    } finally {
      setSaving(false);
    }
  }

  function handleCancel() {
    setValue(saved);
    setEditing(false);
    setError('');
  }

  return (
    <div style={{padding:'1rem',display:'flex',flexDirection:'column',gap:'1rem'}}>
      <div>
        <div className="dkt-sec-title">{es ? '📂 Carpeta del cliente' : '📂 Client Folder'}</div>
        <div className="dkt-sec-sub">
          {es
            ? 'Enlace a la carpeta de Google Drive, OneDrive, Dropbox u otro servicio donde guardas los archivos físicos de este cliente.'
            : "Link to the Google Drive, OneDrive, Dropbox or other folder where you keep this client's physical files."}
        </div>
      </div>

      {!editing && saved && (
        <div style={{background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:12,padding:'1rem',display:'flex',flexDirection:'column',gap:'.75rem'}}>
          <div style={{display:'flex',alignItems:'center',gap:'.6rem'}}>
            <span style={{fontSize:'1.5rem'}}>{provider.icon}</span>
            <div style={{display:'flex',flexDirection:'column'}}>
              <span style={{fontSize:'.7rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)',textTransform:'uppercase',letterSpacing:'.08em'}}>{es ? 'Proveedor' : 'Provider'}</span>
              <span style={{fontSize:'.85rem',fontWeight:700,color:'var(--c-white,#eef6ff)'}}>{provider.label || (es ? 'Enlace' : 'Link')}</span>
            </div>
          </div>
          <div style={{fontSize:'.78rem',color:'var(--c-text2,#7aa3c0)',wordBreak:'break-all',fontFamily:'var(--font-mono)',background:'var(--c-bg2,#0b1622)',border:'1px solid var(--c-border,#1a3550)',borderRadius:8,padding:'.6rem .75rem'}}>
            {saved}
          </div>
          <div style={{display:'flex',gap:'.5rem',flexWrap:'wrap'}}>
            <a href={saved} target="_blank" rel="noopener noreferrer" className="dkt-btn-p" style={{textDecoration:'none'}}>
              <ExternalLink size={14}/>{es ? 'Abrir carpeta' : 'Open folder'}
            </a>
            <button type="button" className="dkt-btn-s" onClick={() => { navigator.clipboard?.writeText(saved).catch(()=>{}); toast.success(es ? 'Enlace copiado' : 'Link copied'); }}>
              <Copy size={14}/>{es ? 'Copiar' : 'Copy'}
            </button>
            <button type="button" className="dkt-btn-s" onClick={() => setEditing(true)}>
              <Edit2 size={14}/>{es ? 'Editar' : 'Edit'}
            </button>
          </div>
        </div>
      )}

      {editing && (
        <div style={{background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:12,padding:'1rem',display:'flex',flexDirection:'column',gap:'.75rem'}}>
          <label className="dkt-input-lbl">{es ? 'URL de la carpeta' : 'Folder URL'}</label>
          <input
            type="url"
            className="dkt-inp"
            placeholder="https://drive.google.com/..."
            value={value}
            onChange={(e) => { setValue(e.target.value); if (error) setError(''); }}
            autoFocus
          />
          {error && <div style={{fontSize:'.75rem',color:'var(--c-red,#ff3d6b)'}}>{error}</div>}
          {value && validateUrl(value) && (
            <div style={{fontSize:'.72rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)'}}>
              {detectDriveProvider(value).icon} {es ? 'Detectado' : 'Detected'}: {detectDriveProvider(value).label || (es ? 'Enlace genérico' : 'Generic link')}
            </div>
          )}
          <div style={{display:'flex',gap:'.5rem',flexWrap:'wrap'}}>
            <button type="button" className="dkt-btn-p" onClick={handleSave} disabled={saving}>
              <Save size={14}/>{saving ? (es ? 'Guardando…' : 'Saving…') : (es ? 'Guardar' : 'Save')}
            </button>
            {saved && (
              <button type="button" className="dkt-btn-s" onClick={handleCancel} disabled={saving}>
                {es ? 'Cancelar' : 'Cancel'}
              </button>
            )}
            {saved && !saving && (
              <button type="button" className="dkt-btn-d" onClick={() => { setValue(''); }} title={es ? 'Vaciar el campo (todavía no se guarda)' : 'Clear the field (not saved yet)'}>
                <Trash2 size={14}/>{es ? 'Vaciar' : 'Clear'}
              </button>
            )}
          </div>
        </div>
      )}

      {!editing && !saved && (
        <div style={{background:'var(--c-surface2,#112538)',border:'1px dashed var(--c-border,#1a3550)',borderRadius:12,padding:'1.5rem',textAlign:'center',display:'flex',flexDirection:'column',gap:'.75rem',alignItems:'center'}}>
          <FolderOpen size={32} style={{color:'var(--c-text3,#45688a)'}}/>
          <div style={{fontSize:'.85rem',color:'var(--c-text2,#7aa3c0)'}}>
            {es ? 'Este cliente todavía no tiene carpeta vinculada.' : 'No folder linked to this client yet.'}
          </div>
          <button type="button" className="dkt-btn-p" onClick={() => setEditing(true)}>
            <Plus size={14}/>{es ? 'Agregar enlace' : 'Add link'}
          </button>
        </div>
      )}
    </div>
  );
}

export function PaymentMethodsTab({ clientId, lang, currentUser }) {
  // Methods are MASKED rows from the backend (last-4 only). Full card/account
  // numbers live encrypted server-side and come back only through a PIN-gated
  // reveal — cached here per id once revealed for this unlocked session.
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadErr, setLoadErr] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [showFull, setShowFull] = useState({});
  const [revealed, setRevealed] = useState({});   // { [id]: {cardNumber, accountNumber, ...} }
  const [revealing, setRevealing] = useState({}); // { [id]: true } while a reveal is in flight
  const [saving, setSaving] = useState(false);
  const [confirmDel, setConfirmDel] = useState(null);
  const [pinLocked, setPinLocked] = useState(true);
  const [pinInput, setPinInput] = useState("");
  const [pinError, setPinError] = useState("");
  const [pinChecking, setPinChecking] = useState(false);
  // The 6-digit PIN the agent typed to unlock the tab, held only in memory for
  // this session so per-item reveals don't re-prompt. Cleared on lock/unmount.
  const pinRef = useRef("");
  const empty = {
    type:"credit_card", label:"", cardholderName:"", cardNumber:"",
    expiryMonth:"", expiryYear:"", cvv:"", bankName:"",
    accountNumber:"", routingNumber:"", accountType:"checking",
    billingAddress:"", notes:""
  };
  const [form, setForm] = useState({...empty});
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const TYPES = [
    {id:"credit_card",  icon:"💳", label:"Credit Card",     labelEs:"Tarjeta de Crédito"},
    {id:"debit_card",   icon:"💳", label:"Debit Card",      labelEs:"Tarjeta de Débito"},
    {id:"bank_account", icon:"🏦", label:"Bank Account (ACH)",labelEs:"Cuenta Bancaria (ACH)"},
    {id:"cash",         icon:"💵", label:"Cash",             labelEs:"Efectivo"},
    {id:"check",        icon:"📝", label:"Check",            labelEs:"Cheque"},
    {id:"other",        icon:"📋", label:"Other",            labelEs:"Otro"},
  ];
  const maskLast4 = (l4) => l4 ? "•••• " + l4 : "--";

  // Load the masked list from the backend. Called once the tab is unlocked.
  const load = async () => {
    setLoading(true); setLoadErr("");
    try { setMethods(await listClientPaymentMethods(clientId)); }
    catch (e) { setLoadErr(e.message || (lang==="es"?"No se pudo cargar":"Could not load")); }
    finally { setLoading(false); }
  };

  // Decrypt one method's full numbers (PIN-gated + audited server-side). Cached
  // per id for the session. A PIN_* failure (e.g. the agent rotated their PIN)
  // re-locks the tab so they re-enter it.
  const ensureRevealed = async (id) => {
    if (revealed[id]) return revealed[id];
    setRevealing(r => ({ ...r, [id]: true }));
    try {
      const data = await revealClientPaymentMethod(clientId, id, pinRef.current);
      setRevealed(r => ({ ...r, [id]: data }));
      return data;
    } catch (e) {
      if (e.code && String(e.code).startsWith("PIN")) {
        pinRef.current = "";
        setPinLocked(true); setShowFull({}); setRevealed({});
        toast.error(lang==="es"?"Vuelve a ingresar tu PIN":"Please re-enter your PIN");
      } else {
        toast.error(e.message || (lang==="es"?"Error":"Error"));
      }
      throw e;
    } finally {
      setRevealing(r => { const n = { ...r }; delete n[id]; return n; });
    }
  };

  const toggleFull = async (m) => {
    if (showFull[m.id]) { setShowFull(f => ({ ...f, [m.id]: false })); return; }
    if (m.hasSensitive && !revealed[m.id]) {
      try { await ensureRevealed(m.id); } catch { return; }
    }
    setShowFull(f => ({ ...f, [m.id]: true }));
  };

  const save = async () => {
    setSaving(true);
    try {
      // CVV is intentionally NOT sent — never stored (PCI-DSS). Everything else
      // sensitive is encrypted server-side.
      const payload = {
        type: form.type, label: form.label, cardholderName: form.cardholderName,
        cardNumber: form.cardNumber, expiryMonth: form.expiryMonth, expiryYear: form.expiryYear,
        bankName: form.bankName, accountType: form.accountType,
        accountNumber: form.accountNumber, routingNumber: form.routingNumber,
        billingAddress: form.billingAddress, notes: form.notes,
      };
      const saved = editItem
        ? await updateClientPaymentMethod(clientId, editItem.id, payload)
        : await createClientPaymentMethod(clientId, payload);
      // Cache the secrets we just typed so an immediate "View" needs no round-trip.
      if (saved?.id) {
        setRevealed(r => ({ ...r, [saved.id]: {
          cardNumber: form.cardNumber || "", accountNumber: form.accountNumber || "",
          routingNumber: form.routingNumber || "", billingAddress: form.billingAddress || "",
          notes: form.notes || "",
        }}));
      }
      await load();
      setShowForm(false); setEditItem(null); setForm({...empty});
      toast.success(lang==="es"?"Método de pago guardado":"Payment method saved");
    } catch (e) {
      toast.error(e.message || (lang==="es"?"No se pudo guardar":"Save failed"));
    } finally {
      setSaving(false);
    }
  };

  const del = async (id) => {
    try {
      await deleteClientPaymentMethod(clientId, id);
      setConfirmDel(null);
      setRevealed(r => { const n = { ...r }; delete n[id]; return n; });
      await load();
    } catch (e) {
      toast.error(e.message || (lang==="es"?"No se pudo eliminar":"Delete failed"));
    }
  };

  const openEdit = async (m) => {
    let secret = {};
    if (m.hasSensitive) { try { secret = await ensureRevealed(m.id); } catch { return; } }
    setEditItem(m);
    setForm({
      ...empty,
      type: m.type || "credit_card",
      label: m.label || "",
      cardholderName: m.cardholderName || "",
      cardNumber: secret.cardNumber || "",
      expiryMonth: m.expiryMonth || "",
      expiryYear: m.expiryYear || "",
      cvv: "",
      bankName: m.bankName || "",
      accountNumber: secret.accountNumber || "",
      routingNumber: secret.routingNumber || "",
      accountType: m.accountType || "checking",
      billingAddress: secret.billingAddress || "",
      notes: secret.notes || "",
    });
    setShowForm(true);
  };
  // Validates the PIN against the backend (which checks the agent's
  // pinHash, or the supervisor's for seats). Replaces the old hardcoded
  // "1234" demo gate so payment-method access uses the same unified PIN
  // as the SSN reveal flow.
  const unlock = async () => {
    if (pinInput.length !== 6) {
      setPinError(lang==="es"?"El PIN debe tener 6 dígitos":"PIN must be 6 digits");
      return;
    }
    setPinChecking(true);
    setPinError("");
    try {
      await verifyPin(pinInput);
      // Hold the verified PIN in memory so per-item reveals don't re-prompt.
      pinRef.current = pinInput;
      setPinLocked(false);
      setPinInput("");
      load();
    } catch (e) {
      if (e.code === 'PIN_NOT_SET') {
        setPinError(lang==="es"
          ? "No tienes PIN configurado. Configúralo en tu perfil → Seguridad."
          : "No PIN configured. Set one up in your profile → Security.");
      } else if (e.code === 'PIN_WRONG') {
        setPinError(lang==="es"?"PIN incorrecto":"Incorrect PIN");
      } else {
        setPinError(e.message);
      }
    } finally {
      setPinChecking(false);
    }
  };
  // PIN lock screen
  if(pinLocked) return (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",
      padding:"3rem 1rem",gap:"1.25rem",textAlign:"center"}}>
      <div style={{width:56,height:56,borderRadius:"50%",background:"rgba(0,212,255,.1)",
        border:"2px solid rgba(0,212,255,.3)",display:"flex",alignItems:"center",
        justifyContent:"center",fontSize:"1.75rem"}}>🔒</div>
      <div>
        <div style={{fontWeight:800,fontSize:".95rem",color:"var(--c-white,#eef6ff)",marginBottom:".4rem"}}>
          {lang==="es"?"Métodos de Pago - Área Segura":"Payment Methods - Secure Area"}
        </div>
        <div style={{fontSize:".75rem",color:"var(--c-text3,#45688a)",lineHeight:1.5}}>
          {lang==="es"?"Ingresa tu PIN para acceder a la información de pago del cliente.":"Enter your PIN to access client payment information."}
        </div>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:".5rem",width:"100%",maxWidth:280}}>
        <input
          type="text" inputMode="numeric" autoComplete="off" maxLength={6}
          name="deskte-pin" data-lpignore="true" data-1p-ignore data-form-type="other"
          value={pinInput} onChange={e=>setPinInput(e.target.value.replace(/\D/g,""))}
          onKeyDown={e=>e.key==="Enter"&&!pinChecking&&unlock()}
          placeholder="••••••"
          /* type="text" + -webkit-text-security masks the digits WITHOUT making it a
             password field, so Edge/Chrome never offer to "save your password" — the
             autoComplete="off" alone was not enough for Edge's MS-account prompt. E-016. */
          style={{textAlign:"center",letterSpacing:".4em",fontSize:"1.2rem",WebkitTextSecurity:"disc",
            background:"var(--c-surface2,#112538)",border:`1px solid ${pinError?"var(--c-red,#ff3d6b)":"var(--c-border,#1a3550)"}`,
            borderRadius:9,padding:".65rem",color:"var(--c-white,#eef6ff)",fontFamily:"var(--font-mono)",
            outline:"none",width:"100%",boxSizing:"border-box"}}/>
        {pinError&&<div style={{fontSize:".72rem",color:"var(--c-red,#ff3d6b)",textAlign:"center"}}>{pinError}</div>}
        <button type="button" onClick={unlock} disabled={pinChecking||pinInput.length!==6}
          style={{background:"var(--c-cyan,#00d4ff)",border:"none",borderRadius:9,padding:".65rem",
            color:"#0a1628",fontWeight:800,fontSize:".85rem",
            cursor:(pinChecking||pinInput.length!==6)?"not-allowed":"pointer",
            opacity:(pinChecking||pinInput.length!==6)?0.5:1}}>
          {pinChecking ? (lang==="es"?"Verificando...":"Verifying...") : <>🔓 {lang==="es"?"Desbloquear":"Unlock"}</>}
        </button>
      </div>
      <div style={{fontSize:".65rem",color:"var(--c-text3,#45688a)",marginTop:".5rem",textAlign:"center",maxWidth:280}}>
        {lang==="es"?"Usa tu PIN de 6 dígitos. ¿No lo tienes? Configúralo en tu perfil → Seguridad.":"Use your 6-digit PIN. Don't have one? Set it in your profile → Security."}
      </div>
    </div>
  );
  return <div>
    {/* Header */}
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"1rem"}}>
      <div style={{display:"flex",alignItems:"center",gap:".5rem"}}>
        <span style={{fontSize:".65rem",padding:".2rem .6rem",borderRadius:100,
          background:"rgba(6,214,160,.1)",border:"1px solid rgba(6,214,160,.25)",
          color:"var(--c-green,#00ff88)",fontWeight:700}}>
          🔓 {lang==="es"?"Desbloqueado":"Unlocked"}
        </span>
        <button type="button" onClick={()=>{pinRef.current="";setPinLocked(true);setShowFull({});setRevealed({});}}
          style={{background:"none",border:"none",cursor:"pointer",
            fontSize:".65rem",color:"var(--c-text3,#45688a)"}}>
          {lang==="es"?"Bloquear":"Lock"} 🔒
        </button>
      </div>
      <button type="button" onClick={()=>{setEditItem(null);setForm({...empty});setShowForm(true);}}
        className="dkt-btn-p" style={{fontSize:".78rem"}}>
        + {lang==="es"?"Agregar Método":"Add Method"}
      </button>
    </div>
    {/* Loading / error */}
    {loading&&<div style={{textAlign:"center",padding:"1.5rem 1rem",color:"var(--c-text3,#45688a)",fontSize:".8rem"}}>
      {lang==="es"?"Cargando…":"Loading…"}
    </div>}
    {!!loadErr&&!loading&&<div style={{padding:".75rem 1rem",marginBottom:".6rem",borderRadius:10,
      background:"rgba(255,61,107,.08)",border:"1px solid rgba(255,61,107,.25)",color:"var(--c-red,#ff3d6b)",
      fontSize:".78rem",display:"flex",alignItems:"center",justifyContent:"space-between",gap:".75rem"}}>
      <span>{loadErr}</span>
      <button type="button" onClick={load} className="dkt-btn-s" style={{fontSize:".72rem",padding:".3rem .75rem"}}>
        {lang==="es"?"Reintentar":"Retry"}
      </button>
    </div>}
    {/* Methods list */}
    {methods.length===0&&!showForm&&!loading&&!loadErr&&(
      <div style={{textAlign:"center",padding:"2.5rem 1rem",color:"var(--c-text3,#45688a)",
        background:"var(--c-surface2,#112538)",borderRadius:12,border:"1px dashed var(--c-border,#1a3550)"}}>
        <div style={{fontSize:"2rem",marginBottom:".5rem"}}>💳</div>
        <div style={{fontSize:".82rem",marginBottom:".3rem",color:"var(--c-text,#c8dff0)"}}>
          {lang==="es"?"No hay métodos de pago registrados":"No payment methods registered"}
        </div>
        <div style={{fontSize:".72rem"}}>{lang==="es"?"Agrega tarjetas, cuentas bancarias o ACH":"Add cards, bank accounts or ACH"}</div>
      </div>
    )}
    <div style={{display:"flex",flexDirection:"column",gap:".6rem",marginBottom:showForm?"1rem":0}}>
      {methods.map(m=>{
        const tp = TYPES.find(t=>t.id===m.type)||TYPES[0];
        const isCard = m.type==="credit_card"||m.type==="debit_card";
        const isBank = m.type==="bank_account";
        const full = showFull[m.id];
        const delConfirm = confirmDel===m.id;
        return <div key={m.id} style={{background:"var(--c-surface2,#112538)",
          border:"1px solid var(--c-border,#1a3550)",borderRadius:11,overflow:"hidden"}}>
          {/* Card header */}
          <div style={{padding:".75rem 1rem",display:"flex",alignItems:"center",justifyContent:"space-between",gap:".75rem"}}>
            <div style={{display:"flex",alignItems:"center",gap:".75rem",flex:1,minWidth:0}}>
              <div style={{width:38,height:38,borderRadius:9,background:"rgba(0,212,255,.08)",
                border:"1px solid rgba(0,212,255,.15)",display:"flex",alignItems:"center",
                justifyContent:"center",fontSize:"1.3rem",flexShrink:0}}>{tp.icon}</div>
              <div style={{minWidth:0}}>
                <div style={{fontWeight:700,fontSize:".85rem",color:"var(--c-white,#eef6ff)"}}>
                  {m.label||tp.label}
                </div>
                <div style={{fontSize:".72rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>
                  {isCard ? maskLast4(m.cardLast4) : isBank ? maskLast4(m.acctLast4) : tp.icon+" "+tp.label}
                </div>
                {m.cardholderName&&<div style={{fontSize:".68rem",color:"var(--c-text2,#7aa3c0)",marginTop:1}}>{m.cardholderName}</div>}
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:".35rem",flexShrink:0}}>
              {m.hasSensitive&&<button type="button" disabled={revealing[m.id]} onClick={()=>toggleFull(m)}
                style={{background:"var(--c-surface3,#162d44)",border:"1px solid var(--c-border,#1a3550)",
                  borderRadius:7,padding:"3px 9px",cursor:revealing[m.id]?"wait":"pointer",fontSize:".65rem",
                  fontWeight:700,color:"var(--c-cyan,#00d4ff)",opacity:revealing[m.id]?0.6:1}}>
                {revealing[m.id]?(lang==="es"?"Abriendo…":"Opening…"):full?"🙈 "+(lang==="es"?"Ocultar":"Hide"):"👁️ "+(lang==="es"?"Ver":"View")}
              </button>}
              <button type="button" onClick={()=>openEdit(m)}
                style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-text3,#45688a)",padding:4,lineHeight:0}}
                onMouseEnter={e=>e.currentTarget.style.color="var(--c-cyan,#00d4ff)"}
                onMouseLeave={e=>e.currentTarget.style.color="var(--c-text3,#45688a)"}><Edit2 size={13}/></button>
              <button type="button" onClick={()=>setConfirmDel(m.id)}
                style={{background:"none",border:"none",cursor:"pointer",color:"var(--c-text3,#45688a)",padding:4,lineHeight:0}}
                onMouseEnter={e=>e.currentTarget.style.color="var(--c-red,#ff3d6b)"}
                onMouseLeave={e=>e.currentTarget.style.color="var(--c-text3,#45688a)"}><Trash2 size={13}/></button>
            </div>
          </div>
          {/* Full details — sensitive numbers come from the PIN-gated reveal (cached in `revealed`) */}
          {full&&(()=>{ const v={...m,...(revealed[m.id]||{})}; return <div style={{borderTop:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface,#0d1c2e)",
            padding:".75rem 1rem",display:"grid",gridTemplateColumns:"1fr 1fr",gap:".5rem"}}>
            {isCard&&<>
              <InfoBlock label={lang==="es"?"Número de Tarjeta":"Card Number"} value={v.cardNumber||"--"} mono/>
              <InfoBlock label="CVV" value={lang==="es"?"No almacenado":"Not stored"}/>
              <InfoBlock label={lang==="es"?"Vencimiento":"Expiry"} value={v.expiryMonth&&v.expiryYear?`${v.expiryMonth}/${v.expiryYear}`:"--"}/>
              <InfoBlock label={lang==="es"?"Titular":"Cardholder"} value={v.cardholderName||"--"}/>
            </>}
            {isBank&&<>
              <InfoBlock label={lang==="es"?"Banco":"Bank"} value={v.bankName||"--"}/>
              <InfoBlock label={lang==="es"?"Tipo de Cuenta":"Account Type"} value={v.accountType||"--"}/>
              <InfoBlock label={lang==="es"?"# de Cuenta":"Account #"} value={v.accountNumber||"--"} mono/>
              <InfoBlock label={lang==="es"?"Routing #":"Routing #"} value={v.routingNumber||"--"} mono/>
            </>}
            {v.billingAddress&&<InfoBlock label={lang==="es"?"Dirección de Facturación":"Billing Address"} value={v.billingAddress} wide/>}
            {v.notes&&<InfoBlock label={lang==="es"?"Notas":"Notes"} value={v.notes} wide/>}
            <div style={{gridColumn:"1/-1",fontSize:".6rem",color:"var(--c-text3,#45688a)",paddingTop:".25rem",
              borderTop:"1px solid var(--c-border,#1a3550)",marginTop:".25rem"}}>
              {lang==="es"?"Agregado por":"Added by"} {v.addedBy} . {v.createdAt?new Date(v.createdAt).toLocaleDateString('en-US'):""}
            </div>
          </div>; })()}
          {/* Delete confirm */}
          {delConfirm&&<div style={{borderTop:"1px solid var(--c-border,#1a3550)",background:"rgba(255,61,107,.06)",
            padding:".65rem 1rem",display:"flex",alignItems:"center",justifyContent:"space-between",gap:".75rem"}}>
            <span style={{fontSize:".78rem",color:"var(--c-red,#ff3d6b)",fontWeight:600}}>
              {lang==="es"?"¿Eliminar este método de pago?":"Delete this payment method?"}
            </span>
            <div style={{display:"flex",gap:".4rem"}}>
              <button type="button" onClick={()=>del(m.id)} className="dkt-btn-d" style={{fontSize:".72rem",padding:".3rem .75rem"}}>
                {lang==="es"?"Sí, eliminar":"Yes, delete"}
              </button>
              <button type="button" onClick={()=>setConfirmDel(null)} className="dkt-btn-s" style={{fontSize:".72rem",padding:".3rem .75rem"}}>
                {lang==="es"?"Cancelar":"Cancel"}
              </button>
            </div>
          </div>}
        </div>;
      })}
    </div>
    {/* Add/Edit Form */}
    {showForm&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-cyan,#00d4ff)",
      borderRadius:12,padding:"1rem",marginTop:".5rem"}}>
      <div style={{fontWeight:800,fontSize:".82rem",color:"var(--c-cyan,#00d4ff)",marginBottom:".875rem",
        display:"flex",alignItems:"center",gap:".5rem"}}>
        💳 {editItem?(lang==="es"?"Editar Método":"Edit Method"):(lang==="es"?"Nuevo Método de Pago":"New Payment Method")}
      </div>
      {/* Type selector */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:".4rem",marginBottom:".875rem"}}>
        {TYPES.map(tp=>(
          <button key={tp.id} type="button" onClick={()=>set("type",tp.id)}
            style={{padding:".5rem",borderRadius:8,cursor:"pointer",textAlign:"center",
              background:form.type===tp.id?"var(--c-cyan-dim)":"var(--c-surface,#0d1c2e)",
              border:`1px solid ${form.type===tp.id?"var(--c-cyan,#00d4ff)":"var(--c-border,#1a3550)"}`,
              color:form.type===tp.id?"var(--c-cyan,#00d4ff)":"var(--c-text3,#45688a)",
              fontSize:".7rem",fontWeight:700,transition:"all .15s"}}>
            {tp.icon} {lang==="es"?tp.labelEs:tp.label}
          </button>
        ))}
      </div>
      {/* Label */}
      <div style={{marginBottom:".6rem"}}>
        <label className="dkt-input-lbl">{lang==="es"?"Etiqueta (ej. Visa Principal)":"Label (e.g. Main Visa)"}</label>
        <input className="dkt-inp" value={form.label} onChange={e=>set("label",e.target.value)}
          placeholder={lang==="es"?"Tarjeta Principal":"Main Card"}/>
      </div>
      {/* Card fields */}
      {(form.type==="credit_card"||form.type==="debit_card")&&<>
        <div style={{marginBottom:".6rem"}}>
          <label className="dkt-input-lbl">{lang==="es"?"Nombre del Titular":"Cardholder Name"}</label>
          <input className="dkt-inp" value={form.cardholderName} onChange={e=>set("cardholderName",e.target.value)} placeholder=""/>
        </div>
        <div style={{marginBottom:".6rem"}}>
          <label className="dkt-input-lbl">{lang==="es"?"Número de Tarjeta":"Card Number"}</label>
          <input className="dkt-inp" value={form.cardNumber} onChange={e=>set("cardNumber",e.target.value.replace(/\D/g,"").slice(0,16))}
            placeholder="" style={{fontFamily:"var(--font-mono)"}}/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".6rem",marginBottom:".6rem"}}>
          <div>
            <label className="dkt-input-lbl">{lang==="es"?"Mes Exp.":"Exp. Month"}</label>
            <input className="dkt-inp" value={form.expiryMonth} onChange={e=>set("expiryMonth",e.target.value.replace(/\D/g,"").slice(0,2))} placeholder="MM" style={{fontFamily:"var(--font-mono)"}}/>
          </div>
          <div>
            <label className="dkt-input-lbl">{lang==="es"?"Año Exp.":"Exp. Year"}</label>
            <input className="dkt-inp" value={form.expiryYear} onChange={e=>set("expiryYear",e.target.value.replace(/\D/g,"").slice(0,4))} placeholder="YYYY" style={{fontFamily:"var(--font-mono)"}}/>
          </div>
          <div>
            <label className="dkt-input-lbl">CVV</label>
            <input className="dkt-inp" value={form.cvv} onChange={e=>set("cvv",e.target.value.replace(/\D/g,"").slice(0,4))} placeholder="123" style={{fontFamily:"var(--font-mono)"}}/>
            <div style={{fontSize:".58rem",color:"var(--c-text3,#45688a)",marginTop:2,lineHeight:1.3}}>
              {lang==="es"?"No se guarda (regla PCI)":"Not stored (PCI rule)"}
            </div>
          </div>
        </div>
      </>}
      {/* Bank account fields */}
      {form.type==="bank_account"&&<>
        {/* Account holder name — reuses the shared cardholderName column so no
            schema change is needed; it auto-fills the policy "Account Holder". */}
        <div style={{marginBottom:".6rem"}}>
          <label className="dkt-input-lbl">{lang==="es"?"Nombre del Titular de la Cuenta":"Account Holder Name"}</label>
          <input className="dkt-inp" value={form.cardholderName} onChange={e=>set("cardholderName",e.target.value)} placeholder=""/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".6rem",marginBottom:".6rem"}}>
          <div>
            <label className="dkt-input-lbl">{lang==="es"?"Nombre del Banco":"Bank Name"}</label>
            <input className="dkt-inp" value={form.bankName} onChange={e=>set("bankName",e.target.value)} placeholder=""/>
          </div>
          <div>
            <label className="dkt-input-lbl">{lang==="es"?"Tipo de Cuenta":"Account Type"}</label>
            <select className="dkt-inp" value={form.accountType} onChange={e=>set("accountType",e.target.value)}>
              <option value="checking">{lang==="es"?"Corriente (Checking)":"Checking"}</option>
              <option value="savings">{lang==="es"?"Ahorros (Savings)":"Savings"}</option>
            </select>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".6rem",marginBottom:".6rem"}}>
          <div>
            <label className="dkt-input-lbl">{lang==="es"?"# de Cuenta":"Account #"}</label>
            <input className="dkt-inp" value={form.accountNumber} onChange={e=>set("accountNumber",e.target.value.replace(/\D/g,""))} placeholder="" style={{fontFamily:"var(--font-mono)"}}/>
          </div>
          <div>
            <label className="dkt-input-lbl">Routing #</label>
            <input className="dkt-inp" value={form.routingNumber} onChange={e=>set("routingNumber",e.target.value.replace(/\D/g,"").slice(0,9))} placeholder="" style={{fontFamily:"var(--font-mono)"}}/>
          </div>
        </div>
      </>}
      {/* Billing address */}
      <div style={{marginBottom:".6rem"}}>
        <label className="dkt-input-lbl">{lang==="es"?"Dirección de Facturación":"Billing Address"}</label>
        <input className="dkt-inp" value={form.billingAddress} onChange={e=>set("billingAddress",e.target.value)} placeholder=""/>
      </div>
      <div style={{marginBottom:".875rem"}}>
        <label className="dkt-input-lbl">{lang==="es"?"Notas":"Notes"}</label>
        <textarea className="dkt-inp" rows={2} value={form.notes} onChange={e=>set("notes",e.target.value)} maxLength={2000}
          placeholder={lang==="es"?"Ej: usa para auto, vence pronto...":"e.g. use for auto policy, expiring soon..."}
          style={{resize:"vertical",minHeight:"2.4rem",fontFamily:"inherit"}}/>
      </div>
      <div style={{display:"flex",gap:".6rem"}}>
        <button type="button" onClick={save} disabled={saving} className="dkt-btn-p" style={{flex:1,justifyContent:"center",opacity:saving?0.6:1,cursor:saving?"wait":"pointer"}}>
          <Save size={14}/>{saving?(lang==="es"?"Guardando…":"Saving…"):(lang==="es"?"Guardar Método":"Save Method")}
        </button>
        <button type="button" onClick={()=>{setShowForm(false);setEditItem(null);setForm({...empty});}} className="dkt-btn-s">
          {lang==="es"?"Cancelar":"Cancel"}
        </button>
      </div>
    </div>}
  </div>;
}
// Activity Log = the COMPLETE per-client event log, fetched from the
// backend by entityId (same source as History). It used to read the
// in-memory `activitylog` prop (only ~100 agency-wide rows) and filter
// by `a.clientId`, but the merge/created logs carry `entityId` not
// `clientId`, so Rosina's Activity Log showed "No activity logged"
// even though the merge WAS in the DB. Now: fetch the client's events
// and show EVERYTHING (created, merged, tagged, ssn, email, doc,
// updated) — the inverse of History, which is whitelisted to data
// changes only.
export function ActivityLogView({ clientId, lang }) {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (!clientId) { setItems([]); return; }
    setItems(null); setErr(null);
    listEntityHistory('client', clientId, { limit: 1000 })
      // Lissette 2026-05-27 clarification: Activity Log shows EVERY
      // event — data changes (marital status, address, etc.) + tasks +
      // notes + docs + emails + appointments — only the TITLE (no
      // diff cards, those live in History). The diff render below is
      // suppressed for this tab so a 'updated' row reads as "✏️
      // Actualizado · Estado Civil" with no OLD/NEW boxes.
      // PHI access events (phi.*, ssn.reveal*) still hidden — those
      // are the compliance-audit-only rows the user doesn't need.
      .then(({ activity }) => { if (!cancelled) setItems((activity || []).filter((a) => !isPhiAccessEvent(a.action))); })
      .catch((e) => { if (!cancelled) { setErr(e.message || 'Error'); setItems([]); } });
    return () => { cancelled = true; };
  }, [clientId]);
  const fmtDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      + ' ' + d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };
  if (items === null) return <div style={{padding:'2rem',textAlign:'center',color:'var(--c-text3,#45688a)',fontSize:'.82rem'}}>
    {lang === 'es' ? 'Cargando actividad…' : 'Loading activity…'}
  </div>;
  if (err) return <div style={{padding:'1rem',color:'var(--c-red,#ff3d6b)',fontSize:'.8rem'}}>⚠ {err}</div>;
  if (items.length === 0) return <div style={{padding:'2rem',textAlign:'center',color:'var(--c-text3,#45688a)',fontSize:'.82rem'}}>
    {lang === 'es' ? 'Sin actividad registrada' : 'No activity logged'}
  </div>;
  return <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
    <div style={{ fontSize: '.62rem', color: 'var(--c-text3,#45688a)', fontFamily: 'monospace', letterSpacing: '.06em', textTransform: 'uppercase', textAlign: 'right' }}>
      {lang === 'es' ? `${items.length} eventos` : `${items.length} events`}
    </div>
    {items.map((h) => {
      const meta = actionMeta(h.action, lang, h.entityType);
      // Lo subio el CLIENTE por el enlace publico. La fila guarda un usuario de
      // la agencia porque la columna es obligatoria, pero enseñar su nombre
      // seria atribuirle algo que no hizo — en un registro de auditoria eso es
      // peor que no tenerlo.
      const porElPortal = h.details && h.details.via === 'portal';
      const autor = porElPortal
        ? (lang === 'es' ? 'Cliente (portal)' : 'Client (portal)')
        : (h.userName || '—');
      const changes = renderableChanges(h.details);
      // La póliza de la que habla la fila. SIEMPRE, también cuando hay cuadros
      // de antes/ahora: antes vivía dentro de `formatDetails`, que solo se
      // llama cuando NO hay diferencias, así que la fila que más lo necesita
      // —"Póliza actualizada · Premium"— era justamente la que no lo decía
      // (Lissette 2026-09-13).
      const identidad = identidadDePoliza(h.details, lang);
      const details = changes.length > 0 ? null : formatDetails(h.details, lang);
      // Name WHAT changed next to the action label so the card reads
      // "Actualizado · Dirección, Idioma" instead of a bare "Updated".
      const fieldSummary = changes.length
        ? changes.map((c) => fieldLabel(c.field, lang)).join(', ')
        : '';
      return <div key={h.id} style={{ background: 'var(--c-surface,#0d1c2e)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ padding: '.5rem .75rem', background: 'var(--c-surface2,#112538)', borderBottom: '1px solid var(--c-border,#1a3550)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '.35rem' }}>
          <span style={{ fontSize: '.73rem', fontWeight: 700, color: 'var(--c-white,#eef6ff)' }}>
            <span style={{ marginRight: 4 }}>{meta.icon}</span>{meta.label}
            {fieldSummary && (
              <span style={{ fontWeight: 500, color: 'var(--c-text2,#7aa3c0)' }}> · {fieldSummary}</span>
            )}
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
            <span style={{ fontSize: '.65rem', color: 'var(--c-cyan,#00d4ff)', fontWeight: 600 }}>{porElPortal ? '📥' : '👤'} {autor}</span>
            <span style={{ fontSize: '.62rem', color: 'var(--c-text3,#45688a)', fontFamily: 'monospace' }}>{fmtDate(h.createdAt)}</span>
          </div>
        </div>
        {/* Lissette 2026-05-27: Activity Log shows TITLE ONLY — no
            diff cards (those live in History). The data-change rows
            ('updated', 'policy.updated', etc.) now appear here too
            so the user can see "✏️ Actualizado · Estado Civil" without
            the bulky OLD/NEW cards. Full diff still in the History tab. */}
        {identidad && (
          <div style={{ padding: '.45rem .75rem', fontSize: '.72rem', color: 'var(--c-text,#c8dff0)', fontWeight: 600 }}>
            📄 {identidad}
          </div>
        )}
        {details && (
          <div style={{ padding: '.5rem .75rem', fontSize: '.72rem', color: 'var(--c-text2,#7aa3c0)', lineHeight: 1.5 }}>
            {details}
          </div>
        )}
      </div>;
    })}
  </div>;
}

// ── Signature templates ──────────────────────────────────────────────────
//
// Starter legal text the agent can send to clients for e-signature.
// Drafted 2026-05-20 to give Lissette substantive language instead of
// the prior 3-line placeholders. THESE ARE TEMPLATES — they reflect
// the standard elements required by federal regulation (45 CFR
// 164.508 for HIPAA, 47 CFR § 64.1200 / TCPA for communication
// consent, 42 CFR § 422.2274 for Medicare Scope of Appointment) but
// should be reviewed by a licensed insurance compliance attorney
// before being used as the agency's production forms. Variables use
// {nombre}, {agente}, {agency}, {fecha}, {telefono}, {email},
// {direccion}, {dob} — these are interpolated by
// SignaturesView.fillTemplate() before sending.
//
// No emojis: pdf-lib's StandardFonts (Helvetica) only encodes WinAnsi,
// so emoji code points crash the renderer silently. The backend
// sanitizer strips them anyway, but keeping the source clean avoids
// confusion.

const TPL_ACA_ES = `CONSENTIMIENTO DE INSCRIPCIÓN — MERCADO DE SEGUROS DE SALUD (ACA)

1. PARTES
   Cliente: {nombre}
   Fecha de nacimiento: {dob}
   Domicilio: {direccion}
   Teléfono: {telefono}    Correo: {email}

   Agente representante: {agente}
   Agencia: {agency}

2. OTORGAMIENTO DE AUTORIZACIÓN
Por medio del presente documento, yo, {nombre}, otorgo mi consentimiento expreso e informado para que el agente identificado arriba actúe como mi representante autorizado para gestionar mi inscripción y mi cobertura de seguro de salud bajo la Ley de Cuidado de Salud a Bajo Precio (Affordable Care Act, "ACA"), incluyendo todos los Mercados de Seguros Médicos (Health Insurance Marketplace) federales y estatales aplicables.

3. ALCANCE DE LA AUTORIZACIÓN
Autorizo a mi agente a:
a) Crear, acceder y modificar mi cuenta en HealthCare.gov o en el portal del Mercado estatal correspondiente.
b) Recopilar y presentar la información de mi hogar, ingresos y demográfica necesaria para determinar mi elegibilidad para subsidios (Premium Tax Credit y Cost-Sharing Reductions).
c) Comparar planes disponibles, recomendar opciones y presentar mi solicitud de inscripción.
d) Realizar cambios de plan durante el Periodo de Inscripción Abierta o un Periodo de Inscripción Especial cuando yo califique.
e) Comunicarse con el Marketplace, con CMS y con las aseguradoras en mi nombre para resolver discrepancias y dar seguimiento.

4. VERACIDAD DE LA INFORMACIÓN
Declaro que la información que proporcione es verdadera, completa y actualizada. Entiendo que proporcionar información falsa al Marketplace puede resultar en sanciones civiles, pérdida de subsidios y obligación de reembolsar cantidades recibidas indebidamente.

5. NO HAY OBLIGACIÓN
Entiendo que firmar este documento NO me obliga a inscribirme en ningún plan en particular. La decisión final de cobertura es exclusivamente mía.

6. COMISIÓN DEL AGENTE
Entiendo que mi agente recibe una comisión pagada directamente por la aseguradora cuando me inscribo en un plan, y que esta comisión NO incrementa el costo de mi prima.

7. DURACIÓN Y REVOCACIÓN
Este consentimiento entra en vigor en la fecha de mi firma y permanece vigente hasta que yo lo revoque por escrito. La revocación no afecta acciones legítimamente tomadas antes de recibir el aviso.

Fecha: {fecha}
Cliente: {nombre}`;

const TPL_ACA_EN = `MARKETPLACE ENROLLMENT CONSENT — ACA HEALTH INSURANCE

1. PARTIES
   Client: {nombre}
   Date of birth: {dob}
   Address: {direccion}
   Phone: {telefono}    Email: {email}

   Designated agent: {agente}
   Agency: {agency}

2. GRANT OF AUTHORIZATION
By this document, I, {nombre}, give my express and informed consent for the agent identified above to act as my authorized representative in connection with my enrollment in and coverage under the Affordable Care Act ("ACA"), including all applicable federal and state Health Insurance Marketplaces.

3. SCOPE OF AUTHORIZATION
I authorize my agent to:
a) Create, access and modify my account on HealthCare.gov or the applicable state Marketplace portal.
b) Collect and submit the household, income and demographic information needed to determine my eligibility for subsidies (Premium Tax Credit and Cost-Sharing Reductions).
c) Compare available plans, recommend options and submit my enrollment application.
d) Make plan changes during the Open Enrollment Period or any Special Enrollment Period for which I qualify.
e) Communicate with the Marketplace, CMS and carriers on my behalf to resolve discrepancies and follow up on my case.

4. ACCURACY OF INFORMATION
I represent that the information I provide is true, complete and current. I understand that providing false information to the Marketplace can result in civil penalties, loss of subsidies and the obligation to repay amounts received in error.

5. NO ENROLLMENT OBLIGATION
I understand that signing this document does NOT obligate me to enroll in any particular plan. Any final coverage decision is mine alone.

6. AGENT COMPENSATION
I understand that my agent is paid a commission by the insurance carrier when I enroll in a plan, and that this commission does NOT increase my premium.

7. TERM AND REVOCATION
This consent takes effect on the date I sign it and remains in effect until I revoke it in writing. Revocation does not affect actions properly taken before the revocation is received.

Date: {fecha}
Client: {nombre}`;

const TPL_HIPAA_ES = `AUTORIZACIÓN PARA EL USO Y DIVULGACIÓN DE INFORMACIÓN MÉDICA PROTEGIDA (HIPAA)
Conforme a 45 CFR § 164.508

PACIENTE / TITULAR DE LA INFORMACIÓN
Nombre: {nombre}
Fecha de nacimiento: {dob}
Domicilio: {direccion}
Teléfono: {telefono}

1. PERSONAS Y ENTIDADES AUTORIZADAS A USAR Y DIVULGAR LA INFORMACIÓN
Autorizo a las siguientes partes a usar y divulgar mi información médica protegida (Protected Health Information, "PHI"):
- Mi agente de seguros {agente}, de la agencia {agency}.
- Aseguradoras y administradores de planes con los que mi agente coordine mi cobertura.
- Agencias federales y estatales relacionadas con mi elegibilidad (CMS, Medicaid, Marketplace estatal).

2. DESCRIPCIÓN DE LA INFORMACIÓN A USAR O DIVULGAR
a) Datos demográficos (nombre, dirección, teléfono, correo, fecha de nacimiento).
b) Número de Seguro Social, únicamente cuando sea necesario para inscripción o verificación de elegibilidad.
c) Información sobre cobertura médica actual y previa (aseguradora, número de póliza, fechas de cobertura, tipo de plan).
d) Historial general de condiciones de salud, diagnósticos, medicamentos y tratamientos, exclusivamente cuando sea necesario para determinar elegibilidad, comparar planes o gestionar reclamos.

3. PROPÓSITO DE LA DIVULGACIÓN
Esta divulgación se hace para los siguientes propósitos:
- Determinar mi elegibilidad para planes de seguro y subsidios.
- Inscribirme, mantener y modificar mi cobertura.
- Asistir en la resolución de reclamos médicos y disputas con aseguradoras.

4. DERECHO A REVOCAR
Tengo derecho a revocar esta autorización en cualquier momento mediante notificación por escrito enviada a mi agente o a la agencia. La revocación no afecta la información ya divulgada antes de recibir el aviso. La revocación puede impedir mi acceso a ciertos productos de seguro que requieran esta autorización.

5. POSIBILIDAD DE RE-DIVULGACIÓN
Entiendo que la información divulgada bajo esta autorización podría ser re-divulgada por el destinatario y, en ese caso, dejar de estar protegida por la regla HIPAA.

6. CONDICIONAMIENTO
Entiendo que mi agente no puede condicionar la prestación de servicios al hecho de que yo firme esta autorización, excepto cuando la cobertura específica solicitada lo requiera por ley o por la aseguradora.

7. EXPIRACIÓN
Esta autorización expira un (1) año a partir de la fecha de mi firma, o antes si la revoco por escrito.

8. COPIA
Tengo derecho a recibir una copia de este formulario firmado.

Fecha: {fecha}
Paciente: {nombre}`;

const TPL_HIPAA_EN = `AUTHORIZATION FOR USE AND DISCLOSURE OF PROTECTED HEALTH INFORMATION (HIPAA)
Pursuant to 45 CFR § 164.508

PATIENT / INFORMATION OWNER
Name: {nombre}
Date of birth: {dob}
Address: {direccion}
Phone: {telefono}

1. PERSONS AND ENTITIES AUTHORIZED TO USE AND DISCLOSE THE INFORMATION
I authorize the following parties to use and disclose my Protected Health Information ("PHI"):
- My insurance agent {agente}, of {agency}.
- Insurance carriers and plan administrators with which my agent coordinates my coverage.
- Federal and state agencies involved in my eligibility (CMS, Medicaid, state Marketplace).

2. DESCRIPTION OF THE INFORMATION TO BE USED OR DISCLOSED
a) Demographic data (name, address, phone, email, date of birth).
b) Social Security number, only as needed for enrollment or eligibility verification.
c) Current and prior health coverage information (carrier, policy number, coverage dates, plan type).
d) General health history, diagnoses, medications and treatments, only as needed to determine eligibility, compare plans or resolve claims.

3. PURPOSE OF THE DISCLOSURE
This disclosure is made for the following purposes:
- Determining my eligibility for insurance plans and subsidies.
- Enrolling in, maintaining and modifying my coverage.
- Assisting in the resolution of medical claims and disputes with insurance carriers.

4. RIGHT TO REVOKE
I have the right to revoke this authorization at any time by written notice to my agent or the agency. Revocation does not affect information already disclosed before the notice is received. Revocation may limit my access to certain insurance products that require this authorization.

5. POTENTIAL FOR RE-DISCLOSURE
I understand that information disclosed under this authorization may be re-disclosed by the recipient and, in that case, may no longer be protected by the HIPAA Privacy Rule.

6. CONDITIONING
I understand that my agent cannot condition services on my signing this authorization, except where the specific coverage requested requires it by law or by the insurance carrier.

7. EXPIRATION
This authorization expires one (1) year from the date I sign it, or earlier if I revoke it in writing.

8. COPY
I have the right to receive a copy of this signed form.

Date: {fecha}
Patient: {nombre}`;

const TPL_COMM_ES = `CONSENTIMIENTO PARA COMUNICACIONES ELECTRÓNICAS
Cumpliendo con la Ley TCPA (47 USC § 227) y las normas FCC 47 CFR § 64.1200

CLIENTE
Nombre: {nombre}
Teléfono: {telefono}
Correo electrónico: {email}

1. CONSENTIMIENTO EXPRESO POR ESCRITO
Por medio del presente, yo, {nombre}, doy mi consentimiento expreso y por escrito para recibir comunicaciones de mi agente de seguros {agente} y de {agency}, así como de las aseguradoras con las que mi agente coordina mi cobertura, en cualquiera de los siguientes canales:
a) Mensajes de texto (SMS) al número proporcionado arriba.
b) Mensajes a través de WhatsApp al número proporcionado arriba.
c) Llamadas telefónicas, incluyendo llamadas automatizadas y mensajes pregrabados.
d) Correo electrónico a la dirección proporcionada arriba.

2. PROPÓSITO DE LAS COMUNICACIONES
Las comunicaciones que recibiré incluyen, sin limitarse a:
- Avisos de renovación, vencimiento y cambios en mis pólizas.
- Recordatorios de documentos requeridos y fechas límite de inscripción.
- Información sobre nuevos productos o cambios regulatorios que afecten mi cobertura.
- Mensajes promocionales y de marketing relacionados con productos de seguro.

3. NO ES CONDICIÓN PARA RECIBIR SERVICIOS
Entiendo que mi consentimiento NO es una condición para recibir servicios de seguro. Puedo recibir servicios sin firmar este consentimiento, aunque la comunicación se limitaría a los canales requeridos por ley.

4. TARIFAS DEL OPERADOR
Entiendo que mi operador puede aplicar tarifas estándar por mensajes y datos. La frecuencia de los mensajes varía según mi actividad y los avisos pendientes en mi cuenta.

5. DERECHO A REVOCAR
Puedo revocar este consentimiento en cualquier momento:
- SMS y WhatsApp: respondiendo "STOP" o "ALTO" a cualquier mensaje.
- Llamadas: pidiendo verbalmente al operador que me retire de la lista.
- Correo: usando el enlace "darse de baja" al pie de cualquier mensaje o respondiendo "STOP".
La revocación se procesará dentro de los 30 días siguientes a la solicitud.

Fecha: {fecha}
Cliente: {nombre}`;

const TPL_COMM_EN = `CONSENT FOR ELECTRONIC COMMUNICATIONS
Pursuant to the Telephone Consumer Protection Act (47 USC § 227) and FCC rule 47 CFR § 64.1200

CLIENT
Name: {nombre}
Phone: {telefono}
Email: {email}

1. EXPRESS WRITTEN CONSENT
I, {nombre}, hereby give my express written consent to receive communications from my insurance agent {agente} and from {agency}, and from insurance carriers with which my agent coordinates my coverage, through any of the following channels:
a) Text messages (SMS) to the phone number above.
b) Messages through WhatsApp to the phone number above.
c) Telephone calls, including automated calls and prerecorded messages.
d) Email to the address above.

2. PURPOSE OF THE COMMUNICATIONS
The communications I will receive include, but are not limited to:
- Renewal, expiration and policy-change notices.
- Reminders of required documents and enrollment deadlines.
- Information about new products or regulatory changes affecting my coverage.
- Promotional and marketing messages related to insurance products.

3. NOT A CONDITION OF SERVICE
I understand that my consent is NOT a condition of receiving insurance services. I may receive services without signing this consent, although communications would be limited to channels required by law.

4. CARRIER FEES
I understand that my mobile carrier may apply standard message and data rates. Message frequency varies based on my account activity and pending notices.

5. RIGHT TO REVOKE
I may revoke this consent at any time by:
- SMS and WhatsApp: replying "STOP" to any message.
- Calls: verbally asking the agent or operator to remove me from the list.
- Email: using the "unsubscribe" link at the bottom of any message or replying "STOP".
Revocation will be processed within 30 days of the request.

Date: {fecha}
Client: {nombre}`;

const TPL_PLANCHG_ES = `AUTORIZACIÓN PARA CAMBIO DE PLAN DE SEGURO

PARTES
Cliente: {nombre}
Fecha de nacimiento: {dob}
Teléfono: {telefono}    Correo: {email}

Agente: {agente}    Agencia: {agency}

1. INSTRUCCIÓN DE CAMBIO
Por medio del presente, yo, {nombre}, autorizo a mi agente de seguros para realizar los cambios discutidos en mi cobertura actual, incluyendo, según sea aplicable:
a) Cambio de plan dentro del mismo carrier (por ejemplo, subir o bajar de nivel de cobertura).
b) Cambio de carrier (transferencia a otra aseguradora).
c) Adición o eliminación de dependientes en la póliza.
d) Cambio de método de pago, frecuencia o información de facturación.
e) Cancelación de la póliza actual cuando el nuevo plan haya sido aprobado.

2. RECONOCIMIENTO DE IMPLICACIONES
Entiendo y acepto que este cambio puede tener las siguientes implicaciones:
- Diferencia en el costo de mi prima mensual.
- Diferencia en deducibles, copagos, coaseguro y máximos de mi bolsillo.
- Cambios en la red de proveedores y farmacias contratadas.
- Posible interrupción de cobertura durante el periodo entre la cancelación del plan anterior y la entrada en vigor del nuevo plan.
- Posible pérdida de beneficios acumulados (por ejemplo, gastos aplicados al deducible del año en curso).

3. DECLARACIÓN DE INFORMACIÓN CORRECTA
Confirmo que la información que proporcioné a mi agente para fundamentar este cambio (incluyendo ingresos, composición familiar y necesidades médicas) es verdadera y completa.

4. NO HAY GARANTÍA DE APROBACIÓN
Entiendo que la solicitud está sujeta a la aprobación de la aseguradora o del Marketplace. Firmar este formulario no garantiza la aprobación final del cambio.

5. REVOCACIÓN
Puedo revocar esta autorización por escrito en cualquier momento ANTES de que el cambio sea procesado por la aseguradora. Una vez procesado el cambio, deberé seguir el procedimiento de cancelación o cambio establecido por la aseguradora.

Fecha: {fecha}
Cliente: {nombre}`;

const TPL_PLANCHG_EN = `INSURANCE PLAN CHANGE AUTHORIZATION

PARTIES
Client: {nombre}
Date of birth: {dob}
Phone: {telefono}    Email: {email}

Agent: {agente}    Agency: {agency}

1. CHANGE INSTRUCTION
By this document, I, {nombre}, authorize my insurance agent to make the changes we discussed to my current coverage, including, as applicable:
a) Plan change within the same carrier (e.g., upgrading or downgrading coverage).
b) Carrier change (transferring to another insurance carrier).
c) Addition or removal of dependents on the policy.
d) Change of payment method, frequency or billing information.
e) Cancellation of the current policy once the new plan has been approved.

2. ACKNOWLEDGMENT OF IMPLICATIONS
I understand and accept that this change may have the following implications:
- Difference in monthly premium cost.
- Difference in deductibles, copays, coinsurance and out-of-pocket maximums.
- Changes to the network of contracted providers and pharmacies.
- Possible coverage gap between cancellation of the prior plan and the effective date of the new plan.
- Possible loss of accumulated benefits (e.g., expenses applied toward the current year's deductible).

3. ACCURACY OF INFORMATION
I confirm that the information I gave my agent to support this change (including income, household composition and medical needs) is true and complete.

4. NO GUARANTEE OF APPROVAL
I understand that the request is subject to approval by the carrier or the Marketplace. Signing this form does not guarantee final approval of the change.

5. REVOCATION
I may revoke this authorization in writing at any time BEFORE the change has been processed by the carrier. Once the change has been processed, I must follow the cancellation or change procedure established by the carrier.

Date: {fecha}
Client: {nombre}`;

const TPL_MEDSOA_ES = `ALCANCE DEL CONSENTIMIENTO PARA UNA CITA — MEDICARE
(Scope of Appointment — SOA, conforme a 42 CFR § 422.2274)

BENEFICIARIO DE MEDICARE
Nombre: {nombre}
Fecha de nacimiento: {dob}
Teléfono: {telefono}
Dirección: {direccion}

AGENTE / CORREDOR
Nombre del agente: {agente}
Agencia: {agency}
Teléfono del agente: (a completar por el agente)
Número de licencia: (a completar por el agente)

1. PROPÓSITO DE ESTE FORMULARIO
Las normas de Medicare requieren que los agentes y corredores documenten antes de una cita los tipos de productos que el beneficiario aceptó que se discutan. Este formulario únicamente confirma esos tipos de productos. Firmarlo NO constituye una solicitud de inscripción en ningún plan.

2. TIPOS DE PRODUCTOS AUTORIZADOS PARA DISCUTIR
Marque cada categoría que el beneficiario aceptó discutir en esta cita:
[ ] Medicare Advantage (Parte C) / Medicare Advantage con Medicamentos Recetados (MAPD)
[ ] Plan de Medicamentos Recetados (Parte D / PDP)
[ ] Medicare Supplement (Medigap)
[ ] Plan de Salud Hospitalario / Hospital Indemnity
[ ] Plan Dental / Visión / Auditivo independiente
[ ] Otro: ________________________

3. RECONOCIMIENTOS DEL BENEFICIARIO
Reconozco y entiendo que:
a) Esta cita no obliga a inscribirme en ningún plan, no afecta mi cobertura actual de Medicare y no me inscribe automáticamente en ningún programa.
b) El agente solo discutirá los productos marcados arriba. Si deseo información sobre otros productos, debo solicitar y firmar un nuevo formulario SOA antes de discutirlos.
c) Puedo poner fin a la cita en cualquier momento.
d) Puedo encontrar opciones de planes de Medicare en www.medicare.gov o llamando al 1-800-MEDICARE.
e) El agente trabaja con un número limitado de carriers de Medicare y no representa a la totalidad del mercado.

4. INFORMACIÓN DE CONTACTO PROPORCIONADA
Mi información de contacto (teléfono, correo, dirección) será usada únicamente para coordinar esta cita y dar seguimiento a los productos discutidos. NO se compartirá ni se venderá a terceros con fines de marketing.

Fecha de la cita: {fecha}
Beneficiario: {nombre}`;

const TPL_MEDSOA_EN = `MEDICARE SCOPE OF APPOINTMENT (SOA)
Pursuant to 42 CFR § 422.2274

MEDICARE BENEFICIARY
Name: {nombre}
Date of birth: {dob}
Phone: {telefono}
Address: {direccion}

AGENT / BROKER
Agent name: {agente}
Agency: {agency}
Agent phone: (to be completed by the agent)
License number: (to be completed by the agent)

1. PURPOSE OF THIS FORM
Medicare rules require agents and brokers to document, prior to a personal marketing appointment, the product types the beneficiary agreed to discuss. This form only confirms those product types. Signing it does NOT constitute an enrollment request in any plan.

2. PRODUCT TYPES AUTHORIZED FOR DISCUSSION
Check each category the beneficiary agreed to discuss in this appointment:
[ ] Medicare Advantage (Part C) / Medicare Advantage with Prescription Drug coverage (MAPD)
[ ] Prescription Drug Plan (Part D / PDP)
[ ] Medicare Supplement (Medigap)
[ ] Hospital Indemnity plan
[ ] Standalone Dental / Vision / Hearing plan
[ ] Other: ________________________

3. BENEFICIARY ACKNOWLEDGMENTS
I acknowledge and understand that:
a) This appointment does not obligate me to enroll in any plan, does not affect my current Medicare coverage and does not automatically enroll me in any program.
b) The agent will discuss only the products checked above. To discuss other products, I must request and sign a new SOA before they may be discussed.
c) I may end the appointment at any time.
d) I can find Medicare plan options at www.medicare.gov or by calling 1-800-MEDICARE.
e) The agent represents a limited number of Medicare carriers and does not represent the entire market.

4. CONTACT INFORMATION
My contact information (phone, email, address) will be used only to coordinate this appointment and to follow up on the products discussed. It will NOT be shared or sold to third parties for marketing purposes.

Appointment date: {fecha}
Beneficiary: {nombre}`;

const TPL_LIFE_ES = `AUTORIZACIÓN PARA SOLICITUD DE SEGURO DE VIDA

SOLICITANTE / ASEGURADO PROPUESTO
Nombre: {nombre}
Fecha de nacimiento: {dob}
Domicilio: {direccion}
Teléfono: {telefono}    Correo: {email}

Agente: {agente}    Agencia: {agency}

1. AUTORIZACIÓN PARA OBTENER INFORMACIÓN
Por medio del presente, yo, {nombre}, autorizo a las aseguradoras de vida con las que mi agente presente solicitud a obtener y usar la siguiente información para evaluar mi asegurabilidad, mi prima y la emisión de la póliza:
a) Mi historial médico, incluyendo expedientes y reportes de médicos, hospitales, clínicas, farmacias, laboratorios y otros proveedores de salud que me hayan atendido.
b) Información del Medical Information Bureau (MIB), incluyendo cualquier reporte de aseguradoras anteriores.
c) Mi historial de manejo y de antecedentes (DMV, MVR, reportes criminales públicos) cuando sea relevante.
d) Mi historial financiero y de crédito cuando la aseguradora lo requiera para verificar capacidad de pago de prima.
e) Información de seguros de vida previos, incluyendo aplicaciones pendientes y rechazos.

2. PROPÓSITO Y USO
La información será usada exclusivamente para:
- Evaluar mi solicitud de seguro de vida.
- Determinar la clase de riesgo y la prima aplicable.
- Detectar y prevenir fraude.
- Cumplir con requisitos regulatorios.

3. RE-DIVULGACIÓN
Entiendo que la información puede ser compartida con MIB, reaseguradoras y agencias gubernamentales según lo permita la ley, y podría dejar de estar protegida por leyes de privacidad de salud.

4. DECLARACIÓN
Declaro que toda la información que proporcioné en mi solicitud es verdadera y completa a mi mejor entendimiento. Entiendo que la omisión o falsedad de información material puede resultar en la negación de cobertura o en la rescisión de la póliza, y en la pérdida de las primas pagadas.

5. DURACIÓN Y REVOCACIÓN
Esta autorización es válida por veinticuatro (24) meses a partir de la fecha de mi firma. Puedo revocarla por escrito en cualquier momento; la revocación no afecta información ya divulgada.

6. COPIA
Tengo derecho a recibir una copia de este formulario y a solicitar a cualquier aseguradora que reciba mi información que me proporcione una copia.

Fecha: {fecha}
Solicitante: {nombre}`;

const TPL_LIFE_EN = `LIFE INSURANCE APPLICATION AUTHORIZATION

APPLICANT / PROPOSED INSURED
Name: {nombre}
Date of birth: {dob}
Address: {direccion}
Phone: {telefono}    Email: {email}

Agent: {agente}    Agency: {agency}

1. AUTHORIZATION TO OBTAIN INFORMATION
By this document, I, {nombre}, authorize the life insurance carriers to which my agent submits an application to obtain and use the following information to evaluate my insurability, premium and policy issuance:
a) My medical history, including records and reports from doctors, hospitals, clinics, pharmacies, laboratories and other health providers who have treated me.
b) Information from the Medical Information Bureau (MIB), including any reports from prior insurers.
c) My driving and background history (DMV, MVR, public criminal records) where relevant.
d) My financial and credit history when the carrier requires it to verify premium payment capacity.
e) Prior life insurance information, including pending applications and declinations.

2. PURPOSE AND USE
The information will be used solely for:
- Evaluating my life insurance application.
- Determining the risk class and applicable premium.
- Detecting and preventing fraud.
- Complying with regulatory requirements.

3. RE-DISCLOSURE
I understand that the information may be shared with MIB, reinsurers and government agencies as permitted by law, and may no longer be protected by health privacy laws.

4. REPRESENTATION
I represent that all information I provided in my application is true and complete to the best of my knowledge. I understand that omission or material misrepresentation may result in denial of coverage or rescission of the policy, and forfeiture of premiums paid.

5. TERM AND REVOCATION
This authorization is valid for twenty-four (24) months from the date I sign it. I may revoke it in writing at any time; revocation does not affect information already disclosed.

6. COPY
I have the right to receive a copy of this form and to request a copy from any carrier that receives my information.

Date: {fecha}
Applicant: {nombre}`;

const TPL_PC_ES = `AUTORIZACIÓN PARA SOLICITUD DE SEGURO DE AUTO / PROPIEDAD (P&C)

SOLICITANTE
Nombre: {nombre}
Fecha de nacimiento: {dob}
Domicilio asegurado: {direccion}
Teléfono: {telefono}    Correo: {email}

Agente: {agente}    Agencia: {agency}

1. AUTORIZACIÓN
Por medio del presente, yo, {nombre}, autorizo a mi agente a presentar mi solicitud de seguro de auto y/o propiedad (Property & Casualty) con las aseguradoras seleccionadas, y a obtener la información necesaria para cotizar y emitir mi póliza, incluyendo:
a) Mi reporte de manejo (Motor Vehicle Record, MVR) y reporte de seguros previos (Comprehensive Loss Underwriting Exchange, CLUE).
b) Mi historial de crédito basado en seguros (Insurance Credit Score) cuando la ley estatal lo permita.
c) Información sobre la propiedad asegurada (avalúos públicos, reportes de zona de riesgo, fotos exteriores tomadas por inspectores autorizados).
d) Información sobre vehículos asegurados (VIN, año, marca, modelo, uso, kilometraje).

2. DECLARACIONES
Declaro que:
a) La información que proporcioné en mi solicitud es verdadera y completa.
b) He divulgado a mi agente todos los conductores del hogar, todas las reclamaciones de los últimos cinco (5) años y todas las violaciones de tránsito de los últimos tres (3) años, según aplique.
c) La propiedad o vehículos a asegurar son de mi propiedad o tengo interés asegurable legítimo en ellos.

3. PRIMA Y PAGO
Entiendo que la prima cotizada está sujeta a verificación por la aseguradora y puede ajustarse si la información verificada difiere de la solicitud. Cualquier diferencia me será comunicada antes de la emisión final.

4. CANCELACIÓN DE PÓLIZA ANTERIOR
Si esta solicitud reemplaza una póliza existente, autorizo a mi agente a coordinar la cancelación de la póliza anterior una vez que la nueva esté en vigor, a fin de evitar gaps de cobertura.

5. AVISO DE FRAUDE
Entiendo que cualquier persona que con la intención de defraudar o engañar a una aseguradora presente una solicitud que contenga información falsa o incompleta comete un acto de fraude de seguros, sujeto a sanciones penales y civiles bajo las leyes del estado donde se emita la póliza.

Fecha: {fecha}
Solicitante: {nombre}`;

const TPL_PC_EN = `AUTO / PROPERTY (P&C) INSURANCE APPLICATION AUTHORIZATION

APPLICANT
Name: {nombre}
Date of birth: {dob}
Insured address: {direccion}
Phone: {telefono}    Email: {email}

Agent: {agente}    Agency: {agency}

1. AUTHORIZATION
By this document, I, {nombre}, authorize my agent to submit my auto and/or property (Property & Casualty) insurance application to selected carriers, and to obtain the information needed to quote and issue my policy, including:
a) My driving record (Motor Vehicle Record, MVR) and prior insurance loss report (Comprehensive Loss Underwriting Exchange, CLUE).
b) My insurance-based credit score when permitted by state law.
c) Information about the insured property (public assessment records, risk-zone reports, exterior photos taken by authorized inspectors).
d) Information about insured vehicles (VIN, year, make, model, use, mileage).

2. REPRESENTATIONS
I represent that:
a) The information I provided in my application is true and complete.
b) I have disclosed to my agent all household drivers, all claims from the last five (5) years and all traffic violations from the last three (3) years, as applicable.
c) The property or vehicles to be insured are mine or I have a legitimate insurable interest in them.

3. PREMIUM AND PAYMENT
I understand that the quoted premium is subject to carrier verification and may be adjusted if verified information differs from the application. Any difference will be communicated to me before final issuance.

4. CANCELLATION OF PRIOR POLICY
If this application replaces an existing policy, I authorize my agent to coordinate the cancellation of the prior policy once the new one is in effect, to avoid coverage gaps.

5. FRAUD WARNING
I understand that any person who, with intent to defraud or deceive an insurance carrier, submits an application containing false or incomplete information commits an act of insurance fraud, subject to criminal and civil penalties under the laws of the state where the policy is issued.

Date: {fecha}
Applicant: {nombre}`;

// Self-Employment Income Affidavit — income verification for self-employed
// Marketplace applicants who have no pay stubs / W-2. The {{...}} business and
// income fields have no client-record equivalent, so the Send modal prompts
// the agent to type them (SignaturesView customFields → fillTemplate extras).
// Same placeholder names in ES and EN so one set of inputs fills both bodies.
const TPL_SELFEMP_ES = `DECLARACIÓN JURADA DE INGRESOS — TRABAJO POR CUENTA PROPIA
(Self-Employment Income Affidavit)

DECLARANTE
Nombre: {nombre}
Fecha de nacimiento: {dob}
Domicilio: {direccion}
Teléfono: {telefono}    Correo: {email}

Agente: {agente}    Agencia: {agency}

1. DECLARACIÓN DE ACTIVIDAD
Yo, {nombre}, declaro que trabajo por cuenta propia (self-employed) y que la siguiente información describe mi actividad y mis ingresos actuales:
- Nombre del negocio o actividad: {{nombreNegocio}}
- Tipo de trabajo o servicios que realizo: {{tipoTrabajo}}
- Trabajo por cuenta propia desde (mes/año): {{inicioActividad}}

2. INGRESOS DECLARADOS
- Ingreso BRUTO mensual promedio: {{ingresoBrutoMensual}}
- Gastos de negocio mensuales promedio: {{gastosMensuales}}
- Ingreso NETO mensual promedio (bruto menos gastos): {{ingresoNetoMensual}}
- Ingreso neto ANUAL estimado para el año en curso: {{ingresoNetoAnual}}

3. FALTA DE DOCUMENTACIÓN TRADICIONAL
Declaro que, por la naturaleza de mi trabajo, no recibo talones de pago (pay stubs) ni formulario W-2 de un empleador por esta actividad. Presento esta declaración jurada como evidencia de mis ingresos para la verificación de elegibilidad ante el Mercado de Seguros Médicos (Health Insurance Marketplace) y/o la agencia estatal correspondiente. Mantengo registros de mi actividad (facturas, recibos, estados de cuenta bancarios, declaración de impuestos con Schedule C) y puedo presentarlos si me son requeridos.

4. OBLIGACIÓN DE REPORTAR CAMBIOS
Entiendo que debo reportar al Mercado cualquier cambio en mis ingresos o en la composición de mi hogar dentro de los treinta (30) días siguientes al cambio, ya que los subsidios (Premium Tax Credit y Cost-Sharing Reductions) se basan en mi ingreso anual estimado y se reconcilian en mi declaración de impuestos federal.

5. DECLARACIÓN BAJO PENA DE PERJURIO
Declaro bajo pena de perjurio que la información contenida en este documento es verdadera, correcta y completa a mi mejor saber y entender. Entiendo que proporcionar información falsa puede resultar en la pérdida de mi cobertura o de mis subsidios, en la obligación de reembolsar créditos fiscales recibidos indebidamente, y en sanciones civiles o penales bajo las leyes federales y estatales aplicables.

Fecha: {fecha}
Declarante: {nombre}`;

const TPL_SELFEMP_EN = `SELF-EMPLOYMENT INCOME AFFIDAVIT

AFFIANT
Name: {nombre}
Date of birth: {dob}
Address: {direccion}
Phone: {telefono}    Email: {email}

Agent: {agente}    Agency: {agency}

1. STATEMENT OF SELF-EMPLOYMENT
I, {nombre}, declare that I am self-employed and that the following information describes my current work activity and income:
- Business or activity name: {{nombreNegocio}}
- Type of work or services performed: {{tipoTrabajo}}
- Self-employed since (month/year): {{inicioActividad}}

2. DECLARED INCOME
- Average monthly GROSS income: {{ingresoBrutoMensual}}
- Average monthly business expenses: {{gastosMensuales}}
- Average monthly NET income (gross minus expenses): {{ingresoNetoMensual}}
- Estimated ANNUAL net income for the current year: {{ingresoNetoAnual}}

3. LACK OF TRADITIONAL DOCUMENTATION
I declare that, due to the nature of my work, I do not receive pay stubs or a W-2 form from an employer for this activity. I submit this affidavit as evidence of my income for eligibility verification with the Health Insurance Marketplace and/or the applicable state agency. I keep records of my activity (invoices, receipts, bank statements, tax return with Schedule C) and can provide them upon request.

4. DUTY TO REPORT CHANGES
I understand that I must report to the Marketplace any change in my income or household composition within thirty (30) days of the change, since subsidies (Premium Tax Credit and Cost-Sharing Reductions) are based on my estimated annual income and are reconciled on my federal tax return.

5. DECLARATION UNDER PENALTY OF PERJURY
I declare under penalty of perjury that the information contained in this document is true, correct and complete to the best of my knowledge and belief. I understand that providing false information may result in the loss of my coverage or subsidies, the obligation to repay improperly received tax credits, and civil or criminal penalties under applicable federal and state law.

Date: {fecha}
Affiant: {nombre}`;

// CARTA DE CANCELACIÓN DE PÓLIZA (Lissette 2026-10-15): "en la parte de firma
// agregar para personalizar una carta para que firme el cliente la fecha de
// cancelación de póliza". {fechaCancelacion} y {motivoCancelacion} salen de la
// póliza adjunta si ya los tiene; si no, la ventana de envío los pide como
// campos libres. Como todas las plantillas, la agencia la puede editar.
const TPL_CANCEL_ES = `SOLICITUD DE CANCELACIÓN DE PÓLIZA

Fecha: {fecha}

Para: {carrier}

DATOS DEL ASEGURADO
Nombre: {nombre}
Fecha de nacimiento: {dob}
Dirección: {direccion}
Teléfono: {telefono}    Correo: {email}

DATOS DE LA PÓLIZA
Número de póliza: {policyNumber}
Member ID: {memberId}
Personas aseguradas: {insuredPersons}

1. SOLICITUD
Por medio de la presente, yo, {nombre}, solicito la cancelación de la póliza arriba indicada, con fecha efectiva de cancelación: {fechaCancelacion}.

Motivo de la cancelación: {motivoCancelacion}

2. RECONOCIMIENTO
Entiendo y acepto que:
- A partir de la fecha de cancelación dejaré de tener cobertura bajo esta póliza, y no se pagarán reclamaciones por servicios recibidos después de esa fecha.
- Soy responsable de cualquier prima pendiente hasta la fecha de cancelación.
- La póliza no se renovará. Si más adelante deseo cobertura, deberé solicitarla de nuevo durante un periodo de inscripción válido.

3. AUTORIZACIÓN
Autorizo a mi agente {agente}, de {agency}, a presentar esta solicitud de cancelación ante la aseguradora en mi nombre.

Fecha: {fecha}
Asegurado: {nombre}`;

const TPL_CANCEL_EN = `POLICY CANCELLATION REQUEST

Date: {fecha}

To: {carrier}

INSURED INFORMATION
Name: {nombre}
Date of birth: {dob}
Address: {direccion}
Phone: {telefono}    Email: {email}

POLICY INFORMATION
Policy number: {policyNumber}
Member ID: {memberId}
Insured persons: {insuredPersons}

1. REQUEST
By this letter, I, {nombre}, request the cancellation of the policy listed above, with an effective cancellation date of: {fechaCancelacion}.

Reason for cancellation: {motivoCancelacion}

2. ACKNOWLEDGMENT
I understand and agree that:
- As of the cancellation date I will no longer have coverage under this policy, and no claims will be paid for services received after that date.
- I am responsible for any premium owed up to the cancellation date.
- The policy will not renew. If I want coverage later, I must apply again during a valid enrollment period.

3. AUTHORIZATION
I authorize my agent {agente}, of {agency}, to submit this cancellation request to the carrier on my behalf.

Date: {fecha}
Insured: {nombre}`;

export const SEED_DOC_TEMPLATES = [
  { id: "ct1", category: "consent",       name: "Consentimiento ACA / Marketplace", nameEn: "ACA / Marketplace Consent",            bodyEs: TPL_ACA_ES,     bodyEn: TPL_ACA_EN,     body: TPL_ACA_ES,     createdAt: "2025-01-01", source: "system" },
  { id: "ct2", category: "hipaa",         name: "Autorización HIPAA",               nameEn: "HIPAA Authorization",                   bodyEs: TPL_HIPAA_ES,   bodyEn: TPL_HIPAA_EN,   body: TPL_HIPAA_ES,   createdAt: "2025-01-01", source: "system" },
  { id: "ct3", category: "communication", name: "Consentimiento de Comunicación",   nameEn: "Communication Consent",                 bodyEs: TPL_COMM_ES,    bodyEn: TPL_COMM_EN,    body: TPL_COMM_ES,    createdAt: "2025-01-01", source: "system" },
  { id: "ct4", category: "plan_change",   name: "Autorización Cambio de Plan",      nameEn: "Plan Change Authorization",             bodyEs: TPL_PLANCHG_ES, bodyEn: TPL_PLANCHG_EN, body: TPL_PLANCHG_ES, createdAt: "2025-01-01", source: "system" },
  { id: "ct5", category: "medicare_soa",  name: "Medicare — Scope of Appointment",  nameEn: "Medicare Scope of Appointment",         bodyEs: TPL_MEDSOA_ES,  bodyEn: TPL_MEDSOA_EN,  body: TPL_MEDSOA_ES,  createdAt: "2025-01-01", source: "system" },
  { id: "ct6", category: "life_app",      name: "Autorización Solicitud Vida",      nameEn: "Life Insurance App Authorization",      bodyEs: TPL_LIFE_ES,    bodyEn: TPL_LIFE_EN,    body: TPL_LIFE_ES,    createdAt: "2025-01-01", source: "system" },
  { id: "ct7", category: "auto_pc",       name: "Autorización Auto / P&C",          nameEn: "Auto / P&C Application Authorization",  bodyEs: TPL_PC_ES,      bodyEn: TPL_PC_EN,      body: TPL_PC_ES,      createdAt: "2025-01-01", source: "system" },
  { id: "ct8", category: "self_employment", name: "Declaración Jurada — Ingresos por Cuenta Propia", nameEn: "Self-Employment Income Affidavit", bodyEs: TPL_SELFEMP_ES, bodyEn: TPL_SELFEMP_EN, body: TPL_SELFEMP_ES, createdAt: "2026-07-02", source: "system" },
  { id: "ct9", category: "policy_cancellation", name: "Carta de Cancelación de Póliza", nameEn: "Policy Cancellation Letter", bodyEs: TPL_CANCEL_ES, bodyEn: TPL_CANCEL_EN, body: TPL_CANCEL_ES, createdAt: "2026-10-15", source: "system" },
];


// ============================================================
// Email helpers — shared by ClientCommsTab (Email channel uses the
// ClientEmailMessage backend via SendGrid Inbound Parse).
// `escapeHtml` runs on the composer text before send; `stripHtmlToText`
// renders inbound HTML emails as readable plain text in the chat bubble.
// ============================================================

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function stripHtmlToText(html) {
  if (!html) return '';
  return String(html).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}

// Parse a pasted WhatsApp / iMessage / SMS conversation into bubble-
// shaped messages. Handles the common export formats agents see:
//
//   WhatsApp Web (US):   [5/14/26, 10:32:14 AM] Maria Lopez: Hola
//   WhatsApp export:     5/14/26, 10:32 - Maria Lopez: Hola
//   WhatsApp en español: [14/5/26 10:32] Maria: Hola
//   iMessage paste:      May 14, 2026 10:32 AM — Maria: Hola
//
// `selfNames` is the list of names that should be marked direction='out'
// (typically the logged-in agent + any "You" / "Tú" sentinel). Anything
// else becomes direction='in'. Lines that don't match a recognized
// header are attached to the previous message as additional body text
// (multi-line messages are common in WhatsApp exports).
function parsePastedConversation(text, { selfNames = [], lang = 'en' } = {}) {
  const lines = String(text || '').split(/\r?\n/);
  const out = [];
  // One regex covers the common formats — date + optional comma + time
  // + optional separator + sender + colon + body. The order of capture
  // groups is: 1=date, 2=time, 3=sender, 4=body.
  const headerRe = /^\s*\[?\s*(\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4})[,\s]+(\d{1,2}:\d{2}(?::\d{2})?\s*(?:AM|PM|am|pm)?)\s*\]?\s*[-—]?\s*([^:]+?):\s*(.*)$/;
  const selfSet = new Set(selfNames.map((s) => String(s).trim().toLowerCase()).filter(Boolean));
  // Common "self" sentinels regardless of language.
  ['you', 'me', 'tú', 'tu', 'yo'].forEach((s) => selfSet.add(s));
  let current = null;
  for (const raw of lines) {
    const m = raw.match(headerRe);
    if (m) {
      if (current) out.push(current);
      const [, datePart, timePart, sender, body] = m;
      const senderTrim = sender.trim();
      const isSelf = selfSet.has(senderTrim.toLowerCase());
      current = {
        id: 'paste_' + out.length + '_' + Math.random().toString(36).slice(2, 6),
        dir: isSelf ? 'out' : 'in',
        text: body || '',
        time: timePart,
        date: datePart,
        sender: senderTrim,
        status: 'read',
        _pasted: true,
      };
    } else if (current && raw.trim()) {
      // Continuation line of the previous message.
      current.text = (current.text + '\n' + raw).trim();
    }
  }
  if (current) out.push(current);
  return out;
}

function apiEmailToBubble(msg, lang) {
  const date = new Date(msg.sentAt || msg.receivedAt || msg.createdAt);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const isToday = date.toDateString() === today.toDateString();
  const isYesterday = date.toDateString() === yesterday.toDateString();
  const dateLabel = isToday
    ? (lang === 'es' ? 'Hoy' : 'Today')
    : isYesterday
      ? (lang === 'es' ? 'Ayer' : 'Yesterday')
      : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  return {
    id: msg.id,
    dir: msg.direction === 'OUTBOUND' ? 'out' : 'in',
    subject: msg.subject || '',
    text: msg.bodyText || stripHtmlToText(msg.bodyHtml) || '',
    time: date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
    date: dateLabel,
    status: msg.direction === 'OUTBOUND' ? 'sent' : 'read',
    labels: Array.isArray(msg.labels) ? msg.labels : [],
    _real: true, // marker so the delete button only shows on real (server) rows
  };
}

// Picker for attaching a client's own documents to an outbound email. Groups
// the documents by tab (policy type, from folderType/lineCategory) → folder, so
// the agent navigates them exactly like the Documents tab. Each picked doc can
// go as a 7-day secure LINK (default) or a real file ATTACHMENT.
function DocAttachPicker({ docs = [], sel = {}, onChange, onClose, lang }) {
  const es = lang === "es";
  const groups = useMemo(() => {
    const m = new Map(); // tabId -> { label, folders: Map(folderName -> docs[]) }
    (docs || []).forEach((d) => {
      const tabId = d.folderType || d.lineCategory || "";
      const pt = tabId ? getPolicyType(tabId) : null;
      const tabLabel = pt ? (es ? (pt.labelEs || pt.label) : pt.label) : (es ? "General" : "General");
      if (!m.has(tabId)) m.set(tabId, { label: tabLabel, folders: new Map() });
      const folderName = d.folder || (es ? "General" : "General");
      const g = m.get(tabId);
      if (!g.folders.has(folderName)) g.folders.set(folderName, []);
      g.folders.get(folderName).push(d);
    });
    return [...m.entries()].map(([id, v]) => ({ id, label: v.label, folders: [...v.folders.entries()].map(([name, ds]) => ({ name, docs: ds })) }));
  }, [docs, es]);

  const toggle = (id) => onChange((s) => { const n = { ...s }; if (n[id]) delete n[id]; else n[id] = "link"; return n; });
  const setMode = (id, mode) => onChange((s) => ({ ...s, [id]: mode }));
  const modeBtn = (active) => ({ display: "inline-flex", alignItems: "center", gap: 3, padding: ".15rem .45rem", borderRadius: 7, fontSize: ".62rem", fontWeight: 700, cursor: "pointer", border: "1px solid " + (active ? "var(--c-cyan,#00d4ff)" : "var(--c-border,#1a3550)"), background: active ? "var(--c-cyan,#00d4ff)22" : "transparent", color: active ? "var(--c-cyan,#00d4ff)" : "var(--c-text2,#7aa3c0)" });

  return (
    <Modal title={es ? "Adjuntar documentos" : "Attach documents"} onClose={onClose}>
      <div style={{ display: "flex", flexDirection: "column", gap: ".8rem" }}>
        {groups.length === 0 ? (
          <div style={{ fontSize: ".82rem", color: "var(--c-text3,#45688a)", padding: "1rem", textAlign: "center" }}>
            {es ? "Este cliente no tiene documentos subidos." : "This client has no uploaded documents."}
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxHeight: "55vh", overflowY: "auto" }}>
            {groups.map((g) => (
              <div key={g.id || "general"}>
                <div style={{ fontSize: ".7rem", fontWeight: 800, color: "var(--c-cyan,#00d4ff)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: ".35rem" }}>📁 {g.label}</div>
                {g.folders.map((f) => (
                  <div key={f.name} style={{ marginLeft: ".4rem", marginBottom: ".5rem" }}>
                    <div style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)", margin: ".15rem 0 .25rem" }}>{f.name}</div>
                    {f.docs.map((d) => (
                      <div key={d.id} style={{ display: "flex", alignItems: "center", gap: ".5rem", padding: ".25rem .35rem", fontSize: ".78rem" }}>
                        <input type="checkbox" checked={!!sel[d.id]} onChange={() => toggle(d.id)} />
                        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "var(--c-text,#c8dff0)" }}>{d.name}{d.size ? <span style={{ color: "var(--c-text3,#45688a)", fontSize: ".66rem" }}> · {d.size}</span> : null}</span>
                        {sel[d.id] && (
                          <span style={{ display: "inline-flex", gap: 3 }}>
                            <span title={es ? "Enlace seguro (7 días)" : "Secure link (7 days)"} style={modeBtn(sel[d.id] === "link")} onClick={() => setMode(d.id, "link")}><Link2 size={11} /> {es ? "Enlace" : "Link"}</span>
                            <span title={es ? "Adjuntar archivo real" : "Attach real file"} style={modeBtn(sel[d.id] === "attach")} onClick={() => setMode(d.id, "attach")}><Paperclip size={11} /> {es ? "Archivo" : "File"}</span>
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
        <div style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)" }}>{es ? "Enlace = descarga segura por 7 días. Archivo = adjunto real (máx. 4 MB c/u; si pesa más se manda como enlace)." : "Link = secure 7-day download. File = real attachment (max 4 MB each; larger is sent as a link)."}</div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: ".5rem" }}>
          <button type="button" className="dkt-btn primary" onClick={onClose}>{es ? `Listo (${Object.keys(sel).length})` : `Done (${Object.keys(sel).length})`}</button>
        </div>
      </div>
    </Modal>
  );
}

export function ClientCommsTab({ client, lang, currentUser, docs = [], onDocsChange }) {
  const [channel, setChannel] = useState("whatsapp");
  // Client phone, digits+leading-plus only (wa.me / providers need it clean).
  // Was referenced by sendMsg but never DEFINED in this component — every
  // SMS/WhatsApp send from the Messages tab died with an uncaught
  // "ReferenceError: phone is not defined" and no visible reaction
  // (Lissette 2026-07-16, console screenshot).
  const phone = (client?.phone || '').replace(/[^0-9+]/g, '');
  const [allMsgs, setAllMsgs] = useState({
    // WhatsApp / SMS start EMPTY. Real conversations land here via the
    // "📋 Pegar" button (parsed + encrypted into PastedConversation, F-N1)
    // or are sent off-platform via click-to-send (wa.me / sms: deep links).
    // No mock seed data — agents must never see fabricated client chats.
    whatsapp: [],
    sms: [],
    // Email is loaded from the real CRM backend (ClientEmailMessage table)
    // via apiListClientEmails on first switch into the email tab — see the
    // useEffect just below this state init.
    email: [],
  });
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [emailSending, setEmailSending] = useState(false);
  const [smsSending, setSmsSending] = useState(false);
  // MMS images to attach to the next SMS (Lissette 2026-07-16): uploaded to
  // Blob via the notes attachment-sas flow; only the blobUrl refs go with the
  // send — the backend signs them for the provider.
  const [smsImgs, setSmsImgs] = useState([]); // [{name,blobUrl,_preview}]
  const [smsImgUploading, setSmsImgUploading] = useState(false);
  const smsImgRef = useRef(null);
  const addSmsImages = async (files) => {
    const imgs = [...files].filter((f) => f && f.type && f.type.startsWith('image/'));
    if (!imgs.length) return;
    if (smsImgs.length + imgs.length > 3) { toast.error(lang === 'es' ? 'Máximo 3 imágenes por SMS.' : 'Max 3 images per SMS.'); return; }
    setSmsImgUploading(true);
    try {
      for (const f of imgs) {
        const ref = await apiUploadNoteAttachment(f);
        setSmsImgs((prev) => [...prev, { name: f.name || 'imagen.png', blobUrl: ref.blobUrl, _preview: URL.createObjectURL(f) }]);
      }
    } catch (e) { toast.error((lang === 'es' ? 'No se pudo subir la imagen: ' : 'Image upload failed: ') + (e.message || e)); }
    finally { setSmsImgUploading(false); }
  };
  // Label filter — when set, the email channel only shows messages whose
  // labels array contains the selected value. Declared up here (instead of
  // next to its consumers further down) because `msgs` reads it during the
  // initial render path; if the declaration sat below that read site the
  // first render with channel="email" hit a Temporal Dead Zone and the
  // whole tree blanked out.
  const [emailLabelFilter, setEmailLabelFilter] = useState('');

  // Pasted WhatsApp / SMS conversations — F-N1 (audit 2026-05-20 v2)
  // migrated from localStorage (`dkt6_pasted_<clientId>_<channel>`) to an
  // encrypted backend table. localStorage is read ONCE as a migration
  // shim and uploaded to the server, then cleared. After that, the
  // server is the single source of truth.
  const pasteKey = (ch) => `dkt6_pasted_${client.id}_${ch}`;
  // RECARGA EN VIVO (Lissette 2026-10-25: "no se están sincronizando
  // automáticamente nada"). La extensión de WhatsApp guarda en el servidor y
  // éste avisa con `client.updated` ("Nudge any open ClientDetail…", en
  // integrations.routes.ts), pero esta pestaña solo pedía los mensajes al
  // cambiar de canal o de cliente: nadie escuchaba ese aviso. Con la ficha
  // abierta, lo que la extensión guardaba no aparecía hasta salir y volver.
  // Cada aviso para ESTE cliente sube el contador y el efecto de abajo vuelve
  // a pedir la copia del servidor.
  const [recargaPegados, setRecargaPegados] = useState(0);
  useEffect(() => {
    if (!client?.id) return;
    const alActualizarCliente = (e) => {
      const d = (e && e.detail) || {};
      if (d.id !== client.id) return;
      setRecargaPegados((n) => n + 1);
    };
    window.addEventListener('deskte:client-updated', alActualizarCliente);
    return () => window.removeEventListener('deskte:client-updated', alActualizarCliente);
  }, [client?.id]);
  useEffect(() => {
    if (channel !== 'whatsapp' && channel !== 'sms') return;
    let cancelled = false;
    (async () => {
      // 1. Migration shim: lift any pre-F-N1 localStorage paste up to the
      //    backend, then nuke the key so it never gets read again.
      try {
        const raw = localStorage.getItem(pasteKey(channel));
        if (raw) {
          const legacy = JSON.parse(raw);
          if (Array.isArray(legacy) && legacy.length > 0) {
            try {
              await apiAppendPastedMessages(client.id, channel, legacy);
            } catch (e) {
              console.warn('[paste-migrate] backend rejected legacy payload:', e.message);
            }
          }
          // Whether the upload worked or not, clear local PHI — keeping
          // it on disk is the exact harm F-N1 closes.
          localStorage.removeItem(pasteKey(channel));
        }
      } catch (e) {
        console.warn('[paste-migrate] localStorage read failed:', e.message);
      }
      // 2. Pull the authoritative server copy.
      try {
        const data = await apiListPastedMessages(client.id, channel);
        if (cancelled) return;
        const stored = Array.isArray(data?.messages) ? data.messages : [];
        if (stored.length === 0) return;
        setAllMsgs((a) => {
          const previos = (a[channel] || []).filter((m) => m._pasted);
          // Se conserva lo que hay solo si va POR DELANTE del servidor (un
          // "📋 Pegar" recién hecho) o si es exactamente lo mismo. Comparar
          // solo la cantidad no basta: al llegar al tope de 5.000 mensajes el
          // servidor recorta por delante y la cantidad ya no cambia nunca.
          const ultPrevio = previos[previos.length - 1];
          const ultServidor = stored[stored.length - 1];
          const igual = previos.length === stored.length && !!ultPrevio && !!ultServidor
            && ultPrevio.id === ultServidor.id && ultPrevio.text === ultServidor.text;
          if (previos.length > stored.length || igual) return a;
          return { ...a, [channel]: [...stored, ...(a[channel] || []).filter((m) => !m._pasted)] };
        });
      } catch (e) {
        console.warn('[paste-load] backend fetch failed:', e.message);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel, client.id, recargaPegados]);

  // Paste modal state. `pasteChannel` is the channel the paste targets
  // (whatsapp | sms); set when the user clicks the "Paste conversation"
  // button. `pasteText` is the raw textarea content.
  const [pasteChannel, setPasteChannel] = useState(null);
  const [pasteText, setPasteText] = useState('');
  const [pastePreview, setPastePreview] = useState([]);
  const previewPaste = (text) => {
    const parsed = parsePastedConversation(text, {
      selfNames: [currentUser?.name, currentUser?.displayName, currentUser?.firstName].filter(Boolean),
      lang,
    });
    setPastePreview(parsed);
  };
  const commitPaste = async () => {
    if (pastePreview.length === 0) {
      toast.error(lang === 'es' ? 'No se reconoció ningún mensaje en el texto pegado' : 'No messages recognized in the pasted text');
      return;
    }
    const channelToSave = pasteChannel;
    const batch = pastePreview;
    try {
      // Backend is the source of truth — it merges with prior rows and
      // returns the full decrypted array so we can drop any local state.
      const result = await apiAppendPastedMessages(client.id, channelToSave, batch);
      const next = Array.isArray(result?.messages) ? result.messages : batch;
      setAllMsgs((a) => ({ ...a, [channelToSave]: [...next, ...(a[channelToSave] || []).filter((m) => !m._pasted)] }));
      setPasteChannel(null);
      setPasteText('');
      setPastePreview([]);
      toast.success(lang === 'es'
        ? `Se agregaron ${batch.length} mensajes al hilo`
        : `Added ${batch.length} messages to the thread`);
    } catch (err) {
      toast.error(lang === 'es'
        ? `No se pudo guardar la conversación: ${err.message}`
        : `Couldn't save the conversation: ${err.message}`);
    }
  };
  const cancelPaste = () => {
    setPasteChannel(null);
    setPasteText('');
    setPastePreview([]);
  };
  // Load real email thread when the user opens the Email channel. Fires once
  // per client (the cached value lives in allMsgs.email until a manual reload
  // is needed after send/delete).
  useEffect(() => {
    if (channel !== 'email') return;
    if (emailLoading) return;
    let cancelled = false;
    setEmailLoading(true);
    setEmailError(null);
    apiListClientEmails(client.id)
      .then((data) => {
        if (cancelled) return;
        setAllMsgs((a) => ({ ...a, email: (data || []).slice().reverse().map((m) => apiEmailToBubble(m, lang)) }));
      })
      .catch((err) => {
        if (cancelled) return;
        setEmailError(err.message);
      })
      .finally(() => {
        if (!cancelled) setEmailLoading(false);
      });
    return () => { cancelled = true; };
    // We intentionally don't depend on lang — re-formatting on language toggle
    // is a nice-to-have. Re-fetch happens on client change or channel switch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel, client.id]);
  const [text, setText] = useState("");
  // Real (auto) SMS thread from the sms_messages table — merged into the SMS
  // tab alongside any manually PASTED messages, so both modes coexist: clients
  // with a connected provider get live inbound/outbound; others keep pasting.
  const [smsRealMsgs, setSmsRealMsgs] = useState([]);
  const loadSmsRealThread = () => {
    if (channel !== 'sms' || !client?.id) return;
    apiGetClientSmsThread(client.id)
      .then((list) => setSmsRealMsgs((Array.isArray(list) ? list : []).map((m) => ({
        id: `real-${m.id}`,
        dir: m.direction === 'outbound' ? 'out' : 'in',
        text: m.body,
        media: Array.isArray(m.media) ? m.media : [],
        date: new Date(m.createdAt).toLocaleDateString(lang === 'es' ? 'es' : 'en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
        time: new Date(m.createdAt).toLocaleTimeString(lang === 'es' ? 'es' : 'en-US', { hour: '2-digit', minute: '2-digit' }),
        _ts: +new Date(m.createdAt),
        _liveSms: true,
      }))))
      .catch(() => setSmsRealMsgs([]));
  };
  useEffect(() => { if (channel === 'sms') loadSmsRealThread(); else setSmsRealMsgs([]); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [channel, client?.id]);
  const [emailSubject, setEmailSubject] = useState("");
  // Copias visibles del correo (queja 16). Guarda direcciones, no indices: la
  // lista del hogar se recalcula cuando la ficha cambia y un indice apuntaria
  // a otra persona.
  const [ccSel, setCcSel] = useState([]);
  const hogarCc = useMemo(() => miembrosDelHogarConCorreo(client, lang), [client, lang]);
  // Attach client documents to an outbound email (from the Documents tab,
  // browsable by tab/folder). { [docId]: 'link' | 'attach' }.
  const [attachOpen, setAttachOpen] = useState(false);
  const [attachSel, setAttachSel] = useState({});
  // Rich-text email body (contentEditable) — formatting toolbar writes into it;
  // we read innerHTML (formatted) + innerText (plain) at send time. Kept
  // uncontrolled to avoid caret jumps (Lissette 2026-07-14: centrar/letra/tamaño).
  const emailBodyRef = useRef(null);
  const emailFileRef = useRef(null); // hidden <input> for computer-file attach
  const [attachingFile, setAttachingFile] = useState(false);
  const applyFmt = (cmd, val) => { try { document.execCommand('styleWithCSS', false, true); } catch {} document.execCommand(cmd, false, val); emailBodyRef.current?.focus(); };
  // Opening a <select> steals focus and collapses the editor's selection, so we
  // snapshot the range on mousedown and restore it before applying font/size.
  const savedRangeRef = useRef(null);
  const saveSel = () => { const s = window.getSelection(); if (s && s.rangeCount && emailBodyRef.current && emailBodyRef.current.contains(s.anchorNode)) savedRangeRef.current = s.getRangeAt(0).cloneRange(); };
  const applyFmtSaved = (cmd, val) => { const r = savedRangeRef.current; emailBodyRef.current?.focus(); if (r) { const s = window.getSelection(); s.removeAllRanges(); s.addRange(r); } applyFmt(cmd, val); };
  // Attach a file straight from the computer: upload it as a client document
  // (reuses the doc pipeline), then mark it as a real attachment on the email.
  const attachComputerFile = async (file) => {
    if (!file) return;
    setAttachingFile(true);
    try {
      const created = await apiUploadDocument(file, { clientId: client.id, category: 'other' });
      if (onDocsChange) onDocsChange((prev) => prev.some((x) => x.id === created.id) ? prev : [...prev, { ...created, clientId: client.id, name: file.name, uploadedAt: created.uploadedAt || new Date().toISOString() }]);
      setAttachSel((s) => ({ ...s, [created.id]: 'attach' }));
      toast.success(lang === 'es' ? 'Archivo adjuntado' : 'File attached');
    } catch (err) { toast.error(motivoDeSubidaFallida(err, lang === 'es')); }
    finally { setAttachingFile(false); }
  };
  const CHANNELS = [
    {id:"whatsapp",label:"WhatsApp",color:"#25d366",dim:"rgba(37,211,102,.1)",
     placeholder:lang==="es"?"Escribe un mensaje de WhatsApp...":"Type a WhatsApp message..."},
    {id:"sms",    label:"SMS",    color:"#5b8af5",dim:"rgba(91,138,245,.1)",
     placeholder:lang==="es"?"Escribe un SMS (160 car.)...":"Type SMS (160 chars)..."},
    {id:"email",  label:"Email",  color:"#f59e0b",dim:"rgba(245,158,11,.1)",
     placeholder:lang==="es"?"Escribe un email...":"Type an email..."},
  ];
  const ch = CHANNELS.find(x=>x.id===channel);
  // Apply the email label filter on top of the channel array. Other
  // channels ignore the filter entirely.
  const rawMsgs = allMsgs[channel]||[];
  const msgs = channel === "email" && emailLabelFilter
    ? rawMsgs.filter((m) => (m.labels || []).includes(emailLabelFilter))
    : channel === "sms"
    ? [...rawMsgs, ...smsRealMsgs].sort((a, b) => ((a._ts || 0) - (b._ts || 0)))
    : rawMsgs;
  // Keep the thread pinned to the NEWEST message: jump to the bottom when the
  // channel opens or new messages load, so the agent sees the latest first
  // without scrolling all the way down (Lissette 2026-07-27). Older messages
  // stay above — scroll up to read history.
  const threadRef = useRef(null);
  useEffect(() => {
    const el = threadRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [channel, msgs.length, emailLoading]);
  const sendMsg = async () => {
    // An SMS may carry ONLY images (MMS) — the old text-only guard silently
    // swallowed the click for image-only sends (Lissette 2026-07-16: "no sale
    // los sms": the upload worked, Enviar did nothing, no request ever left).
    if (!text.trim() && !(channel === 'sms' && smsImgs.length > 0)) return;
    // Email channel: real send through the agent's connected mailbox (Gmail /
    // Outlook OAuth), with the Reply-To trick wired in sendClientEmail so any
    // reply lands back here via SendGrid Inbound Parse.
    if (channel === 'email') {
      const subj = (emailSubject || '').trim();
      if (!subj) {
        toast.error(lang === 'es' ? 'Asunto requerido' : 'Subject required');
        return;
      }
      if (!client.email) {
        toast.error(lang === 'es' ? 'El cliente no tiene email registrado.' : 'Client has no email on file.');
        return;
      }
      setEmailSending(true);
      // Prefer the rich-text editor's HTML (bold/align/font/size). Fall back to
      // the plain-text→<p> conversion when the editor is empty/unavailable.
      const editor = emailBodyRef.current;
      const editorText = editor ? editor.innerText : '';
      const usingRich = !!editor && editorText.trim().length > 0;
      const bod = (usingRich ? editorText : text).trim();
      const html = usingRich
        ? editor.innerHTML
        : bod.split('\n').map((line) => (line ? `<p>${escapeHtml(line)}</p>` : '<br/>')).join('');
      const docsPayload = Object.entries(attachSel).map(([documentId, mode]) => ({ documentId, mode }));
      // Solo se copia a quien SIGUE estando en la ficha: si el agente marco al
      // conyuge y luego se le quito el correo, `hogarCc` ya no lo trae y el
      // backend lo rechazaria entero con CC_NOT_IN_HOUSEHOLD.
      const ccPayload = ccSel.filter((e) => hogarCc.some((m) => m.email === e));
      let enviado = null;
      const doSend = async (ack) => {
        enviado = await apiSendClientEmail(client.id, { subject: subj, html, text: bod, docs: docsPayload, cc: ccPayload, acknowledgePhi: ack });
        return enviado;
      };
      try {
        try {
          await doSend(false);
        } catch (err) {
          // PHI gate: backend blocks the first send; re-confirm then resend.
          if (err.code === 'PHI_DETECTED') {
            const ok = await confirmDialog({
              title: lang === 'es' ? 'Posible información sensible' : 'Possible sensitive info',
              message: lang === 'es' ? 'Se detectó posible información sensible (PHI) en el correo. ¿Enviar de todos modos?' : 'Possible sensitive info (PHI) was detected. Send anyway?',
              danger: true, confirmLabel: lang === 'es' ? 'Enviar' : 'Send',
            });
            if (!ok) { setEmailSending(false); return; }
            await doSend(true);
          } else { throw err; }
        }
        toast.success(lang === 'es' ? 'Email enviado' : 'Email sent');
        // A un copiado dado de baja no se le manda, pero el correo SI salio.
        // Se dice en voz alta: si no, el agente da por hecho que a la esposa
        // le llego.
        const omitidas = (enviado && enviado.ccOmitidas) || [];
        if (omitidas.length) {
          toast.error(
            (lang === 'es'
              ? 'No se copio a estas direcciones porque se dieron de baja: '
              : 'These addresses were not copied because they unsubscribed: ') + omitidas.join(', '),
          );
        }
        setText('');
        if (emailBodyRef.current) emailBodyRef.current.innerHTML = '';
        setEmailSubject('');
        setCcSel([]);
        setAttachSel({});
        // Reload the thread so the new outbound row appears (with its real id).
        const data = await apiListClientEmails(client.id);
        setAllMsgs((a) => ({ ...a, email: (data || []).slice().reverse().map((mm) => apiEmailToBubble(mm, lang)) }));
      } catch (err) {
        const msg = String(err?.message || err);
        toast.error((lang === 'es' ? 'No se pudo enviar: ' : 'Failed to send: ') + msg);
      } finally {
        setEmailSending(false);
      }
      return;
    }
    // SMS: send via the agent's connected provider (text and/or MMS images).
    if (channel === 'sms') {
      if (!phone) {
        toast.error(lang === 'es' ? 'El cliente no tiene teléfono registrado.' : 'Client has no phone on file.');
        return;
      }
      if (!text.trim() && smsImgs.length === 0) return;
      setSmsSending(true);
      try {
        await apiSendClientSms(client.id, { message: text.trim(), mediaUrls: smsImgs.map((i) => i.blobUrl) });
        toast.success(lang === 'es' ? (smsImgs.length ? 'SMS con imagen enviado' : 'SMS enviado') : (smsImgs.length ? 'SMS with image sent' : 'SMS sent'));
        setText('');
        setSmsImgs([]);
        // Refresh from the real store (the send was persisted server-side),
        // so the new outbound bubble appears without a duplicate optimistic row.
        loadSmsRealThread();
      } catch (err) {
        const msg = String(err?.message || err);
        if (msg === 'no-integration') {
          toast.error(lang === 'es'
            ? 'Conecta un proveedor (SignalWire, Twilio o RingCentral) en "SMS y Llamadas" primero.'
            : 'Connect a provider (SignalWire, Twilio or RingCentral) in "SMS & Calls" first.');
        } else {
          toast.error((lang === 'es' ? 'No se pudo enviar: ' : 'Failed to send: ') + msg);
        }
      } finally {
        setSmsSending(false);
      }
      return;
    }
    // WhatsApp: open WA Web / app pre-filled (agent sends from their own number).
    // The agent pastes the thread back with the "📋 Pegar" button.
    if (!phone) {
      toast.error(lang === 'es' ? 'El cliente no tiene teléfono registrado.' : 'Client has no phone on file.');
      return;
    }
    const body = encodeURIComponent(text.trim());
    const url = `https://wa.me/${phone.replace(/^\+/, '')}?text=${body}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    toast.success(lang === 'es'
      ? 'Abriendo… envía desde tu teléfono, luego usa 📋 Pegar para guardar la conversación'
      : 'Opening… send from your phone, then use 📋 Paste to log the thread');
    setText("");
  };
  // Delete a real email message (only enabled for email channel rows that
  // came from the server — _real marker is set by apiEmailToBubble).
  const deleteEmailMsg = async (msgId) => {
    if (!(await confirmDialog({ message: lang === 'es' ? '¿Eliminar este email del CRM?' : 'Delete this email from the CRM?', danger: true }))) return;
    setAllMsgs((a) => ({ ...a, email: a.email.filter((m) => m.id !== msgId) }));
    try {
      await apiDeleteClientEmail(client.id, msgId);
      toast.success(lang === 'es' ? 'Email eliminado' : 'Email deleted');
    } catch (err) {
      toast.error((lang === 'es' ? 'No se pudo eliminar: ' : 'Failed to delete: ') + err.message);
      // Reload to get back to canonical state.
      try {
        const data = await apiListClientEmails(client.id);
        setAllMsgs((a) => ({ ...a, email: (data || []).slice().reverse().map((mm) => apiEmailToBubble(mm, lang)) }));
      } catch {}
    }
  };
  // User-applied labels — agencies pick their own taxonomy. v1 uses a
  // simple prompt() since the typical flow is "label this thread as
  // 'Renovación' and never look at it again"; a fancier popover with
  // saved labels can come in v2 once the taxonomy stabilizes.
  const editEmailLabels = async (msg) => {
    const current = (msg.labels || []).join(', ');
    const next = window.prompt(
      lang === 'es'
        ? 'Etiquetas (separadas por coma, vacío = quitar todas)'
        : 'Labels (comma-separated, empty = clear)',
      current,
    );
    if (next === null) return;
    const labels = next.split(',').map((s) => s.trim()).filter(Boolean);
    // Optimistic update so the UI feels instant.
    setAllMsgs((a) => ({ ...a, email: a.email.map((m) => m.id === msg.id ? { ...m, labels } : m) }));
    try {
      await apiUpdateClientEmailLabels(client.id, msg.id, labels);
    } catch (err) {
      toast.error((lang === 'es' ? 'No se pudo guardar las etiquetas: ' : 'Could not save labels: ') + err.message);
      // Revert by reloading.
      try {
        const data = await apiListClientEmails(client.id);
        setAllMsgs((a) => ({ ...a, email: (data || []).slice().reverse().map((mm) => apiEmailToBubble(mm, lang)) }));
      } catch {}
    }
  };
  // Aggregate all labels currently in use in this client's thread so the
  // filter dropdown reflects the live taxonomy.
  const allLabelsInThread = useMemo(() => {
    const s = new Set();
    (allMsgs.email || []).forEach((m) => (m.labels || []).forEach((l) => s.add(l)));
    return Array.from(s).sort();
  }, [allMsgs.email]);
  const statusIcon = (s,color) => {
    if(s==="read")      return <span style={{color,fontSize:".7rem"}}>✓✓</span>;
    if(s==="delivered") return <span style={{color:"#8eafc2",fontSize:".7rem"}}>✓✓</span>;
    return <span style={{color:"#4a6a82",fontSize:".7rem"}}>✓</span>;
  };
  return <div style={{display:"flex",flexDirection:"column",gap:".75rem"}}>
    {/* -- Channel tabs -- */}
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".4rem"}}>
      {CHANNELS.map(x=>(
        <button key={x.id} type="button" onClick={()=>setChannel(x.id)} style={{
          padding:".5rem .75rem",borderRadius:9,cursor:"pointer",
          background:channel===x.id?x.dim:"var(--c-surface2,#112538)",
          border:`1px solid ${channel===x.id?x.color:"var(--c-border,#1a3550)"}`,
          color:channel===x.id?x.color:"var(--c-text3,#45688a)",
          fontWeight:700,fontSize:".73rem",
          display:"flex",alignItems:"center",justifyContent:"center",gap:".4rem",
          transition:"all .2s",
        }}>
          {x.id==="whatsapp"&&"💬"}
          {x.id==="sms"&&"📱"}
          {x.id==="email"&&"✉️"}
          {x.label}
          <span style={{
            fontSize:".58rem",padding:"1px 5px",borderRadius:100,
            background:channel===x.id?x.color+"33":"var(--c-surface3,#162d44)",
            color:channel===x.id?x.color:"var(--c-text3,#45688a)",
          }}>
            {(allMsgs[x.id]||[]).length}
          </span>
        </button>
      ))}
    </div>
    {/* -- Chat window -- */}
    <div style={{
      background:"var(--c-surface2,#112538)",border:`1px solid var(--c-border,#1a3550)`,
      borderRadius:12,overflow:"hidden",
    }}>
      {/* Chat header */}
      <div style={{
        padding:".6rem .875rem",borderBottom:"1px solid var(--c-border,#1a3550)",
        display:"flex",alignItems:"center",justifyContent:"space-between",
        background:`linear-gradient(90deg,${ch.color}0a,transparent)`,
      }}>
        <div style={{fontSize:".7rem",color:"var(--c-text3,#45688a)"}}>
          {channel==="whatsapp"&&`WhatsApp . ${client.phone}`}
          {channel==="sms"&&`SMS . ${client.phone}`}
          {channel==="email"&&`Email . ${client.email}`}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:".5rem"}}>
          {channel === "email" ? (
            <span style={{fontSize:".58rem",fontWeight:700,padding:"2px 7px",borderRadius:100,
              background:"rgba(0,255,136,.1)",color:"var(--c-green,#00ff88)",
              border:"1px solid rgba(0,255,136,.25)"}}>
              ✓ {lang==="es"?"Conectado":"Connected"}
            </span>
          ) : (
            <span style={{fontSize:".58rem",fontWeight:700,padding:"2px 7px",borderRadius:100,
              background:"rgba(91,138,245,.12)",color:"var(--c-blue,#5b8af5)",
              border:"1px solid rgba(91,138,245,.28)"}}
              title={lang==="es"?"Envía desde tu teléfono y registra la conversación con el botón Pegar":"Send from your phone and log the conversation with the Paste button"}>
              📋 {lang==="es"?"Registro manual":"Manual log"}
            </span>
          )}
          {/* Label filter for the email channel. Populated from the
              live taxonomy of labels actually present in the thread,
              so the dropdown stays small + relevant. Hidden when no
              labels are in use anywhere in the thread. */}
          {channel === "email" && allLabelsInThread.length > 0 && (
            <select
              value={emailLabelFilter}
              onChange={(e) => setEmailLabelFilter(e.target.value)}
              style={{fontSize:'.65rem',padding:'2px 6px',borderRadius:6,border:'1px solid var(--c-border,#1a3550)',background:'var(--c-surface2,#112538)',color:emailLabelFilter ? 'var(--c-amber,#ffb700)' : 'var(--c-text2,#7aa3c0)',fontFamily:'inherit',cursor:'pointer'}}
              title={lang === 'es' ? 'Filtrar por etiqueta' : 'Filter by label'}
            >
              <option value="">🏷️ {lang === 'es' ? 'Todas' : 'All'} ({rawMsgs.length})</option>
              {allLabelsInThread.map((l) => (
                <option key={l} value={l}>
                  {l} ({rawMsgs.filter((m) => (m.labels || []).includes(l)).length})
                </option>
              ))}
            </select>
          )}
          {/* Paste conversation — only for whatsapp / sms since email
              has its own real backend send/receive. Lets the agent
              keep a record of an off-platform thread without leaving
              Deskte. v1 is local-only (localStorage); a Twilio backend
              would land in the same place. */}
          {(channel === 'whatsapp' || channel === 'sms') && (
            <button type="button"
              onClick={() => { setPasteChannel(channel); setPasteText(''); setPastePreview([]); }}
              style={{
                background: 'var(--c-amber-dim)', border: '1px solid rgba(255,183,0,.35)',
                borderRadius: 7, padding: '3px 10px', cursor: 'pointer',
                color: 'var(--c-amber,#ffb700)', fontWeight: 700, fontSize: '.65rem',
                fontFamily: 'var(--font-body)', display: 'flex', alignItems: 'center', gap: 4,
              }}
              title={lang === 'es' ? 'Pegar conversación de WhatsApp/SMS' : 'Paste WhatsApp/SMS conversation'}
            >
              📋 {lang === 'es' ? 'Pegar' : 'Paste'}
            </button>
          )}
        </div>
      </div>
      {/* Messages */}
      <div ref={threadRef} style={{
        height:300,overflowY:"auto",padding:".75rem",
        display:"flex",flexDirection:"column",gap:".5rem",
      }}>
        {channel === "email" && emailLoading && (
          <div style={{ textAlign: 'center', color: 'var(--c-text3,#45688a)', fontSize: '.75rem', padding: '1rem' }}>
            {lang === 'es' ? 'Cargando…' : 'Loading…'}
          </div>
        )}
        {channel === "email" && emailError && (
          <div style={{ textAlign: 'center', color: 'var(--c-red,#ff3d6b)', fontSize: '.75rem', padding: '.5rem .75rem', background: 'var(--c-red-dim,rgba(255,61,107,.12))', borderRadius: 8 }}>
            ⚠️ {emailError}
          </div>
        )}
        {channel === "email" && !emailLoading && !emailError && msgs.length === 0 && (
          <div style={{ textAlign: 'center', color: 'var(--c-text3,#45688a)', fontSize: '.75rem', padding: '1rem' }}>
            {lang === 'es' ? 'No hay emails todavía. Envía el primero abajo.' : 'No emails yet. Send the first one below.'}
          </div>
        )}
        {(channel === "whatsapp" || channel === "sms") && msgs.length === 0 && (
          <div style={{ textAlign: 'center', color: 'var(--c-text3,#45688a)', fontSize: '.75rem', padding: '1.25rem .75rem', lineHeight: 1.7 }}>
            <div style={{ fontSize: '1.5rem', marginBottom: '.4rem' }}>{channel === "whatsapp" ? "💬" : "📱"}</div>
            {lang === 'es'
              ? <>No hay conversaciones registradas.<br/>Escribe abajo y pulsa <strong>Enviar</strong> para abrir {channel === "whatsapp" ? "WhatsApp" : "Mensajes"} con tu número,<br/>o usa <strong>📋 Pegar</strong> para guardar una conversación existente.</>
              : <>No conversations logged yet.<br/>Type below and hit <strong>Send</strong> to open {channel === "whatsapp" ? "WhatsApp" : "Messages"} from your number,<br/>or use <strong>📋 Paste</strong> to log an existing thread.</>}
          </div>
        )}
        {msgs.map((m,i)=>{
          const isOut=m.dir==="out";
          const showDate=i===0||msgs[i-1].date!==m.date;
          return <div key={m.id}>
            {showDate&&<div style={{textAlign:"center",margin:".35rem 0"}}>
              <span style={{fontSize:".6rem",color:"var(--c-text3,#45688a)",
                background:"var(--c-surface,#0d1c2e)",padding:"2px 10px",
                borderRadius:100,fontFamily:"var(--font-mono)"}}>{m.date}</span>
            </div>}
            <div style={{display:"flex",justifyContent:isOut?"flex-end":"flex-start"}}>
              <div style={{
                maxWidth:"75%",
                background:isOut?(m.isDoc?`linear-gradient(135deg,rgba(0,212,255,.15),rgba(6,214,160,.1))`:`${ch.color}1a`):"var(--c-surface,#0d1c2e)",
                border:`1px solid ${isOut?(m.isDoc?"rgba(0,212,255,.3)":ch.color+"2a"):"var(--c-border,#1a3550)"}`,
                borderRadius:isOut?"12px 12px 3px 12px":"12px 12px 12px 3px",
                padding:".55rem .75rem",
              }}>
                {channel==="email"&&m.subject&&(
                  <div style={{fontSize:".65rem",fontWeight:800,color:"var(--c-amber,#ffb700)",
                    marginBottom:".35rem",paddingBottom:".35rem",
                    borderBottom:"1px solid rgba(245,158,11,.2)"}}>
                    ✉️ {m.subject}
                  </div>
                )}
                {m.isDoc&&<div style={{fontSize:".6rem",fontWeight:800,color:"var(--c-cyan,#00d4ff)",
                  marginBottom:".35rem",display:"flex",alignItems:"center",gap:4}}>
                  📋 {lang==="es"?"CONSENTIMIENTO":"CONSENT DOCUMENT"}
                </div>}
                {/* WhatsApp photo (from the browser extension). Click to open full size. */}
                {m.imageUrl&&<BlobImg src={m.imageUrl} alt={lang==="es"?"Imagen de WhatsApp":"WhatsApp image"}
                  onClick={()=>openBlobInNewTab(m.imageUrl)}
                  style={{maxWidth:"100%",maxHeight:280,borderRadius:8,display:"block",cursor:"pointer",
                    marginBottom:(m.text&&!/^\[📷/.test(m.text))?".35rem":0}} />}
                {/* MMS images (signed read URLs from the SMS thread). */}
                {Array.isArray(m.media)&&m.media.map((u,mi)=>(
                  <BlobImg key={`mms-${mi}`} src={u} alt="MMS"
                    onClick={()=>openBlobInNewTab(u)}
                    style={{maxWidth:"100%",maxHeight:280,borderRadius:8,display:"block",cursor:"pointer",
                      marginBottom:m.text?".35rem":0}} />
                ))}
                {/* Hide the bare "[📷 Imagen]" placeholder once the real image renders. */}
                {!(m.imageUrl&&/^\[📷/.test(m.text||""))&&<div style={{
                  fontSize:".77rem",lineHeight:1.55,
                  color:isOut?"var(--c-white,#eef6ff)":"var(--c-text,#c8dff0)",
                  whiteSpace:"pre-line"
                }}>{m.text}</div>}
                {/* Labels (email channel only). Displayed as small
                    amber chips below the body; click "🏷️" to edit. */}
                {channel === "email" && (m.labels?.length > 0 || m._real) && (
                  <div style={{display:'flex',alignItems:'center',flexWrap:'wrap',gap:4,marginTop:'.35rem',paddingTop:'.35rem',borderTop:'1px solid var(--ci-bg-05)'}}>
                    {(m.labels || []).map((label) => (
                      <span key={label} style={{fontSize:'.6rem',fontWeight:700,padding:'2px 7px',borderRadius:100,background:'rgba(255,183,0,.15)',color:'var(--c-amber,#ffb700)',border:'1px solid rgba(255,183,0,.3)'}}>
                        🏷️ {label}
                      </span>
                    ))}
                    {m._real && (
                      <button
                        type="button"
                        onClick={() => editEmailLabels(m)}
                        title={lang === 'es' ? 'Editar etiquetas' : 'Edit labels'}
                        style={{background:'none',border:'1px dashed var(--c-border,#1a3550)',cursor:'pointer',color:'var(--c-text3,#45688a)',padding:'1px 7px',borderRadius:100,fontSize:'.6rem',fontWeight:600,display:'inline-flex',alignItems:'center',gap:3}}
                      >
                        {(m.labels || []).length === 0
                          ? (lang === 'es' ? '+ Etiqueta' : '+ Label')
                          : '✎'}
                      </button>
                    )}
                  </div>
                )}
                <div style={{display:"flex",alignItems:"center",justifyContent:"flex-end",gap:".3rem",marginTop:".3rem"}}>
                  <span style={{fontSize:".6rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>{m.time}</span>
                  {isOut&&statusIcon(m.status,ch.color)}
                  {channel === "email" && m._real && (
                    <button
                      type="button"
                      onClick={() => deleteEmailMsg(m.id)}
                      title={lang === 'es' ? 'Eliminar' : 'Delete'}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--c-text3,#45688a)', padding: 2, marginLeft: 4, display: 'flex', alignItems: 'center' }}
                    >
                      <Trash2 size={11} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>;
        })}
      </div>
      {/* Composer */}
      <div style={{borderTop:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface,#0d1c2e)",padding:".6rem .75rem",display:"flex",flexDirection:"column",gap:".4rem"}}>
        {channel==="email"&&(
          <input className="dkt-inp" value={emailSubject} onChange={e=>setEmailSubject(e.target.value)}
            placeholder={lang==="es"?"Asunto del email...":"Email subject..."}
            style={{fontSize:".75rem",padding:".4rem .65rem"}}/>
        )}
        {/* CC al resto del hogar — Lissette 2026-09-02, queja 16. Solo sale
            cuando hay a quien copiar: el conyuge o un dependiente con correo
            propio en la ficha. Es copia VISIBLE (se ven entre ellos). */}
        {channel==="email"&&hogarCc.length>0&&(
          <div style={{display:"flex",alignItems:"center",gap:".3rem",flexWrap:"wrap"}}>
            <span style={{fontSize:".64rem",color:"var(--c-text2,#7aa3c0)",fontWeight:700,letterSpacing:".04em"}}>
              {lang==="es"?"Copia a":"Copy to"}
            </span>
            {hogarCc.map(m=>{ const on=ccSel.includes(m.email); return (
              <button key={m.key} type="button" title={m.email}
                onClick={()=>setCcSel(v=>on?v.filter(e=>e!==m.email):[...v,m.email])}
                style={{display:"inline-flex",alignItems:"center",gap:4,borderRadius:100,padding:".18rem .55rem",fontSize:".64rem",fontWeight:600,cursor:"pointer",maxWidth:220,
                  background:on?"var(--c-cyan,#00d4ff)22":"var(--c-surface2,#112538)",
                  border:on?"1px solid var(--c-cyan,#00d4ff)":"1px solid var(--c-border,#1a3550)",
                  color:on?"var(--c-text,#c8dff0)":"var(--c-text2,#7aa3c0)"}}>
                {on?<Check size={10}/>:<Plus size={10}/>}
                <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.nombre}</span>
                <span style={{opacity:.65}}>· {m.parentesco}</span>
              </button>
            ); })}
          </div>
        )}
        {channel==="email"&&(
          <div style={{display:"flex",justifyContent:"flex-end"}}>
            <AiDraftButton lang={lang} compact bodyAsHtml
              contextHint={`This is a direct email from an insurance agent to their client ${[client?.firstName,client?.lastName].filter(Boolean).join(' ')}. Return the body as simple HTML paragraphs.`}
              onResult={({ subject, body }) => { if (subject) setEmailSubject(subject); if (emailBodyRef.current) { emailBodyRef.current.innerHTML = body || ''; setText(emailBodyRef.current.innerText || ''); } }} />
          </div>
        )}
        {channel==="email"&&(
          <div style={{display:"flex",alignItems:"center",gap:".4rem",flexWrap:"wrap"}}>
            <button type="button" onClick={()=>setAttachOpen(true)}
              style={{display:"inline-flex",alignItems:"center",gap:4,background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",color:"var(--c-text2,#7aa3c0)",borderRadius:8,padding:".3rem .55rem",fontSize:".68rem",cursor:"pointer",fontWeight:600}}>
              <Paperclip size={12}/> {lang==="es"?"Adjuntar documento":"Attach document"}{Object.keys(attachSel).length?` (${Object.keys(attachSel).length})`:""}
            </button>
            {/* Attach a file straight from the computer (uploads + attaches). */}
            <input ref={emailFileRef} type="file" style={{display:"none"}} onChange={e=>{const f=e.target.files&&e.target.files[0]; e.target.value=''; if(f) attachComputerFile(f);}}/>
            <button type="button" onClick={()=>emailFileRef.current&&emailFileRef.current.click()} disabled={attachingFile}
              style={{display:"inline-flex",alignItems:"center",gap:4,background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",color:"var(--c-text2,#7aa3c0)",borderRadius:8,padding:".3rem .55rem",fontSize:".68rem",cursor:attachingFile?"wait":"pointer",fontWeight:600}}>
              <Upload size={12}/> {attachingFile?(lang==="es"?"Subiendo…":"Uploading…"):(lang==="es"?"Subir archivo":"Upload file")}
            </button>
            {Object.entries(attachSel).map(([id,mode])=>{ const d=docs.find(x=>x.id===id); if(!d) return null; return (
              <span key={id} style={{display:"inline-flex",alignItems:"center",gap:4,background:"var(--c-cyan,#00d4ff)18",border:"1px solid var(--c-border,#1a3550)",color:"var(--c-text,#c8dff0)",borderRadius:100,padding:".15rem .5rem",fontSize:".64rem",maxWidth:200}}>
                {mode==="attach"?<Paperclip size={10}/>:<Link2 size={10}/>}
                <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.name}</span>
                <span onClick={()=>setAttachSel(s=>{const n={...s};delete n[id];return n;})} style={{cursor:"pointer",fontWeight:700,opacity:.7}}>×</span>
              </span>
            ); })}
          </div>
        )}
        {/* Rich-text formatting toolbar — email only */}
        {channel==="email"&&(()=>{ const tb={display:"inline-flex",alignItems:"center",justifyContent:"center",width:26,height:26,borderRadius:6,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface2,#112538)",color:"var(--c-text2,#7aa3c0)",cursor:"pointer",padding:0}; const sel={background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",color:"var(--c-text,#c8dff0)",borderRadius:6,fontSize:".68rem",padding:"3px 4px",cursor:"pointer"}; return (
          <div style={{display:"flex",alignItems:"center",gap:4,flexWrap:"wrap"}}>
            <button type="button" title={lang==="es"?"Negrita":"Bold"} onMouseDown={e=>{e.preventDefault();applyFmt('bold');}} style={tb}><Bold size={13}/></button>
            <button type="button" title={lang==="es"?"Cursiva":"Italic"} onMouseDown={e=>{e.preventDefault();applyFmt('italic');}} style={tb}><Italic size={13}/></button>
            <button type="button" title={lang==="es"?"Subrayado":"Underline"} onMouseDown={e=>{e.preventDefault();applyFmt('underline');}} style={tb}><Underline size={13}/></button>
            <span style={{width:1,height:18,background:"var(--c-border,#1a3550)",margin:"0 2px"}}/>
            <button type="button" title={lang==="es"?"Izquierda":"Left"} onMouseDown={e=>{e.preventDefault();applyFmt('justifyLeft');}} style={tb}><AlignLeft size={13}/></button>
            <button type="button" title={lang==="es"?"Centrar":"Center"} onMouseDown={e=>{e.preventDefault();applyFmt('justifyCenter');}} style={tb}><AlignCenter size={13}/></button>
            <button type="button" title={lang==="es"?"Derecha":"Right"} onMouseDown={e=>{e.preventDefault();applyFmt('justifyRight');}} style={tb}><AlignRight size={13}/></button>
            {/* Justificado — Lissette 2026-09-02, queja 9. */}
            <button type="button" title={lang==="es"?"Justificar":"Justify"} onMouseDown={e=>{e.preventDefault();applyFmt('justifyFull');}} style={tb}><AlignJustify size={13}/></button>
            <span style={{width:1,height:18,background:"var(--c-border,#1a3550)",margin:"0 2px"}}/>
            <select title={lang==="es"?"Tipo de letra":"Font"} defaultValue="" onMouseDown={saveSel} onChange={e=>{const v=e.target.value; if(v) applyFmtSaved('fontName',v); e.target.value="";}} style={sel}>
              <option value="">{lang==="es"?"Letra":"Font"}</option>
              <option value="Arial">Arial</option><option value="Georgia">Georgia</option><option value="Times New Roman">Times</option><option value="Courier New">Courier</option><option value="Verdana">Verdana</option>
            </select>
            <select title={lang==="es"?"Tamaño":"Size"} defaultValue="" onMouseDown={saveSel} onChange={e=>{const v=e.target.value; if(v) applyFmtSaved('fontSize',v); e.target.value="";}} style={sel}>
              <option value="">{lang==="es"?"Tamaño":"Size"}</option>
              <option value="2">{lang==="es"?"Pequeño":"Small"}</option><option value="3">{lang==="es"?"Normal":"Normal"}</option><option value="5">{lang==="es"?"Grande":"Large"}</option><option value="7">{lang==="es"?"Enorme":"Huge"}</option>
            </select>
          </div>
        ); })()}
        {/* MMS image chips pending on the next SMS send. */}
        {channel==="sms"&&smsImgs.length>0&&<div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:6}}>
          {smsImgs.map((im,i)=>(
            <div key={i} style={{position:"relative",width:56,height:56,borderRadius:8,overflow:"hidden",border:"1px solid var(--c-border,#1a3550)"}}>
              <img src={im._preview} alt={im.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
              <button type="button" onClick={()=>setSmsImgs(prev=>prev.filter((_,j)=>j!==i))}
                style={{position:"absolute",top:1,right:1,width:16,height:16,borderRadius:"50%",border:"none",background:"rgba(0,0,0,.7)",color:"#fca5a5",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,fontSize:10,lineHeight:1}}>×</button>
            </div>
          ))}
        </div>}
        <div style={{display:"flex",alignItems:"flex-end",gap:".5rem"}}>
          {channel==="sms"&&<>
            {/* Snapshot the FileList BEFORE resetting the input — clearing
                `value` empties the live FileList, so the old order uploaded
                NOTHING (Lissette 2026-07-16: la camarita "no hace nada"). */}
            <input ref={smsImgRef} type="file" accept="image/*" multiple style={{display:"none"}}
              onChange={e=>{const fs=Array.from(e.target.files||[]);e.target.value="";if(fs.length)addSmsImages(fs);}}/>
            <button type="button" onClick={()=>smsImgRef.current&&smsImgRef.current.click()} disabled={smsImgUploading}
              title={lang==="es"?"Adjuntar imagen (MMS) — también puedes pegar con Ctrl+V":"Attach image (MMS) — you can also paste with Ctrl+V"}
              style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:9,
                padding:".55rem .6rem",cursor:smsImgUploading?"wait":"pointer",color:"var(--c-text2,#7aa3c0)",lineHeight:0,flexShrink:0}}>
              {smsImgUploading?"⏳":"📷"}
            </button>
          </>}
          {channel==="email"?(
            <div ref={emailBodyRef} contentEditable suppressContentEditableWarning
              onInput={e=>setText(e.currentTarget.innerText)}
              data-ph={ch.placeholder}
              style={{
                flex:1,minHeight:52,maxHeight:200,overflowY:"auto",background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",
                borderRadius:9,padding:".5rem .75rem",color:"var(--c-white,#eef6ff)",
                fontFamily:"var(--font-body)",fontSize:".78rem",outline:"none",lineHeight:1.5,transition:"border-color .2s",
              }}
              onFocus={e=>e.currentTarget.style.borderColor=ch.color}
              onBlur={e=>e.currentTarget.style.borderColor="var(--c-border,#1a3550)"}/>
          ):(
          <textarea value={text} onChange={e=>setText(e.target.value)}
            onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendMsg();}}}
            onPaste={channel==="sms"?(e)=>{const items=[...(e.clipboardData?.items||[])].filter(it=>it.type&&it.type.startsWith("image/"));if(items.length){e.preventDefault();addSmsImages(items.map(it=>it.getAsFile()).filter(Boolean));}}:undefined}
            placeholder={ch.placeholder} rows={2}
            style={{
              flex:1,background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",
              borderRadius:9,padding:".5rem .75rem",color:"var(--c-white,#eef6ff)",
              fontFamily:"var(--font-body)",fontSize:".78rem",resize:"none",outline:"none",
              lineHeight:1.5,transition:"border-color .2s",
            }}
            onFocus={e=>e.target.style.borderColor=ch.color}
            onBlur={e=>e.target.style.borderColor="var(--c-border,#1a3550)"}/>
          )}
          {(()=>{ const hasContent = !!text.trim() || (channel==="sms" && smsImgs.length>0); return (
          <button type="button" onClick={sendMsg} disabled={!hasContent || emailSending || smsSending} style={{
            background:(hasContent && !emailSending && !smsSending)?ch.color:"var(--c-surface2,#112538)",
            border:"none",borderRadius:9,padding:".6rem .8rem",
            cursor:(hasContent && !emailSending)?"pointer":"not-allowed",
            color:(hasContent && !emailSending)?"#070f1a":"var(--c-text3,#45688a)",lineHeight:0,
            transition:"all .2s",flexShrink:0,
            boxShadow:(hasContent && !emailSending)?`0 4px 14px ${ch.color}44`:"none",
          }}>
            <Send size={14}/>
          </button>
          ); })()}
        </div>
        {channel==="sms"&&<div style={{fontSize:".6rem",color:text.length>160?"var(--c-red,#ff3d6b)":"var(--c-text3,#45688a)",
          textAlign:"right",fontFamily:"var(--font-mono)"}}>{text.length}/160</div>}
      </div>
    </div>
    {/* -- Integration status --
        Email is wired through SendGrid Inbound Parse + OAuth send (PR #99-#101).
        WhatsApp + SMS work in "manual log" mode: click-to-send deep links +
        the 📋 Pegar button persist threads into the encrypted PastedConversation
        table (F-N1). Twilio BYOT auto send/receive is the deferred next step —
        ver pending_sms_whatsapp_calls_strategy.md. */}
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:".4rem"}}>
      {[
        {icon:"💬",name:"WhatsApp",mode:"manual"},
        {icon:"📱",name:"SMS",mode:"manual"},
        {icon:"📧",name:lang==="es"?"Email":"Email",mode:"connected"},
      ].map(s=>{
        const connected = s.mode === "connected";
        return (
        <div key={s.name} style={{
          background:"var(--c-surface2,#112538)",
          border:`1px solid ${connected?"rgba(0,255,136,.25)":"rgba(91,138,245,.28)"}`,
          borderRadius:8,padding:".4rem .6rem",
          display:"flex",alignItems:"center",gap:".4rem",
        }}>
          <span style={{fontSize:".85rem"}}>{s.icon}</span>
          <div>
            <div style={{fontSize:".65rem",fontWeight:700,color:"var(--c-text2,#7aa3c0)"}}>{s.name}</div>
            <div style={{fontSize:".58rem",color:connected?"var(--c-green,#00ff88)":"var(--c-blue,#5b8af5)",fontFamily:"var(--font-mono)"}}>
              {connected
                ? <>✓ {lang==="es"?"Conectado":"Connected"}</>
                : <>📋 {lang==="es"?"Registro manual":"Manual log"}</>}
            </div>
          </div>
        </div>
        );
      })}
    </div>
    {/* Attach client documents to an email — browse by tab (policy type) /
        folder, pick link or real file per document. */}
    {attachOpen && (
      <DocAttachPicker docs={docs} sel={attachSel} onChange={setAttachSel} onClose={()=>setAttachOpen(false)} lang={lang} />
    )}
    {/* Paste WhatsApp / SMS conversation modal. The user pastes a
        conversation export, we parse it client-side, show a preview
        so they can confirm before committing to localStorage. */}
    {pasteChannel && (
      <div style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,.7)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }} onClick={cancelPaste}>
        <div onClick={(e) => e.stopPropagation()} style={{ background: 'var(--c-surface,#0d1c2e)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 14, width: '100%', maxWidth: 720, maxHeight: '85vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--c-border,#1a3550)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '.95rem', fontWeight: 800, color: 'var(--c-white,#eef6ff)' }}>
                📋 {lang === 'es' ? 'Pegar conversación' : 'Paste conversation'} — {pasteChannel === 'whatsapp' ? '💬 WhatsApp' : '📱 SMS'}
              </div>
              <div style={{ fontSize: '.7rem', color: 'var(--c-text3,#45688a)', marginTop: 2 }}>
                {lang === 'es'
                  ? 'Pega el chat desde WhatsApp Web / iMessage / la app de SMS. Detectamos cada mensaje automáticamente.'
                  : 'Paste the chat from WhatsApp Web / iMessage / SMS app. Each message will be detected automatically.'}
              </div>
            </div>
            <button onClick={cancelPaste} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--c-text3,#45688a)' }}><X size={16}/></button>
          </div>
          <div style={{ padding: '1rem 1.25rem', flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '.75rem' }}>
            <textarea
              value={pasteText}
              onChange={(e) => { setPasteText(e.target.value); previewPaste(e.target.value); }}
              placeholder={lang === 'es'
                ? 'Pega aquí. Ejemplo:\n[5/14/26, 10:32 AM] Maria Lopez: Hola, necesito información sobre mi póliza...\n[5/14/26, 10:35 AM] You: Claro, ¿qué necesitas saber?'
                : 'Paste here. Example:\n[5/14/26, 10:32 AM] Maria Lopez: Hi, I need info about my policy...\n[5/14/26, 10:35 AM] You: Sure, what do you need to know?'}
              style={{
                width: '100%', minHeight: 160, padding: '.7rem .9rem',
                background: 'var(--c-surface2,#112538)', border: '1px solid var(--c-border,#1a3550)',
                borderRadius: 9, color: 'var(--c-white,#eef6ff)', fontSize: '.78rem',
                fontFamily: 'var(--font-mono)', resize: 'vertical', outline: 'none',
              }}
            />
            {pastePreview.length > 0 && (
              <div>
                <div style={{ fontSize: '.7rem', fontWeight: 700, color: 'var(--c-amber,#ffb700)', marginBottom: '.4rem' }}>
                  ✓ {lang === 'es' ? `${pastePreview.length} mensajes detectados` : `${pastePreview.length} messages detected`}
                </div>
                <div style={{ maxHeight: 220, overflowY: 'auto', background: 'var(--c-surface2,#112538)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 8, padding: '.5rem' }}>
                  {pastePreview.slice(0, 12).map((m, i) => (
                    <div key={i} style={{ padding: '.35rem .5rem', borderRadius: 6, marginBottom: 3, background: m.dir === 'out' ? 'rgba(0,212,255,.06)' : 'var(--ci-bg-02)', fontSize: '.7rem' }}>
                      <span style={{ color: m.dir === 'out' ? 'var(--c-cyan,#00d4ff)' : 'var(--c-amber,#ffb700)', fontWeight: 700, marginRight: 6 }}>
                        {m.sender}
                      </span>
                      <span style={{ color: 'var(--c-text3,#45688a)', fontFamily: 'var(--font-mono)', fontSize: '.62rem', marginRight: 6 }}>
                        {m.date} {m.time}
                      </span>
                      <span style={{ color: 'var(--c-text,#c8dff0)' }}>{m.text.length > 80 ? m.text.slice(0, 79) + '…' : m.text}</span>
                    </div>
                  ))}
                  {pastePreview.length > 12 && (
                    <div style={{ fontSize: '.65rem', color: 'var(--c-text3,#45688a)', fontStyle: 'italic', textAlign: 'center', padding: '.25rem' }}>
                      … +{pastePreview.length - 12} {lang === 'es' ? 'más' : 'more'}
                    </div>
                  )}
                </div>
              </div>
            )}
            {pasteText && pastePreview.length === 0 && (
              <div style={{ fontSize: '.7rem', color: 'var(--c-red,#ef4444)', padding: '.5rem .75rem', background: 'rgba(239,68,68,.08)', border: '1px solid rgba(239,68,68,.2)', borderRadius: 7 }}>
                {lang === 'es'
                  ? 'No se reconoció ningún mensaje. Formato esperado: [fecha hora] Nombre: mensaje'
                  : 'No messages recognized. Expected format: [date time] Name: message'}
              </div>
            )}
          </div>
          <div style={{ padding: '.75rem 1.25rem', borderTop: '1px solid var(--c-border,#1a3550)', display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
            <button type="button" onClick={cancelPaste} style={{ padding: '.5rem 1rem', borderRadius: 8, border: '1px solid var(--c-border,#1a3550)', background: 'var(--c-surface2,#112538)', color: 'var(--c-text2,#7aa3c0)', fontSize: '.78rem', fontWeight: 600, cursor: 'pointer' }}>
              {lang === 'es' ? 'Cancelar' : 'Cancel'}
            </button>
            <button type="button" onClick={commitPaste} disabled={pastePreview.length === 0} style={{ padding: '.55rem 1.2rem', borderRadius: 8, border: 'none', background: pastePreview.length === 0 ? 'var(--c-surface2,#112538)' : 'linear-gradient(135deg,#cc8800,#ff9900)', color: pastePreview.length === 0 ? 'var(--c-text3,#45688a)' : '#fff', fontSize: '.82rem', fontWeight: 800, cursor: pastePreview.length === 0 ? 'not-allowed' : 'pointer' }}>
              {lang === 'es' ? `Agregar ${pastePreview.length} al hilo` : `Add ${pastePreview.length} to thread`}
            </button>
          </div>
        </div>
      </div>
    )}
  </div>;
}
const DOC_TEMPLATE_CATS = [
  {id:"all",         label:"Todas",          labelEn:"All",           icon:"📋"},
  {id:"consent",     label:"Consentimiento", labelEn:"Consent",       icon:"✅"},
  {id:"hipaa",       label:"HIPAA",          labelEn:"HIPAA",         icon:"🏥"},
  {id:"communication",label:"Comunicación",  labelEn:"Communication", icon:"💬"},
  {id:"plan_change", label:"Cambio de Plan", labelEn:"Plan Change",   icon:"🔄"},
  {id:"auto",        label:"Auto",           labelEn:"Auto",          icon:"🚗"},
  {id:"home",        label:"Hogar",          labelEn:"Home",          icon:"🏠"},
  {id:"commercial",  label:"Comercial",      labelEn:"Commercial",    icon:"🏢"},
  {id:"other",       label:"Otro",           labelEn:"Other",         icon:"📄"},
];

// Positional extractor — uses pdfjs's per-item (x, y) coordinates to figure
// out which household-member column each `•` in the eligibility table sits
// under. The flat-text path can't do this because joining items by " " loses
// the X positions.
//
// Returns either null (couldn't anchor the header row) or:
//   { persons: ["Luis R", "Francis L", "Victoria R"],
//     needsDocsPersons: ["Francis L"],         // El Mercado necesita documentos row
//     immigrationPersons: [...],               // anchored on "confirmar estatus"
//     citizenshipPersons: [...],
//     incomePersons: [...] }
//
// Lissette's 2026-05-27 PDF needed this — the parser was attributing the
// docs to the wrong person because the flat-text path can only count bullets,
// not place them on columns.
async function extractPositionalPersons(pdf) {
  const items = [];
  for (let p = 1; p <= Math.min(pdf.numPages, 5); p++) {
    const page = await pdf.getPage(p);
    const content = await page.getTextContent();
    for (const it of content.items) {
      const [, , , , x, y] = it.transform;
      const str = (it.str || '').trim();
      if (str) items.push({ str, x, y, page: p });
    }
  }
  // Anchor on "Solicit" (the "Solicitó cobertura." row right under the
  // household-member header) — "Applied for coverage" in the English notice.
  const solicit = items.find(it => /^(?:Solicit|Applied)/i.test(it.str));
  if (!solicit) return null;
  // Person first names — capitalized words 3+ chars long, slightly above
  // the Solicit row.
  const firstNames = items.filter(it =>
    it.page === solicit.page &&
    it.y > solicit.y - 5 &&
    it.y < solicit.y + 40 &&
    /^\p{Lu}\p{Ll}{2,}$/u.test(it.str)
  ).sort((a, b) => a.x - b.x);
  if (firstNames.length === 0) return null;
  // Pair each first name with its single-letter initial (one row below,
  // same X within 30 units).
  const initials = items.filter(it =>
    it.page === solicit.page &&
    it.y > solicit.y - 15 &&
    it.y < solicit.y + 30 &&
    /^\p{Lu}$/u.test(it.str)
  );
  const persons = firstNames.map(fn => {
    let nearestInit = null, dmin = Infinity;
    for (const ii of initials) {
      if (ii.y >= fn.y) continue;
      const d = Math.abs(ii.x - fn.x);
      if (d < dmin && d < 30) { dmin = d; nearestInit = ii; }
    }
    return { name: nearestInit ? `${fn.str} ${nearestInit.str}` : fn.str, x: fn.x };
  });
  // For a given anchor row, find bullets on that row (Y within tolerance)
  // and assign each bullet to the nearest person column by X.
  const findBulletPersons = (rowMatch, tolY = 15) => {
    const rowItem = items.find(it => rowMatch.test(it.str));
    if (!rowItem) return null;
    const bullets = items.filter(it =>
      it.page === rowItem.page &&
      it.str === '•' &&
      Math.abs(it.y - rowItem.y) <= tolY
    );
    if (bullets.length === 0) return null;
    const matched = bullets.map(b => {
      let bestIdx = -1, dmin = Infinity;
      persons.forEach((p, i) => {
        const d = Math.abs(p.x - b.x);
        if (d < dmin) { dmin = d; bestIdx = i; }
      });
      return persons[bestIdx]?.name || null;
    }).filter(Boolean);
    return [...new Set(matched)];
  };
  // Primary anchor: who needs SOMETHING.
  const needsDocsPersons = findBulletPersons(/El Mercado necesita documentos|The Marketplace needs documents/i);
  // Type-specific anchors. Short fragments because the full action sentence
  // ("Antes del DATE, presente documentos para confirmar estatus migratorio")
  // is split across multiple pdfjs items.
  const immigrationPersons =
    findBulletPersons(/(?:confirmar estatus|estatus migratorio|estatus de inmigración|confirmando.+ciudadanía o inmigración|immigration status|confirm.+immigration|confirming.+citizenship or immigration)/i)
    || needsDocsPersons;
  const incomePersons =
    findBulletPersons(/(?:verificación de ingresos|confirmar.+ingresos|presente documentos.+ingresos|income verification|confirm.+income|send documents.+income)/i)
    || needsDocsPersons;
  const citizenshipPersons =
    findBulletPersons(/(?:prueba de ciudadanía|citizenship proof|proof of citizenship)/i)
    || needsDocsPersons;
  return {
    persons: persons.map(p => p.name),
    needsDocsPersons,
    immigrationPersons,
    incomePersons,
    citizenshipPersons,
    genericPersons: needsDocsPersons,
  };
}

// Los lectores de Pennie y Maryland, el corte del anexo y la deteccion de
// "carta solo de resultados" viven en crm-app/parsearElegibilidad.js desde
// 2026-10-22 (E-379), para poder probarlos sin React.

// A file uploaded to the Eligibility tab that carries NONE of the markers an
// eligibility letter has (federal or state) is almost certainly the wrong
// document — most often the client's APPLICATION/intake form (Lissette
// 2026-07-02: "Aplicacion 2026.pdf"). Classify it so the notice says exactly
// that instead of the generic "couldn't detect documents".
// Returns 'application' | 'other' | null (null = looks eligibility-related,
// keep the generic message so support can tune the parser).
function classifyNonEligibilityDoc(flat) {
  if (!flat || !flat.trim()) return null; // OCR read nothing → generic message
  // Intake/application form: field-label soup (Solicitante, Cónyuge,
  // Dependiente, Requiere cobertura...) with no Marketplace letter language.
  const looksApplication =
    /(Solicitante Principal|Datos del C[oó]nyug|Datos Dependiente|Primary Applicant)/i.test(flat) &&
    /(Requiere cobertura|Estatus Migratorio|Ingreso individual|Needs coverage|Immigration Status)/i.test(flat);
  if (looksApplication) return 'application';
  // Anything else with zero eligibility-letter signal.
  const hasEligibilitySignal =
    /(elegibilidad|eligibility|necesita documentos|documentos? requeridos?|presente documentos|submit documents|healthcare\.gov|cuidadodesalud|Marketplace|Mercado de (?:Seguros|Salud)|Pennie|Maryland Health)/i.test(flat);
  return hasEligibilitySignal ? null : 'other';
}

// ── In-browser OCR for photos & scanned PDFs (Fase 2) ──────────────────────
// Tesseract.js runs ENTIRELY in the browser (WASM); the client's document
// never leaves the device — only the library/lang assets come from the CDN.
// That keeps OCR HIPAA-safe (no BAA needed), same choice as Licenses OCR.
async function ensureTesseractElig() {
  if (window.Tesseract) return;
  const { loadCdnScript, TESSERACT_5_1_1 } = await import("../cdnVendor.js");
  await loadCdnScript(TESSERACT_5_1_1);
}
async function ocrImageToText(image) {
  await ensureTesseractElig();
  // "eng" only: the keywords we detect ("No Verificado", "Ingresos", "Lawful
  // Presence"...) are accent-free Latin script, so the English model reads
  // them fine. Using a single language keeps it fast and matches the proven
  // Licenses OCR. (Adding "spa" would pull a second traineddata download and
  // another failure surface for no detection benefit.)
  const { data } = await window.Tesseract.recognize(image, "eng");
  return (data && data.text) || "";
}
// Render PDF pages to canvases so OCR can read scanned PDFs with no text layer.
async function pdfPagesToCanvasesElig(pdf, maxPages) {
  const out = [];
  for (let p = 1; p <= Math.min(pdf.numPages, maxPages); p++) {
    const page = await pdf.getPage(p);
    const viewport = page.getViewport({ scale: 2 });
    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
    out.push(canvas);
  }
  return out;
}

function parseEligibilityPDF(text) {
  const alerts = [];
  const rawFlat = text.replace(/\s+/g,' ');

  // ── State-based marketplace formats ──
  // These use different layouts than the federal HealthCare.gov template
  // handled below. Try each first; the first that matches wins.
  // NOTE (2026-07-21): the federal path below used to anchor on Spanish
  // literals ONLY, so an English HealthCare.gov notice matched nothing and the
  // agent saw "no documents detected" — or, worse, a false "nothing pending".
  // Every anchor is bilingual now; keep it that way when adding templates.
  const pennie = parsePennieFormat(rawFlat);
  if (pennie) return pennie;
  const maryland = parseMarylandFormat(rawFlat);
  if (maryland) return maryland;
  // Everything below only cares about the actual per-application results/
  // DMI pages, never the generic "Eligibility Guide" appendix bundled after
  // them — strip it once here so no downstream regex can false-positive on
  // guide boilerplate (see stripGuideAppendix above).
  const flat = stripGuideAppendix(rawFlat);
  // Virginia: resultados con "Acción necesaria · Documentos requeridos" por
  // persona — no es un resumen limpio (E-412).
  const conAccion = parseResultadosConAccionNecesaria(flat);
  if (conAccion) return conAccion;
  if (isResultsOnlyEligibility(flat)) {
    const appIdMatch = flat.match(/(?:ID de solicitud|Application ID)\s*:?\s*(\d+)/i);
    return { clientNameFromPdf: '', applicationId: appIdMatch ? appIdMatch[1] : '', alerts: [], resultsOnly: true };
  }

  // ── 1. Extract client name ──
  const nameMatch = flat.match(/(?:Contacto primario|Primary contact)\s+([A-Za-zÀ-ÿ\s]+?)(?:\d|$)/i);
  const clientNameFromPdf = nameMatch ? nameMatch[1].trim() : "";

  // ── 2. Extract application ID ──
  const appIdMatch = flat.match(/(?:Número de Identificación de Solicitud|Application ID)\s*(\d+)/i);
  const applicationId = appIdMatch ? appIdMatch[1] : "";

  // ── 3. Extract person names from table header ──
  // Pattern: names appear between "ayuda financiera:" line and "Solicitó cobertura".
  //
  // NOTE on character classes: previous version used [A-ZÀ-Ÿ] which in JS
  // (without /u flag) is the LITERAL codepoint range U+0041-Z + U+00C0-U+0178.
  // That range INCLUDES lowercase Latin-1 letters like ñ (U+00F1), which
  // caused the parser to match "ño L" out of "año Luis R" and trash the first
  // person slot. Switched to Unicode property classes (\p{Lu} / \p{Ll}) with
  // /u flag so only real uppercase/lowercase Unicode letters match. Fix:
  // 2026-05-27.
  const persons = [];
  const headerMatch = flat.match(/(?:(?:ayuda financiera|financial (?:help|assistance))[^•]*?)((?:\p{Lu}\p{Ll}+\s+(?:del?\s+)?\p{Lu}[\s,]*)+)\s*(?:Solicit|Applied)/iu);
  if(headerMatch) {
    const raw = headerMatch[1].trim();
    const nameChunks = raw.match(/\p{Lu}\p{Ll}+(?:\s+(?:del?|la|el))?\s+\p{Lu}(?:\p{Ll}+)?/gu);
    if(nameChunks) nameChunks.forEach(n => persons.push(n.trim()));
  }
  // Fallback: try short names like "Luis R" "Francis L" "Victoria R"
  if(persons.length===0) {
    const shortMatch = flat.match(/(?:(?:ayuda financiera|financial (?:help|assistance))[^•]*?)((?:\p{Lu}\p{Ll}+\s+\p{Lu}\s*)+)\s*(?:Solicit|Applied)/iu);
    if(shortMatch) {
      const chunks = shortMatch[1].trim().match(/\p{Lu}\p{Ll}+\s+\p{Lu}\b/gu);
      if(chunks) chunks.forEach(n => persons.push(n.trim()));
    }
  }
  // Fallback: PDF table columns extract names and initials on separate lines
  // e.g. "Luis Francis Victoria R L R Solicitó" or "Luis Francis Victoria\nR L R\nSolicitó"
  if(persons.length===0) {
    const sepMatch = flat.match(/(?:ayuda financiera|financial (?:help|assistance))[^]*?(\$[\d,.]+\/(?:año|year|yr))\s*([\s\S]*?)\s*(?:Solicit|Applied)/i);
    if(sepMatch) {
      const block = sepMatch[2].trim();
      // Extract all capitalized words/letters from the block
      const tokens = block.match(/\p{Lu}\p{Ll}*|\p{Lu}/gu);
      if(tokens && tokens.length >= 2) {
        // Separate first names (2+ chars) from initials (1 char)
        const firstNames = tokens.filter(t => t.length > 1);
        const initials = tokens.filter(t => t.length === 1);
        // Match first names with initials in order
        if(firstNames.length > 0 && initials.length === firstNames.length) {
          firstNames.forEach((fn, i) => persons.push(fn + " " + initials[i]));
        } else if(firstNames.length > 0) {
          // If can't pair, just use first names
          firstNames.forEach(fn => persons.push(fn));
        }
      }
    }
  }

  // ── 4. Detect who needs documents ──
  // Look for "El Mercado necesita documentos" row and count bullets after it.
  // Bullets in the rendered PDF table sit UNDER each person column from
  // LEFT to RIGHT (column order = Luis | Francis | Victoria). 1 bullet =
  // first person (the primary contact), 2 bullets = first two, etc.
  // (Earlier this code did right-to-left which inverted Lissette's PDF —
  // see 2026-05-27 fix.)
  const docPersons = [];
  const needsDocsMatch = flat.match(/(?:El Mercado necesita documentos|The Marketplace needs documents)[^•]*((?:\s*•\s*)*)/i);
  if(needsDocsMatch && persons.length>0) {
    const bullets = (needsDocsMatch[1].match(/•/g)||[]).length;
    if(bullets>0 && bullets<=persons.length) {
      for(let i=0; i<bullets; i++) docPersons.push(persons[i]);
    }
  }
  // Also check "confirmando su información de ciudadanía o inmigración" row
  const immigPersons = [];
  const immigRowMatch = flat.match(/(?:confirmando su información de ciudadanía o inmigración|confirming your citizenship or immigration information)[^•]*((?:\s*•\s*)*)/i);
  if(immigRowMatch && persons.length>0) {
    const bullets = (immigRowMatch[1].match(/•/g)||[]).length;
    if(bullets>0 && bullets<=persons.length) {
      for(let i=0; i<bullets; i++) immigPersons.push(persons[i]);
    }
  }
  // Merge both lists (unique)
  const allAffected = [...new Set([...docPersons, ...immigPersons])];
  const affectedStr = allAffected.length>0 ? allAffected.join(", ") : "";

  // ── 5. La fecha limite ──
  // Vivia aqui, en cuatro intentos encadenados y sin una sola prueba. Se mudo
  // a crm-app/documentosDeElegibilidad.js con lo demas (queja 71): es la misma
  // faena —leer la carta— y ahora hay cinco formatos de fecha que atender, uno
  // por mercado de estado. El caso que obliga a anclarla sigue siendo el de
  // 2026-05-27: una carta con DOS "antes del" (la de inscribirse y la de
  // entregar documentos), donde quedarse con la primera da siempre la
  // equivocada.
  const docDeadline = fechaLimite(flat);

  // ── 6. Detect document requirement types from "Documentos para confirmar" section headers ──
  // Each requirement type has its own page/section with a large header like:
  //   "Documentos para confirmar\nEstatus de inmigración"
  //   "Documentos para confirmar\nVerificación de ingresos"
  //   "Documentos para confirmar\nPrueba de ciudadanía"
  // El aviso generico con su fecha se sigue dando siempre que la carta pida
  // algo, aunque no se reconozca el tipo (Lissette 2026-07-28): mejor un aviso
  // sin etiqueta que una etiqueta equivocada.
  // QUE PIDE LA CARTA. La decision vive en crm-app/documentosDeElegibilidad.js
  // desde 2026-09-04 (queja 70): aqui se buscaban las palabras sueltas por las
  // quince paginas, y el folleto que TODAS las cartas llevan detras encendia
  // avisos que la carta no pedia — "Verificacion de Ingresos" en una carta que
  // solo pide ciudadania. Ademas la guarda estaba mal escrita y no guardaba
  // nada (`a && /x/ || /y/` se lee `(a && x) || y`). Ahora solo cuentan el
  // titulo de la seccion y la linea con la fecha, y se prueba con textos
  // inventados en tests/unit/documentosDeElegibilidad.test.ts.
  const pedidos = tiposPedidos(flat);
  const needsDocs = pedidos.necesitaDocs;

  // Immigration/citizenship status docs — detected by dedicated section header "Estatus de inmigración"
  // or by the "confirmando su información de ciudadanía o inmigración" row in the results table.
  // "ciudadanía o inmigración" is ONE requirement — do NOT split into separate alerts.
  //
  // We deliberately do NOT name the person in the alert text. pdfjs's flat
  // text extraction doesn't preserve table column geometry, so we can't tell
  // which household member each `•` belongs to with confidence. The agent
  // knows from filling out the application. The `persons` field is still
  // populated as a best-guess for any downstream consumer.
  // Both orders matter: pdfjs emits the header and the subtitle in whichever
  // order the layout puts them, and the English notice puts "Immigration
  // status" FIRST. Matching only one direction silently dropped the alert.
  if(pedidos.inmigracion) {
    alerts.push({
      type:"immigration_docs",
      doc: "Documentos de Estatus Migratorio",
      docEn: "Immigration Status Documents",
      persons: allAffected,
      deadline: docDeadline,
      status:"pending"
    });
  }

  // Income verification — ONLY if there is a dedicated section header for income verification
  if(pedidos.ingresos) {
    alerts.push({
      type:"income_docs",
      doc: "Verificación de Ingresos",
      docEn: "Income Verification",
      persons: allAffected,
      deadline: docDeadline,
      status:"pending"
    });
  }

  // Citizenship proof — ONLY if there is a dedicated section header specifically for citizenship
  // (separate from immigration). Do NOT trigger on "ciudadanía o inmigración" which is covered above.
  if(pedidos.ciudadania) {
    alerts.push({
      type:"citizenship_docs",
      doc: "Prueba de Ciudadanía",
      docEn: "Citizenship Proof",
      persons: allAffected,
      deadline: docDeadline,
      status:"pending"
    });
  }

  // Prueba del numero de Seguro Social. Sale en la tabla de Colorado
  // ("Proof of your Social Security Number") — un tipo propio, no una variante
  // de ciudadania: los documentos que se aceptan son otros.
  if(pedidos.ssn) {
    alerts.push({
      type:"ssn_docs",
      doc: "Prueba de Número de Seguro Social",
      docEn: "Social Security Number Proof",
      persons: allAffected,
      deadline: docDeadline,
      status:"pending"
    });
  }

  // Otra cobertura (Covered California): el cruce de datos dice que la persona
  // podria tener seguro de un empleador, Medicare o Veterans Health, y le pide
  // que lo desmienta.
  if(pedidos.otraCobertura) {
    alerts.push({
      type:"other_coverage_docs",
      doc: "Prueba de que NO tiene otra cobertura",
      docEn: "Proof of No Other Coverage",
      persons: allAffected,
      deadline: docDeadline,
      status:"pending"
    });
  }

  // Las dos que NO piden papeles. Van fuera del `needsDocs` a proposito: una
  // carta puede no pedir ni un documento y aun asi ser urgente, y hasta hoy
  // esas dos no dejaban ningun aviso — la agente no se enteraba de nada.
  if(pedidos.impuestos) {
    alerts.push({
      type:"tax_reconcile",
      doc: "Declarar impuestos con el Formulario 8962 (no es un documento para subir)",
      docEn: "File taxes with IRS Form 8962 (nothing to upload)",
      persons: allAffected,
      deadline: docDeadline,
      status:"pending"
    });
  }

  if(pedidos.medicaid) {
    alerts.push({
      type:"medicaid_overlap",
      doc: "Tiene Medicaid/CHIP y plan con ayuda: actualizar la solicitud",
      docEn: "Has Medicaid/CHIP and a subsidized plan: update the application",
      persons: allAffected,
      deadline: docDeadline,
      status:"pending"
    });
  }

  // If documents are needed but no specific type detected, add generic.
  // E-379: SOLO si la carta lo pide con todas las letras ("El Mercado necesita
  // documentos", la linea con la fecha…). `needsDocs` tambien se enciende con
  // formas sueltas que trae el folleto de cualquier carta, y con eso una carta
  // de resultados salia con un aviso generico que la carta no pide.
  if(alerts.length===0 && needsDocs && pedidos.peticionExplicita) {
    alerts.push({
      type:"generic_docs",
      doc: "Documentos Requeridos por el Mercado",
      docEn: "Marketplace Required Documents",
      persons: allAffected,
      deadline: docDeadline,
      status:"pending"
    });
  }

  return { clientNameFromPdf, applicationId, alerts };
}



export function EligibilityTab({ clientId, clientName, eligibilityAlerts, onEligibilityAlertsChange, docs, onDocsChange, onRequestsChange, lang, client }) {
  const es = lang==="es";
  const [parsing,setParsing]=useState(false);
  const [error,setError]=useState(null);
  const [lastParsed,setLastParsed]=useState(null);
  const [isDragOver,setIsDragOver]=useState(false);
  // After parsing, we hold the freshly-detected alerts here and ask the agent
  // to confirm WHO each requested document is for (from the client's household)
  // before saving. Auto-detection — especially from a photo/OCR upload — can't
  // reliably attribute a bullet to a person, so alerts used to save with just
  // the doc type ("documentos migratorios") and never named the people
  // (Lissette 2026-07-24: un seat subió una elegibilidad para DOS personas y la
  // alerta no decía a quién). null = no review open.
  const [reviewAlerts,setReviewAlerts]=useState(null);
  const [reviewSel,setReviewSel]=useState({});
  // Household members the requested documents can be assigned to: the client,
  // their spouse, and each dependent (deduped). Names mirror how the Alertas
  // view builds them (spouse/dependent share the client's last name if theirs
  // is blank).
  const householdMembers = useMemo(() => {
    const m = [];
    const last = client?.lastName || (clientName||"").split(" ").slice(1).join(" ");
    if (client?.firstName) m.push(`${client.firstName} ${client.lastName||""}`.trim());
    else if (clientName) m.push(clientName.trim());
    if (hasCurrentSpouse(client)) m.push(`${client.spouse.firstName} ${client.spouse.lastName||last||""}`.trim());
    (client?.dependents||[]).forEach(d => { if (d?.firstName) m.push(`${d.firstName} ${d.lastName||last||""}`.trim()); });
    return [...new Set(m.filter(Boolean))];
  }, [client, clientName]);
  // Raw extracted text shown only when a document was read but produced no
  // alerts — lets the agent copy it so the parser can be tuned to a new
  // template / OCR output. Stays client-side (same PHI the agent uploaded).
  const [debugText,setDebugText]=useState("");
  const fileRef=useRef(null);
  const clientAlerts = (eligibilityAlerts||[]).filter(a=>a.clientId===clientId);

  // Persist the PDF into the docs collection so it can be viewed and
  // downloaded later from the Documents tab. Returns the docRecord on
  // success, null on failure. ALWAYS runs — even if the alert parser
  // later finds nothing, we still want the file saved.
  const saveEligibilityPdfToDocs = async (file) => {
    if (!onDocsChange) return null;
    const sz = file.size<1024?file.size+" B":file.size<1048576?Math.round(file.size/1024)+" KB":(file.size/1048576).toFixed(1)+" MB";
    // Full ISO timestamp (not date-only) so the per-tab badge counter can
    // compare against `lastSeenTabs.docs` which is also a full timestamp.
    // Lissette bug 2026-05-27: uploading eligibility wasn't badging the
    // Documents tab because date-only "2026-05-27" parsed as midnight UTC,
    // BEFORE the mount-time stamp from the same day.
    const today = new Date().toISOString();
    const isApiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (isApiMode) {
      // Delete prior eligibility doc(s) for this client on the server so
      // we keep only the latest PDF, then upload the new one via the SAS
      // helper. We persist the marker on the backend `category` column
      // (value 'eligibility') because frontend-only fields are dropped on
      // save — `category` survives the round-trip and is what the
      // saved-file banner uses to find the PDF after reload.
      try {
        const prior = (docs || []).filter(d => d.clientId === clientId && (d.source === "eligibility" || d.type === "eligibility") && d.id);
        await Promise.all(prior.map(p => apiDeleteDocument(p.id).catch(() => null)));
        const created = await apiUploadDocument(file, { clientId, category: "eligibility" });
        const docRecord = {
          ...created,
          clientId,
          name: file.name,
          // `type` matches what mapDocumentFromApi returns after a reload
          // (it maps type ← category). `source` is the in-memory marker.
          type: "eligibility",
          uploadedAt: created.uploadedAt || today,
          size: sz,
          required: false,
          source: "eligibility",
        };
        onDocsChange(prev => {
          const filtered = (prev || []).filter(
            d => !(d.clientId === clientId && (d.source === "eligibility" || d.type === "eligibility"))
          );
          return [...filtered, docRecord];
        });
        return docRecord;
      } catch (err) {
        setError((es ? 'No se pudo guardar el PDF. ' : 'Could not save the PDF. ') + motivoDeSubidaFallida(err, es));
        return null;
      }
    } else {
      // Legacy localStorage path: embed bytes as base64 dataURL.
      try {
        const dataUrl = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (ev) => resolve(ev.target.result);
          reader.onerror = () => reject(reader.error || new Error("FileReader failed"));
          reader.readAsDataURL(file);
        });
        const docRecord = {
          id: `elig_pdf_${Date.now()}`,
          clientId,
          name: file.name,
          type: es ? "Documento de Elegibilidad" : "Eligibility Document",
          uploadedAt: today,
          size: sz,
          data: dataUrl,
          mimeType: file.type || "application/pdf",
          required: false,
          source: "eligibility",
        };
        onDocsChange(prev => {
          const filtered = (prev || []).filter(
            d => !(d.clientId === clientId && d.source === "eligibility")
          );
          return [...filtered, docRecord];
        });
        return docRecord;
      } catch (err) {
        setError((es ? 'No se pudo guardar el PDF. ' : 'Could not save the PDF. ') + motivoDeSubidaFallida(err, es));
        return null;
      }
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    await processPdfFile(file);
    if(fileRef.current) fileRef.current.value="";
  };

  const processPdfFile = async (file) => {
    if(!file) return;
    const isPdf = file.type==="application/pdf" || /\.pdf$/i.test(file.name||"");
    const isImg = (file.type||"").startsWith("image") || /\.(png|jpe?g|webp|gif|bmp|tiff?|heic)$/i.test(file.name||"");
    if(!isPdf && !isImg) {
      // Chrome names an unfinished download "name.pdf.crdownload" — it may
      // even open locally, but it's not a trustworthy PDF. Say exactly that
      // instead of the bare "PDF only" (Lissette 2026-07-04 picked one from
      // Downloads and thought the reader had broken).
      if (/\.(crdownload|part|download|tmp)$/i.test(file.name||"")) {
        setError(es
          ? `"${file.name}" es una DESCARGA INCOMPLETA del navegador (termina en .crdownload). Descarga el PDF de nuevo desde el Mercado y sube el archivo que termina en .pdf.`
          : `"${file.name}" is an INCOMPLETE browser download (ends in .crdownload). Re-download the PDF from the Marketplace and upload the file ending in .pdf.`);
      } else {
        setError(es
          ? `Solo PDF o imagen (foto). El archivo seleccionado ("${file.name}") no es PDF ni imagen.`
          : `Only PDF or image (photo) files allowed. The selected file ("${file.name}") is not a PDF or image.`);
      }
      return;
    }
    setParsing(true); setError(null); setDebugText("");

    // STEP 1 — Save the file first. The alert parser is best-effort: if it
    // can't extract required-document rows / deadlines (e.g. unfamiliar
    // Marketplace template, blurry photo), we still want the file persisted
    // so the agent can at least keep + view it from the client record.
    const savedRecord = await saveEligibilityPdfToDocs(file);

    // STEP 2 — Best-effort parse for required-document alerts.
    try {
      // Extract text. PDFs use pdf.js's text layer (fast); photos and
      // scanned/no-text PDFs fall back to in-browser OCR (Tesseract).
      let fullText = "";
      let pdf = null; // only set for PDFs with a real text layer (positional needs it)
      if(isPdf) {
        const arrayBuffer = await file.arrayBuffer();
        const uint8 = new Uint8Array(arrayBuffer);
        // Load pdfjs from CDN if not loaded (F-N4: SRI-pinned via cdnVendor).
        if(!window.pdfjsLib) {
          const { loadCdnScript, PDFJS_3_11_174, PDFJS_WORKER_3_11_174 } = await import("../cdnVendor.js");
          await loadCdnScript(PDFJS_3_11_174);
          await loadCdnScript(PDFJS_WORKER_3_11_174);
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_3_11_174.url;
        }
        pdf = await window.pdfjsLib.getDocument({data:uint8}).promise;
        for(let i=1; i<=Math.min(pdf.numPages,5); i++) {
          const page = await pdf.getPage(i);
          const content = await page.getTextContent();
          // Palabras enteras aunque el PDF traiga letras espaciadas (E-412).
          fullText += unirTextoDeLaPagina(content.items) + "\n";
        }
        // Scanned PDF with no usable text layer → OCR the rendered pages.
        if(fullText.replace(/\s+/g,"").length < 20) {
          toast.info(es?"Leyendo el PDF con OCR en tu navegador… puede tardar ~10-20s":"Reading the PDF with in-browser OCR… may take ~10-20s");
          const canvases = await pdfPagesToCanvasesElig(pdf, 3);
          let otext = "";
          for(const c of canvases) otext += (await ocrImageToText(c)) + "\n";
          fullText = otext;
          pdf = null; // OCR text has no (x,y) geometry — skip positional enrichment
        }
      } else {
        // Image / photo → OCR directly. Read the file as a data URL first.
        toast.info(es?"Leyendo la foto con OCR en tu navegador… puede tardar ~10-20s":"Reading the photo with in-browser OCR… may take ~10-20s");
        const dataUrl = await new Promise((resolve,reject)=>{
          const r = new FileReader();
          r.onload = () => resolve(r.result);
          r.onerror = () => reject(r.error || new Error("FileReader failed"));
          r.readAsDataURL(file);
        });
        // Race against a timeout so a stalled OCR (blocked CDN asset, huge
        // image) surfaces a clear error instead of hanging forever with no
        // message — the symptom Lissette hit ("no dice nada").
        fullText = await Promise.race([
          ocrImageToText(dataUrl),
          new Promise((_, rej) => setTimeout(() => rej(new Error(es?"El OCR tardó demasiado (posible bloqueo de red o imagen muy grande)":"OCR timed out (possible network block or very large image)")), 60000)),
        ]);
      }
      const result = parseEligibilityPDF(fullText);
      // Enrich each alert with positional person attribution. The flat-text
      // parser can only count bullets; pdfjs's (x, y) per-item coords let us
      // place each bullet under the right household-member column. Only
      // available for text-layer PDFs (pdf!=null); skipped for OCR. Falls
      // back silently to a generic alert text if anything goes wrong.
      try {
        if (pdf) {
        const positional = await extractPositionalPersons(pdf);
        if (positional && Array.isArray(result.alerts)) {
          const personListFor = (type) => {
            if (type === 'immigration_docs') return positional.immigrationPersons;
            if (type === 'income_docs')      return positional.incomePersons;
            if (type === 'citizenship_docs') return positional.citizenshipPersons;
            if (type === 'generic_docs')     return positional.genericPersons;
            return positional.needsDocsPersons;
          };
          result.alerts = result.alerts.map(a => {
            const pers = personListFor(a.type);
            if (!pers || pers.length === 0) return a;
            const personStr = pers.join(', ');
            return {
              ...a,
              doc:   a.doc   + ' — ' + personStr,
              docEn: a.docEn + ' — ' + personStr,
              persons: pers,
            };
          });
        }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[eligibility-parser] positional extraction failed (using generic labels):', e);
      }
      if(result.alerts.length===0) {
        // Diagnostic: log the extracted text so we can iterate on the parser
        // when a real PDF doesn't match. Truncated to first 800 chars.
        // Safe to leave in — this only runs when the parser already failed
        // and the text never leaves the user's browser.
        // eslint-disable-next-line no-console
        console.log('[eligibility-parser] no alerts matched. Extracted text (first 800 chars):\n',
          (fullText || '').slice(0, 800).replace(/\s+/g, ' '));
        // Surface the extracted text (not for RESULTS-only PDFs, which are
        // expected to have no alerts) so the agent can copy it to us if a new
        // template / OCR output needs the parser tuned.
        // Wrong-document detection: an application/intake form (or any file
        // with zero eligibility-letter markers) is not a parser failure — tell
        // the agent exactly what happened instead of the generic message.
        const flatText = (fullText || '').replace(/\s+/g, ' ').trim();
        const wrongDocKind = result.resultsOnly ? null : classifyNonEligibilityDoc(flatText);
        if (!result.resultsOnly && !wrongDocKind) {
          setDebugText(flatText
            ? flatText.slice(0, 2000)
            : (es
                ? '(El OCR no pudo leer texto de esta imagen. Prueba una captura/imagen más grande y nítida, o sube el PDF.)'
                : '(OCR could not read text from this image. Try a larger, sharper screenshot/image, or upload the PDF.)'));
        } else {
          // RESULTS-only or wrong document: the "send this text to support"
          // box is noise — there is nothing to tune in the parser.
          setDebugText('');
        }
        // PDF was already saved in STEP 1 — show a soft notice, not an error.
        if (result.resultsOnly && savedRecord) {
          // Virginia-style eligibility RESULTS summary: nothing is pending,
          // so this is the expected happy path — not a parse failure.
          setError(es
            ? "✅ Este documento es un RESUMEN de elegibilidad (sin documentos pendientes). Se guardó correctamente y puedes verlo en el banner de arriba."
            : "✅ This is an eligibility RESULTS summary (no pending documents). It was saved and you can view it in the banner above.");
        } else if (wrongDocKind === 'application') {
          setError(es
            ? "⚠️ Este documento parece una APLICACIÓN (formulario con datos del cliente), NO una carta de elegibilidad del Mercado — por eso no hay documentos requeridos ni fechas límite que detectar." + (savedRecord ? " Se guardó y puedes verlo en el banner de arriba. Sube aquí la carta de \"Resultados de elegibilidad\" del Mercado." : "")
            : "⚠️ This looks like an APPLICATION (client intake form), NOT a Marketplace eligibility letter — so there are no required documents or deadlines to detect." + (savedRecord ? " It was saved and you can view it in the banner above. Upload the Marketplace \"Eligibility Results\" letter here." : ""));
        } else if (wrongDocKind === 'other') {
          setError(es
            ? "⚠️ Este documento no parece una carta de elegibilidad del Mercado, por eso no se detectaron documentos requeridos ni fechas límite." + (savedRecord ? " Se guardó y puedes verlo en el banner de arriba." : "")
            : "⚠️ This document doesn't look like a Marketplace eligibility letter, so no required documents or deadlines were detected." + (savedRecord ? " It was saved and you can view it in the banner above." : ""));
        } else if (savedRecord) {
          setError(es
            ? "Documento guardado, pero no se pudieron detectar documentos requeridos ni fechas límite automáticamente. Si subiste una foto, prueba con una imagen más nítida o el PDF. Puedes verlo en el banner de arriba."
            : "Document saved, but no required documents or deadlines were auto-detected. If you uploaded a photo, try a sharper image or the PDF. You can view it in the banner above.");
        } else {
          setError(es?"No se encontraron documentos requeridos ni fechas límite en este documento.":"No required documents or deadlines found in this document.");
        }
        setParsing(false);
        return;
      }
      const now = new Date().toISOString();
      const newAlerts = result.alerts.map((a,i)=>({
        ...a, id:`elig_${clientId}_${Date.now()}_${i}`, clientId, applicationId:result.applicationId, pdfName:file.name, createdAt:now
      }));
      setLastParsed({ name:file.name, count:newAlerts.length, clientNameFromPdf:result.clientNameFromPdf });
      setDebugText("");
      // Open the "who is this for?" review instead of saving straight away.
      openReview(newAlerts);
    } catch(err) {
      // Parser threw (pdfjs failed, CSP block, malformed PDF). The file was
      // still saved in STEP 1 — surface a soft message.
      // eslint-disable-next-line no-console
      console.error('[eligibility-parser] threw:', err);
      if (savedRecord) {
        setError(es?`PDF guardado, pero falló el análisis automático: ${err.message}`:`PDF saved, but parsing failed: ${err.message}`);
      } else {
        setError(es?`Error al leer PDF: ${err.message}`:`Error reading PDF: ${err.message}`);
      }
    }
    setParsing(false);
  };

  // Drag-and-drop a PDF anywhere on the upload zone. Without these the
  // browser navigates to the dropped file (opens the PDF), which is
  // the behavior Lissette was hitting on 2026-05-26.
  const handleDragOver = (e) => { e.preventDefault(); e.stopPropagation(); setIsDragOver(true); };
  const handleDragLeave = (e) => { e.preventDefault(); e.stopPropagation(); setIsDragOver(false); };
  const handleDrop = async (e) => {
    e.preventDefault(); e.stopPropagation();
    setIsDragOver(false);
    const file = e.dataTransfer?.files?.[0];
    if (file) await processPdfFile(file);
  };

  // Save a batch of alerts, replacing any prior alerts for this client (the
  // established behavior — one eligibility letter per client).
  const commitAlerts = (alertsToSave) => {
    onEligibilityAlertsChange(prev => [...(prev||[]).filter(a=>a.clientId!==clientId), ...alertsToSave]);
  };
  // Open the confirmation step, pre-selecting whatever people auto-detection
  // guessed (matched to household members by first name; falls back to the raw
  // detected names so nothing is lost even if the client's household isn't
  // filled in).
  const openReview = (alerts) => {
    const sel = {};
    (alerts||[]).forEach(a => {
      const detected = Array.isArray(a.persons) ? a.persons.filter(Boolean) : [];
      const matched = householdMembers.filter(hm => detected.some(p => {
        const first = String(p).toLowerCase().split(/\s+/)[0];
        return first && hm.toLowerCase().includes(first);
      }));
      sel[a.id] = matched.length ? matched : detected;
    });
    setReviewSel(sel);
    setReviewAlerts(alerts);
  };
  const toggleReviewPerson = (alertId, name) => {
    setReviewSel(prev => {
      const cur = prev[alertId] || [];
      const next = cur.includes(name) ? cur.filter(n=>n!==name) : [...cur, name];
      return { ...prev, [alertId]: next };
    });
  };
  // Bake the chosen people into each alert's label (stripping any prior
  // " — Names" suffix first so we never double it) and save. `persons` is kept
  // on the object too for any future structured consumer.
  const confirmReview = () => {
    const finalized = (reviewAlerts||[]).map(a => {
      const people = (reviewSel[a.id]||[]).filter(Boolean);
      const baseDoc = String(a.doc||"").split(" — ")[0];
      const baseEn = String(a.docEn||"").split(" — ")[0];
      if (!people.length) return { ...a, doc:baseDoc, docEn:baseEn };
      const str = people.join(", ");
      return { ...a, persons:people, doc:`${baseDoc} — ${str}`, docEn:`${baseEn} — ${str}` };
    });
    commitAlerts(finalized);
    setReviewAlerts(null);
    setReviewSel({});
  };
  // Closing without picking still SAVES the parsed alerts (raw doc type, no
  // names) so a parse is never lost — but strips any speculative suffix.
  const cancelReview = () => {
    const finalized = (reviewAlerts||[]).map(a => ({
      ...a, doc:String(a.doc||"").split(" — ")[0], docEn:String(a.docEn||"").split(" — ")[0],
    }));
    commitAlerts(finalized);
    setReviewAlerts(null);
    setReviewSel({});
  };

  const toggleStatus = (alertId) => {
    onEligibilityAlertsChange(prev => (prev||[]).map(a => a.id===alertId ? {...a, status:a.status==="pending"?"completed":"pending"} : a));
  };
  const removeAlert = (alertId) => {
    onEligibilityAlertsChange(prev => (prev||[]).filter(a=>a.id!==alertId));
  };
  const removeAll = () => {
    onEligibilityAlertsChange(prev => (prev||[]).filter(a=>a.clientId!==clientId));
  };

  // Send a document-request portal link to the client for a single alert.
  // Creates a server-backed DocumentRequest, sends an email if the client has
  // one on file, copies the portal URL to the clipboard, and shows a prompt
  // so the agent can paste it into WhatsApp/SMS if needed.
  // 2026-05-27: re-exposed in EligibilityTab because Lissette couldn't find
  // the flow that already exists in the DocRequests view.
  const requestFromClient = async (alert) => {
    const docName = es ? alert.doc : (alert.docEn || alert.doc);
    const isApiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (!isApiMode) {
      setError(es ? "Esta función requiere conexión al servidor." : "This feature needs server connection.");
      return;
    }
    // El servidor rechaza esta llamada por cuatro motivos distintos, y uno de
    // ellos —PHI_DETECTED— no es una negativa sino una PREGUNTA: "revisa esto
    // y reenvia confirmando". Antes se enseñaba como error definitivo y no
    // habia forma de seguir, que es el fallo que reporto Lissette el
    // 2026-09-01. Correos Masivos y Firmas ya sabian contestar esa pregunta.
    const crear = (ack) => apiCreateDocRequest({
      clientId,
      title: docName,
      description: alert.deadline
        ? (es ? `Por favor sube este documento antes del ${alert.deadline}.` : `Please upload this document by ${alert.deadline}.`)
        : (es ? `Por favor sube este documento.` : `Please upload this document.`),
      documentsNeeded: [docName],
      channel: 'email',
      expirationDays: 14,
      acknowledgePhi: ack,
    });
    try {
      let created;
      try {
        created = await crear(false);
      } catch (err) {
        const motivo = mensajeDeFalloDeSolicitud(err, lang);
        if (!motivo.sePuedeConfirmar) throw err;
        const ok = await confirmDialog({
          title: es ? 'Posible información sensible' : 'Possible sensitive info',
          message: motivo.texto,
          danger: true,
          confirmLabel: es ? 'Enviar igual' : 'Send anyway',
        });
        if (!ok) return;
        created = await crear(true);
      }
      // La solicitud existia en el servidor pero NO entraba en la lista de la
      // aplicacion, asi que ni el modulo de Solicitudes ni la fila automatica
      // de Seguimiento/Envios aparecian hasta recargar la pagina entera — y
      // parecia que "no se creaba sola" (Lissette 2026-08-20). Se mete aqui,
      // con la misma forma que usa el resto de la aplicacion.
      if (onRequestsChange) {
        const nombre = `${client?.firstName || ''} ${client?.lastName || ''}`.trim();
        onRequestsChange((prev) => [{
          id: created.id,
          clientId,
          clientName: created.clientName || nombre,
          title: created.title || docName,
          documentsNeeded: created.documentsNeeded || [docName],
          docs: (created.documentsNeeded || [docName]).map((name) => ({ name, required: false, status: 'pending' })),
          sentAt: (created.sentAt || created.createdAt || new Date().toISOString()).split('T')[0],
          uploadToken: created.portalToken,
          link: created.portalUrl || `${window.location.origin}/upload/${created.portalToken || ''}`,
          email: created.clientEmail || client?.email || '',
          status: created.status || 'pending',
        }, ...(prev || [])]);
      }
      const portalUrl = created.portalUrl || (window.location.origin + '/upload/' + (created.portalToken || ''));
      try { await navigator.clipboard.writeText(portalUrl); } catch {}
      const sentMsg = created.emailSent
        ? (es ? `Email enviado al cliente con el link.\n\nLink (también copiado al portapapeles):\n${portalUrl}`
              : `Email sent to client with the link.\n\nLink (also copied to clipboard):\n${portalUrl}`)
        : (es ? `Link copiado al portapapeles. Compártelo manualmente (WhatsApp/SMS):\n${portalUrl}`
              : `Link copied to clipboard. Share it manually (WhatsApp/SMS):\n${portalUrl}`);
      window.alert(sentMsg);
    } catch (err) {
      // El texto sale de un solo sitio, compartido con la pestaña de
      // Solicitudes: antes se pegaba el identificador interno del servidor
      // ("agent_no_mailbox") tal cual, que no le dice nada a nadie.
      setError(mensajeDeFalloDeSolicitud(err, lang).texto);
    }
  };

  // Delete the saved eligibility PDF + any alerts it produced. Asks for
  // confirmation first because this is destructive and unrecoverable
  // (the bytes live in Azure Blob; once deleted they're gone).
  const deleteSavedPdf = async () => {
    const pdf = (docs||[]).find(d=>d.clientId===clientId&&(d.source==="eligibility"||d.type==="eligibility")&&(d.data||d.blobUrl));
    if (!pdf) return;
    const msg = es
      ? "¿Eliminar el PDF de elegibilidad guardado? Esta acción no se puede deshacer.\n\nTambién se eliminarán todas las alertas (documentos requeridos / fechas) que se generaron de este PDF."
      : "Delete the saved eligibility PDF? This cannot be undone.\n\nAll alerts (required documents / deadlines) generated from this PDF will also be removed.";
    if (!(await confirmDialog({ message: msg, danger: true }))) return;
    const isApiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    try {
      if (isApiMode && pdf.id) await apiDeleteDocument(pdf.id);
    } catch (err) {
      setError((es?'Error al eliminar el PDF: ':'Failed to delete PDF: ')+err.message);
      return;
    }
    // Remove from local docs state regardless of mode.
    if (onDocsChange) {
      onDocsChange(prev => (prev||[]).filter(d => !(d.clientId === clientId && (d.source === "eligibility" || d.type === "eligibility"))));
    }
    // Clear all eligibility alerts for this client too.
    onEligibilityAlertsChange(prev => (prev||[]).filter(a=>a.clientId!==clientId));
    setLastParsed(null);
    setError(null);
  };

  const daysUntilDeadline = (deadline) => {
    if(!deadline) return null;
    const [y,m,d] = deadline.split("-").map(Number);
    const target = new Date(y,m-1,d);
    const today = new Date(); today.setHours(0,0,0,0);
    return Math.ceil((target-today)/(1000*60*60*24));
  };

  const sortedAlerts = [...clientAlerts].sort((a,b) => {
    const da = daysUntilDeadline(a.deadline)||999;
    const db = daysUntilDeadline(b.deadline)||999;
    return da-db;
  });

  // API-mode docs carry a `blobUrl` (no inline `data`); legacy localStorage
  // docs carry a base64 `data` field. Accept either so the saved-file
  // banner shows in both modes. After a page reload, server-side docs come
  // back with `type === "eligibility"` (mapped from the backend `category`
  // column) — the in-memory `source` marker is only present until refresh.
  const savedPdf = (docs||[]).find(d=>d.clientId===clientId&&(d.source==="eligibility"||d.type==="eligibility")&&(d.data||d.blobUrl));

  return <div>
    {/* "¿Para quién es cada documento?" confirmation shown right after a PDF/
        photo is parsed. Auto-detection can't reliably attribute a document to a
        household member (esp. from OCR), so the agent confirms here before the
        alert is saved — that's how the WHO gets into the alert text. */}
    {reviewAlerts && (
      <div onClick={cancelReview} style={{position:'fixed',inset:0,background:'rgba(3,10,20,.72)',zIndex:10000,display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
        <div onClick={e=>e.stopPropagation()} style={{background:'var(--c-surface,#0d1c2e)',border:'1px solid var(--c-border,#1a3550)',borderRadius:14,maxWidth:560,width:'100%',maxHeight:'85vh',overflow:'auto',boxShadow:'0 20px 60px rgba(0,0,0,.5)'}}>
          <div style={{padding:'1rem 1.15rem',borderBottom:'1px solid var(--c-border,#1a3550)'}}>
            <div style={{fontSize:'.95rem',fontWeight:800,color:'var(--c-white,#eef6ff)'}}>{es?'¿Para quién es cada documento?':'Who is each document for?'}</div>
            <div style={{fontSize:'.72rem',color:'var(--c-text3,#45688a)',marginTop:4}}>{es?'Marca a las personas del hogar. Se detectaron automáticamente pero conviene confirmar — sobre todo si subiste una foto.':'Check the household members. We auto-detect them, but please confirm — especially for a photo upload.'}</div>
          </div>
          <div style={{padding:'.5rem 1.15rem'}}>
            {reviewAlerts.map(a => {
              const baseDoc = String((es?a.doc:(a.docEn||a.doc))||'').split(' — ')[0];
              const sel = reviewSel[a.id] || [];
              // Show every household member PLUS any auto-detected name that
              // isn't one (so a prefilled name is always visible & toggleable).
              const opts = [...new Set([...householdMembers, ...sel])];
              return (
                <div key={a.id} style={{padding:'.75rem 0',borderBottom:'1px solid var(--c-border,#1a3550)'}}>
                  <div style={{fontSize:'.82rem',fontWeight:700,color:'var(--c-white,#eef6ff)',marginBottom:2}}>📋 {baseDoc}</div>
                  {a.deadline && <div style={{fontSize:'.68rem',color:'#ffb700',marginBottom:6}}>{es?'Fecha límite:':'Deadline:'} {a.deadline}</div>}
                  <div style={{display:'flex',flexWrap:'wrap',gap:6,marginTop:6}}>
                    {opts.length===0 && <div style={{fontSize:'.72rem',color:'var(--c-text3,#45688a)'}}>{es?'(Este cliente no tiene cónyuge/dependientes registrados)':'(No spouse/dependents on file for this client)'}</div>}
                    {opts.map(m => {
                      const on = sel.includes(m);
                      return (
                        <button key={m} type="button" onClick={()=>toggleReviewPerson(a.id,m)} style={{display:'inline-flex',alignItems:'center',gap:6,padding:'.35rem .7rem',borderRadius:999,cursor:'pointer',fontSize:'.74rem',fontWeight:600,border:`1px solid ${on?'var(--c-green,#00ff88)':'var(--c-border,#1a3550)'}`,background:on?'rgba(0,255,136,.14)':'var(--c-surface2,#112538)',color:on?'var(--c-green,#00ff88)':'var(--c-text2,#7aa3c0)'}}>
                          {on?'✓':'＋'} {m}
                        </button>
                      );
                    })}
                  </div>
                  {sel.length>0 && <div style={{fontSize:'.68rem',color:'var(--c-text3,#45688a)',marginTop:6}}>{es?'Para:':'For:'} {sel.join(', ')}</div>}
                </div>
              );
            })}
          </div>
          <div style={{padding:'.85rem 1.15rem',display:'flex',gap:'.5rem',justifyContent:'flex-end',borderTop:'1px solid var(--c-border,#1a3550)'}}>
            <button type="button" onClick={cancelReview} style={{padding:'.5rem .9rem',borderRadius:8,border:'1px solid var(--c-border,#1a3550)',background:'var(--c-surface2,#112538)',color:'var(--c-text2,#7aa3c0)',fontSize:'.78rem',fontWeight:600,cursor:'pointer'}}>{es?'Guardar sin especificar':'Save without names'}</button>
            <button type="button" onClick={confirmReview} style={{padding:'.5rem 1rem',borderRadius:8,border:'1px solid var(--c-green,#00ff88)',background:'rgba(0,255,136,.14)',color:'var(--c-green,#00ff88)',fontSize:'.78rem',fontWeight:700,cursor:'pointer'}}>{es?'Guardar alertas':'Save alerts'}</button>
          </div>
        </div>
      </div>
    )}
    <div style={{fontSize:'.8rem',fontWeight:700,color:'var(--c-white,#eef6ff)',marginBottom:'.75rem'}}>{es?"Elegibilidad — Documentos Requeridos":"Eligibility — Required Documents"}</div>

    {savedPdf&&<div style={{display:'flex',alignItems:'center',gap:'.6rem',padding:'.6rem .8rem',borderRadius:10,background:'rgba(0,212,255,.06)',border:'1px solid rgba(0,212,255,.2)',marginBottom:'.75rem'}}>
      <DocTypeThumbnail doc={savedPdf} size={42}/>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'.78rem',fontWeight:700,color:'var(--c-white,#eef6ff)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{savedPdf.name}</div>
        <div style={{fontSize:'.65rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono,monospace)'}}>{es?"Archivo guardado":"Saved file"} · {savedPdf.size||""} · {savedPdf.uploadedAt}</div>
      </div>
      <div style={{display:'flex',alignItems:'center',gap:6}}>
        {savedPdf.data
          ? <FileActions
              file={{name:savedPdf.name,data:savedPdf.data,type:savedPdf.mimeType||"application/pdf",size:savedPdf.size}}
              lang={lang}
              size="lg"
              sendSubject={es?`Documentos requeridos — ${clientName}`:`Required documents — ${clientName}`}
              sendBody={es
                ? `Hola ${clientName},\n\nAdjunto la carta de elegibilidad del Mercado con los documentos que necesitamos recibir antes de la fecha límite.\n\nPor favor revisa y envíanos los documentos marcados como pendientes.\n\nGracias,\n— ${es?"Tu agente":"Your agent"}`
                : `Hi ${clientName},\n\nPlease find attached your Marketplace eligibility letter with the documents we need to receive before the deadline.\n\nPlease review and send us the pending documents.\n\nThanks,\n— Your agent`}
            />
          : <button onClick={async ()=>{
              try { const url = await apiGetDocumentReadUrl(savedPdf.id); window.open(url, '_blank', 'noopener,noreferrer'); }
              catch (err) { setError((es?'Error al abrir: ':'Failed to open: ')+err.message); }
            }} style={{display:'flex',alignItems:'center',gap:6,padding:'.45rem .9rem',background:'rgba(0,212,255,.12)',border:'1px solid rgba(0,212,255,.3)',color:'var(--c-cyan,#00d4ff)',fontSize:'.78rem',fontWeight:600,borderRadius:8,cursor:'pointer'}}>
              <FileText size={14}/>{es?'Ver PDF':'View PDF'}
            </button>}
        <button
          onClick={deleteSavedPdf}
          title={es?'Eliminar PDF y alertas':'Delete PDF and alerts'}
          style={{display:'flex',alignItems:'center',gap:6,padding:'.45rem .8rem',background:'rgba(255,61,107,.10)',border:'1px solid rgba(255,61,107,.3)',color:'#ff3d6b',fontSize:'.78rem',fontWeight:600,borderRadius:8,cursor:'pointer'}}
          onMouseEnter={e=>{e.currentTarget.style.background='rgba(255,61,107,.20)';}}
          onMouseLeave={e=>{e.currentTarget.style.background='rgba(255,61,107,.10)';}}
        >
          <Trash2 size={14}/>{es?'Eliminar':'Delete'}
        </button>
      </div>
    </div>}

    {/* Upload section — accepts both click-to-pick and drag-and-drop. */}
    <div
      onDragOver={handleDragOver}
      onDragEnter={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      style={{
        padding:'1rem',
        borderRadius:12,
        border: isDragOver ? '2px solid var(--c-cyan,#00d4ff)' : '1px dashed var(--c-cyan,#00d4ff)',
        background: isDragOver ? 'rgba(0,212,255,.12)' : 'rgba(0,212,255,.04)',
        marginBottom:'1rem',
        textAlign:'center',
        transition:'background .15s, border .15s',
      }}
    >
      <Upload size={24} style={{margin:'0 auto .5rem',color:'var(--c-cyan,#00d4ff)'}}/>
      <div style={{fontSize:'.78rem',color:'var(--c-text2,#7aa3c0)',marginBottom:'.5rem'}}>{es?"Sube el PDF o FOTO de Elegibilidad del Mercado para extraer documentos requeridos y fechas límite automáticamente":"Upload the Marketplace Eligibility PDF or PHOTO to automatically extract required documents and deadlines"}</div>
      <div style={{fontSize:'.68rem',color:'var(--c-text3,#45688a)',marginBottom:'.6rem'}}>{es?"Click en el botón o arrastra el PDF/foto aquí (PDF, JPG, PNG)":"Click the button or drag the PDF/photo here (PDF, JPG, PNG)"}</div>
      <label style={{display:'inline-flex',alignItems:'center',gap:'.4rem',padding:'.45rem 1rem',borderRadius:8,background:'var(--c-cyan,#00d4ff)',color:'#000',fontSize:'.75rem',fontWeight:700,cursor:parsing?'wait':'pointer',opacity:parsing?.6:1}}>
        <Upload size={13}/>{parsing?(es?"Analizando...":"Analyzing..."):(es?"Subir Elegibilidad (PDF o Foto)":"Upload Eligibility (PDF or Photo)")}
        <input ref={fileRef} type="file" accept=".pdf,image/*" onChange={handleUpload} style={{display:'none'}} disabled={parsing}/>
      </label>
    </div>

    {error&&<div style={{padding:'.6rem .8rem',borderRadius:8,background:'rgba(255,61,107,.08)',border:'1px solid rgba(255,61,107,.2)',color:'#ff3d6b',fontSize:'.75rem',marginBottom:'.75rem'}}><AlertTriangle size={13} style={{verticalAlign:'middle',marginRight:4}}/>{error}</div>}
    {debugText&&<div style={{padding:'.6rem .8rem',borderRadius:8,background:'rgba(122,163,192,.08)',border:'1px solid rgba(122,163,192,.25)',fontSize:'.72rem',marginBottom:'.75rem'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:'.5rem',marginBottom:'.4rem'}}>
        <span style={{color:'var(--c-text2,#7aa3c0)',fontWeight:600}}>{es?"Texto leído del documento (para soporte):":"Text read from the document (for support):"}</span>
        <button type="button" className="dkt-btn-s" onClick={()=>{navigator.clipboard?.writeText(debugText).then(()=>toast.success(es?"Texto copiado — pégaselo a soporte":"Text copied — paste it to support")).catch(()=>{});}}>{es?"Copiar texto":"Copy text"}</button>
      </div>
      <div style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)',marginBottom:'.4rem'}}>{es?"Si no detectó los documentos, copia este texto y envíaselo a soporte para ajustar el lector a este formato de estado.":"If it didn't detect the documents, copy this text and send it to support so we can tune the reader for this state's format."}</div>
      <textarea readOnly value={debugText} style={{width:'100%',minHeight:90,maxHeight:160,resize:'vertical',fontFamily:'monospace',fontSize:'.66rem',padding:'.4rem',borderRadius:6,border:'1px solid rgba(122,163,192,.3)',background:'var(--c-bg,#0d1b2a)',color:'var(--c-text2,#7aa3c0)'}}/>
    </div>}

    {lastParsed&&<div style={{padding:'.6rem .8rem',borderRadius:8,background:'rgba(0,255,136,.06)',border:'1px solid rgba(0,255,136,.18)',color:'#00ff88',fontSize:'.72rem',marginBottom:'.75rem'}}>
      <CheckCircle size={13} style={{verticalAlign:'middle',marginRight:4}}/>
      {es?`Se extrajeron ${lastParsed.count} alertas del PDF "${lastParsed.name}"`:`Extracted ${lastParsed.count} alerts from "${lastParsed.name}"`}
      {lastParsed.clientNameFromPdf&&<span style={{opacity:.7}}> — {lastParsed.clientNameFromPdf}</span>}
    </div>}

    {/* Alerts list */}
    {sortedAlerts.length===0&&<div style={{textAlign:'center',padding:'2rem',color:'var(--c-text3,#45688a)',fontSize:'.8rem'}}>📋 {es?"Sin alertas de elegibilidad. Sube un PDF para comenzar.":"No eligibility alerts. Upload a PDF to get started."}</div>}

    {sortedAlerts.length>0&&<div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'.5rem'}}>
      <span style={{fontSize:'.7rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)'}}>{sortedAlerts.length} {es?"alertas":"alerts"}</span>
      <button onClick={removeAll} style={{fontSize:'.65rem',color:'#ff3d6b',background:'none',border:'none',cursor:'pointer',textDecoration:'underline'}}>{es?"Eliminar todas":"Remove all"}</button>
    </div>}

    <div style={{display:'flex',flexDirection:'column',gap:'.4rem'}}>
      {sortedAlerts.map(a=>{
        const days = daysUntilDeadline(a.deadline);
        const isOverdue = days!==null && days<0;
        const isUrgent = days!==null && days>=0 && days<=14;
        const isCompleted = a.status==="completed";
        const color = isCompleted?"#00ff88":isOverdue?"#ff3d6b":isUrgent?"#ffb700":"#00d4ff";
        const icon = isCompleted?"✅":isOverdue?"🚨":isUrgent?"⚠️":"📄";
        return <div key={a.id} style={{display:'flex',alignItems:'center',gap:'.6rem',padding:'.65rem .85rem',borderRadius:10,
          background:isOverdue?'rgba(255,61,107,.06)':isCompleted?'rgba(0,255,136,.04)':'var(--c-surface2,#112538)',
          border:`1px solid ${isOverdue?'rgba(255,61,107,.18)':isCompleted?'rgba(0,255,136,.15)':'var(--c-border,#1a3550)'}`,
          borderLeft:`3px solid ${color}`,opacity:isCompleted?.65:1}}>
          <span style={{fontSize:16,flexShrink:0,cursor:'pointer'}} onClick={()=>toggleStatus(a.id)} title={es?"Cambiar estado":"Toggle status"}>{icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:'.8rem',color:isOverdue?'#ff3d6b':isCompleted?'#00ff88':'var(--c-text,#c8dff0)',fontWeight:isUrgent||isOverdue?700:500,lineHeight:1.4,textDecoration:isCompleted?'line-through':'none'}}>
              {es?a.doc:a.docEn||a.doc}
            </div>
            <div style={{display:'flex',gap:'.6rem',alignItems:'center',marginTop:3}}>
              {a.deadline&&<span style={{fontSize:'.62rem',padding:'1px 6px',borderRadius:4,fontWeight:700,fontFamily:'var(--font-mono)',letterSpacing:'.04em',
                background:`${color}15`,color,border:`1px solid ${color}30`}}>
                {isOverdue?(es?"VENCIDO":"OVERDUE"):days===0?(es?"HOY":"TODAY"):days===1?(es?"MAÑANA":"TOMORROW"):`${days} ${es?"días":"days"}`} — {a.deadline}
              </span>}
              {a.applicationId&&<span style={{fontSize:'.58rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)'}}>ID: {a.applicationId}</span>}
            </div>
          </div>
          {!isCompleted&&<button
            onClick={()=>requestFromClient(a)}
            title={es?"Crear link de subida y enviar al cliente":"Create upload link and send to client"}
            style={{display:'flex',alignItems:'center',gap:4,padding:'.35rem .7rem',background:'rgba(0,212,255,.10)',border:'1px solid rgba(0,212,255,.3)',color:'var(--c-cyan,#00d4ff)',fontSize:'.7rem',fontWeight:600,borderRadius:7,cursor:'pointer',whiteSpace:'nowrap'}}
            onMouseEnter={e=>{e.currentTarget.style.background='rgba(0,212,255,.22)';}}
            onMouseLeave={e=>{e.currentTarget.style.background='rgba(0,212,255,.10)';}}
          >
            <Send size={12}/>{es?'Solicitar al cliente':'Request from client'}
          </button>}
          {/* Manual "Received" — Lissette 2026-07-01: after the document
              comes in, the agent marks it received and the alert disappears.
              Always manual (never auto-clears on client upload); confirms
              first so a stray click can't drop a deadline alert silently. */}
          <button
            onClick={()=>{
              const label = es ? a.doc : (a.docEn || a.doc);
              const ok = window.confirm(es
                ? `¿Marcar "${label}" como recibido? La alerta se quitará.`
                : `Mark "${label}" as received? The alert will be removed.`);
              if (ok) removeAlert(a.id);
            }}
            title={es?"Marcar recibido — quita la alerta":"Mark received — removes the alert"}
            style={{display:'flex',alignItems:'center',gap:4,padding:'.35rem .7rem',background:'rgba(0,255,136,.10)',border:'1px solid rgba(0,255,136,.3)',color:'var(--c-green,#00ff88)',fontSize:'.7rem',fontWeight:600,borderRadius:7,cursor:'pointer',whiteSpace:'nowrap'}}
            onMouseEnter={e=>{e.currentTarget.style.background='rgba(0,255,136,.22)';}}
            onMouseLeave={e=>{e.currentTarget.style.background='rgba(0,255,136,.10)';}}
          >
            <CheckCircle size={12}/>{es?'Recibido':'Received'}
          </button>
          <button onClick={()=>removeAlert(a.id)} style={{background:'none',border:'none',cursor:'pointer',color:'var(--c-text3,#45688a)',padding:2}} title={es?"Eliminar":"Remove"}><X size={14}/></button>
        </div>;
      })}
    </div>
  </div>;
}


// Render note text with clickable links that open in a new tab, plus
// **bold**/==highlight== formatting inside the non-link parts (renderRichNote).
function renderNoteText(text) {
  const src = String(text || "");
  // Una nota guardada como HTML acotado se pinta entera desde su arbol: partirla
  // por las URLs cortaria el marcado por la mitad. Los enlaces de una nota con
  // formato se quedan como texto, que es como se veian antes de que existiera
  // este editor.
  if (isRichNote(src)) return renderRichNote(src);
  const parts = src.split(/(https?:\/\/[^\s]+)/g);
  return parts.map((p, i) => /^https?:\/\//.test(p)
    ? <a key={i} href={p} target="_blank" rel="noopener noreferrer" style={{ color: "var(--c-cyan,#00d4ff)", textDecoration: "underline", wordBreak: "break-all" }}>{p}</a>
    : <span key={i}>{renderRichNote(p)}</span>);
}
const isImageFile = (f) => (f?.type || f?.mimeType || "").startsWith("image/");
const fileSrc = (f) => f?.data || f?.url || f?.imageUrl || "";

// Watch what the provider did with a call we placed, and tell the agent.
//
// MightyCall has no status webhook and will accept a call with 200 and a real
// id, then abandon it. Every attempt on 2026-07-22 was recorded "Missed" with
// the leg never connected, while Deskte showed a running timer — hours were
// spent guessing what a silent UI meant. Polls a few times, then reports.
//
// Deliberately one-shot and fire-and-forget: it must never block the modal or
// throw into it. An unknown status says NOTHING — silence beats a false alarm
// on a call that is actually in progress.
async function watchCallOutcome(getCallStatus, callId, es) {
  // Must outlast the provider's own ring timeout. The first version gave up at
  // 26s and a real failing call rang for 33.5s, so it saw only "still
  // ringing", said nothing, and looked exactly like the silence it was built
  // to fix. MightyCall rings ~35s, so watch past a minute.
  const waits = [8000, 8000, 10000, 12000, 15000, 15000];
  for (const ms of waits) {
    await new Promise((r) => setTimeout(r, ms));
    let s = null;
    try { s = await getCallStatus(callId); } catch { return; }
    if (!s) continue;
    if (s.connected) {
      // Connected at least once: nothing to warn about.
      return;
    }
    // "Missed"/"Dropped" is terminal — the provider gave up on it.
    if (/missed|dropped|voicemail/i.test(s.status || "")) {
      const who = s.calledLabel ? ` (${s.calledLabel})` : "";
      toast.error(es
        ? `La llamada no se conectó${who}. MightyCall la marcó como "${s.status}". Nadie contestó la primera llamada, así que el cliente nunca repicó.`
        : `The call never connected${who}. MightyCall marked it "${s.status}". Nobody answered the first leg, so the client was never rung.`);
      return;
    }
  }
}

// CallNoteModal — quick "call + take notes" flow from the client header.
//
// Dials via a `tel:` link (opens the agent's RingCentral desktop app or
// phone, so calls go out on THEIR line — multi-seat / multi-line works:
// each seat dials from their own number, fully concurrent). While the call
// runs, the agent types notes and picks an outcome; on save it writes ONE
// real client note (📞 Call (mm:ss) — Outcome + notes) via onSave, so the
// note lands in the client's Notes tab and history. Frontend-only.
function CallNoteModal({ client, lang, onClose, onSave }) {
  const es = lang === "es";
  const [active, setActive] = useState(false);
  const [secs, setSecs] = useState(0);
  const [note, setNote] = useState("");
  const [disp, setDisp] = useState("");
  const [saving, setSaving] = useState(false);
  const callNoteTaRef = useRef(null);
  // In-app calling is only offered when the agency has a provider connected,
  // routed for voice, AND covered by a signed BAA — the server refuses
  // otherwise, and a button that always fails is worse than none.
  const [inAppReady, setInAppReady] = useState(false);
  const [calling, setCalling] = useState(false);
  // Whose line the provider will actually ring. MightyCall rings the extension
  // of the MightyCall USER whose credentials are stored — not whoever presses
  // Call. Saying "we're calling YOU" to someone whose phone cannot ring is
  // what burned an afternoon, so name the real line instead.
  const [ringsAs, setRingsAs] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (typeof window === "undefined" || !window.__deskteAuth) return undefined;
    import("../api.js")
      .then(({ getPhoneIntegrations }) => getPhoneIntegrations())
      .then((d) => {
        if (cancelled) return;
        setInAppReady(!!d?.canCallInApp);
        setRingsAs(d?.ringsAs || null);
      })
      .catch(() => { if (!cancelled) setInAppReady(false); }); // fall back to the tel: dialer
    return () => { cancelled = true; };
  }, []);
  const ringsAsLabel = ringsAs
    ? [ringsAs.name, ringsAs.extension ? `ext ${ringsAs.extension}` : ""].filter(Boolean).join(" — ")
    : "";

  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => setSecs((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, [active]);

  const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
  // Keep digits and a leading + for international; drop spaces/dashes/parens.
  const dialHref = String(client.phone || "").replace(/[^\d+]/g, "");

  const DISPOS = [
    ["answered", es ? "Contestó" : "Answered", "#00ff88"],
    ["no_answer", es ? "No contestó" : "No answer", "#ffb700"],
    ["voicemail", es ? "Buzón de voz" : "Voicemail", "#a78bfa"],
    ["busy", es ? "Ocupado" : "Busy", "#ef4444"],
    ["callback", es ? "Volver a llamar" : "Call back", "#00d4ff"],
  ];
  const dispLabel = (k) => (DISPOS.find((d) => d[0] === k) || [, k])[1];

  const handleSave = async () => {
    if (saving) return;
    const head = `📞 ${es ? "Llamada" : "Call"}${secs > 0 ? ` (${fmt(secs)})` : ""}${disp ? ` — ${dispLabel(disp)}` : ""}`;
    const text = note.trim() ? `${head}\n${note.trim()}` : head;
    setSaving(true);
    try {
      await onSave(text);
      onClose();
    } catch (err) {
      toast.error((es ? "No se pudo guardar: " : "Couldn't save: ") + (err?.message || err));
      setSaving(false);
    }
  };

  const nothingYet = !note.trim() && !disp && secs === 0;

  return (
    <Modal title={`📞 ${es ? "Llamar a" : "Call"} ${client.firstName} ${client.lastName}`} onClose={onClose}>
      <div style={{ display: "flex", flexDirection: "column", gap: ".875rem" }}>
        <div>
          <label className="dkt-input-lbl">{es ? "Teléfono" : "Phone"}</label>
          <input className="dkt-inp" value={client.phone || ""} readOnly />
        </div>

        {!active ? (
          inAppReady ? (
            // In-app calling: the provider rings the AGENT first, then bridges
            // the client, so the call goes out on the agency's number and gets
            // logged. No tel: link, so nothing depends on which app the
            // computer has registered — the fix for the RingCentral/MightyCall
            // confusion (German Pomares ticket 2026-07-21).
            <button
              type="button"
              disabled={!dialHref || calling}
              onClick={async () => {
                setCalling(true);
                try {
                  const { placeInAppCall, getCallStatus } = await import("../api.js");
                  const placed = await placeInAppCall(client.id);
                  setActive(true);
                  toast.success(
                    ringsAsLabel
                      ? (es
                        ? `Suena primero la línea de ${ringsAsLabel}. Al contestarla, repica el cliente.`
                        : `${ringsAsLabel}'s line rings first. Answering it rings the client.`)
                      : (es
                        ? "Suena primero la línea de MightyCall conectada. Al contestarla, repica el cliente."
                        : "The connected MightyCall line rings first. Answering it rings the client."));
                  // The provider can accept a call and then abandon it without
                  // telling anyone: on 2026-07-22 every attempt came back
                  // "Missed", never connected, while this modal happily showed
                  // a running timer. Poll for a bit and say so. Unknown status
                  // stays silent — no news must never read as failure.
                  if (placed?.callId) watchCallOutcome(getCallStatus, placed.callId, es);
                } catch (err) {
                  // Fall back to the OS dialer rather than dead-ending: an
                  // expired BAA or a disconnected provider shouldn't stop the
                  // agent from calling.
                  //
                  // Say it in the agent's language. Provider jargon reached
                  // the user once already ("MightyCall error 404"), which
                  // reads as Deskte being broken and tells them nothing they
                  // can act on. Configuration problems the agent CAN fix
                  // (bad-from, no-integration, no-callback) keep their
                  // specific message; anything else gets the plain sentence.
                  // "no-line" (GoTo has no line to dial from) and
                  // "not-your-line" (the connection belongs to someone else, so
                  // it would ring THEM) are the same kind of thing: the agent
                  // fixes both in SMS & Calls, and the generic sentence would
                  // send them to support instead.
                  const actionable = ["bad-from", "no-integration", "no-callback", "not-enabled", "no-line", "not-your-line"];
                  const detail = actionable.includes(err?.reason) ? (err?.message || "") : "";
                  toast.error(
                    detail
                      || (es
                        ? "No se pudo llamar desde Deskte. Abriendo el marcador del teléfono."
                        : "Could not call from Deskte. Opening the phone dialer."),
                  );
                  if (dialHref) { try { window.location.href = `tel:${dialHref}`; } catch { /* no handler */ } }
                  setActive(true);
                } finally {
                  setCalling(false);
                }
              }}
              className="dkt-btn-p"
              style={{ justifyContent: "center", background: "linear-gradient(135deg,#059669,#10b981)", opacity: dialHref && !calling ? 1 : 0.5, cursor: calling ? "wait" : "pointer" }}
            >
              <Phone size={15} />{calling ? (es ? "Llamando…" : "Calling…") : (es ? "Llamar ahora" : "Call now")}
            </button>
          ) : (
            <a
              href={dialHref ? `tel:${dialHref}` : undefined}
              onClick={() => { if (dialHref) setActive(true); }}
              className="dkt-btn-p"
              style={{ justifyContent: "center", background: "linear-gradient(135deg,#059669,#10b981)", textDecoration: "none", opacity: dialHref ? 1 : 0.5, pointerEvents: dialHref ? "auto" : "none" }}
            >
              <Phone size={15} />{es ? "Llamar ahora" : "Call now"}
            </a>
          )
        ) : (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "1.9rem", fontWeight: 800, fontFamily: "var(--font-mono)", color: "var(--c-green,#00ff88)", marginBottom: ".4rem" }}>
              <span style={{ width: 9, height: 9, borderRadius: "50%", background: "#00ff88", display: "inline-block", marginRight: 8, animation: "pulse 1s infinite" }} />
              {fmt(secs)}
            </div>
            <button type="button" onClick={() => setActive(false)} style={{ fontSize: ".72rem", fontWeight: 700, color: "var(--c-red,#ff3d6b)", background: "rgba(239,68,68,.12)", border: "1px solid rgba(239,68,68,.3)", borderRadius: 8, padding: ".3rem .8rem", cursor: "pointer" }}>
              🔴 {es ? "Terminar llamada" : "End call"}
            </button>
          </div>
        )}

        {/* This dials with a `tel:` link, so the OPERATING SYSTEM chooses which
            app answers it — Deskte has no say. Saying "RingCentral" here (as
            this line used to) made agents think the provider they picked under
            "SMS y Llamadas" controls it: German Pomares disabled RingCentral,
            enabled MightyCall, and still got RingCentral, because RingCentral
            is what his Windows has registered for phone links (ticket
            2026-07-21). Be explicit instead of naming one brand. */}
        {/* The incoming leg shows the AGENCY's own number, so the agent sees
            what looks like a call from themselves. That is inherent to the
            callback model — the provider rings the business number first —
            and MightyCall's API takes only `from` and `to`, with no field to
            set the caller ID. So it cannot be fixed in code; it can only stop
            being a surprise. Lissette hit exactly this on her first real
            call: "sale como si me estuviera llamando yo misma". */}
        <div className="dkt-phase">📞 {inAppReady
          ? (es
              ? `Primero suena la línea de MightyCall conectada${ringsAsLabel ? ` (${ringsAsLabel})` : ""} — NO la tuya, si no eres tú quien la conectó. Esa persona debe contestar: el cliente NO repica hasta entonces. Escribe las notas mientras hablas y guárdalas en la ficha.`
              : `The connected MightyCall line rings first${ringsAsLabel ? ` (${ringsAsLabel})` : ""} — NOT yours, unless you connected it. That person must answer: the client does NOT ring until then. Take notes during the call and save them to the profile.`)
          : (es
              ? "Se abrirá la app de llamadas que tu computadora tenga como predeterminada para teléfono. Escribe las notas mientras hablas y guárdalas en la ficha del cliente."
              : "This opens whichever calling app your computer has set as the default for phone links. Take notes during the call and save them to the client's profile.")}</div>
        {!inAppReady && (
          <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", lineHeight: 1.5 }}>
            {es
              ? "¿Se abre la app equivocada? No se elige desde Deskte: cámbiala en Windows → Configuración → Aplicaciones → Aplicaciones predeterminadas → Elegir predeterminados por tipo de vínculo → TEL. En Mac, en Ajustes de FaceTime."
              : "Wrong app opening? It isn't chosen in Deskte: change it in Windows → Settings → Apps → Default apps → Choose defaults by link type → TEL. On Mac, in FaceTime settings."}
          </div>
        )}

        <div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".38rem" }}>
            <label className="dkt-input-lbl" style={{ margin: 0 }}>{es ? "Notas de la llamada" : "Call notes"}</label>
            <NoteFormatButtons taRef={callNoteTaRef} value={note} onChange={setNote} lang={lang} compact full />
          </div>
          <RichNoteBox boxRef={callNoteTaRef} rows={4} value={note} onChange={setNote} lang={lang}
            placeholder={es ? "Lo que se habló, próximos pasos, compromisos..." : "What was discussed, next steps, commitments..."} />
        </div>

        <div>
          <label className="dkt-input-lbl">{es ? "Resultado" : "Outcome"}</label>
          <div style={{ display: "flex", gap: ".35rem", flexWrap: "wrap" }}>
            {DISPOS.map(([k, label, color]) => (
              <button type="button" key={k} onClick={() => setDisp(disp === k ? "" : k)}
                style={{ padding: ".35rem .7rem", borderRadius: 8, border: `1px solid ${color}${disp === k ? "" : "44"}`, background: disp === k ? color : `${color}1a`, color: disp === k ? "#06121f" : color, fontSize: ".72rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                {label}
              </button>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", gap: ".5rem" }}>
          <button disabled={saving || nothingYet} onClick={handleSave} className="dkt-btn-p" style={{ flex: 1, opacity: (saving || nothingYet) ? 0.6 : 1 }}>
            <Save size={14} />{saving ? (es ? "Guardando..." : "Saving...") : (es ? "Guardar en notas" : "Save to notes")}
          </button>
          <button onClick={onClose} className="dkt-btn-s">{es ? "Cerrar" : "Close"}</button>
        </div>
      </div>
    </Modal>
  );
}

/**
 * Hilo de comentarios de UNA nota (Lissette 2026-08-07).
 *
 * El hilo se carga al abrirlo, no con la lista de notas: `listNotes()` trae
 * TODAS las notas de la agencia al arrancar la app, así que incluir los
 * cuerpos ahí engordaría la carga inicial. De la lista solo llega
 * `note.commentCount`, que es lo que se pinta cerrado.
 *
 * Los helpers pesados (subida a Blob, formato de fecha/tamaño, iconos) llegan
 * por props desde ClientNotesTab en vez de duplicarse aquí.
 */
function NoteCommentThread({ note, es, lang, users, currentUser, canModerate, uploadPending, fmtDate, fmtSize, fileIcon, onPreview, isApiMode, onCountChange }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [comments, setComments] = useState([]);
  const [draft, setDraft] = useState("");
  const [draftFiles, setDraftFiles] = useState([]);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");
  const [editFiles, setEditFiles] = useState([]);
  const [savingEdit, setSavingEdit] = useState(false);
  const fileRef = useRef();
  const editFileRef = useRef();

  // Cerrado, el contador viene de la nota (lo mantiene el evento SSE). Abierto
  // y cargado, manda el hilo: `comments` ES la lista real, así que nunca puede
  // desmentir a lo que el usuario está viendo.
  const noteCount = typeof note.commentCount === "number" ? note.commentCount : 0;
  const count = loaded ? comments.length : noteCount;

  const readPreview = (f) => new Promise(res => {
    const reader = new FileReader();
    reader.onload = e => res({ name: f.name, size: f.size, type: f.type, data: e.target.result, file: f });
    reader.readAsDataURL(f);
  });
  const pickFiles = (incoming, setter) => {
    Promise.all(Array.from(incoming).map(readPreview)).then(loadedFiles => setter(prev => [...prev, ...loadedFiles]));
  };

  const load = async () => {
    if (!isApiMode) { setLoaded(true); return; }
    setLoading(true);
    try {
      setComments(await apiListNoteComments(note.id));
      setLoaded(true);
    } catch (err) {
      toast.error((es ? "No se pudieron cargar los comentarios: " : "Couldn't load comments: ") + (err?.message || err));
    } finally {
      setLoading(false);
    }
  };

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next && !loaded && !loading) load();
  };

  // Comentarios de otras personas en vivo. deskte-full.jsx reemite los eventos
  // SSE como CustomEvent; aquí solo interesan los de ESTA nota.
  //
  // Se escucha aunque el hilo esté cerrado: si no, al abrirlo se mostraría una
  // lista vieja. Cuando está cerrado basta con invalidar (`loaded=false`) para
  // que la próxima apertura recargue.
  useEffect(() => {
    const onEvt = (e) => {
      const d = e?.detail;
      if (!d || d.noteId !== note.id) return;
      if (!open) { setLoaded(false); return; }
      if (d.action === "deleted") {
        setComments(prev => prev.filter(x => x.id !== d.id));
        return;
      }
      // El payload SSE es la fila del backend SIN mapear: trae `content`, no
      // `text`, y `attachments` sin firmar. Metida cruda en el hilo, la
      // burbuja salía con autor y hora pero SIN TEXTO — y como el evento
      // suele ganarle a la respuesta del POST, el propio comentario recién
      // escrito se quedaba vacío (Crismar 2026-08-11: "no aparece, solo sale
      // que yo lo creé"). Mismo mapeo que las llamadas HTTP, misma forma.
      const mapped = d.comment ? mapNoteCommentFromApi(d.comment) : null;
      if (!mapped || !mapped.id) return;
      setComments(prev => (
        prev.some(x => x.id === mapped.id)
          ? prev.map(x => (x.id === mapped.id ? mapped : x))
          : [...prev, mapped]
      ));
    };
    window.addEventListener("deskte:note-comment", onEvt);
    return () => window.removeEventListener("deskte:note-comment", onEvt);
  }, [note.id, open]);

  // Contador de la nota ("💬 3") = longitud EXACTA del hilo cargado.
  //
  // Antes cada alta/baja mandaba un delta (+1/−1) al padre, y el manejador SSE
  // de deskte-full.jsx sumaba OTRO +1 al recibir el eco del mismo comentario:
  // un comentario propio contaba dos veces (Crismar 2026-08-11: "coloco 1
  // comentario y me dice que hay 2"). Publicar el total absoluto es idempotente
  // — da igual el orden en que lleguen el POST y su eco SSE — y además corrige
  // un contador ya desfasado en cuanto se abre el hilo.
  useEffect(() => {
    // Sin servidor no hay hilo que cargar (`load` marca `loaded` sin pedir
    // nada), así que publicar un 0 solo ensuciaría la nota.
    if (!loaded || !isApiMode || !onCountChange) return;
    onCountChange(note.id, comments.length);
  // `onCountChange` es una función nueva en cada render del padre; incluirla
  // en las dependencias reengancharía el efecto en bucle.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [note.id, loaded, comments]);

  const submit = async () => {
    if (saving) return;
    if (!draft.trim() && draftFiles.length === 0) return;
    if (!isApiMode) {
      toast.error(es ? "Los comentarios necesitan conexión con el servidor." : "Comments need the server connection.");
      return;
    }
    setSaving(true);
    try {
      const attachments = await uploadPending(draftFiles);
      const created = await apiAddNoteComment(note.id, { text: draft.trim(), attachments });
      // El evento SSE también llega a esta pestaña, así que se comprueba el id
      // antes de añadir: sin esto el comentario propio saldría duplicado.
      setComments(prev => (prev.some(x => x.id === created.id) ? prev : [...prev, created]));
      setDraft("");
      setDraftFiles([]);
    } catch (err) {
      toast.error((es ? "No se pudo comentar: " : "Couldn't add the comment: ") + (err?.message || err));
    } finally {
      setSaving(false);
    }
  };

  const startEdit = (cm) => {
    setEditingId(cm.id);
    setEditText(cm.text || "");
    setEditFiles((cm.files || []).map(f => ({ ...f })));
  };

  const saveEdit = async () => {
    if (savingEdit || !editingId) return;
    if (!editText.trim() && editFiles.length === 0) {
      toast.error(es ? "El comentario necesita texto o una foto." : "The comment needs text or a photo.");
      return;
    }
    setSavingEdit(true);
    try {
      const attachments = await uploadPending(editFiles);
      const updated = await apiUpdateNoteComment(editingId, { text: editText.trim(), attachments });
      setComments(prev => prev.map(x => (x.id === updated.id ? updated : x)));
      setEditingId(null);
      setEditText("");
      setEditFiles([]);
    } catch (err) {
      toast.error((es ? "No se pudo guardar: " : "Couldn't save: ") + (err?.message || err));
    } finally {
      setSavingEdit(false);
    }
  };

  const remove = async (cm) => {
    const ok = await confirmDialog({
      title: es ? "¿Borrar comentario?" : "Delete comment?",
      message: es ? "Esta acción no se puede deshacer." : "This can't be undone.",
      confirmLabel: es ? "Borrar" : "Delete",
      danger: true,
    });
    if (!ok) return;
    try {
      await apiDeleteNoteComment(cm.id);
      setComments(prev => prev.filter(x => x.id !== cm.id));
    } catch (err) {
      toast.error((es ? "No se pudo borrar: " : "Couldn't delete: ") + (err?.message || err));
    }
  };

  const canTouch = (cm) => canModerate || cm.authorId === currentUser?.id;

  const filePreviews = (list, setter, inputRef) => (
    <>
      {list.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: ".35rem", marginTop: ".35rem" }}>
          {list.map((f, i) => (
            isImageFile(f) && fileSrc(f) ? (
              <div key={i} style={{ position: "relative" }}>
                <img src={fileSrc(f)} alt={f.name || "image"} title={f.name || "image"}
                  style={{ width: 56, height: 56, borderRadius: 6, border: "1px solid var(--c-border,#1a3550)", objectFit: "cover" }} />
                <button type="button" onClick={() => setter(prev => prev.filter((_, j) => j !== i))} title={es ? "Quitar" : "Remove"}
                  style={{ position: "absolute", top: -5, right: -5, width: 16, height: 16, borderRadius: "50%", background: "var(--c-red,#ff3d6b)", color: "#fff", border: "none", cursor: "pointer", fontSize: ".6rem", lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
              </div>
            ) : (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: ".35rem", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 6, padding: ".25rem .5rem" }}>
                <span style={{ fontSize: ".8rem" }}>{fileIcon(f.type)}</span>
                <span style={{ fontSize: ".68rem", color: "var(--c-text,#c8dff0)", maxWidth: 130, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</span>
                <button type="button" onClick={() => setter(prev => prev.filter((_, j) => j !== i))} title={es ? "Quitar" : "Remove"}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)", fontSize: ".7rem" }}>✕</button>
              </div>
            )
          ))}
        </div>
      )}
      <input ref={inputRef} type="file" multiple accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" style={{ display: "none" }}
        onChange={e => { if (e.target.files?.length) pickFiles(e.target.files, setter); e.target.value = ""; }} />
    </>
  );

  return (
    <div style={{ marginTop: ".55rem", borderTop: "1px solid var(--c-border,#1a3550)", paddingTop: ".45rem" }}>
      <button type="button" onClick={toggle}
        style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)", fontSize: ".7rem", fontWeight: 700, padding: ".15rem 0", display: "inline-flex", alignItems: "center", gap: ".3rem" }}>
        💬 {count > 0
          ? `${count} ${count === 1 ? (es ? "comentario" : "comment") : (es ? "comentarios" : "comments")}`
          : (es ? "Comentar" : "Comment")}
        <span style={{ fontSize: ".6rem" }}>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div style={{ marginTop: ".4rem", display: "flex", flexDirection: "column", gap: ".4rem" }}>
          {loading && (
            <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)" }}>{es ? "Cargando…" : "Loading…"}</div>
          )}

          {comments.map(cm => {
            const author = users && users.find(u => u.id === cm.authorId);
            const authorLabel = author ? author.name : (cm.authorName || (es ? "Usuario" : "User"));
            const initials = authorLabel.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
            const color = author?.color || "#0077aa";
            const imgs = (cm.files || []).filter(f => isImageFile(f) && fileSrc(f));
            const others = (cm.files || []).filter(f => !isImageFile(f));
            return (
              <div key={cm.id} style={{ display: "flex", gap: ".45rem", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 8, padding: ".45rem .55rem" }}>
                <div style={{ width: 22, height: 22, borderRadius: "50%", background: color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: ".55rem", fontWeight: 800, color: "#fff", flexShrink: 0 }}>
                  {initials}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: ".4rem" }}>
                    <div style={{ fontSize: ".7rem", fontWeight: 700, color: "var(--c-white,#eef6ff)" }}>
                      {authorLabel}
                      <span style={{ fontWeight: 500, color: "var(--c-text3,#45688a)", marginLeft: ".4rem" }}>{fmtDate(cm.createdAt)}</span>
                      {cm.updatedAt && cm.updatedAt !== cm.createdAt && (
                        <span style={{ fontWeight: 500, color: "var(--c-text3,#45688a)", marginLeft: ".3rem", fontStyle: "italic" }}>
                          ({es ? "editado" : "edited"})
                        </span>
                      )}
                    </div>
                    {canTouch(cm) && editingId !== cm.id && (
                      <div style={{ display: "flex", gap: ".1rem", flexShrink: 0 }}>
                        <button type="button" onClick={() => startEdit(cm)} title={es ? "Editar" : "Edit"}
                          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)", fontSize: ".7rem", padding: ".1rem .25rem" }}>✏️</button>
                        <button type="button" onClick={() => remove(cm)} title={es ? "Borrar" : "Delete"}
                          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)", fontSize: ".7rem", padding: ".1rem .25rem" }}>🗑️</button>
                      </div>
                    )}
                  </div>

                  {editingId === cm.id ? (
                    <div style={{ marginTop: ".3rem" }}>
                      <NoteEditor value={editText} onChange={setEditText} lang={es ? "es" : "en"} rows={2} usuarios={users} />
                      {filePreviews(editFiles, setEditFiles, editFileRef)}
                      <div style={{ display: "flex", gap: ".35rem", marginTop: ".35rem" }}>
                        <button type="button" onClick={() => editFileRef.current?.click()}
                          style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text,#c8dff0)", fontSize: ".68rem", padding: ".25rem .5rem", borderRadius: 6, cursor: "pointer" }}>📎</button>
                        <button type="button" onClick={saveEdit} disabled={savingEdit}
                          style={{ background: "var(--c-cyan,#00d4ff)", border: "none", color: "#06121f", fontWeight: 800, fontSize: ".68rem", padding: ".25rem .6rem", borderRadius: 6, cursor: savingEdit ? "wait" : "pointer", opacity: savingEdit ? .6 : 1 }}>
                          {savingEdit ? (es ? "Guardando…" : "Saving…") : (es ? "Guardar" : "Save")}
                        </button>
                        <button type="button" onClick={() => { setEditingId(null); setEditText(""); setEditFiles([]); }}
                          style={{ background: "none", border: "none", color: "var(--c-text3,#45688a)", fontSize: ".68rem", cursor: "pointer" }}>
                          {es ? "Cancelar" : "Cancel"}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      {cm.text && (
                        <div style={{ fontSize: ".74rem", color: "var(--c-text,#c8dff0)", whiteSpace: "pre-wrap", wordBreak: "break-word", marginTop: ".15rem" }}>
                          {renderNoteText(cm.text)}
                        </div>
                      )}
                      {imgs.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: ".3rem", marginTop: ".3rem" }}>
                          {imgs.map((f, i) => (
                            <img key={i} src={fileSrc(f)} alt={f.name || "image"} title={f.name || "image"}
                              onClick={() => onPreview({ src: fileSrc(f), name: f.name })}
                              style={{ maxWidth: 130, maxHeight: 110, borderRadius: 6, border: "1px solid var(--c-border,#1a3550)", objectFit: "cover", cursor: "zoom-in" }} />
                          ))}
                        </div>
                      )}
                      {others.map((f, i) => (
                        <div key={i} style={{ display: "flex", alignItems: "center", gap: ".4rem", marginTop: ".25rem", background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 6, padding: ".25rem .5rem" }}>
                          <span style={{ fontSize: ".8rem" }}>{fileIcon(f.type)}</span>
                          <span style={{ flex: 1, fontSize: ".68rem", color: "var(--c-text,#c8dff0)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</span>
                          <span style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", flexShrink: 0 }}>{fmtSize(f.size)}</span>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            );
          })}

          {!loading && loaded && comments.length === 0 && (
            <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)", fontStyle: "italic" }}>
              {es ? "Sin comentarios todavía." : "No comments yet."}
            </div>
          )}

          {/* Composer */}
          <div>
            <NoteEditor value={draft} onChange={setDraft} lang={es ? "es" : "en"} rows={2} usuarios={users}
              placeholder={es ? "Escribe un comentario…" : "Write a comment…"} />
            {filePreviews(draftFiles, setDraftFiles, fileRef)}
            <div style={{ display: "flex", gap: ".35rem", marginTop: ".35rem" }}>
              <button type="button" onClick={() => fileRef.current?.click()} title={es ? "Adjuntar foto o archivo" : "Attach photo or file"}
                style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text,#c8dff0)", fontSize: ".68rem", padding: ".25rem .5rem", borderRadius: 6, cursor: "pointer" }}>📎</button>
              <button type="button" onClick={submit} disabled={saving || (!draft.trim() && draftFiles.length === 0)}
                style={{ background: "var(--c-cyan,#00d4ff)", border: "none", color: "#06121f", fontWeight: 800, fontSize: ".68rem", padding: ".25rem .7rem", borderRadius: 6, cursor: saving ? "wait" : "pointer", opacity: (saving || (!draft.trim() && draftFiles.length === 0)) ? .5 : 1 }}>
                {saving ? (es ? "Enviando…" : "Sending…") : (es ? "Comentar" : "Comment")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export function ClientNotesTab({ clientId, notes, onNotesChange, onDocsChange, docs = [], users, currentUser, lang, category = null, estadoNotas = "listo", onReintentarNotas }) {
  const es = lang === "es";
  const [text, setText] = useState("");
  const [files, setFiles] = useState([]);
  const [dragging, setDragging] = useState(false);
  const [saving, setSaving] = useState(false); // creating a note (uploading photos)
  const [previewImg, setPreviewImg] = useState(null); // { src, name } for the lightbox
  // Notas abiertas a mano. Las largas se pintan recortadas (ver notaLarga.js);
  // esto guarda cuales desplego la agente, por id. Se pierde al cerrar la
  // ficha, y esta bien: al volver a entrar interesa ver la lista corta otra vez.
  const [notasAbiertas, setNotasAbiertas] = useState({});
  const [editingNoteId, setEditingNoteId] = useState(null); // note being edited inline
  const [editNoteText, setEditNoteText] = useState("");
  const [editFiles, setEditFiles] = useState([]); // attachments while editing a note
  const [editDragging, setEditDragging] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);
  const fileRef = useRef();
  const editFileRef = useRef();
  const noteTaRef = useRef(null);
  const editTaRef = useRef(null);

  const uid = () => Math.random().toString(36).slice(2,9);

  // Read a File into a preview object. Keeps the original `file` so the byte
  // content can be uploaded to Blob on save (data is only for the instant
  // thumbnail); existing attachments already carry blobUrl/url and no file.
  const readFilePreview = (f) => new Promise(res => {
    const reader = new FileReader();
    reader.onload = e => res({ name: f.name, size: f.size, type: f.type, data: e.target.result, file: f });
    reader.readAsDataURL(f);
  });
  const handleFiles = (incoming, setter = setFiles) => {
    Promise.all(Array.from(incoming).map(readFilePreview)).then(loaded => setter(prev => [...prev, ...loaded]));
  };

  const removeFile = (idx) => setFiles(prev => prev.filter((_,i) => i !== idx));
  const removeEditFile = (idx) => setEditFiles(prev => prev.filter((_,i) => i !== idx));

  // Turn a mixed list (existing attachments with blobUrl + freshly-picked File
  // previews) into the persisted attachment shape. New files upload to Blob;
  // existing ones pass their bare blobUrl straight through. Uploads run in
  // parallel — one slow photo shouldn't serialize the rest.
  const uploadPending = async (list) => Promise.all((list || []).map(async (f) => {
    if (f.blobUrl) return { name: f.name, type: f.type, size: f.size, blobUrl: f.blobUrl };
    if (f.file) return apiUploadNoteAttachment(f.file);
    return null;
  })).then(arr => arr.filter(Boolean));

  const isApiModeN = typeof window !== "undefined" && !!window.__deskteAuth;

  // Quién puede tocar comentarios ajenos. Mismo criterio que el backend
  // (canModerateComments en notes.routes.ts): dueño de agencia, solo agent, o
  // platform owner. Aquí solo esconde botones — quien manda es el backend, que
  // devuelve 403 si alguien lo intenta igual.
  const canModerateComments =
    currentUser?.role === "agency_owner" ||
    currentUser?.role === "solo_agent" ||
    !!currentUser?.isPlatformOwner;

  // El contador que se pinta cerrado vive en la nota, no en el hilo. El hilo
  // publica su TOTAL (no un delta) cada vez que cambia, así que esto es un
  // simple "pon este número": aplicarlo dos veces deja el mismo valor, que es
  // justo lo que hacía falta cuando el eco SSE del propio comentario llega
  // además de la respuesta del POST.
  const setCommentCount = (noteId, total) => {
    onNotesChange && onNotesChange(prev => {
      const list = prev || [];
      const cur = list.find(x => x.id === noteId);
      // Sin cambio → devolver la MISMA lista para que React no re-renderice.
      if (!cur || cur.commentCount === total) return prev;
      return list.map(x => (x.id === noteId ? { ...x, commentCount: Math.max(0, total) } : x));
    });
  };

  const addNote = async () => {
    if (saving) return;
    if (!text.trim() && files.length === 0) return;
    const noteId = uid();
    if (isApiModeN) {
      // Upload photos/files to Blob, then persist the note WITH the attachment
      // references so they survive a reload (the whole point of this ticket).
      setSaving(true);
      let attachments = [];
      try {
        attachments = await uploadPending(files);
      } catch (err) {
        toast.error((es ? "No se pudieron subir las fotos: " : "Couldn't upload the photos: ") + (err?.message || err));
        setSaving(false);
        return;
      }
      let created;
      try {
        created = await apiCreateNote({ clientId, text: text.trim(), category: category || undefined, attachments });
      } catch (err) {
        toast.error("Failed to save note: " + err.message);
        setSaving(false);
        return;
      }
      // `created` already carries `files` (signed read URLs) from mapNoteFromApi.
      onNotesChange && onNotesChange(prev => {
        const arr = prev || [];
        return arr.some(x => x.id === created.id)
          ? arr.map(x => x.id === created.id ? { ...x, ...created } : x)
          : [created, ...arr];
      });
      setSaving(false);
    } else {
      // Local/demo mode (no backend): keep the base64 preview on the note.
      const note = {
        id: noteId,
        clientId,
        text: text.trim(),
        files: files.map(f => ({ name: f.name, size: f.size, type: f.type, data: f.data })),
        category: category || null,
        authorId: currentUser?.id || "",
        authorName: currentUser?.name || (es ? "Usuario" : "User"),
        createdAt: new Date().toISOString(),
      };
      onNotesChange && onNotesChange(prev => [note, ...(prev || [])]);
    }
    setText("");
    setFiles([]);
  };

  // Pin / unpin a note so the important ones stay at the top of the list
  // (Lissette 2026-06-17: "déjame fijar algunas notas y que queden de primero").
  // Optimistic: flip locally first, then persist; revert on failure. The
  // backend already returns pinned-first and the list below re-sorts.
  const togglePin = async (note) => {
    const next = !note.isPinned;
    onNotesChange && onNotesChange(prev => (prev || []).map(n => n.id === note.id ? { ...n, isPinned: next } : n));
    if (isApiModeN) {
      try { await apiUpdateNote(note.id, { isPinned: next }); }
      catch (e) {
        toast.error((lang === "es" ? "No se pudo fijar la nota: " : "Could not pin the note: ") + (e.message || e));
        onNotesChange && onNotesChange(prev => (prev || []).map(n => n.id === note.id ? { ...n, isPinned: !next } : n));
      }
    }
  };

  const deleteNote = async (id) => {
    const ok = await confirmDialog({
      message: lang === "es" ? "¿Seguro que quieres borrar esta nota? Esta acción no se puede deshacer." : "Are you sure you want to delete this note? This cannot be undone.",
      danger: true,
    });
    if (!ok) return;
    // Delete on the backend so it's persisted AND recorded in the activity log
    // (created / updated / deleted must all be auditable).
    if (isApiModeN) {
      try { await apiDeleteNote(id); }
      catch (e) { toast.error((lang === "es" ? "No se pudo borrar la nota: " : "Could not delete the note: ") + (e.message || e)); return; }
    }
    onNotesChange && onNotesChange(prev => (prev || []).filter(n => n.id !== id));
  };

  // Seed the edit form with the note's text AND its current attachments so the
  // agent can add/remove photos (Lissette 2026-07-13 ticket: editing a note
  // must allow uploading photos).
  const startEditNote = (note) => {
    setEditingNoteId(note.id);
    setEditNoteText(note.text || "");
    setEditFiles((note.files || []).map(f => ({ ...f })));
  };
  const cancelEditNote = () => { setEditingNoteId(null); setEditNoteText(""); setEditFiles([]); setEditDragging(false); };
  const saveNoteEdit = async (note) => {
    if (savingEdit) return;
    const next = editNoteText.trim();
    if (!next && editFiles.length === 0) {
      toast.error(es ? "La nota debe tener texto o una foto." : "The note must have text or a photo.");
      return;
    }
    setSavingEdit(true);
    let attachments = [];
    if (isApiModeN) {
      try {
        attachments = await uploadPending(editFiles);
      } catch (err) {
        toast.error((es ? "No se pudieron subir las fotos: " : "Couldn't upload the photos: ") + (err?.message || err));
        setSavingEdit(false);
        return;
      }
    }
    const prevSnapshot = { text: note.text, files: note.files };
    // Optimistic: show new text + the edit-form previews immediately.
    onNotesChange && onNotesChange(prev => (prev || []).map(n => n.id === note.id ? { ...n, text: next, files: editFiles } : n));
    if (isApiModeN) {
      try {
        const updated = await apiUpdateNote(note.id, { text: next, attachments });
        // Replace with the server copy (fresh signed URLs on the attachments).
        onNotesChange && onNotesChange(prev => (prev || []).map(n => n.id === note.id ? { ...n, ...updated } : n));
      } catch (e) {
        toast.error((es ? "No se pudo editar la nota: " : "Could not edit the note: ") + (e.message || e));
        onNotesChange && onNotesChange(prev => (prev || []).map(n => n.id === note.id ? { ...n, ...prevSnapshot } : n));
        setSavingEdit(false);
        return;
      }
    }
    setSavingEdit(false);
    cancelEditNote();
  };

  const fmtDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) +
      " " + d.toLocaleTimeString('en-US', { hour: "2-digit", minute: "2-digit" });
  };

  const fmtSize = (bytes) => {
    if (!bytes) return "";
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024*1024) return (bytes/1024).toFixed(1) + " KB";
    return (bytes/1024/1024).toFixed(1) + " MB";
  };

  const fileIcon = (type) => {
    if (!type) return "📄";
    if (type.startsWith("image/")) return "🖼️";
    if (type === "application/pdf") return "📕";
    if (type.includes("word")) return "📘";
    if (type.includes("excel") || type.includes("sheet")) return "📗";
    return "📄";
  };

  // Only this stream's notes: regular Notes tab (category null) vs the
  // "Cambio de vida" tab (category 'life_change'). Both share the same
  // clientNotes collection and filter locally.
  const streamNotes = (notes || []).filter((n) => (n.category || null) === (category || null));
  // Pinned notes first, then newest. A stable client-side sort so optimistic
  // pins jump to the top instantly (the server also returns this order).
  const noteList = [...streamNotes].sort((a, b) =>
    ((b.isPinned ? 1 : 0) - (a.isPinned ? 1 : 0)) ||
    String(b.createdAt || "").localeCompare(String(a.createdAt || ""))
  );

  return (
    <div style={{ padding: "1rem", display: "flex", flexDirection: "column", gap: "1rem" }}>

      {/* Input area */}
      <div style={{ background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 10, overflow: "hidden" }}>
        {/* WYSIWYG: bold and highlight show as bold and highlight, never as
            **markers** (Lissette 2026-07-22: "la forma de escribir simbolos es
            muy confusa"). Image paste still works — RichNoteBox hands image
            files to handleFiles and only falls back to plain text otherwise. */}
        <RichNoteBox
          boxRef={noteTaRef}
          value={text}
          onChange={setText}
          onPasteFiles={handleFiles}
          usuarios={users}
          lang={lang}
          placeholder={category === "life_change"
            ? (lang === "es" ? "Anota un cambio de vida (matrimonio, bebé, nuevo empleo, mudanza, cambio de ingresos...). Pega fotos con Ctrl/⌘+V" : "Log a life change (marriage, baby, new job, move, income change...). Paste photos with Ctrl/⌘+V")
            : (lang === "es" ? "Escribe una nota... (pega imágenes con Ctrl/⌘+V, los links se vuelven clicables)" : "Write a note... (paste images with Ctrl/⌘+V, links become clickable)")}
          rows={3}
          className=""
          style={{ width: "100%", background: "transparent", border: "none", padding: ".75rem", color: "var(--c-text,#c8dff0)", fontSize: ".84rem", outline: "none", fontFamily: "inherit", boxSizing: "border-box" }}
        />

        {/* Attached files preview */}
        {files.length > 0 && (
          <div style={{ padding: ".5rem .75rem", display: "flex", flexWrap: "wrap", gap: ".4rem", borderTop: "1px solid var(--c-border,#1a3550)" }}>
            {files.map((f, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: ".3rem", background: "var(--c-surface2,#112538)", borderRadius: 6, padding: ".25rem .5rem", fontSize: ".72rem", color: "var(--c-text2,#7aa3c0)" }}>
                <span>{fileIcon(f.type)}</span>
                <span style={{ maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</span>
                <span style={{ color: "var(--c-text3,#45688a)" }}>({fmtSize(f.size)})</span>
                <button type="button" onClick={() => removeFile(i)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)", padding: 0, fontSize: ".8rem", lineHeight: 1 }}>✕</button>
              </div>
            ))}
          </div>
        )}

        {/* Drop zone / footer */}
        <div
          onDragOver={e => { e.preventDefault(); setDragging(true); }}
          onDragLeave={() => setDragging(false)}
          onDrop={e => { e.preventDefault(); setDragging(false); handleFiles(e.dataTransfer.files); }}
          style={{ padding: ".5rem .75rem", borderTop: "1px solid var(--c-border,#1a3550)", display: "flex", alignItems: "center", justifyContent: "space-between", background: dragging ? "rgba(0,212,255,.06)" : "transparent", transition: "background .15s" }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap" }}>
            <button type="button" onClick={() => fileRef.current && fileRef.current.click()}
              style={{ fontSize: ".73rem", color: "var(--c-text3,#45688a)", background: "none", border: "1px dashed var(--c-border,#1a3550)", borderRadius: 6, padding: ".28rem .65rem", cursor: "pointer", display: "flex", alignItems: "center", gap: ".3rem" }}>
              📎 {lang === "es" ? "Adjuntar archivo" : "Attach file"}
            </button>
            <NoteFormatButtons taRef={noteTaRef} value={text} onChange={setText} lang={lang} compact full />
          </div>
          <input ref={fileRef} type="file" multiple style={{ display: "none" }} onChange={e => { handleFiles(e.target.files); e.target.value = ""; }} />
          <button type="button" onClick={addNote} disabled={saving}
            style={{ background: "var(--c-cyan,#00d4ff)", color: "#070d14", fontWeight: 800, fontSize: ".78rem", padding: ".38rem .9rem", borderRadius: 7, border: "none", cursor: saving ? "wait" : "pointer", opacity: saving ? .6 : 1 }}>
            {saving ? (lang === "es" ? "Subiendo…" : "Uploading…") : (lang === "es" ? "Agregar" : "Add Note")}
          </button>
        </div>
      </div>

      {/* Notes list */}
      {/* Cargando o fallo: nunca "Sin notas aún" si no se sabe (E-376). */}
      {estadoNotas === "error" && (
        <div role="alert" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: ".6rem", flexWrap: "wrap", padding: ".6rem .8rem", borderRadius: 8, fontSize: ".78rem", background: "rgba(245,158,11,.1)", border: "1px solid rgba(245,158,11,.35)", color: "var(--c-amber,#f59e0b)" }}>
          <span>{noteList.length === 0
            ? (es ? "No se pudieron cargar las notas de este cliente. No es que no tenga: el servidor no contestó." : "Couldn't load this client's notes. It doesn't mean there are none: the server didn't answer.")
            : (es ? "Puede que falten notas: el servidor no contestó al cargarlas." : "Some notes may be missing: the server didn't answer.")}</span>
          {typeof onReintentarNotas === "function" && (
            <button type="button" onClick={onReintentarNotas}
              style={{ background: "transparent", color: "var(--c-amber,#f59e0b)", fontWeight: 800, fontSize: ".76rem", padding: ".3rem .8rem", borderRadius: 7, border: "1px solid rgba(245,158,11,.6)", cursor: "pointer" }}>
              {es ? "Reintentar" : "Retry"}
            </button>
          )}
        </div>
      )}
      {noteList.length === 0 && estadoNotas === "error" ? null : noteList.length === 0 && estadoNotas === "cargando" ? (
        <div style={{ textAlign: "center", padding: "1.5rem", color: "var(--c-text3,#45688a)", fontSize: ".8rem" }}>
          {es ? "Cargando notas…" : "Loading notes…"}
        </div>
      ) : noteList.length === 0 ? (
        <div style={{ textAlign: "center", padding: "1.5rem", color: "var(--c-text3,#45688a)", fontSize: ".8rem" }}>
          {category === "life_change"
            ? (lang === "es" ? "Sin cambios de vida registrados aún" : "No life changes logged yet")
            : (lang === "es" ? "Sin notas aún" : "No notes yet")}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: ".65rem" }}>
          {noteList.map(note => {
            const author = users && users.find(u => u.id === note.authorId);
            const authorLabel = author ? author.name : (note.authorName || (lang === "es" ? "Usuario" : "User"));
            const initials = authorLabel.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
            const color = author?.color || "#0077aa";
            return (
              <div key={note.id} style={{ background: note.isPinned ? "rgba(255,183,0,.06)" : "var(--c-surface,#0d1c2e)", border: note.isPinned ? "1px solid rgba(255,183,0,.45)" : "1px solid var(--c-border,#1a3550)", borderRadius: 10, padding: ".75rem" }}>
                {/* Header */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: ".45rem" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
                    <div style={{ width: 28, height: 28, borderRadius: "50%", background: color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: ".65rem", fontWeight: 800, color: "#fff", flexShrink: 0 }}>
                      {initials}
                    </div>
                    <div>
                      <div style={{ fontSize: ".77rem", fontWeight: 700, color: "var(--c-white,#eef6ff)", display: "flex", alignItems: "center", gap: ".4rem" }}>
                        {authorLabel}
                        {note.isPinned && <span style={{ fontSize: ".6rem", fontWeight: 800, color: "var(--c-amber,#ffb700)", background: "rgba(255,183,0,.14)", border: "1px solid rgba(255,183,0,.3)", borderRadius: 100, padding: ".05rem .4rem", display: "inline-flex", alignItems: "center", gap: 3 }}>📌 {lang === "es" ? "Fijada" : "Pinned"}</span>}
                      </div>
                      <div style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)" }}>{fmtDate(note.createdAt)}</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: ".1rem", flexShrink: 0 }}>
                    {/* Las notas de la etapa de PROSPECTO se muestran aquí para
                        tener el historial completo, pero no se editan aquí: la
                        original vive en la pizarra de Prospectos y no hay copia
                        que pueda separarse. Ofrecer ✏️ o 🗑️ sería ofrecer algo
                        que el servidor rechazaría. */}
                    {note.readOnly ? (
                      <span title={lang === "es"
                          ? "Escrita cuando era prospecto. Se edita en Prospectos y Referidos."
                          : "Written while a prospect. Edit it in Prospects & Referrals."}
                        style={{ fontSize: ".58rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: ".05em",
                          padding: "2px 7px", borderRadius: 5, whiteSpace: "nowrap",
                          background: "rgba(0,212,255,.12)", color: "var(--c-cyan,#00d4ff)" }}>
                        ⭐ {lang === "es" ? "Prospecto" : "Prospect"}
                      </span>
                    ) : (<>
                    {editingNoteId !== note.id && (
                      <button type="button" onClick={() => startEditNote(note)}
                        title={lang === "es" ? "Editar nota" : "Edit note"}
                        style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)", fontSize: ".8rem", padding: ".2rem .4rem", borderRadius: 4 }}>
                        ✏️
                      </button>
                    )}
                    <button type="button" onClick={() => togglePin(note)}
                      title={note.isPinned ? (lang === "es" ? "Desfijar nota" : "Unpin note") : (lang === "es" ? "Fijar arriba" : "Pin to top")}
                      style={{ background: "none", border: "none", cursor: "pointer", color: note.isPinned ? "var(--c-amber,#ffb700)" : "var(--c-text3,#45688a)", fontSize: ".85rem", padding: ".2rem .4rem", borderRadius: 4, opacity: note.isPinned ? 1 : 0.65 }}>
                      📌
                    </button>
                    <button type="button" onClick={() => deleteNote(note.id)}
                      style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)", fontSize: ".8rem", padding: ".2rem .4rem", borderRadius: 4 }}>
                      🗑️
                    </button>
                  </>)}
                    </div>
                </div>

                {/* Text — inline editor when this note is being edited, else the
                    rendered text (clickable links plus bold/highlight formatting). */}
                {editingNoteId === note.id ? (
                  <div
                    style={{ marginBottom: ".4rem" }}
                    onPaste={e => {
                      const items = e.clipboardData && e.clipboardData.items;
                      if (!items) return;
                      const imgs = [];
                      for (const it of items) { if (it.type && it.type.startsWith("image/")) { const f = it.getAsFile(); if (f) imgs.push(f); } }
                      if (imgs.length) { e.preventDefault(); handleFiles(imgs, setEditFiles); }
                    }}
                    onDragOver={e => { e.preventDefault(); setEditDragging(true); }}
                    onDragLeave={() => setEditDragging(false)}
                    onDrop={e => { e.preventDefault(); setEditDragging(false); if (e.dataTransfer.files && e.dataTransfer.files.length) handleFiles(e.dataTransfer.files, setEditFiles); }}
                  >
                    <NoteEditor value={editNoteText} onChange={setEditNoteText} lang={lang === "es" ? 'es' : 'en'} rows={3} usuarios={users} />

                    {/* Attachment previews (existing photos + newly added). */}
                    {editFiles.length > 0 && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: ".4rem", marginTop: ".4rem" }}>
                        {editFiles.map((f, i) => (
                          isImageFile(f) && fileSrc(f) ? (
                            <div key={i} style={{ position: "relative" }}>
                              <img src={fileSrc(f)} alt={f.name || "image"} title={f.name || "image"}
                                style={{ width: 72, height: 72, borderRadius: 8, border: "1px solid var(--c-border,#1a3550)", objectFit: "cover" }} />
                              <button type="button" onClick={() => removeEditFile(i)} title={es ? "Quitar" : "Remove"}
                                style={{ position: "absolute", top: -6, right: -6, width: 18, height: 18, borderRadius: "50%", background: "var(--c-red,#ff3d6b)", color: "#fff", border: "none", cursor: "pointer", fontSize: ".7rem", lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
                            </div>
                          ) : (
                            <div key={i} style={{ display: "flex", alignItems: "center", gap: ".3rem", background: "var(--c-surface2,#112538)", borderRadius: 6, padding: ".25rem .5rem", fontSize: ".72rem", color: "var(--c-text2,#7aa3c0)" }}>
                              <span>{fileIcon(f.type)}</span>
                              <span style={{ maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</span>
                              <button type="button" onClick={() => removeEditFile(i)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text3,#45688a)", padding: 0, fontSize: ".8rem", lineHeight: 1 }}>✕</button>
                            </div>
                          )
                        ))}
                      </div>
                    )}

                    <div style={{ display: "flex", alignItems: "center", gap: ".5rem", marginTop: ".4rem" }}>
                      <button type="button" onClick={() => editFileRef.current && editFileRef.current.click()}
                        style={{ fontSize: ".72rem", color: editDragging ? "var(--c-cyan,#00d4ff)" : "var(--c-text3,#45688a)", background: "none", border: "1px dashed var(--c-border,#1a3550)", borderRadius: 6, padding: ".28rem .65rem", cursor: "pointer", display: "flex", alignItems: "center", gap: ".3rem" }}>
                        📎 {es ? "Agregar foto / archivo" : "Add photo / file"}
                      </button>
                      <span style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)" }}>{es ? "o pega con Ctrl/⌘+V" : "or paste with Ctrl/⌘+V"}</span>
                      <input ref={editFileRef} type="file" multiple style={{ display: "none" }} onChange={e => { handleFiles(e.target.files, setEditFiles); e.target.value = ""; }} />
                    </div>

                    <div style={{ display: "flex", gap: ".4rem", justifyContent: "flex-end", marginTop: ".4rem" }}>
                      <button type="button" onClick={cancelEditNote} disabled={savingEdit}
                        style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text2,#7aa3c0)", fontSize: ".74rem", fontWeight: 700, padding: ".3rem .8rem", borderRadius: 7, cursor: "pointer" }}>
                        {lang === "es" ? "Cancelar" : "Cancel"}
                      </button>
                      <button type="button" onClick={() => saveNoteEdit(note)} disabled={savingEdit}
                        style={{ background: "var(--c-cyan,#00d4ff)", border: "none", color: "#070d14", fontSize: ".74rem", fontWeight: 800, padding: ".3rem .9rem", borderRadius: 7, cursor: savingEdit ? "wait" : "pointer", opacity: savingEdit ? .6 : 1 }}>
                        {savingEdit ? (lang === "es" ? "Guardando…" : "Saving…") : (lang === "es" ? "Guardar" : "Save")}
                      </button>
                    </div>
                  </div>
                ) : note.text && (() => {
                  // Una transcripcion de Quo son varios parrafos y empujaba las
                  // demas notas fuera de la pantalla. Larga = cerrada, con los
                  // ".." para abrirla; corta = como siempre, sin nada nuevo.
                  const larga = esNotaLarga(note.text);
                  const abierta = !!notasAbiertas[note.id];
                  const recortada = larga && !abierta;
                  return (
                    <div style={{ marginBottom: (note.files && note.files.length > 0) ? ".6rem" : 0 }}>
                      <div
                        onClick={recortada ? (e) => {
                          // Un enlace dentro de la nota sigue siendo un enlace:
                          // abrirlo no puede desplegar la nota de paso.
                          if (e.target.closest && e.target.closest("a")) return;
                          setNotasAbiertas((p) => ({ ...p, [note.id]: true }));
                        } : undefined}
                        title={recortada ? (es ? "Ver la nota completa" : "Show the full note") : undefined}
                        style={{
                          fontSize: ".83rem", color: "var(--c-text,#c8dff0)", lineHeight: 1.6, whiteSpace: "pre-wrap",
                          cursor: recortada ? "pointer" : undefined,
                          ...(recortada ? ESTILO_RECORTADO : null),
                        }}
                      >
                        {renderNoteText(note.text)}
                      </div>
                      {larga && (
                        <button
                          type="button"
                          onClick={() => setNotasAbiertas((p) => ({ ...p, [note.id]: !abierta }))}
                          style={{ background: "none", border: "none", padding: ".15rem 0 0", cursor: "pointer", fontSize: ".74rem", fontWeight: 700, color: "var(--c-cyan,#00d4ff)" }}
                        >
                          {abierta ? (es ? "Ver menos" : "Show less") : (es ? "… Ver más" : "… Show more")}
                        </button>
                      )}
                    </div>
                  );
                })()}

                {/* Attachments. Images shown inline (click to open full size); the
                    rest as file chips. Inline images hydrate from the mirrored
                    note docs so they survive a reload. */}
                {(() => {
                  const inNote = note.files || [];
                  const noteImgs = inNote.filter(f => isImageFile(f) && fileSrc(f));
                  const fromDocs = noteImgs.length === 0
                    ? (docs || []).filter(d => d.noteId === note.id && isImageFile(d) && fileSrc(d))
                    : [];
                  const images = noteImgs.length ? noteImgs : fromDocs;
                  const otherFiles = inNote.filter(f => !isImageFile(f));
                  if (images.length === 0 && otherFiles.length === 0) return null;
                  return (
                    <div style={{ display: "flex", flexDirection: "column", gap: ".35rem", marginTop: ".4rem" }}>
                      {images.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: ".4rem" }}>
                          {images.map((f, i) => (
                            <img key={i} src={fileSrc(f)} alt={f.name || "image"} title={f.name || "image"}
                              onClick={() => setPreviewImg({ src: fileSrc(f), name: f.name })}
                              style={{ maxWidth: 220, maxHeight: 180, borderRadius: 8, border: "1px solid var(--c-border,#1a3550)", objectFit: "cover", cursor: "zoom-in" }} />
                          ))}
                        </div>
                      )}
                      {otherFiles.map((f, i) => (
                        <div key={i} style={{ display: "flex", alignItems: "center", gap: ".5rem", background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", borderRadius: 6, padding: ".35rem .6rem" }}>
                          <span style={{ fontSize: ".9rem" }}>{fileIcon(f.type)}</span>
                          <span style={{ flex: 1, fontSize: ".74rem", color: "var(--c-text,#c8dff0)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</span>
                          <span style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)", flexShrink: 0 }}>{fmtSize(f.size)}</span>
                          <FileActions file={{ name: f.name, data: fileSrc(f), type: f.type, size: f.size }} lang={lang} />
                        </div>
                      ))}
                    </div>
                  );
                })()}

                {/* Hilo de comentarios. Se pinta cerrado (solo el contador) y
                    carga al abrirlo — ver NoteCommentThread.
                    NO en las notas de cuando era prospecto: viven en la pizarra
                    de Prospectos, no en la tabla de notas, y el servidor no las
                    encuentra — responder daba "Note not found" (Lissette
                    2026-09-29: "no se puede colocar mensajes a las notas"). Se
                    responden donde se editan, en Prospectos y Referidos. */}
                {!note.readOnly && <NoteCommentThread
                  note={note}
                  es={es}
                  lang={lang}
                  users={users}
                  currentUser={currentUser}
                  canModerate={canModerateComments}
                  uploadPending={uploadPending}
                  fmtDate={fmtDate}
                  fmtSize={fmtSize}
                  fileIcon={fileIcon}
                  onPreview={setPreviewImg}
                  isApiMode={isApiModeN}
                  onCountChange={setCommentCount}
                />}
              </div>
            );
          })}
        </div>
      )}

      {/* Image lightbox — opens inline (data:URLs can't be opened in a new tab). */}
      {previewImg && (
        <div onClick={() => setPreviewImg(null)}
          style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(0,0,0,.85)", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }}>
          <div onClick={e => e.stopPropagation()} style={{ position: "relative", maxWidth: "92vw", maxHeight: "88vh", display: "flex", flexDirection: "column", alignItems: "center", gap: ".6rem" }}>
            <img src={previewImg.src} alt={previewImg.name || "image"} style={{ maxWidth: "92vw", maxHeight: "80vh", borderRadius: 8, objectFit: "contain" }} />
            <div style={{ display: "flex", gap: ".5rem" }}>
              <a href={previewImg.src} download={previewImg.name || "image.png"}
                style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "var(--c-cyan,#00d4ff)", color: "#06121f", fontWeight: 800, fontSize: ".78rem", padding: ".45rem .9rem", borderRadius: 8, textDecoration: "none" }}>
                ⬇ {lang === "es" ? "Descargar" : "Download"}
              </a>
              <button type="button" onClick={() => setPreviewImg(null)}
                style={{ background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)", color: "var(--c-text,#c8dff0)", fontWeight: 700, fontSize: ".78rem", padding: ".45rem .9rem", borderRadius: 8, cursor: "pointer" }}>
                {lang === "es" ? "Cerrar" : "Close"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


export function ClientSignatures({ clientId, signatures, client, onDocsChange, t, lang }) {
  const ts=t.signatures;
  const es=lang==="es";
  // "Mover a documentos" (#11): drop the signed PDF into the client's Documents.
  const [movedIds, setMovedIds] = useState({});
  const [movingId, setMovingId] = useState(null);
  const moveSignedToDocs = async (s, fileName) => {
    const src = s.signedDocUrl || (s.signedPdf ? (String(s.signedPdf).startsWith('data:') ? s.signedPdf : 'data:application/pdf;base64,' + s.signedPdf) : '');
    if (!src) return;
    setMovingId(s.id);
    try {
      const resp = await fetch(src);
      if (!resp.ok) throw new Error('fetch ' + resp.status);
      const blob = await resp.blob();
      const file = new File([blob], fileName, { type: 'application/pdf' });
      const created = await apiUploadDocument(file, { clientId, category: 'other' });
      // Set uploadedAt + name so the Documents tab shows it as an UPLOADED file,
      // not a pending slot (Lissette 2026-06-21 #11: "solo se marca, no se mueve").
      if (created && onDocsChange) {
        const doc = { ...created, name: created.name || fileName, uploadedAt: created.uploadedAt || new Date().toISOString() };
        onDocsChange(prev => [doc, ...(prev || [])]);
      }
      setMovedIds(m => ({ ...m, [s.id]: true }));
      toast.success(es ? 'Movido a Documentos ✓' : 'Moved to Documents ✓');
    } catch (e) {
      toast.error((es ? 'No se pudo mover. ' : "Couldn't move. ") + motivoDeSubidaFallida(e, es));
    } finally {
      setMovingId(null);
    }
  };
  const moveBtn = (s, docName) => {
    const fileName = `${String(docName||"firma").replace(/[^a-z0-9]+/gi,"_")}_${client?.lastName||"signed"}.pdf`;
    const done = movedIds[s.id]; const busy = movingId===s.id;
    return <button type="button" disabled={busy||done} onClick={()=>moveSignedToDocs(s, fileName)}
      style={{display:"inline-flex",alignItems:"center",gap:5,background:done?"#dcfce7":"#fff",border:"1px solid #cbd5e1",color:done?"#15803d":"#475569",fontSize:".72rem",fontWeight:700,padding:".4rem .7rem",borderRadius:7,cursor:busy?"wait":(done?"default":"pointer")}}>
      📁 {done?(es?"En Documentos":"In Documents"):busy?(es?"Moviendo…":"Moving…"):(es?"Mover a Documentos":"Move to Documents")}
    </button>;
  };
  // Cap-avoidance: the global signatures list is capped server-side (take 500
  // agency-wide), so a client's older signatures could fall outside it. Fetch
  // THIS client's signatures from the server on open and merge with whatever
  // the global list already had (dedup by id). Self-contained — /signatures
  // already supports ?clientId, so no global setter / prop threading needed.
  const [fetchedSigs,setFetchedSigs]=useState([]);
  useEffect(()=>{
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if(!apiMode || !clientId) return;
    let cancelled=false;
    apiListSignatures({ clientId })
      .then(({ signatures: sigs })=>{ if(!cancelled && sigs) setFetchedSigs(sigs); })
      .catch(()=>{});
    return ()=>{ cancelled=true; };
  },[clientId]);
  const clientSigs=useMemo(()=>{
    const byId=new Map();
    for(const s of (signatures||[])) if(s.clientId===clientId) byId.set(s.id,s);
    for(const s of fetchedSigs) byId.set(s.id,s);
    return Array.from(byId.values());
  },[signatures,fetchedSigs,clientId]);
  return <div>
    <div className="space-y-3 mt-4">
      {clientSigs.map(s=>{
        const isSigned = s.status==="signed" || s.status==="SIGNED";
        const sc=SIGN_STATUS[s.status]||SIGN_STATUS.pending;
        const docName = s.type || s.documentName || 'Document';
        return <div key={s.id} className="bg-gray-50 border border-gray-200 rounded-xl p-3" style={{borderLeft:`3px solid ${isSigned?"#10b981":"#f59e0b"}`}}>
          <div className="flex items-center gap-3">
            <FileSignature size={16} className={isSigned?"text-emerald-500":"text-amber-500"}/>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-gray-900 font-medium">{docName}</div>
              <div className="text-xs text-gray-500">
                📅 {ts.sentAt}: {fmt(s.sentAt)}
                {s.signedAt && <span className="text-emerald-600 ml-2">✅ {ts.signedAt}: {fmt(s.signedAt)}</span>}
              </div>
            </div>
            <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${sc.bg} ${sc.text}`}>{ts[(s.status||'').toLowerCase()]||s.status}</span>
            {s.link && <CopiedBtn link={s.link} label={ts.copyLink} es={es}/>}
          </div>
          {/* Signed PDF download — backend-generated (template + signature + audit page) */}
          {isSigned && s.signedDocUrl && (
            <div className="mt-3 pt-3 border-t border-gray-200" style={{display:"flex",alignItems:"center",gap:".6rem",flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:0,fontSize:".62rem",color:"#94a3b8"}}>
                {es ? "Firmado electrónicamente — ESIGN Act" : "Electronically signed — ESIGN Act"}
              </div>
              <a href={s.signedDocUrl} download={`${docName.replace(/[^a-z0-9]+/gi,"_")}_${client?.lastName||"signed"}.pdf`}
                style={{display:"inline-flex",alignItems:"center",gap:5,background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",fontSize:".72rem",fontWeight:700,padding:".4rem .8rem",borderRadius:7,textDecoration:"none"}}>
                ⬇ {es ? "Descargar PDF firmado" : "Download signed PDF"}
              </a>
              <a href={s.signedDocUrl} target="_blank" rel="noopener noreferrer"
                style={{display:"inline-flex",alignItems:"center",gap:5,background:"#fff",border:"1px solid #cbd5e1",color:"#475569",fontSize:".72rem",fontWeight:700,padding:".4rem .7rem",borderRadius:7,textDecoration:"none"}}>
                ↗ {es ? "Abrir" : "Open"}
              </a>
              {moveBtn(s, docName)}
            </div>
          )}
          {/* Legacy local-only signed signatures (no backend PDF) */}
          {isSigned && !s.signedDocUrl && s.signedPdf && (
            <div className="mt-3 pt-3 border-t border-gray-200" style={{display:"flex",alignItems:"center",gap:".6rem",flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:".68rem",color:"#64748b",fontWeight:600}}>
                  {s.signerName && `👤 ${s.signerName}`}
                  {s.signedAtFull && ` · 🕐 ${new Date(s.signedAtFull).toLocaleString('en-US')}`}
                </div>
                <div style={{fontSize:".6rem",color:"#94a3b8",marginTop:2}}>
                  {es ? "Firmado electrónicamente — ESIGN Act" : "Electronically signed — ESIGN Act"}
                </div>
              </div>
              <FileActions
                file={{name:`${docName.replace(/[^a-z0-9]+/gi,"_")}_${client?.lastName||"signed"}.pdf`,data:s.signedPdf,type:"application/pdf",size:null}}
                lang={lang}
                sendTo={client?.email||""}
                sendSubject={es?`${docName} — firmado`:`${docName} — signed`}
                sendBody={es
                  ? `Hola ${client?.firstName||""},\n\nAdjunto la copia firmada de "${docName}".\n\nFirmado: ${s.signedAt}\n\n— Deskte CRM`
                  : `Hi ${client?.firstName||""},\n\nPlease find attached the signed copy of "${docName}".\n\nSigned: ${s.signedAt}\n\n— Deskte CRM`}
              />
              {moveBtn(s, docName)}
            </div>
          )}
        </div>;
      })}
      {clientSigs.length===0&&<div className="text-center py-6 text-gray-400 text-sm">{ts.noSignatures}</div>}
    </div>
  </div>;
}

// #9 (Lissette 2026-07-08): quote history on the client ficha. The full quote
// (Quote + QuoteItem plans + accepted plan) is already stored — this surfaces it
// per client with a detail modal and a PDF link, so you can see EVERY quote sent.
const QUOTE_STATUS_META = {
  DRAFT:     { es: 'Borrador',   en: 'Draft',     c: '#64748b' },
  SENT:      { es: 'Enviada',    en: 'Sent',      c: '#3b82f6' },
  ACCEPTED:  { es: 'Aceptada',   en: 'Accepted',  c: '#10b981' },
  DECLINED:  { es: 'Rechazada',  en: 'Declined',  c: '#ef4444' },
  EXPIRED:   { es: 'Vencida',    en: 'Expired',   c: '#f59e0b' },
  CONVERTED: { es: 'Convertida', en: 'Converted', c: '#8b5cf6' },
};

export function ClientQuotesTab({ clientId, lang }) {
  const es = lang === 'es';
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [pdfBusy, setPdfBusy] = useState(null);

  const load = () => {
    setLoading(true); setErr('');
    apiListQuotes({ clientId })
      .then((d) => setQuotes(d))
      .catch((e) => setErr(e.message || (es ? 'No se pudo cargar' : 'Failed to load')))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [clientId]);

  const statusBadge = (s) => {
    const m = QUOTE_STATUS_META[s] || { es: s, en: s, c: '#64748b' };
    return (
      <span style={{ fontSize: '.62rem', fontWeight: 800, padding: '2px 9px', borderRadius: 100, background: m.c + '22', color: m.c, border: `1px solid ${m.c}55`, textTransform: 'uppercase', letterSpacing: '.03em' }}>
        {es ? m.es : m.en}
      </span>
    );
  };
  const fmtD = (iso) => { if (!iso) return '—'; const d = new Date(iso); return isNaN(d) ? '—' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); };

  const openDetail = async (id) => {
    setDetailLoading(true); setDetail({ id });
    try { setDetail(await apiGetQuote(id)); }
    catch (e) { toast.error(e.message || (es ? 'No se pudo abrir' : 'Failed to open')); setDetail(null); }
    finally { setDetailLoading(false); }
  };
  const openPdf = async (id) => {
    setPdfBusy(id);
    try { const url = await apiDownloadQuotePdf(id); window.open(url, '_blank'); setTimeout(() => URL.revokeObjectURL(url), 60000); }
    catch (e) { toast.error(e.message || (es ? 'No se pudo abrir el PDF' : 'Failed to open PDF')); }
    finally { setPdfBusy(null); }
  };
  const removeQuote = async (q) => {
    const ok = await confirmDialog({
      title: es ? '¿Eliminar esta cotización?' : 'Delete this quote?',
      message: es ? `Se eliminará "${q.title || q.number}". Esta acción no se puede deshacer.` : `"${q.title || q.number}" will be deleted. This cannot be undone.`,
      danger: true, confirmLabel: es ? 'Eliminar' : 'Delete',
    });
    if (!ok) return;
    try {
      await apiDeleteQuote(q.id);
      setQuotes((prev) => prev.filter((x) => x.id !== q.id));
      if (detail && detail.id === q.id) setDetail(null);
      toast.success(es ? 'Cotización eliminada' : 'Quote deleted');
    } catch (e) { toast.error(e.message || (es ? 'No se pudo eliminar' : 'Failed to delete')); }
  };

  const acceptedItemOf = (q) => (q.items || []).find((it) => it.id === q.acceptedItemId) || null;

  // CONVERTIR A PÓLIZA desde la ficha (Lissette 2026-09-28): la misma flecha
  // verde que tiene el módulo Cotizaciones, para no tener que salir del
  // cliente. Mismo camino en el servidor (POST /quotes/:id/convert-to-policy):
  // usa la opción que aceptó el cliente, la póliza nace PENDIENTE y al cliente
  // no se le manda nada. La póliza aparece sola en la pestaña Pólizas por el
  // aviso `policy.created` que emite el servidor.
  const [convirtiendo, setConvirtiendo] = useState(null);
  const convertir = async (q) => {
    const ok = await confirmDialog({
      title: es ? '¿Convertir a póliza?' : 'Convert to policy?',
      message: es
        ? `Se creará una póliza nueva con la opción ${q.acceptedItemId ? 'que aceptó el cliente' : 'principal'} de "${q.title || q.number}". Nace como PENDIENTE y al cliente NO se le manda nada.`
        : `A new policy will be created from the ${q.acceptedItemId ? 'option the client accepted' : 'first option'} of "${q.title || q.number}". It starts as PENDING and nothing is sent to the client.`,
      confirmLabel: es ? 'Convertir' : 'Convert',
    });
    if (!ok) return;
    setConvirtiendo(q.id);
    try {
      const r = await apiConvertQuoteToPolicy(q.id);
      const polizaId = (r && (r.policy?.id || r.policyId || r.id)) || true;
      setQuotes((prev) => prev.map((x) => (x.id === q.id ? { ...x, status: 'CONVERTED', convertedPolicyId: polizaId } : x)));
      toast.success(es ? 'Póliza creada. Está en la pestaña Pólizas como pendiente.' : 'Policy created. It is in the Policies tab as pending.');
    } catch (e) {
      toast.error(e.message || (es ? 'No se pudo convertir' : 'Failed to convert'));
    } finally {
      setConvirtiendo(null);
    }
  };

  if (loading) return <div style={{ padding: '1.5rem', color: 'var(--c-text3,#45688a)', fontSize: '.85rem' }}>{es ? 'Cargando cotizaciones…' : 'Loading quotes…'}</div>;
  if (err) return <div style={{ padding: '1.5rem', color: 'var(--c-red,#ff3d6b)', fontSize: '.85rem' }}>{err} <button className="dkt-btn ghost xs" onClick={load} style={{ marginLeft: 8 }}>{es ? 'Reintentar' : 'Retry'}</button></div>;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '.9rem' }}>
        <DollarSign size={16} style={{ color: 'var(--c-cyan,#00d4ff)' }} />
        <span style={{ fontWeight: 700, fontSize: '.9rem', color: 'var(--c-white,#eef6ff)' }}>{es ? 'Cotizaciones enviadas' : 'Quotes sent'}</span>
        <span style={{ fontSize: '.7rem', color: 'var(--c-text3,#45688a)', fontFamily: 'var(--font-mono)' }}>· {quotes.length}</span>
      </div>

      {quotes.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '2.5rem 1rem', color: 'var(--c-text3,#45688a)', background: 'var(--c-surface2,#112538)', borderRadius: 12, border: '1px dashed var(--c-border,#1a3550)' }}>
          <div style={{ fontSize: '2rem', marginBottom: '.4rem' }}>💰</div>
          <div style={{ fontSize: '.85rem', color: 'var(--c-text,#c8dff0)' }}>{es ? 'Este cliente no tiene cotizaciones todavía.' : 'This client has no quotes yet.'}</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '.55rem' }}>
          {quotes.map((q) => (
            <div key={q.id} style={{ background: 'var(--c-surface2,#112538)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 11, padding: '.75rem .9rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontFamily: 'var(--font-mono)', fontSize: '.68rem', color: 'var(--c-text3,#45688a)' }}>{q.number}</span>
                    <span style={{ fontWeight: 700, fontSize: '.86rem', color: 'var(--c-white,#eef6ff)' }}>{q.title}</span>
                    {statusBadge(q.status)}
                  </div>
                  <div style={{ fontSize: '.7rem', color: 'var(--c-text2,#7aa3c0)', marginTop: 3 }}>
                    {es ? 'Enviada' : 'Sent'}: {fmtD(q.sentAt || q.createdAt)}
                    {q.acceptedAt ? ` · ${es ? 'Aceptada' : 'Accepted'}: ${fmtD(q.acceptedAt)}` : ''}
                    {typeof q.total !== 'undefined' ? ` · ${es ? 'Total' : 'Total'}: ${fmtMoney(Number(q.total) || 0)}` : ''}
                    {q._count?.items ? ` · ${q._count.items} ${es ? 'planes' : 'plans'}` : ''}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button type="button" className="dkt-btn ghost xs" onClick={() => openDetail(q.id)}><Eye size={13} /> {es ? 'Ver' : 'View'}</button>
                  <button type="button" className="dkt-btn ghost xs" disabled={pdfBusy === q.id} onClick={() => openPdf(q.id)}><Download size={13} /> PDF</button>
                  {q.status === 'ACCEPTED' && !q.convertedPolicyId && (
                    <button type="button" className="dkt-btn ghost xs" disabled={convirtiendo === q.id} onClick={() => convertir(q)}
                      title={es ? 'Convertir a póliza' : 'Convert to policy'} style={{ color: 'var(--c-green,#00ff88)' }}>
                      <ArrowRight size={13} /> {es ? 'Convertir a póliza' : 'Convert to policy'}
                    </button>
                  )}
                  <button type="button" className="dkt-btn ghost xs" title={es ? 'Eliminar' : 'Delete'} onClick={() => removeQuote(q)} style={{ color: 'var(--c-red,#ff3d6b)' }}><Trash2 size={13} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {detail && (
        <Modal title={`💰 ${detail.number || (es ? 'Cotización' : 'Quote')}${detail.title ? ` — ${detail.title}` : ''}`} onClose={() => setDetail(null)} wide>
          {detailLoading ? (
            <div style={{ padding: '1.5rem', color: 'var(--c-text3,#45688a)' }}>{es ? 'Cargando…' : 'Loading…'}</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '.8rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                {statusBadge(detail.status)}
                <span style={{ fontSize: '.72rem', color: 'var(--c-text2,#7aa3c0)' }}>{es ? 'Para' : 'For'}: <strong>{detail.recipientName}</strong>{detail.recipientEmail ? ` · ${detail.recipientEmail}` : ''}</span>
              </div>
              <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', fontSize: '.72rem', color: 'var(--c-text2,#7aa3c0)' }}>
                <span>{es ? 'Enviada' : 'Sent'}: {fmtD(detail.sentAt || detail.createdAt)}</span>
                {detail.viewedAt && <span>{es ? 'Vista' : 'Viewed'}: {fmtD(detail.viewedAt)}</span>}
                {detail.acceptedAt && <span style={{ color: '#10b981', fontWeight: 700 }}>{es ? 'Aceptada' : 'Accepted'}: {fmtD(detail.acceptedAt)}</span>}
                {detail.declinedAt && <span style={{ color: '#ef4444' }}>{es ? 'Rechazada' : 'Declined'}: {fmtD(detail.declinedAt)}</span>}
              </div>

              {(detail.items || []).length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
                  <div style={{ fontSize: '.7rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em', color: 'var(--c-text3,#45688a)', fontFamily: 'var(--font-mono)' }}>{es ? 'Planes cotizados' : 'Quoted plans'}</div>
                  {(detail.items || []).map((it) => {
                    const isAccepted = it.id === detail.acceptedItemId;
                    return (
                      <div key={it.id} style={{ background: isAccepted ? 'rgba(16,185,129,.08)' : 'var(--c-surface2,#112538)', border: `1px solid ${isAccepted ? 'rgba(16,185,129,.5)' : 'var(--c-border,#1a3550)'}`, borderRadius: 10, padding: '.6rem .8rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                          <div style={{ minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                              <span style={{ fontWeight: 700, fontSize: '.85rem', color: 'var(--c-white,#eef6ff)' }}>{it.description}</span>
                              {isAccepted && <span style={{ fontSize: '.6rem', fontWeight: 800, color: '#10b981', background: 'rgba(16,185,129,.15)', border: '1px solid rgba(16,185,129,.4)', borderRadius: 100, padding: '1px 8px' }}>✓ {es ? 'ACEPTADO' : 'ACCEPTED'}</span>}
                            </div>
                            <div style={{ fontSize: '.68rem', color: 'var(--c-text2,#7aa3c0)', marginTop: 2 }}>
                              {[it.carrier, it.planType && nombreDelTipoDeCotizacion(it.planType, es)].filter(Boolean).join(' · ') || (es ? 'Plan' : 'Plan')}
                              {it.effectiveDate ? ` · ${es ? 'Vigencia' : 'Effective'} ${fmtD(it.effectiveDate)}` : ''}
                            </div>
                          </div>
                          <div style={{ textAlign: 'right', flexShrink: 0 }}>
                            <div style={{ fontWeight: 800, fontSize: '.9rem', color: 'var(--c-white,#eef6ff)' }}>{fmtMoneyZero(Number(it.total || it.unitPrice) || 0)}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {detail.notes && <div style={{ fontSize: '.78rem', color: 'var(--c-text,#c8dff0)', whiteSpace: 'pre-wrap', background: 'var(--c-surface2,#112538)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 10, padding: '.6rem .8rem' }}>{detail.notes}</div>}

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, borderTop: '1px solid var(--c-border,#1a3550)', paddingTop: '.7rem', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '.85rem', fontWeight: 800, color: 'var(--c-white,#eef6ff)' }}>{es ? 'Total' : 'Total'}: {fmtMoney(Number(detail.total) || 0)}</span>
                <button type="button" className="dkt-btn primary xs" disabled={pdfBusy === detail.id} onClick={() => openPdf(detail.id)}><Download size={13} /> {es ? 'Descargar PDF' : 'Download PDF'}</button>
              </div>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
}

export function ClientDetail({ client, policies, docs, tasks, signatures, activitylog, onPoliciesChange, onDocsChange, onTasksChange, clientNotes, onClientNotesChange, users, clients, currentUser, onBack, onEditClient, onClientPatched, onClientCreated, onChangeHistory, changeHistory, docTemplates, eligibilityAlerts, onEligibilityAlertsChange, followups=[], onFollowupsChange, tickets=[], onSaveTicket, onAddTicketMessage, onEditTicketMessage, onDeleteTicketMessage, onDeleteTicket, onNotifyTicketClient, loadClientDocs, ticketEmailOnOpen={}, ticketEmailOnResolve={}, seatLabels={}, onSeatLabelsChange, ticketStatuses=[], ticketTypes=[], requests=[], onRequestsChange, customTabDefs=[], tagColors={}, onTagColorsChange, tagLibrary=[], onTagLibraryChange, policyTagLibrary=[], onPolicyTagLibraryChange, policyTagColors={}, onPolicyTagColorsChange, userPrefs={}, t, lang }) {
  // Tell the Deskte AI which client is open so "modify THIS one" works from the
  // floating widget. Clears on unmount / when switching clients.
  useEffect(() => {
    setAiOpenClient(client && client.id
      ? { id: client.id, name: `${client.firstName || ''} ${client.lastName || ''}`.trim() }
      : null);
    return () => setAiOpenClient(null);
  }, [client && client.id]);

  // Restore the last tab the user was on so a hard refresh keeps them on
  // the same section (e.g. Emails → now consolidated into Messages) instead
  // of jumping back to Policies. Maps the retired "emails" key to "comms"
  // for users who still have it saved from before the consolidation.
  const [tab,setTab]=useState(()=>{
    if (typeof window === "undefined") return "policies";
    try {
      const saved = prefsGet("deskte:lastClientTab");
      if (!saved) return "policies";
      if (saved === "emails") return "comms"; // legacy key migration
      return saved;
    } catch { return "policies"; }
  });
  useEffect(()=>{
    try { prefsSet("deskte:lastClientTab", tab); } catch {}
  }, [tab]);
  // Deep-link tab hint: a chat "Ver →" / bell link can target a SPECIFIC tab
  // (window.__magClientTab, e.g. 'lifechange' for a Cambio de vida alert).
  // Consumed when the record opens or switches client, and via the
  // 'deskte:client-tab' nudge when this same record is already open.
  // One-shot: cleared the moment it's applied so normal tab memory
  // (deskte:lastClientTab) keeps working afterwards.
  useEffect(()=>{
    const applyTabHint=()=>{
      const t = typeof window!=="undefined" ? window.__magClientTab : null;
      if (t) { window.__magClientTab=null; setTab(String(t)); }
    };
    applyTabHint();
    window.addEventListener('deskte:client-tab', applyTabHint);
    return ()=>window.removeEventListener('deskte:client-tab', applyTabHint);
  },[client?.id]);
  // Belt-and-suspenders hydration: the profile must ALWAYS render the FULL
  // record (maritalStatus, full address, F4 ficha, SSN flags…), regardless
  // of how the detail was opened. The clients-LIST endpoint omits many of
  // those fields, so a detail set from list data (or before the parent's
  // GET landed) showed blank in the header + the Health/Life tab. Fetch the
  // full record once per client and merge it up via onClientPatched. Runs
  // once per client id; onClientPatched only changes detail (not its id), so
  // there's no re-fetch loop.
  // Fields the user quick-edited (assigned agent, status) while the full-record
  // GET below was still in flight. Without this, that GET resolves LATE and its
  // stale snapshot overwrites the fresh edit — the "I changed the agent but it
  // reverted / didn't save" bug. Reset per client; the GET strips these keys.
  const quickEditProtectRef = useRef(new Set());
  useEffect(() => {
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (!apiMode || !client?.id || !onClientPatched) return;
    quickEditProtectRef.current = new Set();
    let cancelled = false;
    apiGetClient(client.id)
      .then((full) => {
        if (cancelled || !full) return;
        // Don't clobber a value the user edited during the fetch window.
        const merged = { ...full };
        for (const k of quickEditProtectRef.current) delete merged[k];
        onClientPatched(merged);
      })
      .catch(() => { /* non-fatal: list/cached data already rendered */ });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client?.id]);
  // Documents are hydrated globally at app start but the backend caps that
  // list at the 100 most recent agency-wide rows (GET /documents take:100).
  // Once an agency passes ~100 documents, a client's OLDER uploads fall
  // outside that window — and the profile's Documents tab (which filters the
  // global `docs` list by clientId) showed nothing for them, looking exactly
  // like "the documents were deleted". They were always safe in the DB. Fetch
  // THIS client's full document set from the server on open and merge it into
  // the global list so every doc shows — for the owner AND the seat. Merge by
  // id (server row wins) so other clients' docs and in-flight optimistic
  // uploads are preserved. Runs once per client id (same pattern as the
  // full-record hydration above).
  useEffect(() => {
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (!apiMode || !client?.id || !onDocsChange) return;
    let cancelled = false;
    apiListDocuments({ clientId: client.id })
      .then(({ documents }) => {
        if (cancelled || !documents) return;
        onDocsChange((prev) => {
          const byId = new Map((prev || []).map((d) => [d.id, d]));
          for (const d of documents) byId.set(d.id, d);
          return Array.from(byId.values());
        });
      })
      .catch(() => { /* non-fatal: the global cache already rendered what it had */ });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client?.id]);
  // Same cap-avoidance for NOTES. The global notes list is capped server-side
  // (take 500 agency-wide), so a client's older notes could fall outside it.
  // Fetch THIS client's notes on open and merge into the global list by id
  // (onClientNotesChange === the global setNotes; the parent re-filters per
  // client). Backend /notes already supports ?clientId, so frontend-only.
  //
  // Desde E-323 esta es la UNICA carga de las notas completas de la ficha: el
  // arranque ya no las trae. Agencia Pomare, 2026-10-21: "abre un cliente,
  // busca su nota y no le sale nada hasta que refresca". Mientras la peticion
  // iba, la pestaña decia "Sin notas aún"; y si fallaba (servidor lento,
  // despliegue) el error se tragaba y no se reintentaba nunca. Ahora la
  // pestaña sabe si esta cargando o si fallo (`estadoNotas`), se reintenta
  // sola una vez y, si vuelve a fallar, ofrece "Reintentar" en vez de fingir
  // que el cliente no tiene notas (E-376).
  const [estadoNotas, setEstadoNotas] = useState("cargando"); // cargando | listo | error
  const [intentoNotas, setIntentoNotas] = useState(0);
  useEffect(() => {
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (!apiMode || !client?.id || !onClientNotesChange) { setEstadoNotas("listo"); return; }
    let cancelled = false;
    let reintento = null;
    setEstadoNotas("cargando");
    const pedir = (vuelta) => {
      apiListNotes({ clientId: client.id })
        .then(({ notes }) => {
          if (cancelled) return;
          if (notes) {
            onClientNotesChange((prev) => {
              const byId = new Map((prev || []).map((n) => [n.id, n]));
              for (const n of notes) byId.set(n.id, n);
              return Array.from(byId.values());
            });
          }
          setEstadoNotas("listo");
        })
        .catch((err) => {
          if (cancelled) return;
          console.error("[notes] no se pudieron cargar las notas del cliente:", err?.message || err);
          // Un tropiezo suelto (despliegue, servidor ocupado) se arregla solo
          // con esperar un poco; solo si falla dos veces se le dice a la persona.
          if (vuelta === 0) reintento = setTimeout(() => pedir(1), 3000);
          else setEstadoNotas("error");
        });
    };
    pedir(0);
    return () => { cancelled = true; if (reintento) clearTimeout(reintento); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client?.id, intentoNotas]);
  const reintentarNotas = () => setIntentoNotas((n) => n + 1);
  // Same cap-avoidance for TASKS. The global tasks list is capped (limit 200),
  // so a client's older tasks could be missing from the profile. Fetch this
  // client's tasks on open and merge. (Backend /tasks gains ?clientId support.)
  useEffect(() => {
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (!apiMode || !client?.id || !onTasksChange) return;
    let cancelled = false;
    apiListTasks({ clientId: client.id, limit: 1000 })
      .then(({ tasks: clientTasks }) => {
        if (cancelled || !clientTasks) return;
        onTasksChange((prev) => {
          const byId = new Map((prev || []).map((tk) => [tk.id, tk]));
          for (const tk of clientTasks) byId.set(tk.id, tk);
          return Array.from(byId.values());
        });
      })
      .catch(() => { /* non-fatal */ });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client?.id]);
  // ── Notification badges per tab — team-work model ──────────────────
  // Lissette 2026-05-27 (re-redesign): per-tab, per-user, yellow.
  // "Cada uno del seat o agente que lo haya visto" — each user has
  // their own lastSeen stamps. When THIS user clicks a tab, that tab
  // is marked seen for them only. Other teammates still see badges
  // until they click the tab themselves.
  //
  // First-ever visit by this user to this client: seed all tabs with
  // mount-time so items added DURING the visit (in other tabs) show
  // badges. Pre-existing items don't count.
  //
  // The active tab never shows its own badge.
  // The clients-list badge uses a separate `lastVisited` stamp written
  // on unmount.
  const userId = currentUser?.id || null;
  const clientId = client?.id || null;

  // ── Live presence: who else is viewing/editing this same client ─────────
  // Announces this user (enter → heartbeat every 15s → leave) and listens for
  // the agency-wide presence broadcast so the header can show "👁 Haiffa está
  // viendo esta ficha". Self is filtered out. Best-effort: a failed ping never
  // disrupts the page. Pairs with the "no te piso" save guard in
  // [[feature_client_coedit_presence]].
  const [viewers, setViewers] = useState([]);
  useEffect(() => {
    const apiMode = typeof window !== "undefined" && !!window.__deskteAuth;
    if (!apiMode || !clientId) return;
    const myName = currentUser?.name || currentUser?.displayName || "";
    let stopped = false;
    const ping = (action) => { postClientPresence(clientId, action, myName).catch(() => {}); };
    ping("enter");
    const hb = setInterval(() => { if (!stopped) ping("heartbeat"); }, 15000);
    const onPresence = (e) => {
      const d = e.detail || {};
      if (d.clientId !== clientId) return;
      setViewers((Array.isArray(d.viewers) ? d.viewers : []).filter((v) => v.userId !== userId));
    };
    window.addEventListener("deskte:client-presence", onPresence);
    return () => {
      stopped = true;
      clearInterval(hb);
      window.removeEventListener("deskte:client-presence", onPresence);
      ping("leave");
      setViewers([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, userId]);

  const [lastSeenTabs, setLastSeenTabsState] = useState({});
  const initRef = useRef(false);
  const tabRef = useRef(tab);
  // Initial load + seed. Runs once when userId + clientId become known
  // (currentUser is null on the very first render while it loads).
  useEffect(() => {
    if (!clientId) return;
    if (initRef.current) return;
    initRef.current = true;
    const stored = getLastSeenTabs(userId, clientId);
    const now = new Date().toISOString();
    if (Object.keys(stored).length === 0) {
      // First-ever visit: seed every trackable tab with NOW so items
      // added during this visit (in other tabs) get counted.
      const seed = {};
      for (const t of TRACKABLE_TABS) seed[t] = now;
      seed[tab] = now;
      setLastSeenTabsState(seed);
      setLastSeenTabs(userId, clientId, seed);
    } else {
      // Subsequent visit: keep old stamps, refresh only the current tab.
      const next = { ...stored, [tab]: now };
      setLastSeenTabsState(next);
      setLastSeenTabs(userId, clientId, next);
    }
  }, [userId, clientId, tab]);
  // On every tab CHANGE after init, stamp the new tab as seen.
  useEffect(() => {
    if (!initRef.current) return;
    if (tabRef.current === tab) return;
    tabRef.current = tab;
    setLastSeenTabsState(prev => {
      const next = { ...prev, [tab]: new Date().toISOString() };
      setLastSeenTabs(userId, clientId, next);
      return next;
    });
  }, [tab, userId, clientId]);
  // Stamp lastVisited on unmount for the clients-list badge.
  useEffect(() => {
    return () => { markClientVisited(userId, clientId); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, clientId]);
  // Clean up the obsolete PR #361 separate key.
  useEffect(() => {
    if (!userId || !clientId) return;
    try { localStorage.removeItem(`deskte:lastSeen:${userId}:${clientId}`); } catch {}
  }, [userId, clientId]);
  // Perf: filter each agency-wide array down to THIS client once per data
  // change, not on every render. These previously ran in the render body, so
  // opening a client — and every re-render while open (typing a note,
  // switching tabs, an SSE refresh) — re-scanned the full activitylog /
  // changeHistory (largest for the biggest tenant), which froze the profile.
  const {
    _clientPolicies, _clientDocs, _clientSigs, _clientTasks, _clientEligs,
    _clientHist, _clientActs, _clientNotes, _clientComms,
  } = useMemo(() => ({
    _clientPolicies: (policies||[]).filter(p => p.clientId === clientId),
    _clientDocs: (docs||[]).filter(d => d.clientId === clientId),
    _clientSigs: (signatures||[]).filter(s => s.clientId === clientId),
    _clientTasks: (tasks||[]).filter(tk => tk.clientId === clientId),
    _clientEligs: (eligibilityAlerts||[]).filter(e => e.clientId === clientId),
    _clientHist: (changeHistory||[]).filter(h => h.clientId === clientId),
    _clientActs: (activitylog||[]).filter(a => a.entityId === clientId || a.clientId === clientId),
    // Lissette 2026-05-27: Notes / Messages also count toward the badges.
    _clientNotes: (clientNotes||[]).filter(n => n.clientId === clientId),
    // Email/SMS/WhatsApp threads (comms tab): agency-wide activitylog rows
    // whose action starts with 'email.'/'sms.'/'whatsapp.' AND mention this client.
    _clientComms: (activitylog||[]).filter(a => (
      (a.entityId === clientId || a.clientId === clientId || a.details?.clientId === clientId) &&
      /^(email|sms|whatsapp)\./.test(String(a.action || ''))
    )),
  }), [policies, docs, signatures, tasks, eligibilityAlerts, changeHistory, activitylog, clientNotes, clientId]);
  const tabBadges = {
    policies: countNewerThan(_clientPolicies, "createdAt", lastSeenTabs.policies),
    docs: countNewerThan(_clientDocs, "uploadedAt", lastSeenTabs.docs),
    signatures: countNewerThan(_clientSigs, "signedAt", lastSeenTabs.signatures),
    tasks: countNewerThan(_clientTasks, "createdAt", lastSeenTabs.tasks),
    // Persistent yellow count of PENDING eligibility docs ("documentos por
    // enviar") so it stays visible until resolved — not just a freshness blip
    // that clears on view (Lissette 2026-06-19 #16). Falls back to freshness.
    eligibility: _clientEligs.filter(e => e.status === "pending").length || countNewerThan(_clientEligs, "createdAt", lastSeenTabs.eligibility),
    history: countNewerThan(_clientHist, "date", lastSeenTabs.history),
    activity: countNewerThan(_clientActs, "createdAt", lastSeenTabs.activity),
    notes: countNewerThan(_clientNotes.filter(n => (n.category||null) !== "life_change"), "createdAt", lastSeenTabs.notes),
    lifechange: countNewerThan(_clientNotes.filter(n => (n.category||null) === "life_change"), "createdAt", lastSeenTabs.lifechange),
    comms: countNewerThan(_clientComms, "createdAt", lastSeenTabs.comms),
  };
  const [policyModal,setPolicyModal]=useState(null);
  // "Copiar póliza" (2026-10-15): el formulario de Agregar sale ya lleno con la
  // copia. Se vacía al cerrar, para que "Agregar" normal salga en blanco.
  const [policyPrefill,setPolicyPrefill]=useState(null);
  useEffect(()=>{ if(!policyModal) setPolicyPrefill(null); },[policyModal]);
  const [showCancelledPolicies,setShowCancelledPolicies]=useState(false); // cancelled policies live in a collapsed sub-section
  const [deletePolicy,setDeletePolicy]=useState(null);
  // La poliza que se esta moviendo a OTRO cliente. Aqui es donde se descubre el
  // error —abriendo la ficha y viendo una poliza que no es de esta persona—, asi
  // que es la pantalla que mas importa de las dos (Maritza, 2026-09-10).
  const [movPol,setMovPol]=useState(null);
  const [sendingKitId,setSendingKitId]=useState(null);
  const [kitMissingModal,setKitMissingModal]=useState(null); // { policy, missing[] }
  // PIN-gated SSN reveal modal — opened from the 🔒 SSN pill.
  const [ssnRevealOpen, setSsnRevealOpen] = useState(false);
  // Tags + "dependent of" link panel (chips next to the status badge).
  const [tagPanelOpen, setTagPanelOpen] = useState(false);
  const [tagInput, setTagInput] = useState('');
  const [newTagColor, setNewTagColor] = useState(''); // '' = sin color (estilo por defecto)
  const [linkSearch, setLinkSearch] = useState('');
  const [tagSaving, setTagSaving] = useState(false);
  // Persist a small patch (tags / linkedParent) straight to the backend
  // without opening the full edit modal, then mirror it into parent
  // state via onClientPatched so the chips update instantly.
  //
  // CRITICAL: send the FULL client merged with the patch, never the
  // patch alone. mapClientToApi() substitutes the "(falta nombre)"
  // placeholder for any missing firstName/lastName, so PUTting just
  // `{tags}` blew away the client's real name. Spreading `client`
  // first keeps every existing field intact.
  const persistClientPatch = async (patch) => {
    setTagSaving(true);
    try {
      if (typeof window !== 'undefined' && window.__deskteAuth) {
        // Merge the patch onto the FRESH server record, never the possibly
        // still-list-shape `client` — the list omits notes/marital status and
        // F4 PHI, and saving that stale shape would null them. Closes the
        // "add/remove a tag or link before the detail hydrates" data-loss race.
        const full = await apiGetClient(client.id).catch(() => null);
        const base = full || client;
        await apiUpdateClient(client.id, { ...base, ...patch });
      }
      if (typeof onClientPatched === 'function') onClientPatched(patch);
    } catch (e) {
      alert((lang === 'es' ? 'No se pudo guardar: ' : 'Save failed: ') + (e.message || e));
    } finally {
      setTagSaving(false);
    }
  };
  const clientTags = Array.isArray(client.tags) ? client.tags : [];
  // Reusable tag library: the agency's saved tag CATALOG, minus the ones this
  // client already has. Rendered as clickable chips so an existing tag can be
  // re-applied with ONE click instead of being re-typed (Lissette 2026-07-09:
  // "que quede como toggle para reusar en otros clientes"). Case-insensitive
  // de-dupe keeps the first-seen spelling.
  //
  // This used to be computed from the tags in use across `clients`, which meant
  // a tag created for a single client vanished the moment it was taken off that
  // client (Lissette 2026-08-10: "que una vez que se cree la personalizada se
  // quede allí"). It now reads the stored catalog ONLY — falling back to the
  // in-use tags would resurrect a tag deleted from the catalog on the very next
  // refresh, which is exactly what the ✕ is supposed to prevent.
  const reusableTags = useMemo(() => {
    const seen = new Map(); // lowercased -> original spelling
    (Array.isArray(tagLibrary) ? tagLibrary : []).forEach((t) => {
      const s = String(t || '').trim();
      if (s && !seen.has(s.toLowerCase())) seen.set(s.toLowerCase(), s);
    });
    const mine = new Set(clientTags.map((t) => t.toLowerCase()));
    return [...seen.values()].filter((t) => !mine.has(t.toLowerCase())).sort((a, b) => a.localeCompare(b));
  }, [tagLibrary, clientTags]);
  // Put a name into the agency catalog if it isn't there yet (case-insensitive).
  const rememberTagInLibrary = (name) => {
    if (typeof onTagLibraryChange !== 'function') return;
    const v = String(name || '').trim().slice(0, 40);
    if (!v) return;
    onTagLibraryChange((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      if (list.some((t) => String(t || '').trim().toLowerCase() === v.toLowerCase())) return list;
      return [...list, v];
    });
  };
  // Drop a name from the agency catalog. Clients that already carry the tag KEEP
  // it — this only takes it out of the "reuse" list so nobody adds it again.
  // Confirmed first: it's an agency-wide change made from one client's screen.
  const forgetTagFromLibrary = (name) => {
    if (typeof onTagLibraryChange !== 'function') return;
    const v = String(name || '').trim();
    if (!v) return;
    const ok = window.confirm(lang === 'es'
      ? `¿Quitar "${v}" de la lista de etiquetas?\n\nDejará de aparecer para reusar. Los clientes que ya la tengan puesta la conservan.`
      : `Remove "${v}" from the tag list?\n\nIt will no longer show up to reuse. Clients that already have it keep it.`);
    if (!ok) return;
    onTagLibraryChange((prev) => (Array.isArray(prev) ? prev : [])
      .filter((t) => String(t || '').trim().toLowerCase() !== v.toLowerCase()));
  };
  // Set / clear the AGENCY-WIDE color for a tag name (lowercased key). Lives in
  // the shared tagColors map (AgencySetting.tagColors) so the same tag reads the
  // same fluorescent color for every agent + seat. '' clears it back to the
  // default chip look. The tag string on the client is NOT touched.
  const applyTagColor = (name, color) => {
    if (typeof onTagColorsChange !== 'function') return;
    const key = tagColorKey(name);
    if (!key) return;
    onTagColorsChange((prev) => {
      const next = { ...(prev || {}) };
      if (/^#[0-9a-fA-F]{6}$/.test(color || '')) next[key] = String(color).toLowerCase();
      else delete next[key];
      return next;
    });
  };
  const addTag = (raw, color) => {
    const v = String(raw || '').trim().slice(0, 40);
    if (!v) return;
    // Add the (plain) tag to this client if it's new; apply the chosen color to
    // the agency map regardless (so re-typing an existing tag can recolor it).
    if (!clientTags.some((t) => t.toLowerCase() === v.toLowerCase())) {
      persistClientPatch({ tags: [...clientTags, v] });
    }
    // Creating a tag also files it in the agency catalog, so it stays available
    // to reuse even after the last client carrying it loses it.
    rememberTagInLibrary(v);
    if (color) applyTagColor(v, color);
    setTagInput('');
    setNewTagColor('');
  };
  const removeTag = (tag) => persistClientPatch({ tags: clientTags.filter((t) => t !== tag) });
  const setLinkedParent = (parent) => {
    persistClientPatch({
      linkedParentId: parent.id,
      linkedParentName: `${parent.firstName || ''} ${parent.lastName || ''}`.trim(),
    });
    setLinkSearch('');
    setTagPanelOpen(false);
  };
  const clearLinkedParent = () => persistClientPatch({ linkedParentId: '', linkedParentName: '' });

  // ── Vincular QUIEN REFIRIO a este cliente (Lissette 2026-08-28) ───────────
  // Espejo del vinculo de dependiente: se elige de la lista de clientes y queda
  // el vinculo de verdad (referredByClientId), no un nombre escrito a mano. El
  // nombre se guarda TAMBIEN porque es el respaldo que se enseña si el cliente
  // que refirio se borra o se fusiona -- sin el, la etiqueta desapareceria.
  const [refSearch, setRefSearch] = useState('');
  const setReferidoPor = (quien) => {
    persistClientPatch({
      referredByClientId: quien.id,
      refFirstName: quien.firstName || '',
      refLastName: quien.lastName || '',
      referredByFirstName: quien.firstName || '',
      referredByLastName: quien.lastName || '',
    });
    setRefSearch('');
    setTagPanelOpen(false);
  };
  // Quitar el vinculo BORRA de la ficha quien lo refirio -- el vinculo y los
  // nombres -- no solo esconde la etiqueta. Se le advirtio a Lissette y lo
  // pidio igual, y tiene sentido: con el buscador al lado se rehace en dos
  // clics, asi que quitarlo dejo de ser un camino sin vuelta.
  const clearReferidoPor = () => persistClientPatch({
    referredByClientId: '', refFirstName: '', refLastName: '',
    referredByFirstName: '', referredByLastName: '',
  });
  // Seat write-permission gates. Non-assistants always pass; assistants need the explicit perm.
  const _isSeat = currentUser?.role === "assistant";
  const _seatP = _isSeat ? normalizeSeatPermissions(currentUser?.seatPermissions) : null;
  const canEditClient   = !_isSeat || hasSeatPermission(_seatP, "clients.edit");
  const canEditPolicies = !_isSeat || hasSeatPermission(_seatP, "policies.edit");
  // Los dos enlaces directos llevan a Cotizaciones y a Firmas. A un asistente
  // sin ese permiso el sidebar ya le esconde esas pantallas y el guardia de
  // deskte-full lo devolveria a la suya: un boton que te rebota a otra pantalla
  // es peor que no tener boton.
  const canQuote     = !_isSeat || hasSeatPermission(_seatP, "quotes.view");
  const canSign      = !_isSeat || hasSeatPermission(_seatP, "signatures.view");
  // La pestaña Pagos (métodos de pago) pide a un asiento su propio permiso
  // (Lissette 2026-10-16). El servidor también lo exige: esto solo evita
  // enseñar una pestaña que contestaría "sin permiso".
  const canSeePayments = !_isSeat || hasSeatPermission(_seatP, "paymentMethods.view");
  const clientPolicies=policies.filter(p=>p.clientId===client.id);
  // Distinct carriers already in this agency's policy book. Powers the
  // autocomplete dropdown on the carrier field of PolicyForm (free-typing
  // still allowed for first-time carriers).
  const carrierSuggestions = useMemo(
    () => [...new Set((policies || []).map(p => p.carrier).filter(Boolean))].sort(),
    [policies],
  );
  // "Agente asignado" — editable label, picked from a dropdown so EVERY teammate
  // shows every time (a <datalist> filters by the typed text, which hid all but
  // the current value — Lissette 2026-06-15). Options = ALL team members (agents
  // AND seats) + any custom values already used across clients (reusable) + the
  // current value. Saved via the dedicated narrow endpoint so a partial patch
  // never wipes PHI.
  const assignedAgentOptions = useMemo(() => {
    // Seats (role "assistant") are NOT offered here — only real agents + any
    // hand-typed custom names already used across clients (Lissette 2026-06-17:
    // "no pongas los seat, solo agentes y los nombres que uno coloca"). The
    // current value still shows even if it's a legacy seat name (the <select>
    // merges assignedAgentDraft into its options). E-015.
    const seatNames = new Set((users || []).filter(u => u.role === 'assistant').map(u => u.name));
    const team = (users || []).filter(u => u.role !== 'assistant').map(u => u.name);
    const used = (clients || []).map(c => c.assignedAgent).filter(Boolean).filter(n => !seatNames.has(n));
    return [...new Set([...team, ...used].filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }, [users, clients]);
  const [assignedAgentDraft, setAssignedAgentDraft] = useState(client.assignedAgent || client.agentName || '');
  const [assignedAgentSaving, setAssignedAgentSaving] = useState(false);
  // When true, show a free-text input instead of the dropdown (the "Otro nombre…"
  // escape hatch so a brand-new name can still be typed).
  const [assignedAgentCustom, setAssignedAgentCustom] = useState(false);
  // Manage panel (delete custom names) + names hidden instantly after a delete
  // so the picker updates without waiting on the per-client clears + SSE.
  const [assignedAgentManage, setAssignedAgentManage] = useState(false);
  const [hiddenAgentNames, setHiddenAgentNames] = useState(() => new Set());
  useEffect(() => {
    setAssignedAgentDraft(client.assignedAgent || client.agentName || '');
    setAssignedAgentCustom(false);
    setAssignedAgentManage(false);
  }, [client.id]);
  // Persist an explicit value (the dropdown saves on change; the text input on
  // blur). No-op when unchanged so re-selecting the same name doesn't round-trip.
  const persistAssignedAgent = async (raw) => {
    const val = (raw || '').trim();
    if (val === (client.assignedAgent || '')) return;
    // Protect this edit from a late-arriving full-client GET (see ref above).
    quickEditProtectRef.current.add('assignedAgent');
    setAssignedAgentSaving(true);
    try {
      if (typeof window !== 'undefined' && window.__deskteAuth) await apiSetClientAssignedAgent(client.id, val);
      if (typeof onClientPatched === 'function') onClientPatched({ assignedAgent: val });
    } catch (e) {
      alert((lang === 'es' ? 'No se pudo guardar el agente: ' : 'Failed to save agent: ') + (e.message || e));
      setAssignedAgentDraft(client.assignedAgent || client.agentName || '');
    } finally { setAssignedAgentSaving(false); }
  };
  const saveAssignedAgent = () => persistAssignedAgent(assignedAgentDraft);
  // ── Delete custom names from the picker ───────────────────────────────
  // Real teammates (agents/seats from `users`) are NEVER deletable — only
  // free-typed custom names that piled up across clients (typos, test names).
  // `hiddenAgentNames` masks a name instantly; the actual delete clears that
  // value on every client carrying it (they fall back to the default agent),
  // so it stops re-appearing in the dropdown.
  const teamNameSet = useMemo(() => new Set((users || []).map(u => u.name)), [users]);
  const visibleAgentOptions = useMemo(
    () => assignedAgentOptions.filter(a => !hiddenAgentNames.has(a)),
    [assignedAgentOptions, hiddenAgentNames],
  );
  const deletableAgentNames = useMemo(
    () => visibleAgentOptions.filter(a => !teamNameSet.has(a)),
    [visibleAgentOptions, teamNameSet],
  );
  const deleteAgentName = async (name) => {
    const affected = (clients || []).filter(c => c.assignedAgent === name);
    const ok = await confirmDialog({
      message: (lang === 'es'
        ? `¿Eliminar el nombre «${name}» de la lista?`
        : `Delete the name “${name}” from the list?`)
        + (affected.length
            ? (lang === 'es'
                ? ` Está asignado a ${affected.length} cliente(s); quedarán con el agente por defecto.`
                : ` It's assigned to ${affected.length} client(s); they'll fall back to the default agent.`)
            : ''),
      danger: true,
    });
    if (!ok) return;
    // Mask immediately so the picker updates without waiting on the network.
    setHiddenAgentNames(s => new Set(s).add(name));
    if (assignedAgentDraft === name) setAssignedAgentDraft('');
    try {
      if (typeof window !== 'undefined' && window.__deskteAuth) {
        await Promise.all(affected.map(c => apiSetClientAssignedAgent(c.id, '').catch(() => {})));
      }
      // If THIS client carried the name, reflect the cleared value locally.
      if (client.assignedAgent === name && typeof onClientPatched === 'function') {
        quickEditProtectRef.current.add('assignedAgent');
        onClientPatched({ assignedAgent: '' });
      }
    } catch { /* best-effort; the mask already updated the UI */ }
  };
  // Status quick-toggle from the profile header (active / inactive / prospect)
  // so the user doesn't have to open Edit. Uses the narrow setClientStatus
  // endpoint — never touches PHI, safe from the partial-patch wipe.
  const [statusMenuOpen, setStatusMenuOpen] = useState(false);
  const [statusSaving, setStatusSaving] = useState(false);
  const [seatLabelsOpen, setSeatLabelsOpen] = useState(false);
  const STATUS_OPTIONS = [
    { id: 'active', es: 'Activo', en: 'Active', color: '#00ff88' },
    { id: 'inactive', es: 'Inactivo', en: 'Inactive', color: '#64748b' },
    { id: 'prospect', es: 'Prospecto', en: 'Prospect', color: '#00d4ff' },
    { id: 'referral', es: 'Referido', en: 'Referral', color: '#34d399' },
  ];
  const changeStatus = async (s) => {
    setStatusMenuOpen(false);
    if (s === (client.status || 'active')) return;
    // Protect this edit from a late-arriving full-client GET (see ref above).
    quickEditProtectRef.current.add('status');
    setStatusSaving(true);
    try {
      if (typeof window !== 'undefined' && window.__deskteAuth) await apiSetClientStatus(client.id, s);
      if (typeof onClientPatched === 'function') onClientPatched({ status: s });
    } catch (e) {
      alert((lang === 'es' ? 'No se pudo cambiar el estado: ' : 'Failed to change status: ') + (e.message || e));
    } finally { setStatusSaving(false); }
  };
  // LISTA PARA SOMETER (Lissette 2026-09-21). Es una MARCA, no un estatus: al
  // encenderla la persona SIGUE siendo prospecto o referido y no se mueve de
  // su lista — solo se le pone la etiqueta. Por eso vive en el mismo menú (es
  // "otra opción del desplegable", como se pidió) pero separada de las cuatro
  // de arriba, que sí son excluyentes entre sí.
  const [readySaving, setReadySaving] = useState(false);
  const toggleReadyToSubmit = async () => {
    setStatusMenuOpen(false);
    const next = !client.readyToSubmit;
    quickEditProtectRef.current.add('readyToSubmit');
    setReadySaving(true);
    try {
      if (typeof window !== 'undefined' && window.__deskteAuth) await apiSetClientReadyToSubmit(client.id, next);
      if (typeof onClientPatched === 'function') {
        onClientPatched({ readyToSubmit: next, readyToSubmitAt: next ? new Date().toISOString() : null });
      }
    } catch (e) {
      alert((lang === 'es' ? 'No se pudo cambiar la marca: ' : 'Failed to change the flag: ') + (e.message || e));
    } finally { setReadySaving(false); }
  };
  // DUPLICAR (Lissette 2026-09-21). "Que no sean espejo": la copia es una
  // ficha nueva y entera, sin ningún vínculo con ésta. Se confirma antes
  // porque crea una ficha de verdad y hay que decir qué NO se lleva — que es
  // justo lo que nadie espera de un botón llamado "duplicar".
  const [duplicando,setDuplicando]=useState(false);
  const duplicarCliente = async () => {
    const ok = await confirmDialog({
      title: lang==="es"?"Duplicar este cliente":"Duplicate this client",
      message: lang==="es"
        ? `Se creará una ficha NUEVA con los datos de ${formatClientName(client)}: nombre, contacto, dirección, fecha de nacimiento, hogar y etiquetas.\n\nNO se copian sus pólizas, comisiones, documentos ni notas, ni su Seguro Social, licencia, historial médico o legal — ésos son de esa persona y no pueden pasar a otra ficha.\n\nLa copia queda independiente: editarla no toca a la original.`
        : `A NEW record will be created with ${formatClientName(client)}'s data: name, contact, address, date of birth, household and tags.\n\nPolicies, commissions, documents and notes are NOT copied, and neither are the SSN, driver's license, medical or legal history — those belong to that person and cannot move to another record.\n\nThe copy is independent: editing it never touches the original.`,
      confirmLabel: lang==="es"?"Duplicar":"Duplicate",
    });
    if(!ok) return;
    setDuplicando(true);
    try{
      if(typeof window!=='undefined' && window.__deskteAuth){
        const copia = await apiDuplicateClient(client.id);
        if(typeof onClientCreated==='function') onClientCreated(copia);
        toast.success(lang==="es"?"Cliente duplicado ✓":"Client duplicated ✓");
      } else {
        toast.error(lang==="es"?"En la demo no se puede duplicar.":"Duplicating is not available in the demo.");
      }
    }catch(e){
      toast.error((lang==="es"?"No se pudo duplicar: ":"Could not duplicate: ")+(e.message||e));
    }finally{ setDuplicando(false); }
  };
  const totalPremium=clientPolicies.filter(p=>p.status==="active").reduce((s,p)=>s+parseFloat(p.monthlyPremium||0),0);
  // Household income = principal + spouse + any dependent with income.
  // Income fields are free-typed strings ("$50,000", "50000") so strip
  // everything but digits/decimal before summing.
  // Cada persona suma tambien sus OTROS INGRESOS (un segundo trabajo,
  // 2026-10-27; crm-app/otrosIngresos.js).
  const parseMoney=v=>{const n=parseFloat(String(v||"").replace(/[^0-9.]/g,""));return isNaN(n)?0:n;};
  const householdIncome=parseMoney(client.annualIncome)+sumaOtrosIngresos(client.otrosIngresos)+parseMoney(client.spouse?.income)+sumaOtrosIngresos(client.spouse?.otrosIngresos)+(Array.isArray(client.dependents)?client.dependents:[]).reduce((s,d)=>s+parseMoney(d.income)+sumaOtrosIngresos(d.otrosIngresos),0);
  // La etiqueta "INGRESOS HOGAR" sale SIEMPRE que haya un ingreso, aunque sea
  // uno solo. Antes la condición era `householdIncome > annualIncome`, así que
  // cuando solo el titular ganaba el total coincidía con el individual, no era
  // MAYOR, y la etiqueta no se pintaba: la ficha se quedaba sin ingreso del
  // hogar justo en el caso más común (Lissette 2026-08-25, "no estaba
  // colocando cuando era solo un ingreso").
  //
  // Que se vea el mismo número dos veces cuando gana una sola persona es
  // correcto, no una repetición molesta: para el Mercado lo que cuenta es el
  // número del HOGAR, y el agente tiene que poder leerlo sin deducirlo.
  const hasHouseholdIncome=householdIncome>0;
  const hasBday=birthdayToday(client.dob);
  const POLICY_LABELS_CD = {
    carrier:"Compañía",plan:"Plan",policyNumber:"# Póliza",memberId:"Member ID",
    monthlyPremium:"Prima Mensual",familySize:"Tamaño Familia",membersActive:"Miembros Activos",
    effectiveDate:"Fecha Inicio",renewalDate:"Fecha Renovación",status:"Estado Póliza",
    coverageType:"Tipo Cobertura",deductible:"Deducible",liabilityCoverage:"Resp. Civil",
    vehicleYear:"Año Vehículo",vehicleMake:"Marca",vehicleModel:"Modelo",
    vin:"VIN",licensePlate:"Placa",driversOnPolicy:"Conductores",
    propertyAddress:"Dir. Propiedad",propertyType:"Tipo Propiedad",
    yearBuilt:"Año Construcción",squareFootage:"Pies²",insuredValue:"Valor Asegurado",
    businessName:"Negocio",businessType:"Tipo Negocio",businessAddress:"Dir. Negocio",
    numEmployees:"Empleados",annualRevenue:"Ingresos Anuales",
    agentName:"Agente",producerCode:"Cód. Productor",type:"Tipo Póliza"
  };
  const recordPolicyChange = (oldPol, newForm) => {
    if(!onChangeHistory) return;
    const changes=[];
    Object.keys({...oldPol,...newForm}).forEach(k=>{
      if(!POLICY_LABELS_CD[k]) return;
      const ov=String(oldPol[k]||"").trim(), nv=String(newForm[k]||"").trim();
      if(ov!==nv&&(ov||nv)) changes.push({field:k,label:POLICY_LABELS_CD[k],from:ov||"--",to:nv||"--"});
    });
    if(!changes.length) return;
    onChangeHistory(prev=>[{id:Math.random().toString(36).slice(2),type:"policy",
      entityId:oldPol.id,clientId:client.id,date:new Date().toISOString(),
      changes,user:currentUser?.name||"Sistema",carrier:newForm.carrier||oldPol.carrier,
      policyType:newForm.type||oldPol.type},...(prev||[])]);
  };
  const isApiMode = typeof window !== "undefined" && !!window.__deskteAuth;
  const savePolicy=async form=>{
    if(policyModal==="add") {
      const payload = { ...form, clientId: client.id };
      if (isApiMode) {
        try {
          const created = await apiCreatePolicy(payload);
          // Race fix: the SSE policy.created emit can arrive BEFORE the
          // HTTP 201 returns here. If it already appended the row,
          // merge instead of pushing — otherwise both paths add and the
          // policy renders twice (Lissette 2026-05-27).
          const merged = { ...payload, ...created };
          onPoliciesChange(prev =>
            prev.some(p => p.id === merged.id)
              ? prev.map(p => (p.id === merged.id ? { ...p, ...merged } : p))
              : [...prev, merged],
          );
        } catch (err) {
          toast.error((lang === "es" ? "No se pudo guardar la póliza: " : "Failed to save policy: ") + err.message);
          return;
        }
      } else {
        onPoliciesChange(prev=>[...prev,{...form,id:uid(),clientId:client.id}]);
      }
    } else {
      recordPolicyChange(policyModal, form);
      if (isApiMode) {
        try {
          await apiUpdatePolicy(policyModal.id, { ...policyModal, ...form });
        } catch (err) {
          toast.error((lang === "es" ? "No se pudo actualizar la póliza: " : "Failed to update policy: ") + err.message);
          return;
        }
      }
      onPoliciesChange(prev=>prev.map(p=>p.id===policyModal.id?{...policyModal,...form}:p));
    }
    // Policy → Coverage sync. On ADD, additively light up each insured
    // member's matching coverage toggle. On EDIT, reconcile only the people
    // whose membership changed: added → coverage ON, removed → coverage OFF
    // (unless still insured on another policy of this type). Turning the
    // coverage OFF on removal is what makes a manual removal STICK — otherwise
    // the additive Coverage→Policy auto-sync on profile save re-adds them.
    // Non-fatal — the policy itself is already saved above; a failed coverage
    // write must not surface as "policy didn't save".
    try {
      const covPatch = policyModal === "add"
        ? buildCoveragePatchFromPolicy(client, form.type, form.policyInsured)
        : buildCoverageSyncFromPolicyEdit(
            client, form.type,
            policyModal.policyInsured, form.policyInsured,
            clientPolicies.filter(p => p.id !== policyModal.id && p.type === form.type),
          );
      if (covPatch) await persistClientPatch(covPatch);
    } catch { /* coverage mirror is best-effort */ }
    toast.success(lang === "es" ? "Guardado ✓" : "Saved ✓");
    setPolicyModal(null);
  };

  // Inline edit of a policy's insured people straight from the card's "INSURED"
  // dropdown — no need to open Editar Póliza (Lissette 2026-06-23: "tengo que
  // entrar a la ficha y cambiarlo, no está sincronizado"). Persists policyInsured
  // and runs the same Policy→Coverage sync as a full edit so the household
  // coverage toggles (and the by-type count) stay in step.
  // `newExtra` (opcional): los nombres escritos a mano que quedan, cuando se
  // quita uno desde la tarjeta (Lissette 2026-10-02). Sin el, no se tocan.
  const updatePolicyInsured = async (policy, newInsured, newExtra) => {
    const prevInsured = Array.isArray(policy.policyInsured) ? policy.policyInsured : [];
    const extra = Array.isArray(newExtra) ? newExtra : policy.policyInsuredExtra;
    if (isApiMode) {
      try { await apiUpdatePolicy(policy.id, { ...policy, policyInsured: newInsured, policyInsuredExtra: extra }); }
      catch (err) { toast.error((lang === "es" ? "No se pudo actualizar: " : "Failed to update: ") + err.message); return; }
    }
    onPoliciesChange(prev => prev.map(p => (p.id === policy.id ? { ...p, policyInsured: newInsured, policyInsuredExtra: extra } : p)));
    try {
      const covPatch = buildCoverageSyncFromPolicyEdit(
        client, policy.type, prevInsured, newInsured,
        clientPolicies.filter(p => p.id !== policy.id && p.type === policy.type),
      );
      if (covPatch) await persistClientPatch(covPatch);
    } catch { /* coverage mirror is best-effort */ }
    toast.success(lang === "es" ? "Asegurados actualizados ✓" : "Insured updated ✓");
  };

  // Etiquetas de PÓLIZA desde la tarjeta. Distintas de las del cliente: estas
  // describen la póliza y se borran con ella (Lissette 2026-08-15).
  const updatePolicyTags = async (policy, nextTags) => {
    if (isApiMode) {
      try { await apiUpdatePolicy(policy.id, { ...policy, tags: nextTags }); }
      catch (err) {
        toast.error((lang === "es" ? "No se pudieron guardar las etiquetas: " : "Could not save the tags: ") + err.message);
        return;
      }
    }
    onPoliciesChange(prev => prev.map(p => (p.id === policy.id ? { ...p, tags: nextTags } : p)));
  };

  // Estado de pago del MES EN CURSO por póliza, para mostrarlo como etiqueta en
  // la tarjeta de la póliza dentro de la ficha (Lissette 2026-07-08). Reutiliza
  // el mismo endpoint/acción que Pagos del Mes, acotado a este cliente.
  const payPeriod = (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; })();
  const [payByPolicy, setPayByPolicy] = useState({}); // { [policyId]: paymentObj }
  useEffect(() => {
    if (!isApiMode || !client?.id) { setPayByPolicy({}); return; }
    let cancelled = false;
    apiGetPaymentTracker({ period: payPeriod, clientId: client.id })
      .then((res) => { if (cancelled) return; const map = {}; (res.rows || []).forEach((r) => { map[r.id] = r.payment || { paid: false }; }); setPayByPolicy(map); })
      .catch(() => { if (!cancelled) setPayByPolicy({}); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client?.id, isApiMode, clientPolicies.length]);
  // Status id from a payment obj — mirrors PaymentTrackerView.statusOfPay.
  const payStatusOf = (policyId) => {
    const pay = payByPolicy[policyId];
    if (pay?.statusLabel) return pay.statusLabel;
    if (!pay?.markedByUserId) return 'pending';
    return pay.paid ? 'paid' : 'unpaid';
  };
  const setPolicyPaymentStatus = async (policy, status) => {
    if (!isApiMode) { toast.error(lang === "es" ? "Disponible solo en la nube." : "Available in cloud mode only."); return; }
    const paid = status === 'paid';
    const statusLabel = (status === 'paid' || status === 'unpaid') ? '' : status;
    const prev = payByPolicy[policy.id];
    setPayByPolicy((m) => ({ ...m, [policy.id]: { ...(m[policy.id] || {}), paid, statusLabel: statusLabel || null, markedByUserId: currentUser?.id || 'optimistic' } }));
    try {
      await apiMarkPolicyPayment({ policyId: policy.id, period: payPeriod, paid, statusLabel });
      window.dispatchEvent(new CustomEvent('deskte:policy-payment', { detail: { policyId: policy.id, period: payPeriod, paid } }));
    } catch (e) {
      setPayByPolicy((m) => ({ ...m, [policy.id]: prev }));
      toast.error(e.message || (lang === "es" ? "No se pudo guardar" : "Could not save"));
    }
  };

  // F4 Welcome Kit: manual send for a single policy. Backend resolves the kit
  // template by the policy type. On missing required docs it returns the list
  // so we can offer "send anyway"; forceKit bypasses the gate.
  const kitReasonMsg = reason => ({
    no_client_email: lang==="es"?"El cliente no tiene correo — no se envió el kit.":"Client has no email — kit not sent.",
    no_supervisor: lang==="es"?"Este asiento no tiene agente asignado.":"This seat has no supervising agent.",
    agent_no_mailbox: lang==="es"?"Conecta tu correo para enviar el kit.":"Connect your email to send the kit.",
    send_failed: lang==="es"?"No se pudo enviar el kit. Intenta de nuevo.":"The kit could not be sent. Try again.",
  }[reason] || (lang==="es"?"No se envió el kit.":"Kit not sent."));
  const sendKit = async (policy, force=false) => {
    if(!isApiMode){ toast.error(lang==="es"?"Disponible solo en la nube.":"Available in cloud mode only."); return; }
    setSendingKitId(policy.id);
    try{
      const { kit } = await apiSendWelcomeKit({ policyId: policy.id, forceKit: force });
      if(kit?.sent){ avisarKitEnviado(toast,(lang==="es"?"Kit de bienvenida enviado a ":"Welcome kit sent to ")+(kit.sentTo||""),kit.mensaje,lang==="es"); setKitMissingModal(null); }
      else if(kit?.reason==="missing_docs"){ setKitMissingModal({ policy, missing: Array.isArray(kit.missing)?kit.missing:[] }); }
      else if(kit?.reason==="no_template"){ toast.warn(textoSinMensajeDeKit(kit.mensaje?.tipo,"renovacion",lang==="es"),{duration:12000}); }
      else if(kit?.reason){ toast.error(kitReasonMsg(kit.reason)); }
    }catch(err){ toast.error((lang==="es"?"No se pudo enviar: ":"Could not send: ")+(err.message||"")); }
    finally{ setSendingKitId(null); }
  };

  // History is now fetched server-side inside ChangeHistoryTab; the legacy
  // changeHistory prop is left intact for callers that still pass it but it
  // no longer drives the tab.
  const histLabel = lang === 'es' ? 'Historial' : 'History';
  // Note: the "📧 Emails" standalone tab was consolidated into the "💬 Messages"
  // tab (ClientCommsTab → Email channel) on 2026-05-13. That tab now talks to
  // the real ClientEmailMessage API instead of the previous mock data, and is
  // the single place for client email conversations.
  // Custom (agency-shared) tabs render right after Health/Life so they sit
  // beside the other client-profile tabs instead of at the very end.
  //
  // A custom tab only shows on a client's PROFILE when THAT client actually
  // has data for it (Lissette 2026-07-28: "que salgan solo si se le colocan
  // los datos"). Agency-wide custom tabs applied to a client that never uses
  // them are noise on every profile. Values are still entered from Edit →
  // "Pestañas" (that editor always lists every tab, so a freshly created tab
  // is never lost — it just doesn't clutter clients until it has content).
  // A tab with no label is skipped too (a blank tab button is unclickable
  // noise). NOTE: this intentionally reverts the 2026-07-21 always-show change.
  const _cv=(client?.customValues&&typeof client.customValues==="object")?client.customValues:{};
  const _defHasData=(d)=>Array.isArray(d.fields)&&d.fields.some(f=>f&&f.id&&(_cv[f.id]||"").toString().trim());
  const customTabEntries=(Array.isArray(customTabDefs)?customTabDefs:[])
    .filter(d=>d&&d.id&&(d.label||"").trim()&&_defHasData(d))
    .map(d=>["custom_"+d.id,"🧩 "+d.label,Sparkles]);
  // EL ORDEN LO ELIGIO LISSETTE (2026-09-16): *"el orden de las pestañas me
  // gustaría mejorarlo: alerta, elegibilidad, pólizas, hogar, salud/vida,
  // médicos, luego las pestañas que se crean personalizadas, documentos,
  // carpeta, tareas, ticket, seguimientos, firmas digitales, cotizaciones,
  // aplicaciones, notas, cambio vida, pagos, historial de actividades,
  // historial, mensajes"*.
  //
  // Sigue el camino de un expediente: primero lo que hay que MIRAR (alertas,
  // elegibilidad, pólizas, la familia y su salud), después lo que hay que HACER
  // (documentos, tareas, tickets, seguimiento, firmas), y al final lo que se
  // CONSULTA (notas, pagos e historiales). Los mensajes cierran.
  //
  // Son las MISMAS pestañas que antes: aquí solo cambia el orden. Si alguna vez
  // se añade una, va en este mismo sitio y en su render de abajo.
  const TABS=[["alerts",lang==="es"?"Alertas":"Alerts",Bell],["eligibility",lang==="es"?"Elegibilidad":"Eligibility",ClipboardCheck],["policies",t.policies.title,Layers],["household",lang==="es"?"Hogar":"Household",Users],["health",lang==="es"?"Salud/Vida":"Health/Life",Heart],["medicos",lang==="es"?"Médicos y citas":"Doctors & visits",Heart],...customTabEntries,["docs",t.docFolder.title,FileText],["drive",lang==="es"?"Carpeta":"Folder",FolderOpen],["tasks",t.tasks.title,ListTodo],["tickets",lang==="es"?"Tickets":"Tickets",Ticket],["followups",lang==="es"?"Seguimiento":"Follow-ups",Send],["signatures",t.signatures.title,PenTool],["quotes",lang==="es"?"Cotizaciones":"Quotes",DollarSign],["applications",lang==="es"?"Aplicaciones":"Applications",ClipboardCheck],["notes",lang==="es"?"Notas":"Notes",FileText],["lifechange",lang==="es"?"Cambio de vida":"Life change",Repeat],["payment",lang==="es"?"Pagos":"Payment",CreditCard],["activity",t.activitylog.title,Activity],["history",histLabel,Clock],["comms",lang==="es"?"Mensajes":"Messages",MessageSquare],["surveys",lang==="es"?"Encuestas":"Surveys",ClipboardList]];
  const [quickEmail,setQuickEmail]=useState(false);
  const [quickSms,setQuickSms]=useState(false);
  const [quickWa,setQuickWa]=useState(false);
  const [showApplyTemplate,setShowApplyTemplate]=useState(false);
  const [showPortalModal,setShowPortalModal]=useState(false);
  const [showLifeChange,setShowLifeChange]=useState(false);
  const [showRenewalReview,setShowRenewalReview]=useState(false);
  const [showReferrals,setShowReferrals]=useState(false);
  // Los dos enlaces directos de la ficha (Lissette 2026-09-14): se elige AQUI
  // que se va a hacer y la otra pantalla se abre con este cliente ya puesto.
  const [elegirCotizador,setElegirCotizador]=useState(false);
  const [elegirPlantilla,setElegirPlantilla]=useState(false);
  const [qMsg,setQMsg]=useState("");
  const [quickSmsSending,setQuickSmsSending]=useState(false);
  const [smsThread,setSmsThread]=useState([]);
  const [smsThreadLoading,setSmsThreadLoading]=useState(false);
  // MMS images for the QUICK SMS modal (Lissette 2026-07-16: "agrega la
  // camarita al modal de arriba"). Same upload pipeline as the Messages tab.
  const [qSmsImgs,setQSmsImgs]=useState([]); // [{name,blobUrl,_preview}]
  const [qSmsUploading,setQSmsUploading]=useState(false);
  const qSmsImgRef=useRef(null);
  const addQSmsImages=async(files)=>{
    const imgs=[...files].filter(f=>f&&f.type&&f.type.startsWith('image/'));
    if(!imgs.length)return;
    if(qSmsImgs.length+imgs.length>3){toast.error(lang==="es"?"Máximo 3 imágenes por SMS.":"Max 3 images per SMS.");return;}
    setQSmsUploading(true);
    try{
      for(const f of imgs){
        const ref=await apiUploadNoteAttachment(f);
        setQSmsImgs(prev=>[...prev,{name:f.name||'imagen.png',blobUrl:ref.blobUrl,_preview:URL.createObjectURL(f)}]);
      }
    }catch(e){toast.error((lang==="es"?"No se pudo subir la imagen: ":"Image upload failed: ")+(e.message||e));}
    finally{setQSmsUploading(false);}
  };
  const loadSmsThread=()=>{
    if(!client?.id)return;
    setSmsThreadLoading(true);
    apiGetClientSmsThread(client.id)
      .then(msgs=>setSmsThread(Array.isArray(msgs)?msgs:[]))
      .catch(()=>setSmsThread([]))
      .finally(()=>setSmsThreadLoading(false));
  };
  useEffect(()=>{ if(quickSms)loadSmsThread(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ },[quickSms,client?.id]);
  const [quickEmailSending,setQuickEmailSending]=useState(false);
  const [qSubj,setQSubj]=useState("");
  const [showInsuredModal,setShowInsuredModal]=useState(false);
  const [quickCall,setQuickCall]=useState(false);
  return <div>
    <div style={{display:"flex",alignItems:"center",gap:".5rem",marginBottom:"1rem",flexWrap:"wrap"}}>
      <button onClick={onBack} className="dkt-btn-g"><ArrowLeft size={13}/>{t.common.back}</button>
      <button type="button" onClick={duplicarCliente} disabled={duplicando} className="dkt-btn-g"
        style={{marginLeft:"auto",cursor:duplicando?"wait":"pointer",opacity:duplicando?.6:1}}
        title={lang==="es"?"Crea una ficha nueva con los datos de esta persona":"Create a new record with this person's data"}>
        <Copy size={13}/>{duplicando?(lang==="es"?"Duplicando…":"Duplicating…"):(lang==="es"?"Duplicar":"Duplicate")}
      </button>
    </div>
    <div className="dkt-card" style={{padding:"1.1rem",marginBottom:"1rem"}}>
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex items-center gap-4">
          <div className="relative">
            <Avatar client={client} size={14}/>
            {hasBday&&<span className="absolute -top-1 -right-1 text-lg">🎂</span>}
          </div>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:".5rem",flexWrap:"wrap",position:"relative"}}>
              <h2 style={{fontFamily:"var(--font-display)",fontSize:"1.2rem",fontWeight:700,color:"var(--c-white,#eef6ff)",margin:0}}>{formatClientName(client)}</h2>
              <CopyBtn value={formatClientName(client)} label={lang==="es"?"el nombre":"name"} lang={lang} size={13}/>
              {/* Live presence — another teammate has this client open right now.
                  Pairs with the "no te piso" save guard so two people editing the
                  same client know about each other. */}
              {viewers.length > 0 && (
                <span title={lang==="es"?"Otra persona tiene esta ficha abierta ahora mismo":"Someone else has this client open right now"}
                  style={{display:"inline-flex",alignItems:"center",gap:5,fontSize:".68rem",fontWeight:700,background:"rgba(0,212,255,.12)",color:"#7fe3ff",border:"1px solid rgba(0,212,255,.45)",padding:".22rem .6rem",borderRadius:999,whiteSpace:"nowrap"}}>
                  <span style={{width:7,height:7,borderRadius:"50%",background:"#00d4ff",boxShadow:"0 0 6px #00d4ff",flexShrink:0}}/>
                  👁 {viewers.map(v=>v.name || (lang==="es"?"Alguien":"Someone")).join(", ")} {viewers.length>1 ? (lang==="es"?"están aquí":"are here") : (lang==="es"?"está aquí":"is here")}
                </span>
              )}
              {/* Clickable status badge — change active/inactive/prospect right
                  here without opening Edit. Narrow endpoint, no PHI round-trip. */}
              <div style={{position:"relative",display:"inline-flex"}}>
                <button type="button" onClick={()=>setStatusMenuOpen(o=>!o)} disabled={statusSaving}
                  title={lang==="es"?"Cambiar estado":"Change status"}
                  style={{background:"none",border:"none",padding:0,cursor:statusSaving?"wait":"pointer",display:"inline-flex",alignItems:"center",gap:3}}>
                  <Badge status={client.status} t={t}/>
                  <span style={{fontSize:".6rem",color:"var(--c-text3,#45688a)"}}>▾</span>
                </button>
                {statusMenuOpen && <div onClick={()=>setStatusMenuOpen(false)} style={{position:"fixed",inset:0,zIndex:39}}/>}
                {statusMenuOpen && (
                  <div style={{position:"absolute",top:"calc(100% + 5px)",left:0,zIndex:40,background:"var(--c-surface,#0d1c2e)",border:"1px solid var(--c-border,#1a3550)",borderRadius:10,boxShadow:"0 12px 40px rgba(0,0,0,.5)",padding:".3rem",minWidth:150}}>
                    {STATUS_OPTIONS.map(o=>(
                      <button key={o.id} type="button" onClick={()=>changeStatus(o.id)}
                        style={{display:"flex",alignItems:"center",gap:7,width:"100%",background:(client.status||"active")===o.id?"var(--c-surface2,#112538)":"none",border:"none",borderRadius:7,padding:".4rem .55rem",cursor:"pointer",fontFamily:"inherit",fontSize:".78rem",fontWeight:600,color:"var(--c-white,#eef6ff)",textAlign:"left"}}>
                        <span style={{width:8,height:8,borderRadius:"50%",background:o.color,flexShrink:0}}/>
                        {lang==="es"?o.es:o.en}
                        {(client.status||"active")===o.id&&<span style={{marginLeft:"auto",color:o.color,fontSize:".7rem"}}>✓</span>}
                      </button>
                    ))}
                    {/* Separada por una raya: las de arriba son excluyentes
                        entre sí, ésta se enciende ADEMÁS de la que haya. */}
                    <div style={{height:1,background:"var(--c-border,#1a3550)",margin:".3rem 0"}}/>
                    <button type="button" onClick={toggleReadyToSubmit} disabled={readySaving}
                      style={{display:"flex",alignItems:"center",gap:7,width:"100%",background:client.readyToSubmit?"var(--c-surface2,#112538)":"none",border:"none",borderRadius:7,padding:".4rem .55rem",cursor:readySaving?"wait":"pointer",fontFamily:"inherit",fontSize:".78rem",fontWeight:600,color:"var(--c-white,#eef6ff)",textAlign:"left",opacity:readySaving?.6:1}}>
                      <span style={{flexShrink:0}}>📤</span>
                      {lang==="es"?"Lista para someter":"Ready to submit"}
                      {client.readyToSubmit&&<span style={{marginLeft:"auto",color:"#14b8a6",fontSize:".7rem"}}>✓</span>}
                    </button>
                  </div>
                )}
              </div>
              {/* "Atiende" — the seat that owns this client (next to status).
                  Drives ticket auto-assignment + the clients filter. */}
              <AttendedChip
                value={client.attendedBySeatId || ''}
                nombreLibre={client.attendedByName || ''}
                seatLabels={seatLabels}
                users={users}
                lang={lang}
                canEditLabels={!_isSeat}
                onEditLabels={() => setSeatLabelsOpen(true)}
                /* Tocar el chip manda SIEMPRE: elegir un asiento (o "sin
                   asignar") borra el nombre suelto que dejo la importacion. */
                onChange={(seatId) => persistClientPatch({ attendedBySeatId: seatId || null, attendedByName: null })}
              />
              {seatLabelsOpen && (
                <SeatLabelsEditor seatLabels={seatLabels} users={users} lang={lang}
                  onChange={(next) => { if (onSeatLabelsChange) onSeatLabelsChange(next); }}
                  onClose={() => setSeatLabelsOpen(false)} />
              )}
              {/* (Language badge removed from the header — Lissette 2026-06-21:
                  "yo no dije que colocar el idioma allí, no lo quiero".) */}
              {/* Linked-parent chip — the "↗ <titular>" badge. Removable. */}
              {client.linkedParentName && (
                <span style={{fontSize:".62rem",background:"rgba(255,183,0,.12)",color:"var(--c-amber,#ffb700)",padding:".12rem .5rem .12rem .55rem",borderRadius:100,border:"1px solid rgba(255,183,0,.25)",fontWeight:700,display:"inline-flex",alignItems:"center",gap:4}}>
                  ↗ {client.linkedParentName}
                  <button type="button" onClick={clearLinkedParent} disabled={tagSaving} title={lang==="es"?"Quitar vínculo":"Remove link"} style={{background:"none",border:"none",color:"var(--c-amber,#ffb700)",cursor:"pointer",padding:0,fontSize:".7rem",lineHeight:1}}>✕</button>
                </span>
              )}
              {/* Referido por — automatica, como la de arriba (Lissette
                  2026-08-28). SIN la ✕ del vinculo de dependiente a proposito:
                  aquello es un vinculo suelto que se quita, esto es un dato de
                  la ficha y se cambia en sus propios campos. Una ✕ aqui
                  parecería que solo esconde la etiqueta y en realidad estaria
                  borrando quien lo refirio. */}
              {(() => {
                const quien = nombreDeQuienRefirio(client, (id) => (clients || []).find((x) => x.id === id));
                return quien ? (
                  <span title={lang === "es" ? `Referido por ${quien}` : `Referred by ${quien}`}
                    style={{fontSize:".62rem",background:"rgba(167,139,250,.12)",color:"#a78bfa",padding:".12rem .5rem .12rem .55rem",borderRadius:100,border:"1px solid rgba(167,139,250,.28)",fontWeight:700,display:"inline-flex",alignItems:"center",gap:4}}>
                    🔗 {lang === "es" ? "Referido por" : "Referred by"} {quien}
                    {canEditClient && (
                      <button type="button" onClick={clearReferidoPor} disabled={tagSaving}
                        title={lang === "es" ? "Quitar: borra de la ficha quién lo refirió, no solo la etiqueta" : "Remove: clears who referred them from the record, not just the tag"}
                        style={{background:"none",border:"none",color:"#a78bfa",cursor:"pointer",padding:0,fontSize:".7rem",lineHeight:1}}>✕</button>
                    )}
                  </span>
                ) : null;
              })()}
              {/* Custom tag chips. Removable. Colored from the agency tag map. */}
              {clientTags.map((tag)=>{ const _st=tagChipStyle(tagColorFor(tag,tagColors)); return (
                <span key={tag} style={{fontSize:".62rem",background:_st.bg,color:_st.fg,padding:".12rem .5rem .12rem .55rem",borderRadius:100,border:`1px solid ${_st.border}`,fontWeight:700,display:"inline-flex",alignItems:"center",gap:4}}>
                  {tag}
                  <button type="button" onClick={()=>removeTag(tag)} disabled={tagSaving} title={lang==="es"?"Quitar":"Remove"} style={{background:"none",border:"none",color:_st.fg,cursor:"pointer",padding:0,fontSize:".7rem",lineHeight:1,opacity:.8}}>✕</button>
                </span>
              );})}
              {/* Add button + popover */}
              <button type="button" onClick={()=>setTagPanelOpen(o=>!o)} title={lang==="es"?"Etiquetas y vínculo":"Tags & link"} style={{fontSize:".62rem",background:"var(--c-surface2,#112538)",color:"var(--c-text2,#7aa3c0)",padding:".12rem .5rem",borderRadius:100,border:"1px dashed var(--c-border,#1a3550)",fontWeight:700,cursor:"pointer"}}>
                🏷️ +
              </button>
              {tagPanelOpen && (
                <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,zIndex:40,width:320,maxWidth:"calc(100vw - 32px)",background:"var(--c-surface,#0d1c2e)",border:"1px solid var(--c-border,#1a3550)",borderRadius:12,boxShadow:"0 16px 50px rgba(0,0,0,.5)",padding:".85rem"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".6rem"}}>
                    <span style={{fontSize:".75rem",fontWeight:800,color:"var(--c-white,#eef6ff)"}}>🏷️ {lang==="es"?"Etiquetas y vínculo":"Tags & link"}</span>
                    <button type="button" onClick={()=>setTagPanelOpen(false)} style={{background:"none",border:"none",color:"var(--c-text3,#45688a)",cursor:"pointer",fontSize:".9rem"}}>✕</button>
                  </div>
                  {/* Custom tag input */}
                  <div style={{fontSize:".62rem",fontWeight:700,color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:".3rem"}}>{lang==="es"?"Etiqueta personalizada":"Custom tag"}</div>
                  <div style={{display:"flex",gap:".4rem",marginBottom:".5rem"}}>
                    <input
                      type="text"
                      value={tagInput}
                      onChange={(e)=>setTagInput(e.target.value)}
                      onKeyDown={(e)=>{ if(e.key==="Enter"){ e.preventDefault(); addTag(tagInput,newTagColor); } }}
                      placeholder={lang==="es"?'Ej. "VIP", "Renovación"':'e.g. "VIP", "Renewal"'}
                      maxLength={40}
                      style={{flex:1,padding:".4rem .6rem",borderRadius:7,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface2,#112538)",color:"var(--c-text,#c8dff0)",fontSize:".74rem",fontFamily:"inherit",outline:"none"}}
                    />
                    <button type="button" onClick={()=>addTag(tagInput,newTagColor)} disabled={tagSaving||!tagInput.trim()} style={{padding:".4rem .7rem",borderRadius:7,border:"none",background:"var(--c-cyan,#00d4ff)",color:"#06121f",fontWeight:800,fontSize:".72rem",cursor:tagInput.trim()?"pointer":"not-allowed",fontFamily:"inherit",opacity:tagInput.trim()?1:.5}}>
                      {lang==="es"?"Agregar":"Add"}
                    </button>
                  </div>
                  {/* Fluorescent color picker for the new tag (shared agency-wide
                      by tag name). "✕" = no color (default look); last = custom. */}
                  <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",gap:6,marginBottom:".8rem"}}>
                    <button type="button" title={lang==="es"?"Sin color":"No color"} onClick={()=>setNewTagColor('')}
                      style={{width:22,height:22,borderRadius:99,cursor:"pointer",background:"var(--c-surface2,#112538)",border:newTagColor===''?"2px solid var(--c-cyan,#00d4ff)":"1px solid var(--c-border,#1a3550)",color:"var(--c-text3,#45688a)",fontSize:11,lineHeight:1,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                    {TAG_FLUOR_COLORS.map((col)=>(
                      <button key={col} type="button" title={col} onClick={()=>setNewTagColor(col)}
                        style={{width:22,height:22,borderRadius:99,background:col,cursor:"pointer",border:(newTagColor||'').toLowerCase()===col?"2px solid var(--c-white,#eef6ff)":"1px solid rgba(255,255,255,.25)",boxShadow:`0 0 6px ${col}`}}/>
                    ))}
                    <label title={lang==="es"?"Color personalizado":"Custom color"}
                      style={{width:22,height:22,borderRadius:99,cursor:"pointer",border:"1px dashed var(--c-border,#1a3550)",overflow:"hidden",position:"relative",background:"conic-gradient(#ff1744,#ff9500,#ffea00,#39ff14,#00e5ff,#19b6ff,#b026ff,#ff2079,#ff1744)"}}>
                      <input type="color" value={/^#[0-9a-fA-F]{6}$/.test(newTagColor||'')?newTagColor:'#39ff14'} onChange={(e)=>setNewTagColor(e.target.value)}
                        style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:0,cursor:"pointer",border:"none",padding:0}}/>
                    </label>
                  </div>
                  {/* Reusable tags: click an already-created tag to apply it to
                      THIS client — no re-typing. Colored from the agency map. */}
                  {reusableTags.length>0 && (
                    <>
                      <div style={{fontSize:".62rem",fontWeight:700,color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:".3rem"}}>{lang==="es"?"Reusar etiqueta (clic para agregar · ✕ la quita de la lista)":"Reuse a tag (click to add · ✕ removes it from the list)"}</div>
                      <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:".8rem",maxHeight:120,overflowY:"auto"}}>
                        {reusableTags.map((tag)=>{ const _st=tagChipStyle(tagColorFor(tag,tagColors)); return (
                          <span key={tag} style={{display:"inline-flex",alignItems:"center",background:_st.bg,border:`1px solid ${_st.border}`,borderRadius:100,opacity:tagSaving?.6:1}}>
                            <button type="button" onClick={()=>addTag(tag)} disabled={tagSaving}
                              title={lang==="es"?`Agregar "${tag}"`:`Add "${tag}"`}
                              style={{fontSize:".62rem",background:"none",color:_st.fg,padding:".14rem .2rem .14rem .55rem",border:"none",fontWeight:700,cursor:tagSaving?"default":"pointer",display:"inline-flex",alignItems:"center",gap:4,fontFamily:"inherit"}}>
                              <span style={{fontSize:".62rem",lineHeight:1}}>＋</span>{tag}
                            </button>
                            {typeof onTagLibraryChange==="function" && (
                              <button type="button" onClick={()=>forgetTagFromLibrary(tag)} disabled={tagSaving}
                                title={lang==="es"?`Quitar "${tag}" de la lista de etiquetas`:`Remove "${tag}" from the tag list`}
                                style={{background:"none",border:"none",color:_st.fg,cursor:tagSaving?"default":"pointer",padding:".14rem .45rem .14rem .2rem",fontSize:".62rem",lineHeight:1,opacity:.55,fontFamily:"inherit"}}
                                onMouseEnter={(e)=>{e.currentTarget.style.opacity=1;e.currentTarget.style.color="var(--c-red,#ff3d6b)";}}
                                onMouseLeave={(e)=>{e.currentTarget.style.opacity=.55;e.currentTarget.style.color=_st.fg;}}>✕</button>
                            )}
                          </span>
                        );})}
                      </div>
                    </>
                  )}
                  {/* Recolor existing tags (agency-wide). Each row: tag + palette + clear. */}
                  {clientTags.length>0 && (
                    <>
                      <div style={{fontSize:".62rem",fontWeight:700,color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:".3rem"}}>{lang==="es"?"Color de cada etiqueta":"Color each tag"}</div>
                      <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:".8rem"}}>
                        {clientTags.map((tag)=>{ const _cur=tagColorFor(tag,tagColors); const _st=tagChipStyle(_cur); return (
                          <div key={tag} style={{display:"flex",flexWrap:"wrap",alignItems:"center",gap:5}}>
                            <span style={{fontSize:".62rem",background:_st.bg,color:_st.fg,padding:".1rem .5rem",borderRadius:100,border:`1px solid ${_st.border}`,fontWeight:700,maxWidth:130,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{tag}</span>
                            {TAG_FLUOR_COLORS.map((col)=>(
                              <button key={col} type="button" title={col} onClick={()=>applyTagColor(tag,col)}
                                style={{width:16,height:16,borderRadius:99,background:col,cursor:"pointer",border:(_cur||'').toLowerCase()===col?"2px solid var(--c-white,#eef6ff)":"1px solid rgba(255,255,255,.2)"}}/>
                            ))}
                            <button type="button" title={lang==="es"?"Sin color":"No color"} onClick={()=>applyTagColor(tag,'')}
                              style={{width:16,height:16,borderRadius:99,cursor:"pointer",background:"var(--c-surface2,#112538)",border:_cur?"1px solid var(--c-border,#1a3550)":"2px solid var(--c-cyan,#00d4ff)",color:"var(--c-text3,#45688a)",fontSize:9,lineHeight:1,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                          </div>
                        );})}
                      </div>
                    </>
                  )}
                  {/* Link as dependent of... */}
                  <div style={{fontSize:".62rem",fontWeight:700,color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:".3rem"}}>{lang==="es"?"Vincular como dependiente de":"Link as dependent of"}</div>
                  {client.linkedParentName ? (
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:".72rem",color:"var(--c-text,#c8dff0)",background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:7,padding:".4rem .6rem"}}>
                      <span>↗ {client.linkedParentName}</span>
                      <button type="button" onClick={clearLinkedParent} disabled={tagSaving} style={{background:"none",border:"none",color:"var(--c-red,#ef4444)",cursor:"pointer",fontSize:".68rem",fontWeight:700,fontFamily:"inherit"}}>{lang==="es"?"Quitar":"Remove"}</button>
                    </div>
                  ) : (
                    <>
                      <input
                        type="text"
                        value={linkSearch}
                        onChange={(e)=>setLinkSearch(e.target.value)}
                        placeholder={lang==="es"?"Buscar titular por nombre…":"Search head-of-household…"}
                        style={{width:"100%",padding:".4rem .6rem",borderRadius:7,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface2,#112538)",color:"var(--c-text,#c8dff0)",fontSize:".74rem",fontFamily:"inherit",outline:"none"}}
                      />
                      {linkSearch.trim().length >= 2 && (
                        <div style={{maxHeight:150,overflowY:"auto",marginTop:".4rem",border:"1px solid var(--c-border,#1a3550)",borderRadius:7}}>
                          {(clients||[]).filter((c)=>{
                            if(c.id===client.id) return false;
                            const q=linkSearch.toLowerCase().trim();
                            return `${c.firstName||""} ${c.lastName||""}`.toLowerCase().includes(q);
                          }).slice(0,15).map((c)=>(
                            <button key={c.id} type="button" onClick={()=>setLinkedParent(c)} disabled={tagSaving}
                              style={{display:"block",width:"100%",textAlign:"left",padding:".4rem .6rem",border:"none",borderBottom:"1px solid var(--c-border,#1a3550)",background:"transparent",color:"var(--c-text,#c8dff0)",cursor:"pointer",fontFamily:"inherit",fontSize:".72rem"}}
                              onMouseEnter={(e)=>e.currentTarget.style.background="var(--c-surface2,#112538)"}
                              onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}>
                              {c.firstName} {c.lastName}{c.email?` · ${c.email}`:""}
                            </button>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                  {/* Vincular REFERIDO — el mismo mecanismo que el de arriba
                      (Lissette 2026-08-28, con captura). Se elige de la lista
                      de clientes, no se escribe: asi queda el vinculo de
                      verdad y la etiqueta sigue al cliente si le corrigen el
                      apellido. */}
                  <div style={{fontSize:".62rem",fontWeight:700,color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".06em",margin:".7rem 0 .3rem"}}>{lang==="es"?"Vincular referido por":"Link referred by"}</div>
                  {nombreDeQuienRefirio(client,(id)=>(clients||[]).find(x=>x.id===id)) ? (
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:".72rem",color:"var(--c-text,#c8dff0)",background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:7,padding:".4rem .6rem"}}>
                      <span>🔗 {nombreDeQuienRefirio(client,(id)=>(clients||[]).find(x=>x.id===id))}</span>
                      <button type="button" onClick={clearReferidoPor} disabled={tagSaving}
                        title={lang==="es"?"Quita de la ficha quién lo refirió, no solo la etiqueta":"Removes who referred them from the record, not just the tag"}
                        style={{background:"none",border:"none",color:"var(--c-red,#ef4444)",cursor:"pointer",fontSize:".68rem",fontWeight:700,fontFamily:"inherit"}}>{lang==="es"?"Quitar":"Remove"}</button>
                    </div>
                  ) : (
                    <>
                      <input
                        type="text"
                        value={refSearch}
                        onChange={(e)=>setRefSearch(e.target.value)}
                        placeholder={lang==="es"?"Buscar quién lo refirió…":"Search who referred them…"}
                        style={{width:"100%",padding:".4rem .6rem",borderRadius:7,border:"1px solid var(--c-border,#1a3550)",background:"var(--c-surface2,#112538)",color:"var(--c-text,#c8dff0)",fontSize:".74rem",fontFamily:"inherit",outline:"none"}}
                      />
                      {refSearch.trim().length >= 2 && (
                        <div style={{maxHeight:150,overflowY:"auto",marginTop:".4rem",border:"1px solid var(--c-border,#1a3550)",borderRadius:7}}>
                          {(clients||[]).filter((c)=>{
                            // Nadie se refiere a si mismo: ofrecerlo solo sirve
                            // para crear un vinculo circular sin sentido.
                            if(c.id===client.id) return false;
                            const q=refSearch.toLowerCase().trim();
                            return `${c.firstName||""} ${c.lastName||""}`.toLowerCase().includes(q);
                          }).slice(0,15).map((c)=>(
                            <button key={c.id} type="button" onClick={()=>setReferidoPor(c)} disabled={tagSaving}
                              style={{display:"block",width:"100%",textAlign:"left",padding:".4rem .6rem",border:"none",borderBottom:"1px solid var(--c-border,#1a3550)",background:"transparent",color:"var(--c-text,#c8dff0)",cursor:"pointer",fontFamily:"inherit",fontSize:".72rem"}}
                              onMouseEnter={(e)=>e.currentTarget.style.background="var(--c-surface2,#112538)"}
                              onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}>
                              {c.firstName} {c.lastName}{c.email?` · ${c.email}`:""}
                            </button>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
            <div className="text-xs text-gray-400 mt-0.5">{client.addressCity&&`${client.addressCity}, `}{client.addressState}</div>
            {/* Agente asignado — editable label (default the owning agent; customs reusable) */}
            <div style={{display:'flex',alignItems:'center',gap:'.4rem',marginTop:'.45rem',flexWrap:'wrap'}}>
              <span style={{fontSize:'.6rem',fontWeight:800,color:'var(--c-text3,#45688a)',textTransform:'uppercase',letterSpacing:'.06em',whiteSpace:'nowrap'}}>👤 {lang==="es"?"Agente":"Agent"}</span>
              {canEditClient ? (
                <>
                  {assignedAgentCustom ? (
                    // Free-text escape hatch: type a brand-new name, save on blur.
                    <input value={assignedAgentDraft} disabled={assignedAgentSaving} autoFocus
                      onChange={e=>setAssignedAgentDraft(e.target.value)}
                      onBlur={saveAssignedAgent}
                      onKeyDown={e=>{ if(e.key==="Enter"){ e.preventDefault(); e.currentTarget.blur(); } }}
                      placeholder={lang==="es"?"Escribe un nombre":"Type a name"}
                      style={{fontSize:'.74rem',fontWeight:700,color:'var(--c-cyan,#00d4ff)',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:7,padding:'.2rem .55rem',outline:'none',minWidth:150,maxWidth:240,fontFamily:'inherit'}}/>
                  ) : (
                    // Dropdown that ALWAYS lists every teammate + previously-used name.
                    <select value={[...visibleAgentOptions, assignedAgentDraft].includes(assignedAgentDraft)?assignedAgentDraft:''} disabled={assignedAgentSaving}
                      onChange={e=>{ const v=e.target.value; if(v==="__custom__"){ setAssignedAgentCustom(true); setAssignedAgentDraft(''); return; } if(v==="__manage__"){ setAssignedAgentManage(true); return; } setAssignedAgentDraft(v); persistAssignedAgent(v); }}
                      style={{fontSize:'.74rem',fontWeight:700,color:'var(--c-cyan,#00d4ff)',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:7,padding:'.2rem .55rem',outline:'none',minWidth:150,maxWidth:260,fontFamily:'inherit',cursor:'pointer'}}>
                      <option value="">{lang==="es"?"— Sin asignar —":"— Unassigned —"}</option>
                      {[...new Set([...visibleAgentOptions, assignedAgentDraft].filter(Boolean))].sort((a,b)=>a.localeCompare(b)).map(a=><option key={a} value={a}>{a}</option>)}
                      <option value="__custom__">{lang==="es"?"✏️ Otro nombre…":"✏️ Other name…"}</option>
                      {deletableAgentNames.length>0 && <option value="__manage__">{lang==="es"?"🗑 Eliminar nombres…":"🗑 Delete names…"}</option>}
                    </select>
                  )}
                  {assignedAgentSaving&&<span style={{fontSize:'.62rem',color:'var(--c-text3,#45688a)'}}>{lang==="es"?"guardando…":"saving…"}</span>}
                  {assignedAgentManage && (
                    <div style={{flexBasis:'100%',marginTop:'.4rem',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:9,padding:'.55rem .65rem',maxWidth:320}}>
                      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'.4rem'}}>
                        <span style={{fontSize:'.66rem',fontWeight:800,color:'var(--c-text2,#7aa3c0)',textTransform:'uppercase',letterSpacing:'.05em'}}>{lang==="es"?"Eliminar nombres":"Delete names"}</span>
                        <button type="button" onClick={()=>setAssignedAgentManage(false)} style={{background:'none',border:'none',color:'var(--c-text3,#45688a)',fontSize:'.8rem',cursor:'pointer',lineHeight:1}}>✕</button>
                      </div>
                      {deletableAgentNames.length===0 ? (
                        <div style={{fontSize:'.68rem',color:'var(--c-text3,#45688a)',fontStyle:'italic'}}>{lang==="es"?"No hay nombres personalizados para eliminar.":"No custom names to delete."}</div>
                      ) : (
                        <div style={{display:'flex',flexDirection:'column',gap:'.3rem'}}>
                          {deletableAgentNames.map(name=>(
                            <div key={name} style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:'.5rem',background:'var(--c-surface,#0d1c2e)',border:'1px solid var(--c-border,#1a3550)',borderRadius:7,padding:'.25rem .5rem'}}>
                              <span style={{fontSize:'.74rem',fontWeight:600,color:'var(--c-text,#c8dff0)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{name}</span>
                              <button type="button" onClick={()=>deleteAgentName(name)} title={lang==="es"?"Eliminar":"Delete"} style={{flexShrink:0,background:'rgba(255,61,107,.12)',border:'1px solid rgba(255,61,107,.3)',color:'var(--c-red,#ff3d6b)',fontSize:'.66rem',fontWeight:700,borderRadius:6,padding:'.15rem .45rem',cursor:'pointer'}}>🗑 {lang==="es"?"Eliminar":"Delete"}</button>
                            </div>
                          ))}
                        </div>
                      )}
                      <div style={{fontSize:'.6rem',color:'var(--c-text3,#45688a)',marginTop:'.4rem',lineHeight:1.3}}>{lang==="es"?"Solo nombres escritos a mano. Los agentes y asientos del equipo no se pueden borrar aquí.":"Hand-typed names only. Team agents and seats can't be deleted here."}</div>
                    </div>
                  )}
                </>
              ) : (
                <span style={{fontSize:'.74rem',fontWeight:700,color:'var(--c-cyan,#00d4ff)'}}>{client.assignedAgent||client.agentName||'—'}</span>
              )}
            </div>
          </div>
        </div>
        <div style={{display:'flex',gap:'.4rem',flexWrap:'wrap'}}>
          {client.email&&<button onClick={()=>setQuickEmail(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(0,212,255,.1)',border:'1px solid rgba(0,212,255,.2)',color:'var(--c-cyan,#00d4ff)',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}}>
            <Mail size={13}/>Email</button>}
          {client.phone&&<button onClick={()=>setQuickCall(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(16,185,129,.14)',border:'1px solid rgba(16,185,129,.4)',color:'#10b981',fontSize:'.74rem',fontWeight:700,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Llamar y anotar en la ficha":"Call & take notes on the profile"}>
            <Phone size={13}/>{lang==="es"?"Llamar":"Call"}</button>}
          {client.phone&&<button onClick={()=>setQuickSms(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(0,255,136,.08)',border:'1px solid rgba(0,255,136,.18)',color:'var(--c-green,#00ff88)',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}}>
            <Phone size={13}/>SMS</button>}
          {client.phone&&<button onClick={()=>setQuickWa(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(37,211,102,.1)',border:'1px solid rgba(37,211,102,.3)',color:'#25d366',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Abrir WhatsApp con el mensaje listo":"Open WhatsApp pre-filled"}>
            <MessageSquare size={13}/>WhatsApp</button>}
          {/* El boton "Plantilla" sale de la ficha por pedido de Lissette
              (2026-09-02), junto con la entrada "Plantillas" del menu. El
              modal sigue en el archivo y `showApplyTemplate` tambien: es un
              boton menos, no un modulo desmontado. */}
          {canQuote && <button onClick={()=>setElegirCotizador(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(250,204,21,.1)',border:'1px solid rgba(250,204,21,.32)',color:'#facc15',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Abrir el cotizador con los datos de este cliente":"Open the quoter with this client's data"}>
            <DollarSign size={13}/>{lang==="es"?"Cotizar":"Quote"}</button>}
          {canSign && <button onClick={()=>setElegirPlantilla(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(129,140,248,.12)',border:'1px solid rgba(129,140,248,.34)',color:'#a5b4fc',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Pedirle una firma a este cliente":"Ask this client for a signature"}>
            <PenTool size={13}/>{lang==="es"?"Pedir firma":"Signature"}</button>}
          {/* Inscribir en HealthSherpa con este cliente ya elegido (Lissette
              2026-10-28). Los asientos no ven esa pantalla en el menú, así que
              tampoco el botón: llevarlos a una vista que no tienen los mandaría
              de vuelta sin explicación. */}
          {!_isSeat && <button onClick={()=>irAInscribirEnHealthSherpa({cliente:client})} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(244,63,94,.1)',border:'1px solid rgba(244,63,94,.32)',color:'#fb7185',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Abrir Inscribir en HealthSherpa con este cliente":"Open Enroll in HealthSherpa with this client"}>
            <HeartPulse size={13}/>HealthSherpa</button>}
          <button onClick={()=>setShowPortalModal(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(16,185,129,.1)',border:'1px solid rgba(16,185,129,.3)',color:'#10b981',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Acceso al portal del cliente":"Client portal access"}>
            <ExternalLink size={13}/>{lang==="es"?"Portal":"Portal"}</button>
          <button onClick={()=>setShowLifeChange(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(168,85,247,.1)',border:'1px solid rgba(168,85,247,.28)',color:'#c084fc',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Pedirle los documentos de un cambio de vida (boda, hijo, mudanza, perdida de cobertura)":"Ask for life-change documents (marriage, birth, move, loss of coverage)"}>
            <RefreshCw size={13}/>{lang==="es"?"Cambio de vida":"Life change"}</button>
          <button onClick={()=>setShowRenewalReview(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(0,212,255,.1)',border:'1px solid rgba(0,212,255,.3)',color:'#00b8e6',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Crear link de revisión de renovación":"Create renewal review link"}>
            <ClipboardCheck size={13}/>{lang==="es"?"Renovación":"Renewal"}</button>
          {canEditClient && <button onClick={onEditClient} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',color:'var(--c-text,#c8dff0)',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}}>
            <Edit2 size={13}/>{t.common.edit}</button>}
          <button onClick={()=>setShowReferrals(true)} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'rgba(245,158,11,.1)',border:'1px solid rgba(245,158,11,.3)',color:'#f59e0b',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Referidos que nos dio este cliente":"Referrals this client gave us"}>
            <Gift size={13}/>{lang==="es"?"Referido":"Referrals"}</button>
          <button onClick={()=>printClientFicha(client,policies,docs,lang,{agencyName:currentUser?.agency?.name||currentUser?.agencyName,agentName:presentingAgentName(currentUser),
            // Lissette 2026-05-27: cae a user.companyLogo (el data-URL que
            // ella sube en Mi Perfil) para que su logo cargado funcione en la
            // impresion sin volver a Mi Agencia → Marca. La cadena vive en
            // marcaDeLaAgencia.js: era una copia suelta, y por no tenerla
            // tambien en Nomina el recibo de pago salio sin logo (2026-09-03).
            agencyLogoUrl:marcaDeLaAgencia(currentUser).logo})} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',color:'var(--c-text2,#7aa3c0)',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Imprimir Ficha":"Print Profile"}>
            <FileText size={13}/>{lang==="es"?"Imprimir":"Print"}</button>
          <button onClick={()=>{
            const c=client;
            const es=lang==="es";
            // Everything from the ficha (Lissette 2026-06-19 #10): spouse details,
            // ALL dependents with their DOB, plan names + policy detail, the full
            // address broken out, member IDs, etc. — not just counts.
            const sp=c.spouse||{};
            const deps=Array.isArray(c.dependents)?c.dependents:[];
            const cPols=(policies||[]).filter(p=>p.clientId===c.id);
            const depStr=deps.map(d=>`${d.firstName||""} ${d.lastName||""}`.trim()+` (${d.relation||"-"}${d.dob?", "+(es?"nac. ":"DOB ")+d.dob:""})`).join("; ");
            const polStr=cPols.map(p=>`${(getPolicyType(p.type)||{}).label||p.type}: ${p.plan?p.plan+" — ":""}${p.carrier||""} #${p.policyNumber||""}${p.memberId?" MID:"+p.memberId:""} $${p.monthlyPremium||0}/mo (${p.status||""})`).join("; ");
            const planNames=[...new Set(cPols.map(p=>p.plan).filter(Boolean))].join(", ");
            const carriers=[...new Set(cPols.map(p=>p.carrier).filter(Boolean))].join(", ");
            const data=[{
              [es?"Nombre":"First Name"]:c.firstName||"",
              [es?"Apellido":"Last Name"]:c.lastName||"",
              [es?"Teléfono":"Phone"]:c.phone||"",
              Email:c.email||"",
              [es?"Fecha Nac.":"DOB"]:c.dob||"",
              SSN:c.ssnMasked||(c.hasSsn?"***-**-****":""),
              Status:c.status||"",
              [es?"Calle":"Street"]:c.addressStreet||c.address||"",
              [es?"Ciudad":"City"]:c.addressCity||c.city||"",
              [es?"Estado":"State"]:c.addressState||c.state||"",
              ZIP:c.addressZip||c.zipCode||"",
              [es?"Condado":"County"]:c.county||"",
              [es?"Idioma":"Language"]:c.preferredLang||c.preferredLanguage||"",
              [es?"Estado Civil":"Marital"]:c.maritalStatus||"",
              [es?"Estatus Migratorio":"Immigration"]:c.immigrationStatus||"",
              [es?"Ingresos":"Income"]:c.annualIncome||"",
              [es?"Empleador":"Employer"]:c.employer||"",
              [es?"Tamaño Hogar":"Household"]:c.householdSize||"",
              [es?"Asegurados":"Insured"]:countInsuredMembers(c),
              [es?"Cónyuge Nombre":"Spouse First"]:sp.firstName||"",
              [es?"Cónyuge Apellido":"Spouse Last"]:sp.lastName||"",
              [es?"Cónyuge Tel.":"Spouse Phone"]:sp.phone||"",
              [es?"Cónyuge Fecha Nac.":"Spouse DOB"]:sp.dob||"",
              [es?"Cónyuge Empleador":"Spouse Employer"]:sp.employer||"",
              [es?"Cónyuge Ingresos":"Spouse Income"]:sp.income||"",
              [es?"# Dependientes":"# Dependents"]:deps.length,
              [es?"Dependientes (con Fecha Nac.)":"Dependents (with DOB)"]:depStr,
              [es?"Compañías":"Carriers"]:carriers,
              [es?"Nombre(s) del Plan":"Plan Name(s)"]:planNames,
              [es?"Pólizas (detalle)":"Policies (detail)"]:polStr,
              [es?"# Pólizas":"# Policies"]:cPols.length,
              [es?"Pólizas Activas":"Active Policies"]:cPols.filter(p=>p.status==="active").length,
              [es?"Prima Total/Mes":"Total Premium/Mo"]:cPols.reduce((s,p)=>s+(parseFloat(p.monthlyPremium)||0),0),
              [es?"Creado":"Created"]:c.createdAt||"",
              [es?"Notas":"Notes"]:c.notes||"",
            }];
            exportToExcel(data,`${(c.firstName||"client").replace(/[^\w]/g,"_")}_${(c.lastName||"").replace(/[^\w]/g,"_")}.xlsx`,"Client");
          }} style={{display:'flex',alignItems:'center',gap:'.35rem',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',color:'var(--c-text2,#7aa3c0)',fontSize:'.74rem',fontWeight:600,padding:'.4rem .75rem',borderRadius:8,cursor:'pointer',transition:'all .2s'}} title={lang==="es"?"Descargar Excel":"Download Excel"}>
            <Download size={13}/> Excel</button>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:".5rem",marginBottom:".875rem",marginTop:".5rem"}}>
        {[
          {icon:Phone,v:client.phone||"--",lbl:lang==="es"?"el teléfono":"phone",tel:true},
          {icon:Mail,v:client.email||"--",lbl:lang==="es"?"el email":"email"},
          // La edad, entre parentesis, pegada a la fecha (Lissette 2026-08-26).
          // Era el unico sitio donde la del TITULAR no salia: en el formulario
          // de cliente ya la llevan los tres. Se usa `ageFromDob` y no el
          // `getAge` de este archivo porque aquel valida — el de aqui pintaria
          // "(NaN)" con una fecha rota, y eso en la cabecera de la ficha se lee
          // como que el CRM se equivoco con el cliente.
          //
          // Comentario de JS, NO `{/* */}`: esto es un ARRAY de objetos, no
          // hijos JSX, y ahi las llaves rompen el build.
          {icon:Calendar,v:client.dob?`${fmt(client.dob)}${ageFromDob(client.dob)!==null?` (${ageFromDob(client.dob)})`:""}`:"--",lbl:lang==="es"?"la fecha de nacimiento":"date of birth"},
          {icon:Building,v:[client.addressStreet||client.address,client.addressCity||client.city,client.addressState||client.state,client.addressZip||client.zipCode].filter(Boolean).join(", ")||"--",lbl:lang==="es"?"la dirección":"address"},
        ].map(({icon:Icon,v,lbl,tel},i)=><div key={i} style={{display:"flex",alignItems:"center",gap:6,minWidth:0}}><Icon size={12} style={{color:"var(--c-text3,#45688a)",flexShrink:0}}/><span style={{fontSize:".78rem",color:"var(--c-text,#c8dff0)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{/* El teléfono se puede llamar con un clic (Lissette 2026-08-26). El botón de "Llamar y anotar" de arriba sigue siendo el camino completo — con notas y resultado —; esto es el atajo para cuando solo hace falta marcar. */}{tel?<PhoneText value={v}/>:v}</span><CopyBtn value={v} label={lbl} lang={lang} size={11}/></div>)}
      </div>
      {/* Pills section is now always rendered when the client has an id —
          previously it was gated on having at least one populated field,
          which meant a brand-new client without any pill data hid the
          SSN field entirely (it shouldn't, since SSN should be
          discoverable even when "not on file"). */}
      {client.id && (
        <div style={{borderTop:"1px solid var(--c-border,#1a3550)",paddingTop:".75rem",marginTop:".75rem",display:"flex",flexWrap:"wrap",gap:".5rem"}}>
          {(()=>{ const _pl=(client.preferredLanguage||client.preferredLang||"").toString().toLowerCase(); const _es=_pl==="es"||_pl==="spanish"; return (
          <div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🗣️ {lang==="es"?"IDIOMA":"LANGUAGE"}</span>
            <span style={{fontSize:".8rem",fontWeight:700,color:"var(--c-white,#eef6ff)"}}>{_es?(lang==="es"?"Español":"Spanish"):(lang==="es"?"Inglés":"English")}</span>
          </div>); })()}
          {client.maritalStatus&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>💍 {lang==="es"?"ESTADO CIVIL":"MARITAL STATUS"}</span>
            <span style={{fontSize:".8rem",fontWeight:700,color:"var(--c-white,#eef6ff)"}}>{auditValueLabel("maritalStatus",String(client.maritalStatus||"").toLowerCase(),lang)}</span>
          </div>}
          {client.householdSize&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🏠 {lang==="es"?"FAMILIA":"FAMILY"}</span>
            <span style={{fontSize:".8rem",fontWeight:700,color:"var(--c-white,#eef6ff)"}}>{client.householdSize} {lang==="es"?"personas":"people"}</span>
          </div>}
          
          {client.annualIncome&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>💵 {lang==="es"?"INGRESOS":"INCOME"}</span>
            <span style={{fontSize:".8rem",fontWeight:700,color:"var(--c-green,#00ff88)"}}>{client.annualIncome}</span>
            {/* Con otros ingresos (un segundo trabajo, 2026-10-27) se dice
                cuantos y el total del titular, para no leer solo el principal. */}
            {Array.isArray(client.otrosIngresos)&&client.otrosIngresos.length>0&&<span
              title={client.otrosIngresos.map(f=>[f.monto,f.empleador].filter(Boolean).join(" · ")).join("\n")}
              style={{fontSize:".7rem",color:"var(--c-text2,#7aa3c0)"}}>
              + {client.otrosIngresos.length} {lang==="es"?(client.otrosIngresos.length===1?"otro":"otros"):(client.otrosIngresos.length===1?"other":"others")} = <b style={{color:"var(--c-green,#00ff88)"}}>{dineroLegible(ingresoTotalDePersona(client.annualIncome, client.otrosIngresos))}</b>
            </span>}
          </div>}
          {hasHouseholdIncome&&<div style={{background:"rgba(0,255,136,.08)",border:"1px solid rgba(0,255,136,.18)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}} title={lang==="es"?"Suma de ingresos del titular, cónyuge y dependientes. Si solo gana una persona, el hogar es ese mismo ingreso.":"Sum of primary, spouse and dependents' income. If only one person earns, the household is that same income."}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🏠 {lang==="es"?"INGRESOS HOGAR":"HOUSEHOLD INCOME"}</span>
            <span style={{fontSize:".8rem",fontWeight:800,color:"var(--c-green,#00ff88)"}}>{fmtMoney(householdIncome)}</span>
          </div>}
          {client.county&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🏛️ {lang==="es"?"CONDADO":"COUNTY"}</span>
            <span style={{fontSize:".78rem",fontWeight:600,color:"var(--c-text,#c8dff0)"}}>{client.county}</span>
          </div>}
          {client.immigrationStatus&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🌐 {lang==="es"?"ESTATUS":"STATUS"}</span>
            <span style={{fontSize:".78rem",fontWeight:600,color:"var(--c-text,#c8dff0)"}}>{client.immigrationStatus.replace(/_/g," ").replace(/\b\w/g,l=>l.toUpperCase())}</span>
          </div>}
          {client.employer&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🏢 {lang==="es"?"EMPLEADOR":"EMPLOYER"}</span>
            <span style={{fontSize:".78rem",fontWeight:600,color:"var(--c-text,#c8dff0)"}}>{client.employer}{client.employerPhone?` · ☎️ ${client.employerPhone}`:""}</span>
          </div>}
          {!client.employer&&client.employerPhone&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>☎️ {lang==="es"?"TEL. EMPLEADOR":"EMPLOYER PHONE"}</span>
            <span style={{fontSize:".78rem",fontWeight:600,color:"var(--c-text,#c8dff0)"}}>{client.employerPhone}</span>
          </div>}
          {/* F4 — Expanded ficha (read-only display). The data is entered in
              the Edit form's 🏥 Salud/Legal tab; these pills surface it on the
              profile so it's visible without opening Edit. */}
          {/* BIRTH + LICENSE son datos GENERALES → se muestran aquí. Las pills
              de salud/legal (físico, DUI, felonía, médico, hist. familiar)
              NO van en el encabezado — viven en la pestaña Health/Life
              (Lissette 2026-05-28). */}
          {client.placeOfBirth&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🌍 {lang==="es"?"PAÍS NAC.":"BIRTH"}</span>
            <span style={{fontSize:".78rem",fontWeight:600,color:"var(--c-text,#c8dff0)"}}>{client.placeOfBirth}</span>
          </div>}
          {client.driverLicenseState&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🪪 {lang==="es"?"LICENCIA":"LICENSE"}</span>
            <span style={{fontSize:".78rem",fontWeight:600,color:"var(--c-text,#c8dff0)"}}>{client.driverLicenseState}{client.driverLicenseNumber?` · ${client.driverLicenseNumber}`:""}</span>
          </div>}
          {immDocsText(client.immigrationDocs,lang==="es")&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🛂 {lang==="es"?"DOC. MIGRATORIO":"IMM. DOCS"}</span>
            <span style={{fontSize:".78rem",fontWeight:600,color:"var(--c-text,#c8dff0)"}}>{immDocsText(client.immigrationDocs,lang==="es")}</span>
          </div>}
          {/* SSN pill. Renders in three states so the agent always knows
              where they stand:
                - has SSN + decrypted OK → masked + "VER" button → PIN
                  modal on click.
                - has SSN + decrypt failed → masked unavailable + ⚠
                  warning. Click still opens the PIN modal (in case
                  the PIN-gated reveal path uses a different code
                  path than the bulk decrypt).
                - no SSN on file → empty placeholder + "Agregar" → opens
                  the client edit form. Previously this case was hidden
                  entirely, which is how Lissette didn't realize a
                  client's SSN was missing for weeks (2026-05-14). */}
          {client.hasSsn && client.ssnMasked ? (
            <button type="button" onClick={() => setSsnRevealOpen(true)} style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5,cursor:"pointer"}} title={lang==="es"?"Click para mostrar el SSN completo (requiere PIN)":"Click to reveal the full SSN (PIN required)"}>
              <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🔒 SSN</span>
              <span style={{fontSize:".78rem",fontWeight:700,color:"var(--c-white,#eef6ff)",fontFamily:"var(--font-mono)"}}>{client.ssnMasked}</span>
              <span style={{fontSize:".55rem",color:"var(--c-cyan,#00d4ff)",fontFamily:"var(--font-mono)",marginLeft:3}}>{lang==="es"?"VER":"SHOW"}</span>
            </button>
          ) : client.hasSsn && client.ssnDecryptError ? (
            <button type="button" onClick={() => setSsnRevealOpen(true)} style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.3)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5,cursor:"pointer"}} title={lang==="es"?"SSN guardado pero no se pudo descifrar para mostrar el mask. Click para intentar con PIN.":"SSN stored but couldn't be decrypted for masked display. Click to try via PIN."}>
              <span style={{fontSize:".62rem",color:"var(--c-red,#ef4444)",fontFamily:"var(--font-mono)"}}>⚠ SSN</span>
              <span style={{fontSize:".7rem",fontWeight:600,color:"var(--c-red,#ef4444)"}}>{lang==="es"?"Error de descifrado":"Decrypt error"}</span>
              <span style={{fontSize:".55rem",color:"var(--c-cyan,#00d4ff)",fontFamily:"var(--font-mono)",marginLeft:3}}>{lang==="es"?"INTENTAR":"RETRY"}</span>
            </button>
          ) : client.hasSsn ? (
            /* SSN IS on file but no masked value yet — happens when the
               client was just created/imported or comes straight from
               the paginated list (those responses carry `hasSsn` but
               not `ssnMasked`, which only the audited GET /:id decrypt
               produces). Previously this fell through to the "sin
               agregar" state and the pill LIED about a stored SSN.
               Clicking opens the PIN reveal modal (audited decrypt). */
            <button type="button" onClick={() => setSsnRevealOpen(true)} style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5,cursor:"pointer"}} title={lang==="es"?"SSN guardado. Click para mostrarlo (requiere PIN).":"SSN on file. Click to reveal (PIN required)."}>
              <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🔒 SSN</span>
              <span style={{fontSize:".78rem",fontWeight:700,color:"var(--c-white,#eef6ff)",fontFamily:"var(--font-mono)"}}>•••-••-••••</span>
              <span style={{fontSize:".55rem",color:"var(--c-cyan,#00d4ff)",fontFamily:"var(--font-mono)",marginLeft:3}}>{lang==="es"?"VER":"SHOW"}</span>
            </button>
          ) : (
            <button type="button" onClick={() => onEditClient && onEditClient()} style={{background:"var(--c-surface2,#112538)",border:"1px dashed var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5,cursor:"pointer",opacity:.7}} title={lang==="es"?"Click para agregar el SSN del cliente":"Click to add the client's SSN"}>
              <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>🔒 SSN</span>
              <span style={{fontSize:".7rem",fontWeight:500,color:"var(--c-text3,#45688a)",fontStyle:"italic"}}>{lang==="es"?"sin agregar":"not on file"}</span>
              <span style={{fontSize:".55rem",color:"var(--c-cyan,#00d4ff)",fontFamily:"var(--font-mono)",marginLeft:3}}>{lang==="es"?"+ AGREGAR":"+ ADD"}</span>
            </button>
          )}
          {client.dependents&&client.dependents.length>0&&<div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,padding:".35rem .65rem",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:".62rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>👨‍👩‍👧 {lang==="es"?"DEPENDIENTES":"DEPENDENTS"}</span>
            <span style={{fontSize:".8rem",fontWeight:700,color:"var(--c-white,#eef6ff)"}}>{client.dependents.length}</span>
          </div>}
          {/* The old inbound "🤝 REFERIDO {who referred this client}" chip was
              removed 2026-06-17. "Referido" now means OUTBOUND (the referrals
              this client gave us) via the 🎁 button next to Print. The chip was
              also orphaned — its referredBy* data is no longer editable since
              the editor tab was removed, so leftover values were stuck on
              screen with no way to clear them. The data stays in the DB
              (preserved) but is no longer surfaced on the profile. */}
        </div>
      )}
      <div style={{display:"flex",flexWrap:"wrap",alignItems:"center",gap:".75rem",paddingTop:".875rem",borderTop:"1px solid var(--c-border,#1a3550)",marginTop:".875rem"}}>
        <div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:9,padding:".5rem .875rem"}}>
          <div style={{fontSize:".6rem",color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".08em",fontFamily:"var(--font-mono)"}}>{lang==="es"?"Pólizas Activas":"Active Policies"}</div>
          <div style={{fontFamily:"var(--font-display)",fontSize:"1.4rem",fontWeight:800,color:"var(--c-cyan,#00d4ff)",lineHeight:1.1}}>{clientPolicies.filter(p=>p.status==="active").length}</div>
        </div>
        <div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:9,padding:".5rem .875rem"}}>
          <div style={{fontSize:".6rem",color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".08em",fontFamily:"var(--font-mono)"}}>{lang==="es"?"Prima/mes":"Premium/mo"}</div>
          <div style={{fontFamily:"var(--font-display)",fontSize:"1.4rem",fontWeight:800,color:"var(--c-green,#00ff88)",lineHeight:1.1}}>{/* Con pólizas activas, $0 es una prima de verdad (plan con
            subsidio completo) y se escribe "$0.00", no "--" (ticket 2026-10-12). */}
            {clientPolicies.some(p=>p.status==="active") ? fmtMoneyZero(totalPremium) : fmtMoney(totalPremium)}</div>
        </div>
        {/* Miembros asegurados POR POLIZA, al lado de la prima (Lissette
            2026-10-02: "no el total sino por poliza, es decir Salud 4, Life 2").
            Al dia siguiente lo afino: POR TIPO DE SEGURO, no por poliza: "si hay
            dos de salud colocalo todo en salud, la suma, y al final coloca total".
            Cada poliza que sigue viva se cuenta con aseguradosDeLaPoliza (la
            MISMA regla del boton "Asegurados" de la tarjeta, E-296/E-339/E-342),
            se suma dentro de su tipo, y el Total es la suma de todo lo de la caja.
            Se agrupa por el ramo de pantalla (p.type), en el orden en que
            aparecen las polizas. */}
        {/* Solo las que YA empezaron (2026-11-04): la renovación que entra el
            1 de enero contaba a la familia dos veces. Si todas son futuras
            (cliente nuevo que empieza en enero), se cuentan esas: mejor eso
            que una caja vacía. Ver polizaYaEnVigor. */}
        {(() => {
          const noCanceladas = clientPolicies.filter(p => !esEstatusCancelado(p.status));
          const enVigor = noCanceladas.filter(p => polizaYaEnVigor(p));
          const vivas = enVigor.length ? enVigor : noCanceladas;
          if (!vivas.length) return null;
          const porTipo = new Map();
          vivas.forEach(p => {
            const gente = aseguradosDeLaPoliza(p, client, client.dependents || []);
            const t = porTipo.get(p.type) || { pt: getPolicyType(p.type), n: 0, nombres: [] };
            t.n += gente.length;
            t.nombres.push(...gente.map(g => g.name));
            porTipo.set(p.type, t);
          });
          const tipos = [...porTipo.entries()];
          const total = tipos.reduce((s, [, t]) => s + t.n, 0);
          const cifra = {fontFamily:"var(--font-display)",fontSize:"1.15rem",fontWeight:800,color:"var(--c-white,#eef6ff)"};
          const etiqueta = {fontSize:".74rem",color:"var(--c-text2,#7aa3c0)",fontWeight:600};
          return <div style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:9,padding:".5rem .875rem"}}>
            <div style={{fontSize:".6rem",color:"var(--c-text3,#45688a)",textTransform:"uppercase",letterSpacing:".08em",fontFamily:"var(--font-mono)"}}>{lang==="es"?"Miembros por tipo de seguro":"Members by insurance type"}</div>
            <div style={{display:"flex",flexWrap:"wrap",alignItems:"baseline",gap:".3rem .9rem",marginTop:".2rem"}}>
              {tipos.map(([tipo, t]) => (
                <span key={tipo} title={t.nombres.join(", ")} style={{display:"inline-flex",alignItems:"baseline",gap:".3rem",whiteSpace:"nowrap"}}>
                  <span style={etiqueta}>{t.pt.icon} {lang==="es"?t.pt.labelEs:t.pt.label}</span>
                  <span style={cifra}>{t.n}</span>
                </span>
              ))}
              <span style={{display:"inline-flex",alignItems:"baseline",gap:".3rem",whiteSpace:"nowrap",paddingLeft:".9rem",borderLeft:"1px solid var(--c-border,#1a3550)"}}>
                <span style={{...etiqueta,color:"var(--c-cyan,#00d4ff)",textTransform:"uppercase",letterSpacing:".06em"}}>{lang==="es"?"Total":"Total"}</span>
                <span style={{...cifra,color:"var(--c-cyan,#00d4ff)"}}>{total}</span>
              </span>
            </div>
          </div>;
        })()}
        <div style={{display:"flex",gap:4,flexWrap:"wrap",alignItems:"center"}}>
          {/* Show an icon for every NON-cancelled policy (pending + active),
              matching the Policies tab list (which uses status!=="cancelled").
              Filtering to status==="active" wrongly hid Pending policies
              (Lissette 2026-06-23: "me sale solo una y tengo 2"); the only
              ones she wants hidden here are the cancelled ones. */}
          {clientPolicies.filter(p=>p.status!=="cancelled").map(p=>{ const pt=getPolicyType(p.type); return <span key={p.id} title={lang==="es"?pt.labelEs:pt.label} style={{fontSize:20}}>{pt.icon}</span>; })}
        </div>
      </div>
    </div>
    {/* "Cotizar" — se elige el tipo de cotizacion aqui y Cotizaciones se abre
        con este cliente puesto. El del Mercado abre ademas el buscador de
        planes, que se rellena con el ZIP, el ingreso y el hogar de la ficha. */}
    {elegirCotizador&&<Modal title={`💰 ${lang==="es"?"Cotizar para":"Quote for"} ${client.firstName||""} ${client.lastName||""}`.trim()} onClose={()=>setElegirCotizador(false)}>
      <div style={{display:'flex',flexDirection:'column',gap:'.6rem'}}>
        <div style={{fontSize:'.74rem',color:'var(--c-text2,#7aa3c0)',lineHeight:1.5}}>
          {lang==="es"
            ?"Elige qué vas a cotizar. Se abre Cotizaciones con este cliente ya puesto y el título escrito."
            :"Pick what you're quoting. Quotes opens with this client already filled in and a title written."}
        </div>
        <div style={{display:'grid',gap:'.4rem',maxHeight:340,overflowY:'auto'}}>
          {opcionesDeCotizacion(lang).map(o=>(
            <button key={o.id} type="button" onClick={()=>{setElegirCotizador(false);irACotizar({opcionId:o.id,cliente:client,lang});}}
              style={{display:'flex',flexDirection:'column',alignItems:'flex-start',gap:2,textAlign:'left',background:'var(--c-surface2,#112538)',border:`1px solid ${o.nota?'rgba(250,204,21,.35)':'var(--c-border,#1a3550)'}`,borderRadius:9,padding:'.5rem .7rem',cursor:'pointer',fontFamily:'inherit'}}>
              <span style={{fontSize:'.82rem',fontWeight:700,color:o.nota?'#facc15':'var(--c-text,#e7f1f8)'}}>{o.label}</span>
              {o.nota&&<span style={{fontSize:'.68rem',color:'var(--c-text3,#45688a)'}}>{o.nota}</span>}
            </button>
          ))}
        </div>
      </div>
    </Modal>}
    {/* "Pedir firma" — se elige la plantilla aqui y el modal de envio de Firmas
        se abre con este cliente. Si la agencia no tiene ninguna plantilla se
        dice y se ofrece ir a crearla, en vez de un cuadro vacio. */}
    {elegirPlantilla&&(()=>{
      const plantillas=opcionesDePlantilla(docTemplates,lang);
      return <Modal title={`✍️ ${lang==="es"?"Pedir firma a":"Signature from"} ${client.firstName||""} ${client.lastName||""}`.trim()} onClose={()=>setElegirPlantilla(false)}>
        <div style={{display:'flex',flexDirection:'column',gap:'.6rem'}}>
          <div style={{fontSize:'.74rem',color:'var(--c-text2,#7aa3c0)',lineHeight:1.5}}>
            {lang==="es"
              ?"Elige la plantilla. Se abre Firmas con el documento y este cliente ya puestos — solo revisas y envías."
              :"Pick the template. Signatures opens with the document and this client already filled in — review and send."}
          </div>
          {plantillas.length===0?(
            <div style={{display:'flex',flexDirection:'column',gap:'.5rem'}}>
              <div style={{fontSize:'.78rem',color:'var(--c-text,#e7f1f8)'}}>
                {lang==="es"?"Todavía no hay plantillas de firma.":"There are no signature templates yet."}</div>
              <button type="button" onClick={()=>{setElegirPlantilla(false);irAFirmas();}} className="dkt-btn">
                {lang==="es"?"Ir a Firmas → Plantillas":"Go to Signatures → Templates"}</button>
            </div>
          ):(
            <div style={{display:'grid',gap:'.4rem',maxHeight:340,overflowY:'auto'}}>
              {plantillas.map(o=>(
                <button key={o.id} type="button" onClick={()=>{setElegirPlantilla(false);irAFirmar({templateId:o.id,cliente:client});}}
                  style={{display:'flex',alignItems:'center',gap:'.5rem',textAlign:'left',background:'var(--c-surface2,#112538)',border:'1px solid var(--c-border,#1a3550)',borderRadius:9,padding:'.5rem .7rem',cursor:'pointer',fontFamily:'inherit'}}>
                  <span style={{fontSize:'.9rem'}}>{o.icono}</span>
                  <span style={{fontSize:'.82rem',fontWeight:700,color:'var(--c-text,#e7f1f8)'}}>{o.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </Modal>;
    })()}
    {quickEmail&&<Modal title={`Email -> ${client.firstName} ${client.lastName}`} onClose={()=>{setQuickEmail(false);setQMsg("");setQSubj("");}}>
      <div style={{display:'flex',flexDirection:'column',gap:'.875rem'}}>
        <div><label className="dkt-input-lbl">To</label><input className="dkt-inp" value={client.email} readOnly/></div>
        <div><label className="dkt-input-lbl">Subject</label><input className="dkt-inp" value={qSubj} onChange={e=>setQSubj(e.target.value)} placeholder={`Hi ${client.firstName}, regarding your policy...`}/></div>
        <div><label className="dkt-input-lbl">Message</label><textarea className="dkt-inp" rows={5} value={qMsg} onChange={e=>setQMsg(e.target.value)} style={{resize:'none'}} placeholder={`Hi ${client.firstName},\n`}/></div>
        <div className="dkt-phase">📬 {lang==="es"?"Se envía desde el correo de tu agencia. El cliente puede responder directo a ese correo.":"Sent from your agency email. The client can reply directly to it."}</div>
        <div style={{display:'flex',gap:'.5rem'}}>
          <button disabled={!qMsg.trim()||quickEmailSending} onClick={async()=>{
            if(!qMsg.trim()){toast.error(lang==="es"?"Escribe un mensaje.":"Write a message.");return;}
            if(!client.email){toast.error(lang==="es"?"El cliente no tiene correo registrado.":"Client has no email on file.");return;}
            const subject=qSubj.trim()||(lang==="es"?"Mensaje de tu agente":"A message from your agent");
            const esc=(s)=>String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
            // Sin <div pre-wrap>: el correo lo ignora y llega todo pegado. El servidor
            // convierte los saltos en parrafos (ensureHtmlParagraphs).
            const html=esc(qMsg);
            const doSend=(ack)=>apiSendClientEmail(client.id,{subject,html,text:qMsg,acknowledgePhi:ack});
            setQuickEmailSending(true);
            try{
              await doSend(false);
              toast.success(lang==="es"?"Correo enviado":"Email sent");
              setQuickEmail(false);setQMsg("");setQSubj("");
            }catch(err){
              if(err?.code==='phi'){
                const ok=await confirmDialog({title:lang==="es"?"Posible info sensible":"Possible sensitive info",message:lang==="es"?"Se detectó posible información sensible (PHI) en el correo. ¿Enviar de todos modos?":"Possible sensitive info (PHI) detected. Send anyway?",danger:true,confirmLabel:lang==="es"?"Enviar":"Send"});
                if(ok){ try{ await doSend(true); toast.success(lang==="es"?"Correo enviado":"Email sent"); setQuickEmail(false);setQMsg("");setQSubj(""); }catch(e2){ toast.error((lang==="es"?"No se pudo enviar: ":"Failed to send: ")+String(e2?.message||e2)); } }
              } else {
                const m=String(err?.message||err);
                if(/mailbox connected|no-integration/i.test(m)) toast.error(lang==="es"?"Conecta tu correo (Gmail u Outlook) en \"Mi Correo\" para enviar. Por ahora puedes usar Copiar.":"Connect your email (Gmail/Outlook) under \"My Email\" to send. For now you can use Copy.");
                else toast.error((lang==="es"?"No se pudo enviar: ":"Failed to send: ")+m);
              }
            }finally{setQuickEmailSending(false);}
          }} className="dkt-btn-p" style={{flex:1,background:'linear-gradient(135deg,#0284c7,#0ea5e9)',opacity:(!qMsg.trim()||quickEmailSending)?.6:1}}><Send size={14}/>{quickEmailSending?(lang==="es"?"Enviando...":"Sending..."):(lang==="es"?"Enviar Email":"Send Email")}</button>
          <button onClick={()=>{navigator.clipboard?.writeText(`To: ${client.email}\nSubject: ${qSubj}\n${qMsg}`).catch(()=>{});toast.success(lang==="es"?"¡Copiado!":"Copied!");}} className="dkt-btn-s" title={lang==="es"?"Copiar":"Copy"}><Copy size={14}/></button>
          <button onClick={()=>setQuickEmail(false)} className="dkt-btn-s">{t.common.cancel}</button>
        </div>
      </div>
    </Modal>}
    {quickSms&&<Modal title={`SMS -> ${client.firstName} ${client.lastName}`} onClose={()=>{setQuickSms(false);setQMsg("");setQSmsImgs([]);}}>
      <div style={{display:'flex',flexDirection:'column',gap:'.875rem'}}>
        <div><label className="dkt-input-lbl">{lang==="es"?"Teléfono":"Phone"}</label><input className="dkt-inp" value={client.phone} readOnly/></div>
        <div>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:4}}>
            <label className="dkt-input-lbl" style={{margin:0}}>{lang==="es"?"Conversación":"Conversation"}</label>
            <button type="button" onClick={loadSmsThread} title={lang==="es"?"Actualizar":"Refresh"} style={{background:'none',border:'none',color:'var(--c-text3,#45688a)',cursor:'pointer',fontSize:'.85rem',lineHeight:1}}>↻</button>
          </div>
          <div style={{maxHeight:'30vh',overflowY:'auto',display:'flex',flexDirection:'column',gap:6,padding:'.55rem',background:'var(--c-surface,#0d1c2e)',border:'1px solid var(--c-border,#1a3550)',borderRadius:8}}>
            {smsThreadLoading&&smsThread.length===0?(
              <div style={{fontSize:'.75rem',color:'var(--c-text3,#45688a)',textAlign:'center',padding:'.5rem'}}>{lang==="es"?"Cargando...":"Loading..."}</div>
            ):smsThread.length===0?(
              <div style={{fontSize:'.75rem',color:'var(--c-text3,#45688a)',textAlign:'center',padding:'.5rem'}}>{lang==="es"?"Aún no hay mensajes con este cliente. Las respuestas del cliente aparecerán aquí.":"No messages with this client yet. Client replies will show here."}</div>
            ):smsThread.map(m=>{
              const out=m.direction==='outbound';
              return (
                <div key={m.id} style={{alignSelf:out?'flex-end':'flex-start',maxWidth:'82%',background:out?'rgba(0,255,136,.12)':'var(--c-surface2,#112538)',border:`1px solid ${out?'rgba(0,255,136,.25)':'var(--c-border,#1a3550)'}`,borderRadius:10,padding:'.4rem .6rem'}}>
                  {Array.isArray(m.media)&&m.media.length>0&&<div style={{display:'flex',gap:4,flexWrap:'wrap',marginBottom:m.body?4:0}}>
                    {m.media.map((u,i)=><a key={i} href={u} target="_blank" rel="noopener noreferrer"><img src={u} alt="" style={{width:90,height:90,objectFit:'cover',borderRadius:6,display:'block'}}/></a>)}
                  </div>}
                  <div style={{fontSize:'.8rem',color:'var(--c-white,#eef6ff)',whiteSpace:'pre-wrap',wordBreak:'break-word'}}>{m.body}</div>
                  <div style={{fontSize:'.58rem',color:'var(--c-text3,#45688a)',marginTop:2,textAlign:out?'right':'left'}}>{out?(lang==="es"?"Tú":"You"):(lang==="es"?"Cliente":"Client")} · {new Date(m.createdAt).toLocaleString(lang==="es"?"es":"en-US",{month:'short',day:'numeric',hour:'2-digit',minute:'2-digit'})}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div><label className="dkt-input-lbl">{lang==="es"?"Escribe un mensaje":"Write a message"}</label><textarea className="dkt-inp" rows={3} value={qMsg} onChange={e=>setQMsg(e.target.value)}
          onPaste={(e)=>{const items=[...(e.clipboardData?.items||[])].filter(it=>it.type&&it.type.startsWith("image/"));if(items.length){e.preventDefault();addQSmsImages(items.map(it=>it.getAsFile()).filter(Boolean));}}}
          style={{resize:'none'}} placeholder={lang==="es"?`Hola ${client.firstName}, le contacto sobre su póliza...`:`Hi ${client.firstName}, reaching out about your policy...`}/></div>
        {/* MMS: attach / paste images (max 3) — same pipeline as the Messages tab */}
        <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
          <input ref={qSmsImgRef} type="file" accept="image/*" multiple style={{display:'none'}}
            onChange={e=>{const fs=Array.from(e.target.files||[]);e.target.value="";if(fs.length)addQSmsImages(fs);}}/>
          <button type="button" onClick={()=>qSmsImgRef.current&&qSmsImgRef.current.click()} disabled={qSmsUploading} className="dkt-btn-s"
            title={lang==="es"?"Adjuntar imagen (MMS) — también puedes pegar con Ctrl+V":"Attach image (MMS) — you can also paste with Ctrl+V"}>
            {qSmsUploading?"⏳":"📷"} {lang==="es"?"Imagen":"Image"}
          </button>
          {qSmsImgs.map((im,i)=>(
            <div key={i} style={{position:'relative',width:44,height:44,borderRadius:8,overflow:'hidden',border:'1px solid var(--c-border,#1a3550)'}}>
              <img src={im._preview} alt={im.name} style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}}/>
              <button type="button" onClick={()=>setQSmsImgs(prev=>prev.filter((_,j)=>j!==i))}
                style={{position:'absolute',top:1,right:1,width:15,height:15,borderRadius:'50%',border:'none',background:'rgba(0,0,0,.7)',color:'#fca5a5',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',padding:0,fontSize:10,lineHeight:1}}>×</button>
            </div>
          ))}
        </div>
        <div style={{fontSize:'.7rem',color:'var(--c-text3,#45688a)',fontFamily:'var(--font-mono)'}}>{qMsg.length}/160 {lang==="es"?"caracteres":"chars"}</div>
        <div className="dkt-phase">📱 {lang==="es"?'Se envía desde tu proveedor conectado en "SMS y Llamadas".':'Sent from your connected provider under "SMS & Calls".'}</div>
        <div style={{display:'flex',gap:'.5rem'}}>
          <button disabled={(!qMsg.trim()&&qSmsImgs.length===0)||quickSmsSending} onClick={async()=>{
            if(!qMsg.trim()&&qSmsImgs.length===0)return; // text OR image (MMS)
            if(!client.phone){toast.error(lang==="es"?"El cliente no tiene teléfono registrado.":"Client has no phone on file.");return;}
            setQuickSmsSending(true);
            try{
              await apiSendClientSms(client.id,{message:qMsg.trim(),mediaUrls:qSmsImgs.map(i=>i.blobUrl)});
              toast.success(lang==="es"?(qSmsImgs.length?"SMS con imagen enviado":"SMS enviado"):(qSmsImgs.length?"SMS with image sent":"SMS sent"));
              setQMsg("");setQSmsImgs([]);loadSmsThread();
            }catch(err){
              const msg=String(err?.message||err);
              if(msg==='no-integration')toast.error(lang==="es"?'Conecta un proveedor (SignalWire, Twilio o RingCentral) en "SMS y Llamadas" primero.':'Connect a provider (SignalWire, Twilio or RingCentral) in "SMS & Calls" first.');
              else toast.error((lang==="es"?"No se pudo enviar: ":"Failed to send: ")+msg);
            }finally{setQuickSmsSending(false);}
          }} className="dkt-btn-p" style={{flex:1,background:'linear-gradient(135deg,#059669,#065f46)',opacity:((!qMsg.trim()&&qSmsImgs.length===0)||quickSmsSending)?.6:1}}><Send size={14}/>{quickSmsSending?(lang==="es"?"Enviando...":"Sending..."):(lang==="es"?"Enviar SMS":"Send SMS")}</button>
          <button onClick={()=>{navigator.clipboard?.writeText(qMsg).catch(()=>{});toast.success(lang==="es"?"¡Copiado!":"Copied!");}} className="dkt-btn-s" title={lang==="es"?"Copiar mensaje":"Copy message"}><Copy size={14}/></button>
          <button onClick={()=>setQuickSms(false)} className="dkt-btn-s">{t.common.cancel}</button>
        </div>
      </div>
    </Modal>}
    {quickCall&&<CallNoteModal client={client} lang={lang} onClose={()=>setQuickCall(false)} onSave={async(text)=>{
      const isApi=typeof window!=="undefined"&&!!window.__deskteAuth;
      let created=null;
      // Saving is sacred: without the try/catch a rejected create (403 for a
      // seat missing notes.edit, scope 404) escaped the modal with NO error UI
      // — the note just looked saved and was gone on reload (audit 2026-07-31).
      if(isApi){
        try{ created=await apiCreateNote({clientId:client.id,text}); }
        catch(err){ toast.error((lang==="es"?"No se pudo guardar la nota de llamada: ":"Couldn't save the call note: ")+(err?.message||"")); return; }
      }
      const note={id:created?.id||Math.random().toString(36).slice(2,9),clientId:client.id,text,authorId:currentUser?.id||"",authorName:currentUser?.name||(lang==="es"?"Usuario":"User"),createdAt:new Date().toISOString(),...(created||{})};
      onClientNotesChange&&onClientNotesChange(prev=>{
        const arr=prev||[];
        return arr.some(x=>x.id===note.id)?arr.map(x=>x.id===note.id?{...x,...note}:x):[note,...arr];
      });
      toast.success(lang==="es"?"Nota de llamada guardada en la ficha":"Call note saved to the profile");
    }}/>}
    {quickWa&&<Modal title={`WhatsApp -> ${client.firstName} ${client.lastName}`} onClose={()=>{setQuickWa(false);setQMsg("");}}>
      <div style={{display:'flex',flexDirection:'column',gap:'.875rem'}}>
        <div><label className="dkt-input-lbl">{lang==="es"?"Teléfono":"Phone"}</label><input className="dkt-inp" value={client.phone} readOnly/></div>
        <div><label className="dkt-input-lbl">{lang==="es"?"Mensaje WhatsApp":"WhatsApp message"}</label><textarea className="dkt-inp" rows={4} value={qMsg} onChange={e=>setQMsg(e.target.value)} style={{resize:'none'}} placeholder={lang==="es"?`Hola ${client.firstName}, le contacto sobre su póliza...`:`Hi ${client.firstName}, reaching out about your policy...`}/></div>
        <div className="dkt-phase">💬 {lang==="es"?'Se abre WhatsApp Web/app con el mensaje listo; tú lo envías desde tu número. La extensión guarda la conversación.':'Opens WhatsApp Web/app pre-filled; you send it from your number. The extension saves the conversation.'}</div>
        <div style={{display:'flex',gap:'.5rem'}}>
          <button disabled={!client.phone} onClick={()=>{
            if(!client.phone){toast.error(lang==="es"?"El cliente no tiene teléfono registrado.":"Client has no phone on file.");return;}
            // openWhatsApp usa la extensión (cambia de chat en la pestaña ya
            // abierta, sin abrir una nueva por cliente) si está instalada; si
            // no, abre WhatsApp Web en una pestaña fija como respaldo.
            const ok=openWhatsApp(client.phone,qMsg.trim());
            if(!ok){toast.error(lang==="es"?"Número de teléfono inválido.":"Invalid phone number.");return;}
            toast.success(lang==="es"?"Abriendo WhatsApp…":"Opening WhatsApp…");
            setQuickWa(false);setQMsg("");
          }} className="dkt-btn-p" style={{flex:1,background:'linear-gradient(135deg,#25d366,#128c7e)'}}><MessageSquare size={14}/>{lang==="es"?"Abrir WhatsApp":"Open WhatsApp"}</button>
          <button onClick={()=>{navigator.clipboard?.writeText(qMsg).catch(()=>{});toast.success(lang==="es"?"¡Copiado!":"Copied!");}} className="dkt-btn-s" title={lang==="es"?"Copiar mensaje":"Copy message"}><Copy size={14}/></button>
          <button onClick={()=>setQuickWa(false)} className="dkt-btn-s">{t.common.cancel}</button>
        </div>
      </div>
    </Modal>}
    <div style={{display:"flex",flexWrap:"wrap",gap:".4rem",marginBottom:"1rem",paddingBottom:2}}>
      {TABS.filter(([id])=>id!=="payment"||canSeePayments).map(([id,label,Icon])=>{
        const badge = tabBadges[id]||0;
        // The eligibility badge is a persistent "pending docs" count, so show it
        // even while that tab is active (#16); other tabs hide on active.
        const showBadge = badge > 0 && (tab !== id || id === "eligibility");
        return <button key={id} onClick={()=>setTab(id)} className={`dkt-tab${tab===id?" on":""}`} style={{display:"flex",alignItems:"center",gap:".4rem",whiteSpace:"nowrap"}}>
          <Icon size={13}/>{label}
          {showBadge && <span style={{background:"#ffb700",color:"#1a2332",borderRadius:"9999px",padding:"1px 7px",fontSize:".6rem",fontWeight:800,fontFamily:"var(--font-mono)",lineHeight:1.3,marginLeft:".25rem",boxShadow:"0 0 6px rgba(255,183,0,.4)"}} aria-label={lang==="es"?`${badge} nuevos`:`${badge} new`}>{badge > 99 ? "99+" : badge}</span>}
        </button>;
      })}
    </div>
    <div className="dkt-card" style={{padding:"1.25rem"}}>
      {tab==="alerts"&&(()=>{
        const es = lang==="es";
        const allAlerts = [];
        // `isDep` gates the "turning 26" alert. Aging off a parent's
        // plan at 26 only applies to a child dependent — a primary
        // client or a spouse turning 26 is meaningless noise (Lissette
        // asked for the 26 alert ONLY on dependents).
        const addPA = (dob, name, rel, isDep) => {
          if(!dob) return;
          const dBday = daysUntilBirthday(dob);
          const d65 = willTurnAge(dob, 65);
          const d26 = willTurnAge(dob, 26);
          // Birthday — ONLY 1 day before and on the day
          if(dBday === 1) allAlerts.push({ cat:"bday", icon:"🎂", msg: es ? `¡Mañana es el cumpleaños de ${name}${rel?` (${rel})`:""} — cumple ${getAge(dob)+1}!` : `${name}${rel?` (${rel})`:""}'s birthday is TOMORROW — turns ${getAge(dob)+1}!`, color:"#f472b6", urgent:true, days:1 });
          if(dBday === 0) allAlerts.push({ cat:"bday", icon:"🎉", msg: es ? `¡Hoy cumple años ${name}${rel?` (${rel})`:""} — cumple ${getAge(dob)+1}!` : `Today is ${name}${rel?` (${rel})`:""}'s birthday — turns ${getAge(dob)+1}!`, color:"#f472b6", urgent:false, days:0 });
          // Turning 26 — dependents only (ages off the parent's plan).
          if(isDep && d26!==null && d26>0 && d26<=365) allAlerts.push({ cat:"age26", icon:"⚠️", tag:es?"MODIFICAR PLAN":"MODIFY PLAN", msg:`${name} ${rel?`(${rel})`:""} ${es?"cumplirá 26 en":"turns 26 in"} ${d26} ${es?"días":"days"} — ${es?"Se sale del plan":"Ages off parent's plan"}`, color:"#fbbf24", urgent:d26<=90, days:d26 });
          // Turning 65 - 365 days
          if(d65!==null && d65>0 && d65<=365 && d65>90) allAlerts.push({ cat:"age65", icon:"🏥", tag:"MEDICARE", msg:`${name} ${rel?`(${rel})`:""} ${es?"cumplirá 65 en":"will turn 65 in"} ${d65} ${es?"días":"days"}`, color:"#00d4ff", urgent:false, days:d65 });
          // Turning 65 - 90 days URGENT
          if(d65!==null && d65>0 && d65<=90) allAlerts.push({ cat:"age65u", icon:"🚨", tag:es?"MEDICARE URGENTE":"MEDICARE URGENT", msg:`¡${name} ${rel?`(${rel})`:""} ${es?"cumple 65 en":"turns 65 in"} ${d65} ${es?"días! — Inscribir en Medicare AHORA":"days! — Enroll in Medicare NOW"}`, color:"#ff3d6b", urgent:true, days:d65 });
        };
        addPA(client.dob, `${client.firstName} ${client.lastName}`, null, false);
        if(client.spouse?.dob && client.spouse.firstName) addPA(client.spouse.dob, `${client.spouse.firstName} ${client.spouse.lastName||client.lastName}`, es?"cónyuge":"spouse", false);
        (client.dependents||[]).forEach(dep => { if(dep.dob && dep.firstName) addPA(dep.dob, `${dep.firstName} ${dep.lastName||client.lastName}`, dep.relation || (es ? "dependiente" : "dependent"), true); });
        // Renewals
        //
        // El plazo lo manda Perfil -> Preferencias -> Avisos, y puede ser
        // distinto por tipo de poliza. Estaba clavado en 90 dias: el modulo de
        // Renovaciones ya obedecia la preferencia desde el 2026-08-25 y ESTA
        // pantalla seguia con los 90 de siempre, asi que la misma poliza
        // aparecia avisada en un sitio y no en el otro — sin que nada lo
        // explicara. Es la misma regla y el mismo lector (`renewalWindowDays`,
        // en crm-app/utils.js), para que no puedan volver a separarse.
        //
        // Ese lector distingue "no configurado" de "configurado en 30": a quien
        // nunca haya entrado en Preferencias le siguen saliendo los 90 de
        // siempre, no los 30 del valor por defecto del sistema.
        policies.filter(p=>p.clientId===client.id).forEach(p=>{
          const d=daysUntil(p.renewalDate); const pt=getPolicyType(p.type);
          const plazo=renewalWindowDays(userPrefs,p.type,90);
          if(d!==null&&d>=0&&d<=plazo) allAlerts.push({ cat:"renewal", icon:pt.icon, msg:`${es?"Renovación":"Renewal"}: ${es?pt.labelEs:pt.label} — ${es?"en":"in"} ${d} ${es?"días":"days"}`, color:"#ffb700", urgent:d<=14, days:d });
        });
        // Eligibility document alerts
        (eligibilityAlerts||[]).filter(ea=>ea.clientId===client.id&&ea.status==="pending").forEach(ea=>{
          const docName=es?ea.doc:(ea.docEn||ea.doc);
          // No deadline → still surface it (Lissette 2026-06-21 #16: el badge de la
          // pestaña Elegibilidad salía pero en la pestaña Alertas no).
          if(!ea.deadline){ allAlerts.push({ cat:"eligibility", icon:"📋", tag:es?"ELEGIBILIDAD":"ELIGIBILITY", msg:`${docName} — ${es?"documento solicitado (pendiente)":"requested document (pending)"}`, color:"#ffb700", urgent:false, days:9999 }); return; }
          const [y,m,d2]=ea.deadline.split("-").map(Number);
          const target=new Date(y,m-1,d2); const today=new Date(); today.setHours(0,0,0,0);
          const dd=Math.ceil((target-today)/(1000*60*60*24));
          const isOverdue=dd<0;
          allAlerts.push({ cat:"eligibility", icon:isOverdue?"🚨":"📋", tag:es?"ELEGIBILIDAD":"ELIGIBILITY", msg:isOverdue?`${docName} — ${es?"VENCIDO hace":"OVERDUE by"} ${Math.abs(dd)} ${es?"días":"days"}`:`${docName} — ${es?"en":"in"} ${dd} ${es?"días":"days"} (${fmt(ea.deadline)})`, color:isOverdue?"#ff3d6b":dd<=14?"#ffb700":"#00d4ff", urgent:isOverdue||dd<=14, days:isOverdue?-1:dd });
        });
        // Requested documents (document requests / "solicitudes"). Surface every
        // outstanding request's docs here, linked by clientId, so the agent sees
        // pending paperwork on the client's own profile. The request status is
        // the source of truth: pending/partial/expired = still outstanding;
        // "completed" = every requested file was uploaded via the portal, so we
        // hide it. (documentsNeeded keeps the full list even when partially
        // fulfilled, so we can't single out the exact missing one — listing the
        // set is the honest reflection.)
        (requests||[]).filter(r=>r.clientId===client.id&&r.status!=="completed").forEach(req=>{
          const expired = req.status==="expired";
          (req.docs||[]).forEach(d=>{
            const nm = d.name || (es?"Documento":"Document");
            allAlerts.push({ cat:"docrequest", icon:expired?"🚨":"📄", tag:es?"SOLICITUD":"REQUEST", msg:expired?`${es?"Documento solicitado":"Requested document"}: ${nm} — ${es?"link VENCIDO":"link EXPIRED"}`:`${es?"Documento solicitado":"Requested document"}: ${nm} — ${es?"pendiente":"pending"}`, color:expired?"#ff3d6b":"#ffb700", urgent:expired, days:expired?-1:0 });
          });
        });
        const sorted = allAlerts.sort((a,b)=>{ if(a.urgent&&!b.urgent) return -1; if(!a.urgent&&b.urgent) return 1; return (a.days||999)-(b.days||999); });
        return <div>
          <div style={{fontSize:'.8rem',fontWeight:700,color:'var(--c-white,#eef6ff)',marginBottom:'.75rem'}}>{es?"Alertas y Recordatorios":"Alerts & Reminders"} ({sorted.length})</div>
          {sorted.length===0&&<div style={{textAlign:'center',padding:'2rem',color:'var(--c-text3,#45688a)',fontSize:'.8rem'}}>✅ {es?"Sin alertas":"No alerts"}</div>}
          <div style={{display:'flex',flexDirection:'column',gap:'.4rem'}}>
            {sorted.map((a,i)=>(
              <div key={i} style={{display:'flex',alignItems:'center',gap:'.6rem',padding:'.65rem .85rem',borderRadius:10,
                background:a.urgent?'rgba(255,61,107,.06)':'var(--c-surface2,#112538)',
                border:`1px solid ${a.urgent?'rgba(255,61,107,.18)':'var(--c-border,#1a3550)'}`,
                borderLeft:`3px solid ${a.color}`}}>
                <span style={{fontSize:16,flexShrink:0}}>{a.icon}</span>
                <div style={{flex:1}}>
                  <div style={{fontSize:'.8rem',color:a.urgent?a.color:'var(--c-text,#c8dff0)',fontWeight:a.urgent?700:500,lineHeight:1.4}}>{a.msg}</div>
                  {a.tag&&<span style={{display:'inline-block',marginTop:3,fontSize:'.52rem',padding:'1px 6px',borderRadius:4,fontWeight:800,fontFamily:'var(--font-mono)',letterSpacing:'.06em',background:`${a.color}18`,color:a.color,border:`1px solid ${a.color}30`}}>{a.tag}</span>}
                </div>
                {a.cat==="bday"&&(client.email||client.phone)&&<div style={{display:'flex',gap:3,flexShrink:0}}>{CHANNEL_BTNS.map(ch=><button key={ch.id} onClick={()=>{const tpl=EMAIL_TEMPLATE_DEFAULTS.find(t2=>t2.id==="et4");const subj=(es?tpl.subjectEs:tpl.subject).replace(/\{\{firstName\}\}/g,client.firstName);const body=(es?tpl.bodyEs:tpl.body).replace(/\{\{firstName\}\}/g,client.firstName).replace(/\{\{agentName\}\}/g,presentingAgentName(currentUser));sendGreeting(ch.id,client,subj,body,lang);}} title={ch.id} style={{padding:'3px 6px',background:`${ch.color}18`,border:`1px solid ${ch.color}30`,color:ch.color,fontSize:'.75rem',borderRadius:5,cursor:'pointer',lineHeight:1}}>{ch.icon}</button>)}</div>}
              </div>
            ))}
          </div>
        </div>;
      })()}
      {tab==="policies"&&(()=>{
        // Cancelled policies are tucked into a collapsed sub-section so the
        // active ones (the day-to-day) stay clean and up top. A policy is
        // "cancelled" when its status id is 'cancelled' (legacy LAPSED/EXPIRED/
        // INACTIVE already map to 'cancelled' in mapPolicyFromApi); everything
        // else — including custom agency statuses — counts as active.
        const activePolicies=clientPolicies.filter(p=>p.status!=="cancelled");
        const cancelledPolicies=clientPolicies.filter(p=>p.status==="cancelled");
        const renderPolicyBlock=(p)=>(
          <div key={p.id} style={{marginBottom:".5rem"}}>
            <PolicyCard policy={p} lang={lang} t={t} onEdit={canEditPolicies ? setPolicyModal : undefined} onCopy={canEditPolicies ? (pol=>{ setPolicyPrefill(copiaDePoliza(pol)); setPolicyModal("add"); }) : undefined} onDelete={canEditPolicies ? (id=>setDeletePolicy(id)) : undefined} onMove={(canEditPolicies&&isApiMode) ? (pol=>setMovPol(pol)) : undefined} onSendKit={(canEditPolicies&&isApiMode) ? (pol=>sendKit(pol)) : undefined} onUpdateInsured={canEditPolicies ? updatePolicyInsured : undefined} sendingKit={sendingKitId===p.id} dependents={client?.dependents||[]} client={client}
              onUpdateTags={canEditPolicies ? updatePolicyTags : undefined} policyTagLibrary={policyTagLibrary} onPolicyTagLibraryChange={onPolicyTagLibraryChange}
              policyTagColors={policyTagColors} onPolicyTagColorsChange={onPolicyTagColorsChange}
              paymentStatus={payStatusOf(p.id)} paymentPeriod={fmtMonth(payPeriod)} onSetPaymentStatus={(canEditPolicies&&isApiMode) ? setPolicyPaymentStatus : undefined} currentUserId={currentUser?.id}/>
          </div>
        );
        return <>
          {/* Las inscripciones de HealthSherpa de este cliente, ANTES de sus
              pólizas: cuando abres a alguien para llamarlo, lo primero que
              quieres saber es si su inscripción salió y con qué número
              (Lissette, 2026-11-03). Se pinta solo si tiene alguna. */}
          <ClientHealthSherpa clientId={client.id} lang={lang}/>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:".75rem"}}>
            <h3 className="font-bold text-gray-900">{t.policies.title}</h3>
            {canEditPolicies && <button onClick={()=>setPolicyModal("add")} className="flex items-center gap-1.5 px-3 py-2 bg-blue-600 hover:bg-blue-500 text-gray-900 text-xs font-semibold rounded-xl"><Plus size={14}/>{t.policies.addPolicy}</button>}
          </div>
          {clientPolicies.length===0&&<div className="text-center py-8 text-gray-400">{t.policies.noPolcies}</div>}
          {activePolicies.length===0&&cancelledPolicies.length>0&&<div className="text-center py-4 text-gray-400" style={{fontSize:".8rem"}}>{lang==="es"?"No hay pólizas activas.":"No active policies."}</div>}
          <div className="grid md:grid-cols-2 gap-3">
            {activePolicies.map(renderPolicyBlock)}
          </div>
          {cancelledPolicies.length>0&&<div style={{marginTop:"1rem"}}>
            <button onClick={()=>setShowCancelledPolicies(o=>!o)} title={lang==="es"?"Ver/ocultar pólizas canceladas":"Show/hide cancelled policies"} style={{width:"100%",display:"flex",alignItems:"center",gap:8,padding:".7rem .85rem",background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:10,cursor:"pointer",color:"var(--c-text2,#7aa3c0)",fontSize:".82rem",fontWeight:700,textAlign:"left"}}>
              <XCircle size={16} style={{color:"#f87171",flexShrink:0}}/>
              <span style={{flex:1}}>{lang==="es"?"Pólizas canceladas":"Cancelled policies"}</span>
              <span style={{fontFamily:"var(--font-mono)",fontSize:".7rem",padding:"1px 8px",borderRadius:100,background:"rgba(239,68,68,.14)",border:"1px solid rgba(239,68,68,.3)",color:"#f87171"}}>{cancelledPolicies.length}</span>
              <ChevronDown size={16} style={{transform:showCancelledPolicies?"rotate(180deg)":"none",transition:"transform .2s"}}/>
            </button>
            {showCancelledPolicies&&<div className="grid md:grid-cols-2 gap-3" style={{marginTop:".6rem"}}>
              {cancelledPolicies.map(renderPolicyBlock)}
            </div>}
          </div>}
        </>;
      })()}
      {tab==="eligibility"&&<EligibilityTab clientId={client.id} clientName={`${client.firstName} ${client.lastName}`} client={client} eligibilityAlerts={eligibilityAlerts||[]} onEligibilityAlertsChange={onEligibilityAlertsChange} docs={docs} onDocsChange={onDocsChange} onRequestsChange={onRequestsChange} lang={lang}/>}
      {tab==="household"&&<ClientHousehold client={client} lang={lang} t={t} policies={clientPolicies}/>}
      {tab==="health"&&<ClientHealthLife client={client} lang={lang}/>}
      {tab==="medicos"&&<MedicosTab client={client} lang={lang}/>}
      {tab.startsWith("custom_")&&<ClientCustomTabs client={client} customTabDefs={customTabDefs} activeDefId={tab.slice(7)} lang={lang}/>}
      {tab==="docs"&&<DocFolder client={client} policies={policies} docs={docs} onDocsChange={onDocsChange} eligibilityAlerts={eligibilityAlerts} requests={requests} lang={lang} t={t}/>}
      {tab==="drive"&&<ClientDriveTab client={client} onClientPatched={onClientPatched} lang={lang}/>}
      {tab==="tasks"&&<ClientTasksInline clientId={client.id} tasks={tasks} onTasksChange={onTasksChange} users={users} clients={clients} currentUser={currentUser} t={t}/>}
      {tab==="signatures"&&<ClientSignatures clientId={client.id} signatures={signatures} client={client} onDocsChange={onDocsChange} t={t} lang={lang}/>}
      {tab==="followups"&&<FollowupsView clientId={client.id} embedded followups={followups||[]} onFollowupsChange={onFollowupsChange} clients={clients} requests={requests} currentUser={currentUser} lang={lang} canEdit={!_isSeat && typeof onFollowupsChange==="function"}/>}
      {tab==="tickets"&&<TicketsView clientId={client.id} embedded tickets={tickets||[]} onSaveTicket={onSaveTicket} onAddMessage={onAddTicketMessage} onEditMessage={onEditTicketMessage} onDeleteMessage={onDeleteTicketMessage} onDeleteTicket={onDeleteTicket} onNotifyClient={onNotifyTicketClient} loadClientDocs={loadClientDocs} ticketEmailOnOpen={ticketEmailOnOpen} ticketEmailOnResolve={ticketEmailOnResolve} clients={clients} users={users} currentUser={currentUser} lang={lang} seatLabels={seatLabels} customStatuses={ticketStatuses} customTypes={ticketTypes} canEdit={typeof onSaveTicket==="function"}/>}
      {tab==="applications"&&<ClientApplicationsTab client={client} lang={lang}/>}
      {tab==="activity"&&<ActivityLogView clientId={client.id} lang={lang}/>}
      {tab==="notes"&&<ClientNotesTab clientId={client.id} notes={clientNotes||[]} estadoNotas={estadoNotas} onReintentarNotas={reintentarNotas} onNotesChange={onClientNotesChange} onDocsChange={onDocsChange} docs={docs||[]} users={users} currentUser={currentUser} lang={lang}/>}
      {tab==="lifechange"&&<ClientNotesTab clientId={client.id} notes={clientNotes||[]} estadoNotas={estadoNotas} onReintentarNotas={reintentarNotas} onNotesChange={onClientNotesChange} onDocsChange={onDocsChange} docs={docs||[]} users={users} currentUser={currentUser} lang={lang} category="life_change"/>}
      {tab==="history"&&<ChangeHistoryTab clientId={client.id} lang={lang}/>}
      {tab==="payment"&&canSeePayments&&<PaymentMethodsTab clientId={client.id} lang={lang} currentUser={currentUser}/>}
      {tab==="quotes"&&<ClientQuotesTab clientId={client.id} lang={lang}/>}
      {tab==="surveys"&&<ClientEncuestasTab clientId={client.id} lang={lang}/>}
      {tab==="comms"&&<ClientCommsTab client={client} lang={lang} currentUser={currentUser} docTemplates={docTemplates||SEED_DOC_TEMPLATES} docs={(docs||[]).filter(d=>d.clientId===client.id && d.uploadedAt)} onDocsChange={onDocsChange}/>}
    </div>
    {policyModal&&<Modal title={policyModal==="add"?(policyPrefill?(lang==="es"?"Copiar póliza (nueva)":"Copy policy (new)"):t.policies.addTitle):t.policies.editTitle} onClose={()=>setPolicyModal(null)} wide>
      <PolicyForm policy={policyModal==="add"?policyPrefill:policyModal} onSave={savePolicy} onClose={()=>setPolicyModal(null)} t={t} lang={lang} carrierSuggestions={carrierSuggestions} client={client} dependents={client.dependents||[]}
        users={users} currentUser={currentUser}
        knownAgents={[...new Set((policies||[]).map(p=>p.agentLabel).filter(Boolean))]}
        knownAnalysts={[...new Set((policies||[]).map(p=>p.analystName).filter(Boolean))]}
        soaStatusSuggestions={[...new Set((policies||[]).map(p=>p.soaStatus).filter(Boolean))]}
        hraStatusSuggestions={[...new Set((policies||[]).map(p=>p.hraStatus).filter(Boolean))]}
        medicaidSuggestions={[...new Set((policies||[]).map(p=>p.medicaidEligibility).filter(Boolean))]}
        lisSuggestions={[...new Set((policies||[]).map(p=>p.lisLevel).filter(Boolean))]}
        productTypeSuggestions={[...new Set((policies||[]).map(p=>p.productType).filter(Boolean))]}
        knownProcessors={[...new Set((policies||[]).map(p=>p.processedBy).filter(Boolean))]} />
    </Modal>}
    {deletePolicy&&<Modal title={t.common.confirm} onClose={()=>setDeletePolicy(null)}>
      <p className="text-gray-700 mb-5">Remove this policy?</p>
      <div className="flex gap-3">
        <button onClick={async()=>{
          if (isApiMode) {
            try { await apiDeletePolicy(deletePolicy); }
            catch (err) { toast.error((lang==="es"?"No se pudo eliminar la póliza: ":"Failed to delete policy: ")+err.message); return; }
          }
          onPoliciesChange(prev=>prev.filter(p=>p.id!==deletePolicy));
          setDeletePolicy(null);
        }} className="dkt-btn-d" style={{flex:1,justifyContent:"center"}}>{t.common.yes}</button>
        <button onClick={()=>setDeletePolicy(null)} className="dkt-btn-s" style={{flex:1,justifyContent:"center"}}>{t.common.no}</button>
      </div>
    </Modal>}
    {movPol&&<MoverPolizaModal policy={movPol} clients={clients} lang={lang} clienteActual={client}
      onClose={()=>setMovPol(null)}
      onMoved={(movida)=>{
        // La poliza deja de ser de ESTA ficha: se quita de la lista. Dejarla
        // pintada hasta el siguiente refresco es justo lo que Maritza reporto —
        // una poliza en la ficha de quien no es su dueno.
        onPoliciesChange(prev=>prev.filter(p=>p.id!==movida.id));
        setMovPol(null);
      }}/>}
    {kitMissingModal&&(()=>{ const items=kitMissingModal.missing||[]; const mp=kitMissingModal.policy;
      return <Modal title={lang==="es"?"Faltan documentos":"Missing documents"} onClose={()=>setKitMissingModal(null)}>
      <p style={{fontSize:".84rem",color:"#334155",marginBottom:6}}>{lang==="es"?"Antes de enviar el kit de bienvenida a ":"Before sending the welcome kit to "}<strong>{`${client.firstName} ${client.lastName}`}</strong>{lang==="es"?", faltan estos documentos requeridos:":", these required documents are missing:"}</p>
      <ul style={{margin:"8px 0 14px",padding:"10px 12px",listStyle:"none",background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:10}}>
        {items.length?items.map((d,i)=><li key={i} style={{display:"flex",alignItems:"center",gap:8,fontSize:".82rem",color:"#9a3412",fontWeight:600,padding:"3px 0"}}><span style={{color:"#f59e0b"}}>●</span>{lang==="es"?(d.nameEs||d.name):(d.name||d.nameEs)}</li>):<li style={{fontSize:".82rem",color:"#9a3412"}}>{lang==="es"?"Documentos requeridos pendientes.":"Required documents pending."}</li>}
      </ul>
      <p style={{fontSize:".76rem",color:"#64748b",marginBottom:14}}>{lang==="es"?"Puedes subir los documentos y enviar el kit luego, o enviarlo de todos modos ahora.":"You can upload the documents and send the kit later, or send it anyway now."}</p>
      <div className="flex gap-3">
        <button disabled={sendingKitId===mp.id} onClick={()=>sendKit(mp,true)} className="flex-1 dkt-btn-p">{sendingKitId===mp.id?(lang==="es"?"Enviando…":"Sending…"):(lang==="es"?"Enviar de todos modos":"Send anyway")}</button>
        <button onClick={()=>setKitMissingModal(null)} className="flex-1 bg-gray-100 text-gray-700 font-semibold py-2.5 rounded-xl">{lang==="es"?"Cancelar":"Cancel"}</button>
      </div>
    </Modal>; })()}
    {showInsuredModal&&(()=>{
      const calcAge = dob => dob ? Math.floor((new Date()-new Date(dob))/31557600000) : null;
      const all = [];
      all.push({name:`${client.firstName} ${client.lastName}`, relation:lang==="es"?"Titular":"Primary", dob:client.dob, isPrimary:true, insured:memberHasCoverage(client), age:calcAge(client.dob)});
      if(hasCurrentSpouse(client))
        all.push({name:`${client.spouse.firstName} ${client.spouse.lastName||""}`.trim(), relation:lang==="es"?"Cónyuge":"Spouse", dob:client.spouse.dob, insured:memberHasCoverage(client.spouse), age:calcAge(client.spouse?.dob)});
      (client.dependents||[]).forEach(dep=>{
        if(!dep.firstName) return;
        const age=calcAge(dep.dob);
        all.push({name:`${dep.firstName} ${dep.lastName||""}`.trim(), relation:dep.relation||"dep", dob:dep.dob, age, isAdult:age!==null&&age>=26, insured:memberHasCoverage(dep), hasSeparate:dep.separateProfile});
      });
      return <div style={{position:"fixed",inset:0,zIndex:99999,background:"rgba(0,0,0,.78)",backdropFilter:"blur(6px)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}
        onClick={()=>setShowInsuredModal(false)}>
        <div onClick={e=>e.stopPropagation()} style={{background:"var(--c-surface,#0d1c2e)",border:"2px solid rgba(0,212,255,.4)",borderRadius:16,width:"100%",maxWidth:500,maxHeight:"80vh",display:"flex",flexDirection:"column",boxShadow:"0 32px 80px rgba(0,0,0,.7)",overflow:"hidden"}}>
          <div style={{padding:"1rem 1.25rem",background:"linear-gradient(135deg,rgba(0,212,255,.15),rgba(0,150,180,.08))",borderBottom:"1px solid rgba(0,212,255,.25)",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
            <div>
              <div style={{fontFamily:"var(--font-display)",fontWeight:800,fontSize:"1.05rem",color:"var(--c-white,#eef6ff)"}}>🛡️ {lang==="es"?"Miembros del Hogar":"Household Members"}</div>
              <div style={{fontSize:".73rem",color:"var(--c-cyan,#00d4ff)",marginTop:2,fontWeight:600}}>{client.firstName} {client.lastName} . {all.length} {lang==="es"?"personas":"people"}</div>
            </div>
            <button onClick={()=>setShowInsuredModal(false)} style={{background:"var(--c-surface2,#112538)",border:"1px solid var(--c-border,#1a3550)",borderRadius:8,cursor:"pointer",color:"var(--c-text2,#7aa3c0)",lineHeight:0,padding:7}}>
              <X size={16}/>
            </button>
          </div>
          <div style={{overflowY:"auto",padding:".75rem",flex:1}}>
            {all.map((m,mi)=>(
              <div key={mi} style={{display:"flex",alignItems:"center",gap:".875rem",padding:".7rem .875rem",borderRadius:10,marginBottom:".4rem",
                background:m.insured?"rgba(0,212,255,.07)":"var(--ci-bg-02)",
                border:`1px solid ${m.insured?"rgba(0,212,255,.25)":"var(--c-border,#1a3550)"}`}}>
                <div style={{width:40,height:40,borderRadius:"50%",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",
                  fontWeight:800,fontSize:".9rem",fontFamily:"var(--font-display)",
                  background:m.isPrimary?"var(--c-cyan,#00d4ff)":m.insured?"var(--c-surface3,#162d44)":"var(--c-surface2,#112538)",
                  color:m.isPrimary?"#071828":"var(--c-text,#c8dff0)",
                  border:`2px solid ${m.isPrimary?"rgba(0,212,255,.8)":m.insured?"rgba(0,212,255,.2)":"var(--c-border,#1a3550)"}`}}>
                  {(m.name||"?")[0].toUpperCase()}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:".92rem",color:m.insured?"var(--c-white,#eef6ff)":"var(--c-text3,#45688a)",marginBottom:3}}>{m.name}</div>
                  <div style={{display:"flex",alignItems:"center",gap:".4rem",flexWrap:"wrap"}}>
                    <span style={{fontSize:".68rem",color:"var(--c-text3,#45688a)",textTransform:"capitalize",background:"var(--c-surface2,#112538)",padding:"1px 6px",borderRadius:4}}>{m.relation}</span>
                    {m.dob&&<span style={{fontSize:".65rem",color:"var(--c-text3,#45688a)",fontFamily:"var(--font-mono)"}}>📅 {m.dob}{m.age!=null?` . ${m.age}a`:""}</span>}
                    {m.isAdult&&<span style={{fontSize:".62rem",background:"var(--c-amber-dim)",color:"var(--c-amber,#ffb700)",padding:"1px 5px",borderRadius:4,fontWeight:700,border:"1px solid rgba(255,183,0,.2)"}}>⚠️ Mayor 26</span>}
                    {m.hasSeparate&&<span style={{fontSize:".62rem",background:"var(--c-green-dim)",color:"var(--c-green,#00ff88)",padding:"1px 5px",borderRadius:4,fontWeight:700}}>✓ Perfil sep.</span>}
                  </div>
                </div>
                <div style={{flexShrink:0}}>
                  {m.insured
                    ? <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".72rem",fontWeight:800,background:"var(--c-cyan,#00d4ff)",color:"#071828",padding:".3rem .75rem",borderRadius:7,whiteSpace:"nowrap",letterSpacing:".02em"}}>🛡️ {lang==="es"?"ASEGURADO":"COVERED"}</span>
                    : <span style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".72rem",fontWeight:700,background:"var(--c-surface3,#162d44)",color:"var(--c-text3,#45688a)",padding:".3rem .75rem",borderRadius:7,border:"1px solid var(--c-border,#1a3550)",whiteSpace:"nowrap"}}>✕ {lang==="es"?"NO ASEG.":"NOT COVERED"}</span>
                  }
                </div>
              </div>
            ))}
          </div>
          <div style={{padding:".875rem 1rem",borderTop:"1px solid var(--c-border,#1a3550)",display:"flex",justifyContent:"flex-end",flexShrink:0,background:"var(--c-surface,#0d1c2e)"}}>
            <button onClick={()=>setShowInsuredModal(false)}
              style={{fontSize:".78rem",fontWeight:600,background:"var(--c-surface2,#112538)",color:"var(--c-text2,#7aa3c0)",border:"1px solid var(--c-border,#1a3550)",padding:".5rem 1rem",borderRadius:9,cursor:"pointer"}}>
              {lang==="es"?"Cerrar":"Close"}
            </button>
          </div>
        </div>
      </div>;
    })()}
    {showApplyTemplate && (
      <ApplyTemplateModal
        client={client}
        lang={lang}
        onClose={()=>setShowApplyTemplate(false)}
        onApplied={(result)=>{
          // Splice the newly created tasks into local state so they show
          // immediately without a re-fetch.
          if (result?.tasks?.length && onTasksChange) {
            onTasksChange(prev => [...result.tasks.map(taskFromApi), ...prev]);
          }
          // Auto-switch to the Tasks tab so the user sees the new rows
          // without hunting for them.
          setTab("tasks");
          setShowApplyTemplate(false);
        }}
      />
    )}
    {showPortalModal && (
      <ClientPortalModal client={client} lang={lang} onClose={()=>setShowPortalModal(false)} />
    )}
    {showLifeChange && (
      <LifeChangeKitModal client={client} docs={docs} policies={clientPolicies} lang={lang} onClose={()=>setShowLifeChange(false)} />
    )}
    {showRenewalReview && (
      <RenewalReviewModal client={client} lang={lang} onClose={()=>setShowRenewalReview(false)} />
    )}
    {showReferrals && (
      <ClientReferralsModal
        client={client}
        lang={lang}
        onClose={()=>setShowReferrals(false)}
        onClientCreated={onClientCreated}
      />
    )}
    {ssnRevealOpen && (
      <SsnRevealModal
        clientId={client.id}
        clientName={`${client.firstName||""} ${client.lastName||""}`.trim()}
        lang={lang}
        onClose={()=>setSsnRevealOpen(false)}
      />
    )}
  </div>;
}

// ----------------------------------------------------------------------
// ClientReferralsModal — "Referido": the people THIS client referred to us.
// Lists the referral prospects linked back to this client (referredByClientId)
// and lets the agent add a new one. Each referral added becomes a PROSPECT
// (status 'prospect') with referredBy* set to this client, so it appears in
// "Prospectos y Referidos" for follow-up. The prospect is the single source
// of truth — no duplicated list to drift. Moved here 2026-06-17 from the
// client editor's old "Referido" tab (which captured the inverse: who
// referred THIS client).
// ----------------------------------------------------------------------
function ClientReferralsModal({ client, lang, onClose, onClientCreated }) {
  const t = (es, en) => (lang === "es" ? es : en);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [f, setF] = useState({ firstName: "", lastName: "", phone: "", email: "", note: "" });
  const set = (k, v) => setF((prev) => ({ ...prev, [k]: v }));

  const refresh = async () => {
    setLoading(true); setError("");
    try { setList(await listClientReferralsGiven(client.id)); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [client.id]);

  const clientName = `${client.firstName || ""} ${client.lastName || ""}`.trim();

  async function addReferral() {
    if (!f.firstName.trim() && !f.lastName.trim()) {
      toast.error(t("Escribe al menos el nombre del referido.", "Enter at least the referral's name."));
      return;
    }
    setSaving(true);
    try {
      const created = await apiCreateClient({
        firstName: f.firstName.trim() || (lang === "es" ? "Referido" : "Referral"),
        lastName: f.lastName.trim(),
        phone: f.phone.trim(),
        email: f.email.trim(),
        notes: f.note.trim(),
        status: "prospect",
        source: "referral",
        preferredLang: client.preferredLang || "spanish",
        // The inverse link: who referred this new prospect = the current
        // client. Names drive the "Referido por" badge in Prospects; the id
        // is the hard link this profile filters on.
        referredByFirstName: client.firstName || "",
        referredByLastName: client.lastName || "",
        referredByPhone: client.phone || "",
        referredByClientId: client.id,
      });
      // Surface the new prospect in the global clients list (→ it shows in
      // "Prospectos y Referidos") without a full page reload.
      if (onClientCreated && created) onClientCreated(created);
      toast.success(t("Referido agregado como prospecto.", "Referral added as a prospect."));
      setF({ firstName: "", lastName: "", phone: "", email: "", note: "" });
      await refresh();
    } catch (err) {
      toast.error(err.message || t("No se pudo agregar el referido.", "Could not add the referral."));
    } finally { setSaving(false); }
  }

  async function removeReferral(r) {
    const name = `${r.firstName || ""} ${r.lastName || ""}`.trim() || t("este referido", "this referral");
    const ok = await confirmDialog({
      message: t(
        `¿Quitar a "${name}" de la lista de referidos de ${clientName || "este cliente"}? El prospecto se mantiene en "Prospectos y Referidos".`,
        `Remove "${name}" from ${clientName || "this client"}'s referral list? The prospect stays in "Prospects & Referrals".`,
      ),
    });
    if (!ok) return;
    try {
      await unlinkClientReferral(r.id);
      setList((prev) => prev.filter((x) => x.id !== r.id));
      toast.success(t("Quitado de la lista.", "Removed from the list."));
    } catch (err) {
      toast.error(err.message || t("No se pudo quitar.", "Could not remove."));
    }
  }

  const statusChip = (s) => {
    const up = String(s || "").toUpperCase();
    if (up === "ACTIVE") return { label: t("Ya es cliente", "Now a client"), color: "#00ff88", bg: "rgba(0,255,136,.12)" };
    if (up === "INACTIVE") return { label: t("Inactivo", "Inactive"), color: "#7aa3c0", bg: "var(--ci-bd-12)" };
    return { label: t("Prospecto", "Prospect"), color: "#f59e0b", bg: "rgba(245,158,11,.12)" };
  };

  return (
    <Modal title={t("🎁 Referidos que nos dio este cliente", "🎁 Referrals this client gave us")} onClose={onClose} wide>
      <div style={{ fontSize: ".74rem", color: "var(--c-text3,#45688a)", marginBottom: ".75rem" }}>
        {t(
          `Personas que ${clientName || "este cliente"} nos refirió. Cada una se guarda como prospecto en "Prospectos y Referidos" para darle seguimiento.`,
          `People ${clientName || "this client"} referred to us. Each one is saved as a prospect in "Prospects & Referrals" for follow-up.`,
        )}
      </div>

      {/* ── Existing referrals ── */}
      {loading ? (
        <div style={{ fontSize: ".8rem", color: "var(--c-text3,#45688a)", padding: ".5rem 0" }}>{t("Cargando…", "Loading…")}</div>
      ) : error ? (
        <div style={{ fontSize: ".8rem", color: "#ff5d5d", padding: ".5rem 0" }}>{error}</div>
      ) : list.length === 0 ? (
        <div style={{ fontSize: ".8rem", color: "var(--c-text3,#45688a)", fontStyle: "italic", padding: ".5rem 0" }}>
          {t("Aún no hay referidos. Agrega el primero abajo.", "No referrals yet. Add the first one below.")}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: ".4rem", marginBottom: ".5rem" }}>
          {list.map((r) => {
            const chip = statusChip(r.status);
            return (
              <div key={r.id} style={{ display: "flex", alignItems: "flex-start", gap: ".6rem", padding: ".55rem .7rem", border: "1px solid var(--c-border,#1a3550)", borderRadius: 9, background: "var(--ci-bg-02)" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap" }}>
                    <span style={{ fontWeight: 700, color: "var(--c-white,#eef6ff)", fontSize: ".82rem" }}>{`${r.firstName} ${r.lastName}`.trim()}</span>
                    <span style={{ fontSize: ".62rem", fontWeight: 700, color: chip.color, background: chip.bg, padding: ".1rem .45rem", borderRadius: 100 }}>{chip.label}</span>
                  </div>
                  <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginTop: ".2rem", fontSize: ".72rem", color: "var(--c-text2,#7aa3c0)" }}>
                    {r.phone && <span style={{ display: "flex", alignItems: "center", gap: ".25rem" }}><Phone size={11} />{r.phone}</span>}
                    {r.email && <span style={{ display: "flex", alignItems: "center", gap: ".25rem" }}><Mail size={11} />{r.email}</span>}
                  </div>
                  {r.note && <div style={{ marginTop: ".25rem", fontSize: ".72rem", color: "var(--c-text3,#45688a)", fontStyle: "italic" }}>“{r.note}”</div>}
                </div>
                <button onClick={() => removeReferral(r)} title={t("Quitar de la lista", "Remove from list")} style={{ background: "transparent", border: "none", color: "var(--c-text3,#45688a)", cursor: "pointer", padding: ".2rem", borderRadius: 6, flexShrink: 0 }}>
                  <Trash2 size={14} />
                </button>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Add a referral ── */}
      <div style={{ borderTop: "1px solid var(--c-border,#1a3550)", paddingTop: ".75rem", marginTop: ".25rem" }}>
        <div style={{ fontSize: ".62rem", fontWeight: 700, color: "var(--c-cyan,#00d4ff)", textTransform: "uppercase", letterSpacing: ".1em", marginBottom: ".5rem" }}>
          {t("Agregar referido", "Add referral")}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".6rem" }}>
          <Input label={t("Nombre", "First name")} value={f.firstName} onChange={(e) => set("firstName", e.target.value)} placeholder="" />
          <Input label={t("Apellido", "Last name")} value={f.lastName} onChange={(e) => set("lastName", e.target.value)} placeholder="" />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".6rem", marginTop: ".6rem" }}>
          <Input label={t("Teléfono", "Phone")} value={f.phone} onChange={(e) => set("phone", e.target.value)} onBlur={(e) => set("phone", formatPhoneUS(e.target.value))} placeholder="" />
          <Input label={t("Correo", "Email")} type="email" value={f.email} onChange={(e) => set("email", e.target.value)} placeholder="" />
        </div>
        <div style={{ marginTop: ".6rem" }}>
          <Textarea label={t("Nota (opcional)", "Note (optional)")} value={f.note} onChange={(e) => set("note", e.target.value)} placeholder={t("Ej. interesado en Obamacare", "e.g. interested in Obamacare")} />
        </div>
        <div style={{ display: "flex", gap: ".5rem", marginTop: ".75rem" }}>
          <button type="button" onClick={addReferral} disabled={saving} className="dkt-btn-p" style={{ flex: 1, justifyContent: "center", opacity: saving ? .7 : 1 }}>
            <Plus size={14} />{saving ? t("Agregando…", "Adding…") : t("Agregar referido", "Add referral")}
          </button>
          <button type="button" onClick={onClose} className="dkt-btn-s">{t("Cerrar", "Close")}</button>
        </div>
      </div>
    </Modal>
  );
}

// ----------------------------------------------------------------------
// ClientPortalModal — manage portal access tokens for a client.
// Lists all tokens (active + revoked), lets the agent create new ones
// with optional expiry, copy the public URL, open in new tab, or revoke.
// ----------------------------------------------------------------------

function ClientPortalModal({ client, lang, onClose }) {
  const t = (es, en) => (lang === "es" ? es : en);
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [newLabel, setNewLabel] = useState("");
  // Duration is agent-chosen (Lissette #12: "que yo coloque el tiempo"): a number
  // + unit. Backend still hard-caps (5 years) so every PHI link expires (HIPAA).
  // Tope del enlace del portal: 1 año (el servidor rechaza más — MAX_EXPIRY_DAYS
  // en portal.routes.ts). El agente elige el plazo de cada enlace, así que el
  // selector NO puede dejarle pedir algo que luego se recorte sin avisar: eso
  // sería un guardado que hace otra cosa de la que la pantalla prometió.
  const MAX_PORTAL_DIAS = 365;
  const [expiryNum, setExpiryNum] = useState("1");
  const [expiryUnit, setExpiryUnit] = useState("years");
  const maxPorUnidad = expiryUnit === "years" ? 1 : expiryUnit === "months" ? 12 : MAX_PORTAL_DIAS;
  const [justCreatedId, setJustCreatedId] = useState(null);

  const refresh = async () => {
    setLoading(true);
    setError("");
    try { setTokens(await listPortalTokens(client.id)); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [client.id]);

  async function createNew() {
    setBusy(true);
    setError("");
    try {
      const payload = {};
      if (newLabel.trim()) payload.label = newLabel.trim();
      const n = Math.max(1, parseInt(expiryNum, 10) || 1);
      const mult = expiryUnit === "years" ? 365 : expiryUnit === "months" ? 30 : 1;
      payload.expiresInDays = Math.min(n * mult, MAX_PORTAL_DIAS); // red de seguridad; el selector ya no deja pasarse
      const tk = await createPortalToken(client.id, payload);
      setNewLabel("");
      setJustCreatedId(tk.id);
      await refresh();
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }

  async function revoke(id) {
    if (!(await confirmDialog({ message: t("¿Revocar este link? El cliente ya no podrá acceder con esa URL.",
                          "Revoke this link? The client will no longer be able to use it."), danger: true }))) return;
    try { await revokePortalToken(id); await refresh(); }
    catch (err) { setError(err.message); }
  }

  function urlFor(token) {
    return `${window.location.origin}/cliente/${token}`;
  }
  function copyUrl(token) {
    navigator.clipboard?.writeText(urlFor(token)).catch(()=>{});
    toast.success(t("¡Copiado!", "Copied!"));
  }

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex: 100,
      background: "rgba(0,0,0,.7)", backdropFilter: "blur(6px)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem",
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border2,#1f3f60)",
        borderRadius: 16, maxWidth: 640, width: "100%", maxHeight: "85vh",
        display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,.6)",
      }}>
        <div style={{ padding: "1.25rem", borderBottom: "1px solid var(--c-border,#1a3550)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h3 style={{ margin: 0, fontSize: "1.05rem", color: "var(--c-white,#eef6ff)", display: "flex", alignItems: "center", gap: 8 }}>
              <ExternalLink size={16} color="#10b981" />
              {t("Portal del cliente", "Client portal")}
            </h3>
            <div style={{ fontSize: ".78rem", color: "var(--c-text2,#7aa3c0)", marginTop: 2 }}>
              {client.firstName} {client.lastName}
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "var(--c-text2,#7aa3c0)", cursor: "pointer" }}>
            <X size={18} />
          </button>
        </div>

        <div style={{ flex: 1, overflow: "auto", padding: "1rem 1.25rem" }}>
          {/* Help */}
          <div style={{
            background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.2)",
            borderRadius: 10, padding: ".75rem 1rem", marginBottom: "1rem", fontSize: ".82rem",
            color: "var(--c-text,#c8dff0)", lineHeight: 1.55,
          }}>
            {t(
              "Genera un link único para que tu cliente vea sus pólizas, documentos, firmas, cotizaciones y facturas. No requiere login — solo el link.",
              "Generate a unique link so your client can see their policies, documents, signatures, quotes and invoices. No login required — just the link.",
            )}
          </div>

          {error && (
            <div style={{
              background: "#3a1a1a", border: "1px solid #ef4444", borderRadius: 10,
              padding: ".75rem 1rem", marginBottom: 12, color: "#fca5a5",
              display: "flex", alignItems: "center", gap: 10, fontSize: ".88rem",
            }}>
              <AlertTriangle size={16} /><span style={{ flex: 1 }}>{error}</span>
            </div>
          )}

          {/* Create new */}
          <div style={{
            background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)",
            borderRadius: 12, padding: "1rem", marginBottom: "1rem",
          }}>
            <div style={{ fontSize: ".72rem", letterSpacing: ".06em", textTransform: "uppercase", color: "var(--c-text3,#45688a)", fontWeight: 700, marginBottom: ".75rem" }}>
              {t("Nuevo link", "New link")}
            </div>
            <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
              <input value={newLabel} onChange={(e) => setNewLabel(e.target.value)}
                     placeholder={t("Etiqueta opcional (ej. WhatsApp)", "Optional label (e.g. WhatsApp)")}
                     style={{ flex: 1, padding: ".55rem .75rem", borderRadius: 8, background: "var(--c-surface,#0d1c2e)", color: "var(--c-white,#eef6ff)", border: "1px solid var(--c-border,#1a3550)", fontSize: ".88rem", outline: "none" }} />
              <input type="number" min="1" max={maxPorUnidad} value={expiryNum}
                     onChange={(e) => setExpiryNum(String(Math.min(Math.max(1, parseInt(e.target.value, 10) || 1), maxPorUnidad)))}
                     title={t("Duración del link", "Link duration")}
                     style={{ width: 64, padding: ".55rem .5rem", borderRadius: 8, background: "var(--c-surface,#0d1c2e)", color: "var(--c-white,#eef6ff)", border: "1px solid var(--c-border,#1a3550)", fontSize: ".82rem", textAlign: "center" }} />
              <select value={expiryUnit} onChange={(e) => {
                        const u = e.target.value;
                        const tope = u === "years" ? 1 : u === "months" ? 12 : MAX_PORTAL_DIAS;
                        setExpiryUnit(u);
                        setExpiryNum((n) => String(Math.min(Math.max(1, parseInt(n, 10) || 1), tope)));
                      }}
                      style={{ width: 110, padding: ".55rem .5rem", borderRadius: 8, background: "var(--c-surface,#0d1c2e)", color: "var(--c-white,#eef6ff)", border: "1px solid var(--c-border,#1a3550)", fontSize: ".82rem" }}>
                <option value="days">{t("días", "days")}</option>
                <option value="months">{t("meses", "months")}</option>
                <option value="years">{t("años", "years")}</option>
              </select>
            </div>
            <div style={{ fontSize: ".68rem", color: "var(--c-text3,#45688a)", marginBottom: 8 }}>
              {t("Tú eliges cuánto dura el link (máximo 1 año).", "You choose how long the link lasts (max 1 year).")}
            </div>
            <button onClick={createNew} disabled={busy} style={{
              width: "100%", padding: ".65rem", borderRadius: 9,
              background: "linear-gradient(135deg, #10b981, #059669)", color: "#fff",
              border: "none", cursor: "pointer", fontWeight: 700, fontSize: ".88rem",
              display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6,
              opacity: busy ? .6 : 1,
            }}>
              {busy ? "…" : <><Plus size={14} /> {t("Generar link", "Generate link")}</>}
            </button>
          </div>

          {/* Token list */}
          <div style={{ fontSize: ".72rem", letterSpacing: ".06em", textTransform: "uppercase", color: "var(--c-text3,#45688a)", fontWeight: 700, marginBottom: ".5rem" }}>
            {t(`Links existentes (${tokens.length})`, `Existing links (${tokens.length})`)}
          </div>
          {loading ? (
            <div style={{ color: "var(--c-text2,#7aa3c0)", fontSize: ".88rem", padding: ".5rem 0" }}>{t("Cargando…", "Loading…")}</div>
          ) : tokens.length === 0 ? (
            <div style={{ color: "var(--c-text2,#7aa3c0)", fontSize: ".88rem", padding: "1rem", textAlign: "center", background: "var(--c-surface2,#112538)", borderRadius: 10, border: "1px dashed var(--c-border,#1a3550)" }}>
              {t("Aún no hay links generados.", "No links generated yet.")}
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {tokens.map((tk) => {
                const isRevoked = !!tk.revokedAt;
                const isExpired = tk.expiresAt && new Date(tk.expiresAt).getTime() < Date.now();
                const isActive = !isRevoked && !isExpired;
                const isNew = justCreatedId === tk.id;
                return (
                  <div key={tk.id} style={{
                    background: "var(--c-surface2,#112538)",
                    border: `1px solid ${isNew ? "#10b98166" : "var(--c-border,#1a3550)"}`,
                    borderRadius: 10, padding: ".75rem .9rem",
                    boxShadow: isNew ? "0 0 0 3px rgba(16,185,129,.15)" : "none",
                  }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 6 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 700, color: "var(--c-white,#eef6ff)", fontSize: ".88rem" }}>
                          {tk.label || t("Sin etiqueta", "No label")}
                        </div>
                        <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)", marginTop: 2 }}>
                          {tk.viewCount} {t("vistas", "views")}
                          {tk.lastViewedAt && ` · ${t("último", "last")} ${new Date(tk.lastViewedAt).toLocaleString("en-US", { dateStyle: "short", timeStyle: "short" })}`}
                          {tk.expiresAt && ` · ${t("expira", "expires")} ${new Date(tk.expiresAt).toLocaleDateString("en-US")}`}
                        </div>
                      </div>
                      <span style={{
                        fontSize: ".68rem", padding: "3px 9px", borderRadius: 999, fontWeight: 700, letterSpacing: ".04em",
                        background: isActive ? "#10b98122" : "#94a3b822",
                        color:      isActive ? "#10b981"   : "#94a3b8",
                      }}>
                        {isActive ? "ACTIVE" : isRevoked ? "REVOKED" : "EXPIRED"}
                      </span>
                    </div>
                    {isActive && (
                      <>
                        <div style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 6 }}>
                          <input readOnly value={urlFor(tk.token)} style={{
                            flex: 1, padding: ".4rem .65rem", borderRadius: 7,
                            background: "var(--c-surface,#0d1c2e)", color: "var(--c-text2,#7aa3c0)",
                            border: "1px solid var(--c-border,#1a3550)", fontSize: ".72rem",
                            fontFamily: "var(--font-mono,monospace)",
                          }} />
                        </div>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button onClick={() => copyUrl(tk.token)} style={miniActionBtn("primary")}>
                            <Copy size={11} /> {t("Copiar", "Copy")}
                          </button>
                          <button onClick={() => window.open(urlFor(tk.token), "_blank", "noopener,noreferrer")} style={miniActionBtn("ghost")}>
                            <ExternalLink size={11} /> {t("Abrir", "Open")}
                          </button>
                          <button onClick={() => revoke(tk.id)} style={miniActionBtn("danger")}>
                            <Trash2 size={11} /> {t("Revocar", "Revoke")}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function miniActionBtn(kind) {
  const map = {
    primary: { bg: "#00d4ff22", color: "#00d4ff", border: "#00d4ff66" },
    ghost:   { bg: "var(--c-surface,#0d1c2e)", color: "var(--c-text2,#7aa3c0)", border: "var(--c-border,#1a3550)" },
    danger:  { bg: "#7f1d1d22", color: "#fca5a5", border: "#ef444466" },
  }[kind];
  return {
    flex: 1, background: map.bg, color: map.color, border: `1px solid ${map.border}`,
    padding: ".35rem .55rem", borderRadius: 7, cursor: "pointer", fontSize: ".7rem",
    display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 4, fontWeight: 600,
  };
}

// ----------------------------------------------------------------------
// RenewalReviewModal — generate an encrypted "renewal review" link where the
// client confirms the personal-data fields the agent picks (Lissette
// 2026-06-25). Keys MUST match ALLOWED_FIELD_KEYS in renewal-review.routes.ts.
// ----------------------------------------------------------------------

const REVIEW_FIELD_CATALOG = [
  { key: "fullName",        es: "Nombre completo",     en: "Full name",          on: true },
  { key: "dob",             es: "Fecha de nacimiento", en: "Date of birth",      on: true },
  { key: "phone",           es: "Teléfono",            en: "Phone",              on: true },
  { key: "email",           es: "Correo electrónico",  en: "Email",              on: true },
  { key: "address",         es: "Dirección",           en: "Address",            on: true },
  { key: "maritalStatus",   es: "Estado civil",        en: "Marital status",     on: false },
  { key: "language",        es: "Idioma preferido",    en: "Preferred language", on: false },
  { key: "income",          es: "Ingreso anual del hogar", en: "Annual household income", on: true },
  { key: "spouse",          es: "Cónyuge",             en: "Spouse",             on: false },
  // Lissette 2026-09-26: lo del cónyuge y los dependientes que faltaba.
  { key: "spouseDob",       es: "Fecha de nacimiento del cónyuge", en: "Spouse date of birth", on: false },
  { key: "dependents",      es: "Dependientes (nombre y fecha)", en: "Dependents (name & DOB)", on: true },
  { key: "dependentsCount", es: "Nº de dependientes",  en: "# of dependents",    on: true },
  { key: "insuredCount",    es: "Nº de asegurados",    en: "# insured",          on: true },
  // Sensible y apagado por defecto, igual que el SSN: es el dato del cliente y
  // confirmarlo es legitimo, pero viaja en un enlace que puede acabar
  // reenviado. Que el agente lo encienda a proposito.
  { key: "immigrationStatus", es: "Estatus migratorio",  en: "Immigration status", on: false, sensitive: true },
  { key: "spouseImmigration", es: "Estatus migratorio del cónyuge", en: "Spouse immigration status", on: false, sensitive: true },
  { key: "dependentsImmigration", es: "Estatus migratorio de los dependientes", en: "Dependents immigration status", on: false, sensitive: true },
  { key: "ssnLast4",        es: "SSN (últimos 4)",     en: "SSN (last 4)",       on: false, sensitive: true },
  // PREGUNTA, no un dato de la ficha: el cliente la contesta Sí/No en el enlace
  // y la respuesta vuelve en review.answers. Espejo de RR_FIELD_CATALOG en
  // deskte-full.jsx y de `question` en FIELD_CATALOG (renewal-review.routes.ts).
  // La etiqueta es LITERALMENTE la que va a leer el cliente en el enlace (el
  // test revisionEstatusMigratorio obliga a que las tres listas digan lo
  // mismo), y por eso está en segunda persona aunque aquí la vea el agente.
  // ¿QUIERE RENOVAR? (Lissette 2026-09-15). Va ENCENDIDA por defecto y primera
  // entre las preguntas: es lo que el enlace de renovación existe para
  // averiguar. Su seguimiento —el motivo, cuando contesta que no— viaja solo
  // con ella; el servidor lo añade (`conDependientes`).
  { key: "renovar",         es: "¿Quieres renovar tu póliza?", en: "Do you want to renew your policy?", on: true, question: true, siempre: true },
  { key: "renovarMotivo",   es: "¿Por qué no quieres renovarla?", en: "Why not renew it?", on: false, question: true, dependsOn: "renovar" },
  { key: "idme",            es: "¿Tienes cuenta ID.me?", en: "Do you have an ID.me account?", on: false, question: true },
  // Tercera pregunta (Lissette 2026-09-09): si el cliente dice que SI tiene
  // cuenta, se le enseña el correo que tenemos y se le pregunta si es ese.
  // El cliente ve el correo; aqui el agente solo ve la pregunta.
  { key: "idmeEmail",       es: "¿Usaste este mismo correo para tu cuenta ID.me?", en: "Did you use this same email for your ID.me account?", on: false, question: true, dependsOn: "idme" },
  // Y si NO es el mismo, que escriba cual. Sin esto solo sabriamos que "es
  // otro", que obliga a llamarle igual.
  { key: "idmeEmailOther",  es: "¿Con qué correo entras a ID.me?", en: "Which email do you use for ID.me?", on: false, question: true, dependsOn: "idmeEmail" },
];

// Dónde se recuerda la última selección de campos del agente. Antes el modal
// arrancaba SIEMPRE en las casillas por defecto, así que había que volver a
// marcar lo mismo en cada cliente (Lissette 2026-08-25: "no se queda siempre
// fijo, eso tenemos que escogerlo a cada rato"). Se guarda en el navegador —
// es una preferencia de trabajo, no un dato del cliente — y la primera vez se
// siembra del ajuste de agencia `renewalReviewFields.__default__`, que es el
// mismo que edita Renovaciones → "Campos de la revisión".
const RR_FIELDS_LS_KEY = "deskte_renewal_review_fields";
function loadStickyReviewFields() {
  try {
    const raw = localStorage.getItem(RR_FIELDS_LS_KEY);
    const list = raw ? JSON.parse(raw) : null;
    if (!Array.isArray(list)) return null;
    const known = list.filter((k) => REVIEW_FIELD_CATALOG.some((f) => f.key === k));
    return known.length ? known : null;
  } catch { return null; }
}
function saveStickyReviewFields(keys) {
  try { localStorage.setItem(RR_FIELDS_LS_KEY, JSON.stringify(keys)); } catch { /* cuota llena: no vale romper el guardado del link por esto */ }
}

function reviewStatusMeta(status, es) {
  return {
    PENDING:   { label: es ? "Pendiente" : "Pending",   color: "#94a3b8" },
    VIEWED:    { label: es ? "Visto"     : "Viewed",     color: "#38bdf8" },
    CONFIRMED: { label: es ? "Confirmado" : "Confirmed", color: "#10b981" },
    ADJUST:    { label: es ? "Pidió ajuste" : "Wants change", color: "#f59e0b" },
  }[status] || { label: status || "—", color: "#94a3b8" };
}

function RenewalReviewModal({ client, lang, onClose }) {
  const es = lang === "es";
  const t = (sEs, sEn) => (es ? sEs : sEn);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [label, setLabel] = useState("");
  const [expiryDays, setExpiryDays] = useState("14"); // 14 dias por defecto (Lissette 2026-10-01)
  // Selección que SE QUEDA: lo último que eligió este agente (navegador), y si
  // nunca eligió nada, las casillas por defecto. El ajuste de agencia se lee
  // aparte más abajo y solo pisa esto cuando no hay nada guardado localmente.
  const [selected, setSelected] = useState(
    () => new Set(loadStickyReviewFields() || REVIEW_FIELD_CATALOG.filter((f) => f.on).map((f) => f.key)),
  );
  const [justCreatedId, setJustCreatedId] = useState(null);

  // Primera vez en este navegador: siembra con el predeterminado que la agencia
  // configuró en Renovaciones → "Campos de la revisión", para que las dos
  // pantallas no arranquen pidiendo cosas distintas. Silencioso a propósito: un
  // asiento sin permiso de ajustes simplemente se queda con las casillas por
  // defecto, que es lo que veía hasta hoy.
  useEffect(() => {
    if (loadStickyReviewFields()) return;
    let alive = true;
    getAgencySettings()
      .then((s) => {
        const def = s?.renewalReviewFields?.__default__;
        if (!alive || !Array.isArray(def) || !def.length) return;
        const known = def.filter((k) => REVIEW_FIELD_CATALOG.some((f) => f.key === k));
        if (known.length) setSelected(new Set(known));
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const refresh = async () => {
    setLoading(true); setError("");
    try { setReviews(await listRenewalReviews(client.id)); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [client.id]);

  const toggle = (key) => setSelected((prev) => {
    const next = new Set(prev);
    if (next.has(key)) next.delete(key); else next.add(key);
    // Se recuerda al marcar, no al crear el link: así la selección sobrevive
    // aunque el agente cierre el modal sin generar nada.
    saveStickyReviewFields([...next]);
    return next;
  });

  async function createNew() {
    if (selected.size === 0) { setError(t("Elige al menos un dato a mostrar.", "Pick at least one field to show.")); return; }
    setBusy(true); setError("");
    try {
      const fields = REVIEW_FIELD_CATALOG.filter((f) => selected.has(f.key)).map((f) => f.key);
      const days = Math.min(Math.max(1, parseInt(expiryDays, 10) || 14), 90); // tope del servidor
      const rv = await createRenewalReview(client.id, { fields, label: label.trim() || undefined, expiresInDays: days });
      setLabel("");
      setJustCreatedId(rv.id);
      await refresh();
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }

  async function revoke(id) {
    if (!(await confirmDialog({ message: t("¿Revocar este link? El cliente ya no podrá abrirlo.", "Revoke this link? The client won't be able to open it."), danger: true }))) return;
    try { await revokeRenewalReview(id); await refresh(); }
    catch (err) { setError(err.message); }
  }

  const urlFor = (token) => `${window.location.origin}/revision/${token}`;
  const copyUrl = (token) => { navigator.clipboard?.writeText(urlFor(token)).catch(() => {}); toast.success(t("¡Copiado!", "Copied!")); };

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex: 100, background: "rgba(0,0,0,.7)", backdropFilter: "blur(6px)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem",
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "var(--c-surface,#0d1c2e)", border: "1px solid var(--c-border2,#1f3f60)",
        borderRadius: 16, maxWidth: 640, width: "100%", maxHeight: "88vh",
        display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,.6)",
      }}>
        <div style={{ padding: "1.25rem", borderBottom: "1px solid var(--c-border,#1a3550)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h3 style={{ margin: 0, fontSize: "1.05rem", color: "var(--c-white,#eef6ff)", display: "flex", alignItems: "center", gap: 8 }}>
              <ClipboardCheck size={16} color="#00d4ff" />
              {t("Revisión de renovación", "Renewal review")}
            </h3>
            <div style={{ fontSize: ".78rem", color: "var(--c-text2,#7aa3c0)", marginTop: 2 }}>
              {client.firstName} {client.lastName}
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "var(--c-text2,#7aa3c0)", cursor: "pointer" }}>
            <X size={18} />
          </button>
        </div>

        <div style={{ flex: 1, overflow: "auto", padding: "1rem 1.25rem" }}>
          <div style={{
            background: "rgba(0,212,255,.08)", border: "1px solid rgba(0,212,255,.2)",
            borderRadius: 10, padding: ".75rem 1rem", marginBottom: "1rem", fontSize: ".82rem",
            color: "var(--c-text,#c8dff0)", lineHeight: 1.55,
          }}>
            {t(
              "Elige qué datos verá el cliente y qué le quieres preguntar. Genera el link, mándalo, y el cliente confirmará si todo está correcto o si hay que ajustar algo. Lo que marques aquí queda guardado y sale marcado la próxima vez.",
              "Pick which data the client will see and what you want to ask. Generate the link, send it, and the client confirms whether everything is correct or needs a change. Whatever you tick here is remembered and comes back ticked next time.",
            )}
          </div>

          {error && (
            <div style={{
              background: "#3a1a1a", border: "1px solid #ef4444", borderRadius: 10,
              padding: ".75rem 1rem", marginBottom: 12, color: "#fca5a5",
              display: "flex", alignItems: "center", gap: 10, fontSize: ".88rem",
            }}>
              <AlertTriangle size={16} /><span style={{ flex: 1 }}>{error}</span>
            </div>
          )}

          {/* Field picker */}
          <div style={{
            background: "var(--c-surface2,#112538)", border: "1px solid var(--c-border,#1a3550)",
            borderRadius: 12, padding: "1rem", marginBottom: "1rem",
          }}>
            <div style={{ fontSize: ".72rem", letterSpacing: ".06em", textTransform: "uppercase", color: "var(--c-text3,#45688a)", fontWeight: 700, marginBottom: ".75rem" }}>
              {t("Datos a mostrar y preguntas", "Fields to show & questions")}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".4rem .8rem" }}>
              {/* Las preguntas de SEGUIMIENTO no se listan: viajan siempre
                  con su pregunta madre y el servidor las añade solo
                  (Lissette 2026-09-09). Ver conDependientes en
                  renewal-review.routes.ts. */}
              {REVIEW_FIELD_CATALOG.filter((f) => !f.dependsOn).map((f) => {
                const on = selected.has(f.key);
                return (
                  <label key={f.key} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: ".84rem", color: "var(--c-text,#c8dff0)" }}>
                    {/* La pregunta de si quiere renovar va en TODO enlace (el
                        servidor la añade igual, ver PREGUNTAS_SIEMPRE): se
                        enseña marcada y sin poder quitarla, en vez de dejar una
                        casilla que se puede desmarcar y no cambia nada. */}
                    <input type="checkbox" checked={on || !!f.siempre} disabled={!!f.siempre}
                      onChange={() => !f.siempre && toggle(f.key)}
                      style={{ accentColor: "#00d4ff", width: 15, height: 15 }} />
                    <span>
                      {es ? f.es : f.en}
                      {f.siempre && (
                        <span style={{ color: "var(--c-text3,#45688a)", marginLeft: 6, fontSize: ".72rem" }}>
                          {t("(va siempre)", "(always included)")}
                        </span>
                      )}
                      {f.sensitive && <span style={{ color: "#f59e0b", marginLeft: 4 }} title={t("Dato sensible", "Sensitive")}>•</span>}
                      {/* Una pregunta no se confirma, se contesta: la marca
                          evita que se lea como "un dato más de la ficha". */}
                      {f.question && (
                        <span style={{ color: "#00d4ff", marginLeft: 4, fontSize: ".68rem", fontWeight: 700 }}
                              title={t("El cliente la contesta Sí/No", "The client answers Yes/No")}>
                          {t("PREGUNTA", "QUESTION")}
                        </span>
                      )}
                      {/* Aviso de que esta no siempre se le va a enseñar: sale
                          solo si la pregunta de la que depende se contesta que
                          no (Lissette 2026-09-02, punto 72). */}
                      {f.dependsOn && (
                        <span style={{ color: "var(--c-text3,#45688a)", marginLeft: 6, fontSize: ".72rem" }}>
                          {t("(solo si contesta que No a la anterior)", "(only if they answer No to the previous one)")}
                        </span>
                      )}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>

          {/* Create row */}
          <div style={{ display: "flex", gap: 8, marginBottom: "1.25rem", flexWrap: "wrap" }}>
            <input value={label} onChange={(e) => setLabel(e.target.value)}
                   placeholder={t("Etiqueta opcional", "Optional label")}
                   style={{ flex: "1 1 160px", padding: ".55rem .75rem", borderRadius: 8, background: "var(--c-surface,#0d1c2e)", color: "var(--c-white,#eef6ff)", border: "1px solid var(--c-border,#1a3550)", fontSize: ".88rem", outline: "none" }} />
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <input type="number" min="1" max="90" value={expiryDays} onChange={(e) => setExpiryDays(e.target.value)}
                     title={t("Días hasta que expire", "Days until expiry")}
                     style={{ width: 64, padding: ".55rem .5rem", borderRadius: 8, background: "var(--c-surface,#0d1c2e)", color: "var(--c-white,#eef6ff)", border: "1px solid var(--c-border,#1a3550)", fontSize: ".88rem", outline: "none" }} />
              <span style={{ fontSize: ".8rem", color: "var(--c-text2,#7aa3c0)" }}>{t("días", "days")}</span>
            </div>
            <button onClick={createNew} disabled={busy} style={{
              flex: "1 1 140px", padding: ".55rem 1rem", borderRadius: 8, border: "none",
              background: "#00d4ff", color: "#06283a", fontWeight: 700, fontSize: ".88rem",
              cursor: busy ? "wait" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
            }}>
              <Link2 size={14} /> {t("Crear link", "Create link")}
            </button>
          </div>

          {/* Existing links */}
          {loading ? (
            <div style={{ textAlign: "center", color: "var(--c-text2,#7aa3c0)", padding: "1rem" }}>{t("Cargando…", "Loading…")}</div>
          ) : reviews.length === 0 ? (
            <div style={{ textAlign: "center", color: "var(--c-text3,#45688a)", padding: "1rem", fontSize: ".85rem" }}>
              {t("Aún no hay links de revisión.", "No review links yet.")}
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {reviews.map((rv) => {
                const isActive = !rv.revokedAt && (!rv.expiresAt || new Date(rv.expiresAt).getTime() > Date.now());
                const sm = reviewStatusMeta(rv.status, es);
                const isNew = rv.id === justCreatedId;
                return (
                  <div key={rv.id} style={{
                    background: "var(--c-surface2,#112538)",
                    border: `1px solid ${isNew ? "#10b981" : "var(--c-border,#1a3550)"}`,
                    borderRadius: 10, padding: ".75rem .9rem",
                    boxShadow: isNew ? "0 0 0 3px rgba(16,185,129,.15)" : "none",
                  }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 6 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 700, color: "var(--c-white,#eef6ff)", fontSize: ".88rem" }}>
                          {rv.label || t("Sin etiqueta", "No label")}
                        </div>
                        <div style={{ fontSize: ".7rem", color: "var(--c-text3,#45688a)", marginTop: 2 }}>
                          {rv.viewCount} {t("vistas", "views")}
                          {rv.expiresAt && ` · ${t("expira", "expires")} ${new Date(rv.expiresAt).toLocaleDateString("en-US")}`}
                        </div>
                      </div>
                      <span style={{
                        fontSize: ".68rem", padding: "3px 9px", borderRadius: 999, fontWeight: 700, letterSpacing: ".04em",
                        background: `${sm.color}22`, color: sm.color,
                      }}>
                        {sm.label.toUpperCase()}
                      </span>
                    </div>

                    {/* Client's answer */}
                    {rv.response && (
                      <div style={{
                        background: rv.response === "correct" ? "rgba(16,185,129,.1)" : "rgba(245,158,11,.1)",
                        border: `1px solid ${rv.response === "correct" ? "#10b98155" : "#f59e0b55"}`,
                        borderRadius: 8, padding: ".5rem .7rem", marginBottom: 8, fontSize: ".8rem", color: "var(--c-text,#c8dff0)",
                      }}>
                        <strong style={{ color: rv.response === "correct" ? "#10b981" : "#f59e0b" }}>
                          {rv.response === "correct" ? t("Todo correcto ✅", "All correct ✅") : t("Pidió un ajuste ✍️", "Wants a change ✍️")}
                        </strong>
                        {rv.comment && <div style={{ marginTop: 4, fontStyle: "italic" }}>“{rv.comment}”</div>}
                        {/* Respuestas a las preguntas Sí/No del enlace. Se
                            pintan junto a la respuesta principal porque llegan
                            en el mismo envío; sin esto, la pregunta se
                            contestaba y el agente no la veía nunca. */}
                        {rv.answers && typeof rv.answers === "object" && Object.keys(rv.answers).length > 0 && (
                          <div style={{ marginTop: 6, display: "flex", flexWrap: "wrap", gap: 6 }}>
                            {Object.entries(rv.answers).map(([k, v]) => {
                              const f = REVIEW_FIELD_CATALOG.find((x) => x.key === k);
                              // UNA RESPUESTA ESCRITA SE ENSEÑA ESCRITA.
                              //
                              // Esto pintaba `v === "yes" ? "Sí" : "No"` sin
                              // mirar qué había contestado, así que una pregunta
                              // de escribir salía como un "No" rotundo: el
                              // correo de ID.me que el cliente teclea desde el
                              // 2026-09-09 se guardaba bien y en la ficha se
                              // leía "¿Con qué correo entras a ID.me? No". El
                              // dato estaba y la pantalla decía lo contrario
                              // (E-275). Con el motivo de no renovar habría sido
                              // peor: la respuesta que más trabajo ahorra, dicha
                              // al revés.
                              const escrita = v !== "yes" && v !== "no";
                              const yes = v === "yes";
                              const etiqueta = f ? (es ? f.es : f.en) : k;
                              return (
                                <span key={k} style={{
                                  fontSize: ".72rem", padding: "3px 8px", borderRadius: 999, fontWeight: 700,
                                  maxWidth: "100%", whiteSpace: "pre-wrap", wordBreak: "break-word",
                                  background: yes ? "rgba(16,185,129,.14)" : "rgba(148,163,184,.14)",
                                  color: yes ? "#10b981" : "#94a3b8",
                                }}>
                                  {etiqueta} {escrita ? String(v) : yes ? t("Sí", "Yes") : "No"}
                                </span>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}

                    {isActive && (
                      <>
                        <input readOnly value={urlFor(rv.token)} style={{
                          width: "100%", boxSizing: "border-box", padding: ".4rem .65rem", borderRadius: 7, marginBottom: 6,
                          background: "var(--c-surface,#0d1c2e)", color: "var(--c-text2,#7aa3c0)",
                          border: "1px solid var(--c-border,#1a3550)", fontSize: ".72rem", fontFamily: "var(--font-mono,monospace)",
                        }} />
                        <div style={{ display: "flex", gap: 6 }}>
                          <button onClick={() => copyUrl(rv.token)} style={miniActionBtn("primary")}>
                            <Copy size={11} /> {t("Copiar", "Copy")}
                          </button>
                          <button onClick={() => window.open(urlFor(rv.token), "_blank", "noopener,noreferrer")} style={miniActionBtn("ghost")}>
                            <ExternalLink size={11} /> {t("Abrir", "Open")}
                          </button>
                          <button onClick={() => revoke(rv.id)} style={miniActionBtn("danger")}>
                            <Trash2 size={11} /> {t("Revocar", "Revoke")}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// Map a backend Task row to the shape the local tasks state expects.
function taskFromApi(t) {
  return {
    id: t.id,
    clientId: t.clientId,
    title: t.title,
    description: t.description || '',
    dueDate: t.dueDate ? t.dueDate.split('T')[0] : '',
    priority: (t.priority || 'MEDIUM').toLowerCase(),
    status: (t.status || 'PENDING').toLowerCase(),
    category: t.category || '',
    assigneeId: t.assigneeId,
    createdById: t.createdById,
    createdAt: t.createdAt,
  };
}
